import GenerateEnum from '../generateEnum'
import { COMMON_COUNTRY } from './commonCountry'
import { COMMON_SERVICE_TYPE } from './commonServiceType.js'
import { systemTypeEnum } from './common'
import { globalThis, getLabelText } from '../utils.js'

const env = {
  serviceType: ['VAT', 'EPR', 'IPP']
}
const EPRSERIALNUMBERMARKING = new GenerateEnum({
  normal: {
    value: 0,
    label: getLabelText({
      key: 'remote.admin.unmarked',
      text: '无标记'
    })
  },
  extensionRenewal: {
    value: 1,
    label: getLabelText({
      key: 'remote.admin.newNumberExtensionRenewal',
      text: '新下号延期续费'
    })
  },
  newAccountRenewal: {
    value: 2,
    label: getLabelText({
      key: 'remote.admin.newAccountRenewal',
      text: '新下号续费'
    })
  }
})

const lzProductList = [
  {
    name: getLabelText({
      key: 'remote.common.electronicProduct',
      text: '电子产品'
    }),
    iconUrl: 'https://cdn.evatmaster.com/ost/240909d261ad1ce5e845dcbc15fe0fd2af3ed5.svg',
    defaultNum: 1
  },
  {
    name: getLabelText({
      key: ['remote.common.nonElectronicProduct'],
      text: '非电子产品'
    }),
    iconUrl: 'https://cdn.evatmaster.com/ost/240909eb3fd14f953d4809a8c40c32bbdca01d.svg',
    defaultNum: 0
  },
  {
    name: getLabelText({
      key: 'remote.common.largePieceFurniture',
      text: '大件家具'
    }),
    iconUrl: 'https://cdn.evatmaster.com/ost/2409096fc69c09f6ba482c83d39f1b895f96fe.svg',
    defaultNum: 0
  }
]
const scoreType = {
  1: getLabelText({
    key: 'remote.common.universalPoints',
    text: '通用积分'
  }),
  2: getLabelText({
    key: 'remote.common.bonusPoints',
    text: '奖励积分'
  })
}
const SERVICE_STATUS = {
  PENDING_PAYMENT: '0',
  PAID: '1',
  REFUND_IN_PROGRESS: '2',
  SCORE_REFUNDED: '3',
  REFUNDED: '4',
  BALANCE_REFUNDED: '5'
}
const scoreLimitFlagModule = new GenerateEnum({
  YES: {
    value: 0,
    label: getLabelText({
      key: 'remote.common.exchange2',
      text: '兑换'
    })
  },
  NO: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.cashedOut',
      text: '已兑完'
    })
  }
})
const scoreStoreProductType = new GenerateEnum({
  entity: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.physicalGoods',
      text: '实物'
    }),
    selectDisabled: false
  },
  coupon: {
    value: 2,
    label: getLabelText({
      key: 'remote.common.coupons',
      text: '优惠券'
    }),
    selectDisabled: false
  },
  thirdCard: {
    value: 3,
    label: getLabelText({
      key: 'remote.common.third-partyCardsAndVouchers',
      text: '第三方卡券'
    }),
    selectDisabled: true
  },
  thirdResource: {
    value: 4,
    label: getLabelText({
      key: 'remote.common.third-partyResources',
      text: '第三方资源'
    }),
    selectDisabled: false
  }
})
const advertisementModuleType = new GenerateEnum({
  user: {
    value: '0',
    label: getLabelText({
      key: 'remote.common.pcMerchantSide',
      text: 'PC商户端'
    })
  },
  www: {
    value: '1',
    label: getLabelText({
      key: 'remote.common.pcOfficialWebsite',
      text: 'PC官网'
    })
  },
  h5: {
    value: '2',
    label: getLabelText({
      key: 'remote.common.mobileOfficialWebsite',
      text: '手机官网'
    })
  },
  program: {
    value: '3',
    label: getLabelText({
      key: 'remote.common.miniProgram',
      text: '小程序'
    })
  }
})
const faceThePeopleData = new GenerateEnum({
  noLimit: {
    value: 0,
    label: getLabelText({
      key: 'remote.common.unlimited2',
      text: '无限制'
    })
  },
  userTag: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.userTags',
      text: '用户标签'
    })
  },
  whiteList: {
    value: 2,
    label: getLabelText({
      key: 'remote.common.whitelist',
      text: '白名单'
    })
  },
  userGroup: {
    value: 3,
    label: getLabelText({
      key: 'remote.common.customerSegmentation',
      text: '客户分群'
    })
  }
})
const entryCompanyEnum = new GenerateEnum({
  OST: {
    value: 0,
    label: getLabelText({
      key: 'remote.common.shenzhenOushuitongTechnologyCo.Ltd',
      text: '深圳欧税通技术有限公司'
    })
  },
  IPP: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.shanghaiMetroSoftwareTechnologyCo.Ltd',
      text: '上海麦德通软件技术有限公司'
    })
  },
  LIUDU: {
    value: 2,
    label: getLabelText({
      key: 'remote.common.shenzhenLiuduInformationServiceCo.Ltd',
      text: '深圳六度信息服务有限公司'
    })
  }
})
const SERVICE_STATUS_MAP = {
  [SERVICE_STATUS.PENDING_PAYMENT]: getLabelText({
    key: 'remote.common.processing',
    text: '处理中'
  }),
  [SERVICE_STATUS.PAID]: getLabelText({
    key: 'remote.common.completed',
    text: '已完成'
  }),
  [SERVICE_STATUS.REFUND_IN_PROGRESS]: getLabelText({
    key: 'remote.common.refundInProgress',
    text: '退款中'
  }),
  [SERVICE_STATUS.SCORE_REFUNDED]:
    getLabelText({
      key: 'remote.common.refunded',
      text: '已退款'
    }) +
    `（${getLabelText({
      key: 'remote.common.redeemPoints',
      text: '兑换积分'
    })}）`,
  [SERVICE_STATUS.REFUNDED]: getLabelText({
    key: 'remote.common.refunded',
    text: '已退款'
  }),
  [SERVICE_STATUS.BALANCE_REFUNDED]:
    getLabelText({
      key: 'remote.common.refunded',
      text: '已退款'
    }) +
    `（${getLabelText({
      key: 'remote.common.exchangeBalance',
      text: '兑换余额'
    })}）`
}
const withdrawType = {
  1: getLabelText({ key: 'remote.common.underReview', text: '审核中' }),
  2: getLabelText({ key: 'remote.common.auditPassed', text: '审核通过' }),
  3: getLabelText({ key: 'remote.common.auditFailed', text: '审核失败' })
}
const productTypeEnum = {
  ORDINARY: 0, // 普通商品
  OFFICIAL: 1, // 官费商品
  SETMEAL: 2 // 套餐商品
}
const countryList = [
  {
    country: getLabelText({ key: 'remote.common.theUk', text: '英国' }),
    value: '0'
  },
  {
    country: getLabelText({ key: 'remote.common.france', text: '法国' }),
    value: '1'
  },
  {
    country: getLabelText({ key: 'remote.common.germany', text: '德国' }),
    value: '2'
  },
  {
    country: getLabelText({ key: 'remote.common.italy', text: '意大利' }),
    value: '3'
  },
  {
    country: getLabelText({ key: 'remote.common.spain', text: '西班牙' }),
    value: '4'
  },
  {
    country: getLabelText({ key: 'remote.common.poland', text: '波兰' }),
    value: '5'
  },
  {
    country: getLabelText({ key: 'remote.common.czechRepublic', text: '捷克' }),
    value: '6'
  },
  {
    country: getLabelText({ key: 'remote.common.netherlands', text: '荷兰' }),
    value: '7'
  },
  {
    country: getLabelText({ key: 'remote.common.austria', text: '奥地利' }),
    value: '8'
  },
  //  {country:'比利时',value:9},
  //  {country:'瑞典',value:10},
  {
    country: getLabelText({ key: 'remote.common.saudiArabia', text: '沙特' }),
    value: '11'
  },
  {
    country: getLabelText({
      key: 'remote.common.unitedArabEmirates',
      text: '阿联酋'
    }),
    value: '12'
  },
  {
    country: getLabelText({ key: 'remote.common.europeanUnion', text: '欧盟' }),
    value: 'EU'
  },
  {
    country: getLabelText({ key: 'remote.common.japan.text', text: '日本' }),
    value: '100'
  }
]
const payClass = [
  {
    name: getLabelText({ key: 'remote.common.euro', text: '欧元' }),
    value: '0'
  },
  {
    name: getLabelText({ key: 'remote.common.dollar', text: '美元' }),
    value: '1'
  },
  {
    name: getLabelText({ key: 'remote.common.rmb', text: '人民币' }),
    value: '2'
  },
  {
    name: getLabelText({ key: 'remote.common.pound', text: '英镑' }),
    value: '3'
  },
  {
    name: getLabelText({ key: 'remote.common.zloty', text: '兹罗提' }),
    value: '4'
  },
  {
    name: getLabelText({ key: 'remote.common.rial', text: '里亚尔' }),
    value: '5'
  },
  {
    name: getLabelText({ key: 'remote.common.dirham', text: '迪拉姆' }),
    value: '6'
  },
  {
    name: getLabelText({ key: 'remote.common.hongKongDollar', text: '港币' }),
    value: '7'
  }
]
const currencyList = [
  {
    label: '全部',
    value: ''
  },
  // 可变的
  {
    label: getLabelText({ key: 'remote.common.dollar', text: '美元' }),
    value: 'USD',
    symbol: '$'
  },
  {
    label: getLabelText({ key: 'remote.common.euro', text: '欧元' }),
    value: 'EUR',
    symbol: '€'
  },
  {
    label: getLabelText({ key: 'remote.common.pound', text: '英镑' }),
    value: 'GBP',
    symbol: '£'
  },
  {
    label: getLabelText({ key: 'remote.common.japaneseYen', text: '日元' }),
    value: 'JPY',
    symbol: 'Ұ'
  },
  // 固定的
  {
    label: getLabelText({ key: 'remote.common.fixedUsd', text: '固定美元' }),
    value: 'FX_USD'
  },
  {
    label: getLabelText({ key: 'remote.common.fixedEuro', text: '固定欧元' }),
    value: 'FX_EUR'
  },
  {
    label: getLabelText({
      key: 'remote.common.fixedPoundSterling',
      text: '固定英镑'
    }),
    value: 'FX_GBP'
  },
  {
    label: getLabelText({ key: 'remote.common.fixedYen', text: '固定日元' }),
    value: 'FX_JPY'
  },
  {
    label: getLabelText({ key: 'remote.common.fixedWon', text: '固定韩元' }),
    value: 'FX_KRW'
  },
  {
    label: getLabelText({
      key: 'remote.common.fixedPhilippinePeso',
      text: '固定菲律宾比索'
    }),
    value: 'FX_PHP'
  },
  {
    label: getLabelText({
      key: 'remote.common.fixedIndianRupee',
      text: '固定印度卢比'
    }),
    value: 'FX_INR'
  },
  {
    label: getLabelText({
      key: 'remote.common.fixedAustralianDollar',
      text: '固定澳元'
    }),
    value: 'FX_AUD'
  },
  {
    label: getLabelText({
      key: 'remote.common.fixedCanadianDollar',
      text: '固定加元'
    }),
    value: 'FX_CAD'
  },
  {
    label: getLabelText({
      key: 'remote.common.fixedBrazilianReal',
      text: '固定巴西雷亚尔'
    }),
    value: 'FX_BRL'
  },
  {
    label: getLabelText({ key: 'remote.common.won', text: '韩元' }),
    value: 'KRW',
    symbol: '₩'
  },
  {
    label: getLabelText({
      key: 'remote.common.philippinePesos',
      text: '菲律宾比索'
    }),
    value: 'PHP',
    symbol: 'Ұ'
  },
  {
    label: getLabelText({ key: 'remote.common.indianRupee', text: '印度卢比' }),
    value: 'INR',
    symbol: '₹'
  },
  {
    label: getLabelText({
      key: 'remote.common.australianDollar',
      text: '澳元'
    }),
    value: 'AUD',
    symbol: '$'
  },
  {
    label: getLabelText({ key: 'remote.common.canadianDollars', text: '加元' }),
    value: 'CAD',
    symbol: 'C$'
  },
  {
    label: getLabelText({
      key: 'remote.common.brazilianReal',
      text: '巴西雷亚尔'
    }),
    value: 'BRL',
    symbol: 'R$'
  },
  {
    label: getLabelText({
      key: 'remote.common.norwegianKrone',
      text: '挪威克朗'
    }),
    value: 'NOK',
    symbol: 'kr'
  },
  {
    label: getLabelText({
      key: 'remote.common.newZealandDollar',
      text: '新西兰元'
    }),
    value: 'NZD',
    symbol: 'NZ$'
  },
  {
    label: getLabelText({ key: 'remote.common.rmb', text: '人民币' }),
    value: 'CNY',
    symbol: '￥'
  },
  {
    label: getLabelText({
      key: 'remote.common.uaeDirham',
      text: '阿联酋迪拉姆'
    }),
    value: 'AED',
    symbol: 'د.إ'
  },
  {
    label: getLabelText({
      key: 'remote.common.australianDollar',
      text: '澳元'
    }),
    value: 'AUD',
    symbol: 'A$'
  },
  {
    label: getLabelText({ key: 'remote.common.swissFranc', text: '瑞士法郎' }),
    value: 'CHF',
    symbol: 'CHF'
  },
  {
    label: getLabelText({ key: 'remote.common.chileanPeso', text: '智利比索' }),
    value: 'CLP',
    symbol: 'CLP$'
  },
  {
    label: getLabelText({
      key: 'remote.common.colombianPeso',
      text: '哥伦比亚比索'
    }),
    value: 'COP',
    symbol: 'Col$'
  },
  {
    label: getLabelText({ key: 'remote.common.czechKoruna', text: '捷克克朗' }),
    value: 'CZK',
    symbol: 'Kč'
  },
  {
    label: getLabelText({ key: 'remote.common.danishKrone', text: '丹麦克朗' }),
    value: 'DKK',
    symbol: 'kr'
  },
  {
    label: getLabelText({ key: 'remote.common.egyptianPound', text: '埃及镑' }),
    value: 'EGP',
    symbol: '£E'
  },
  {
    label: getLabelText({ key: 'remote.common.hongKongDollar', text: '港币' }),
    value: 'HKD',
    symbol: 'HK$'
  },
  {
    label: getLabelText({
      key: 'remote.common.indonesianRupiah',
      text: '印尼卢比'
    }),
    value: 'IDR',
    symbol: 'Rp'
  },
  {
    label: getLabelText({
      key: 'remote.common.israeliNewShekel',
      text: '以色列新谢克尔'
    }),
    value: 'ILS',
    symbol: '₪'
  },
  {
    label: getLabelText({
      key: 'remote.common.icelandicKrona',
      text: '冰岛克朗'
    }),
    value: 'ISK',
    symbol: 'kr'
  },
  {
    label: getLabelText({
      key: 'remote.common.italianLira',
      text: '意大利里拉'
    }),
    value: 'ITL',
    symbol: '₤'
  },
  {
    label: getLabelText({
      key: 'remote.common.mexicanPeso',
      text: '墨西哥比索'
    }),
    value: 'MXN',
    symbol: 'MXN$'
  },
  {
    label: getLabelText({
      key: 'remote.common.malaysianRinggit',
      text: '马来西亚令吉'
    }),
    value: 'MYR',
    symbol: 'RM'
  },
  {
    label: getLabelText({ key: 'remote.common.zloty', text: '兹罗提' }),
    value: 'PLN',
    symbol: 'zł'
  },
  {
    label: getLabelText({ key: 'remote.common.rouble', text: '俄罗斯卢布' }),
    value: 'RUB',
    symbol: '₽'
  },
  {
    label: getLabelText({
      key: 'remote.common.saudiRiyal',
      text: '沙特里亚尔'
    }),
    value: 'SAR',
    symbol: '﷼'
  },
  {
    label: getLabelText({
      key: 'remote.common.swedishKrona',
      text: '瑞典克朗'
    }),
    value: 'SEK',
    symbol: 'kr'
  },
  {
    label: getLabelText({
      key: 'remote.common.singaporeDollar',
      text: '新加坡元'
    }),
    value: 'SGD',
    symbol: 'S$'
  },
  {
    label: getLabelText({ key: 'remote.common.thaiBaht', text: '泰铢' }),
    value: 'THB',
    symbol: '฿'
  },
  {
    label: getLabelText({
      key: 'remote.common.turkishLira',
      text: '土耳其里拉'
    }),
    value: 'TRY',
    symbol: '₺'
  },
  {
    label: getLabelText({
      key: 'remote.common.southAfricanRand',
      text: '南非兰特'
    }),
    value: 'ZAR',
    symbol: 'R'
  },
  {
    label: getLabelText({
      key: 'remote.common.vietnameseDong',
      text: '越南盾'
    }),
    value: 'VRD',
    symbol: '₫'
  },
  {
    label: '缅甸元',
    value: 'MMK',
    symbol: 'K'
  },
  // 波兰添加其他抵扣项新增币种枚举
  {
    label: getLabelText({
      key: 'remote.common.currencyHungarianForint',
      text: '匈牙利福林'
    }),
    value: 'HUF'
  },
  {
    label: getLabelText({
      key: 'remote.common.currencyRomanianLeu',
      text: '罗马尼亚列亚'
    }),
    value: 'RON'
  },
  {
    label: getLabelText({
      key: 'remote.common.currencyMoroccanDirham',
      text: '摩洛哥迪拉姆'
    }),
    value: 'MAD'
  },
  {
    label: getLabelText({
      key: 'remote.common.currencyBulgarianLev',
      text: '保加利亚列弗'
    }),
    value: 'BGN'
  }
]

const currencyMap = {}
for (let i = 0; i < currencyList.length; i++) {
  const item = currencyList[i]
  currencyMap[item.value] = item.label
}

const sourceType = {
  1: getLabelText({ key: 'remote.common.income', text: '收入' }),
  2: getLabelText({ key: 'remote.common.expenditure', text: '支出' })
}

const rateTypeModules = {
  FLOAT: 0,
  FIXED: 1,
  ACTIVITY: 2,
  // PAY: 3,
  BUYNOWPRICE: 4,
  BOND: 5
}
const rateType = {
  [rateTypeModules.FLOAT]: getLabelText({
    key: 'remote.common.floatingExchangeRate',
    text: '浮动汇率'
  }),
  [rateTypeModules.FIXED]: getLabelText({
    key: 'remote.common.fixedExchangeRate',
    text: '固定汇率'
  }),
  [rateTypeModules.ACTIVITY]: getLabelText({
    key: 'remote.common.activeExchangeRate',
    text: '活动汇率'
  }),
  [rateTypeModules.BUYNOWPRICE]: getLabelText({
    key: 'remote.common.fixedExchangeRate2',
    text: '一口价汇率'
  }),
  [rateTypeModules.BOND]: getLabelText({
    key: 'remote.common.marginExchangeRate',
    text: '保证金汇率'
  })
}
// 提成基数：0：秒杀价格（通用积分也算）；1： 商品原价 ；2：固定价格
const PERCENTAGE_BASE = {
  SECKILL_PRICE: '0',
  PRODUCT_PRICE: '1',
  FIXED_RPICE: '2'
}
const VALIDOBJ = {
  NO: 0,
  YES: 1
}
const VALIDMAP = {
  [VALIDOBJ.NO]: getLabelText({
    key: 'remote.common.offTheShelf',
    text: '下架'
  }),
  [VALIDOBJ.YES]: getLabelText({
    key: 'remote.common.onTheShelf',
    text: '上架'
  })
}
const PERCENTAGE_BASE_MAP = {
  [PERCENTAGE_BASE.SECKILL_PRICE]: getLabelText({
    key: 'remote.common.actualPaidPrice',
    text: '实付价格'
  }),
  [PERCENTAGE_BASE.PRODUCT_PRICE]: getLabelText({
    key: 'remote.common.originalPriceOfGoods',
    text: '商品原价'
  }),
  [PERCENTAGE_BASE.FIXED_RPICE]: getLabelText({
    key: 'remote.common.fixedPrice',
    text: '固定价格'
  })
}

function createSelectList({ constants, map, labelField = 'label', valueField = 'value' }) {
  const list = []

  // 遍历常量对象
  for (const key in constants) {
    if (Object.hasOwnProperty.call(constants, key)) {
      const value = constants[key]

      list.push({
        [labelField]: map[value] || '',
        [valueField]: value
      })
    }
  }

  return list
}

const BILLING_DATA = new GenerateEnum({
  FULL_AMOUNT: {
    value: 2,
    textList: ['服务费：开具增值税发票', '官费: 开具Invoice'],
    tips: '官费直接跨境支付，由第三方开具Invoice',
    tipsWarn: '开具的invoice与国内普通发票具有同等效力，可作为所得税税前扣除凭证，官费不可补开增值税发票。',
    label: getLabelText({
      key: 'remote.common.clearInvoice',
      text: '清分invoice'
    })
  },
  HALF_AMOUNT: {
    value: 1,
    textList: ['全额开增值税发票'],
    tips: `${process?.env?.VUE_APP_MALL_NAME}代收官费，加收官费部分的税费，可全额开具增值税发票`,
    label: getLabelText({
      key: 'remote.common.invoicedInFull',
      text: '全额开票'
    })
  },
  PURE_OFFICIAL_INVOICE: {
    value: 3,
    textList: ['纯官费invoice'],
    label: getLabelText({
      key: 'remote.common.pureOfficialInvoice',
      text: '纯官费invoice'
    })
  },
  BALANCE_PAY_INVOICE: {
    value: 4,
    textList: ['国际支付Invoice'],
    tips: '支持外币换汇支付',
    label: getLabelText({
      key: 'remote.common.fullInvoice',
      text: '全额Invoice'
    })
  }
})
const payWay = {
  OFFLINE: 0, //线下
  WX: 2, // 微信
  ALIPAY: 1, // 支付宝
  PAYLATER: 3, // 先用后付
  BALANCE: 15, // 余额
  EOB_PAY: 16, //网银支付
  ALLIN_PAY: 17,
  AIRWALLEX_INTERNATIONAL: 13, // 空中云汇
  PINGPONG_INTERNATIONAL: 14, //pingpong
  CREDIT: 18, //预授信支付
  STRIPE: 19, // stripe支付
  ZELLE: 21, // ZELLE支付
  MASTERCARD_DOMESTIC: 23 // 万事达国内卡支付
}

const PAYMENT_METHOD = payWay

const balanceTradeType = new GenerateEnum({
  BALANCE_RECHARGE: {
    value: 0,
    label: `${getLabelText({ key: 'remote.common.recharge', text: '充值' })}+`,
    selectShow: true,
    isDistribute: true,
    isDistributeCommission: true
  },
  BALANCE_PREPARE_DEDUCT: {
    value: 1,
    label: `${getLabelText({
      key: 'remote.common.consumption',
      text: '消费'
    })}-`,
    selectShow: true,
    isDistribute: true,
    isDistributeCommission: true
  },
  /*BALANCE_CONFIRM_DEDUCT: {
        value: 2,
        label: "确认扣除",
    },*/
  BALANCE_REFUND: {
    value: 3,
    label: `${getLabelText({
      key: 'remote.common.refundForConsumption',
      text: '消费退款'
    })}+`,
    selectShow: true,
    isDistribute: true,
    isDistributeCommission: true
  },
  BALANCE_EXCHANGE: {
    value: 4,
    label: `${getLabelText({
      key: 'remote.common.serviceRedemption',
      text: '服务兑换'
    })}+`,
    selectShow: true
  },
  BALANCE_CANCEL_ORDER: {
    value: 5,
    label: `${getLabelText({
      key: 'remote.common.cancelTheOrder',
      text: '取消订单'
    })}+`
  },
  BALANCE_GIVE: {
    value: 6,
    label: `${getLabelText({
      key: 'remote.common.complimentarySystem',
      text: '系统赠送'
    })}+`,
    selectShow: true
  },
  BALANCE_WITHDRAWAL: {
    value: 7,
    label: `${getLabelText({
      key: 'remote.common.withdrawalOfBalance',
      text: '余额提现'
    })}-`,
    selectShow: true,
    isDistribute: true
  },
  CANCEL_BALANCE_WITHDRAWAL: {
    value: 10,
    label: `${getLabelText({
      key: 'remote.common.cancelWithdrawal',
      text: '取消提现'
    })}+`,
    selectShow: true
  },
  HISTORY_SCORE: {
    value: 8,
    label: `${getLabelText({
      key: 'remote.common.balanceTransferredFromHistoricalPoints',
      text: '历史积分转余额'
    })}+`, // 后端需要区分，但是前端文案是显示一样
    selectShow: true
  },
  HISTORY_SCORE_CONVERT: {
    value: 9,
    label: `${getLabelText({
      key: 'remote.common.balanceTransferredFromHistoricalPoints',
      text: '历史积分转余额'
    })}+` // 后端需要区分，但是前端文案是显示一样
  },
  COMMISSION_TO_ADD: {
    value: 11,
    label: `${getLabelText({
      key: 'remote.admin.rebateAccounting',
      text: '返佣入账'
    })}+`,
    selectShow: false,
    isDistribute: true,
    isDistributeCommission: true
  },
  COMMISSION_TO_SUBTRACTION: {
    value: 12,
    label: `${getLabelText({
      key: 'remote.admin.commissionDeduction',
      text: '佣金扣除'
    })}-`,
    selectShow: false,
    isDistribute: true,
    isDistributeCommission: true
  },
  COMMISSION_WITHDRAWAL: {
    value: 13,
    label: `${getLabelText({
      key: 'remote.admin.commissionWithdrawal',
      text: '佣金提现'
    })}-`,
    selectShow: false,
    isDistribute: false,
    isDistributeCommission: true
  }
})

const balanceTradeStatus = new GenerateEnum({
  HANDLE: {
    value: 0,
    label: getLabelText({ key: 'remote.common.processing', text: '处理中' })
  },
  SUCCESS: {
    value: 1,
    label: getLabelText({ key: 'remote.common.completed', text: '已完成' })
  },
  FAIL: {
    value: 2,
    label: getLabelText({ key: 'remote.common.failure', text: '失败' })
  },
  CANCEL: {
    value: 3,
    label: getLabelText({ key: 'remote.common.cancelled', text: '已取消' })
  }
})

const payModelModule = new GenerateEnum({
  SINGLE: {
    value: 0,
    label: getLabelText({
      key: 'remote.common.singlePayment',
      text: '单一支付'
    })
  },
  COMBINED: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.combinedPayment',
      text: '组合支付'
    })
  }
})
const isPresentedType = new GenerateEnum({
  NOMARL: {
    value: 0,
    label: getLabelText({
      key: 'remote.common.generalServiceOrder',
      text: '普通服务单'
    }),
    label2: getLabelText({
      key: 'remote.common.after-salesOrder',
      text: '售后单'
    })
  },
  CONVERT_SCORE: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.redeemPoints',
      text: '兑换积分'
    }),
    label2: getLabelText({ key: 'remote.common.exchangeNote', text: '兑换单' })
  },
  CONVERT_BALANCE: {
    value: 2,
    label: getLabelText({
      key: 'remote.common.exchangeBalance',
      text: '兑换余额'
    }),
    label2: getLabelText({ key: 'remote.common.exchangeNote', text: '兑换单' })
  }
})

const fundPaymentMethodEnum = new GenerateEnum({
  ORIGINAL_ROUTE: {
    value: 1,
    label: getLabelText({
      key: 'remote.admin.fundPaymentMethodOriginalRoute',
      text: '自动原路退款'
    })
  },
  MANUAL: {
    value: 0,
    label: getLabelText({
      key: 'remote.admin.fundPaymentMethodManual',
      text: '手动退款'
    })
  }
})
const PERCENTAGE_BASE_LIST = createSelectList({
  constants: PERCENTAGE_BASE,
  map: PERCENTAGE_BASE_MAP
})
// 活动类型，0 秒杀活动 1 满减活动 2 满送活动
const ACTIVITY_TYPE = {
  SECKILL: '0', // 秒杀活动
  FULL_DISCOUNT: '1', //满减
  FULL_GEAR: '2', //满送
  GROUP_BUY: '3', //万人团
  PRICESFOLDS: '4', // 多件多折
  BUY_SEND: '5' //买送
}
const ACTIVITY_OBJ = {
  [ACTIVITY_TYPE.SECKILL]: getLabelText({
    key: 'remote.common.secondKill',
    text: '秒杀'
  }),
  [ACTIVITY_TYPE.FULL_DISCOUNT]: getLabelText({
    key: 'remote.common.fullMinus',
    text: '满减'
  }),
  [ACTIVITY_TYPE.GROUP_BUY]: getLabelText({
    key: 'remote.common.tenThousandPeople',
    text: '万人团'
  }),
  [ACTIVITY_TYPE.PRICESFOLDS]: getLabelText({
    key: 'remote.common.multiplePiecesAndMultipleFolds',
    text: '多件多折'
  }),
  [ACTIVITY_TYPE.BUY_SEND]: getLabelText({
    key: 'remote.common.buyOneGetOneFree',
    text: '买送'
  })
}
const ACTIVITY_URL = {
  [ACTIVITY_TYPE.SECKILL]: 'secondsKillDetail',
  [ACTIVITY_TYPE.FULL_DISCOUNT]: 'fullPricesDiscountDetail',
  [ACTIVITY_TYPE.GROUP_BUY]: 'manyPeopleDetail',
  [ACTIVITY_TYPE.PRICESFOLDS]: 'pricesFoldsDetail',
  [ACTIVITY_TYPE.BUY_SEND]: 'fullPricesDiscountDetail'
}
const ACTIVITY_MENU = {
  [ACTIVITY_TYPE.SECKILL]: 'flashKillingIndex',
  [ACTIVITY_TYPE.FULL_DISCOUNT]: 'fullPricesDiscountIndex',
  [ACTIVITY_TYPE.GROUP_BUY]: 'manyPeopleIndex',
  [ACTIVITY_TYPE.PRICESFOLDS]: 'pricesFoldsIndex',
  [ACTIVITY_TYPE.BUY_SEND]: 'fullPricesDiscountIndex'
}
const country = [
  getLabelText({ key: 'remote.common.theUk', text: '英国' }),
  getLabelText({ key: 'remote.common.france', text: '法国' }),
  getLabelText({ key: 'remote.common.germany', text: '德国' }),
  getLabelText({ key: 'remote.common.italy', text: '意大利' }),
  getLabelText({ key: 'remote.common.spain', text: '西班牙' }),
  getLabelText({ key: 'remote.common.poland', text: '波兰' }),
  getLabelText({ key: 'remote.common.czechRepublic', text: '捷克' }),
  getLabelText({ key: 'remote.common.netherlands', text: '荷兰' }),
  getLabelText({ key: 'remote.common.austria', text: '奥地利' }),
  getLabelText({ key: 'remote.common.belgium', text: '比利时' }),
  getLabelText({ key: 'remote.common.sweden', text: '瑞典' })
]

const productNameType = {
  0: getLabelText({ key: 'remote.common.commonGoods', text: '普通商品' }),
  1: getLabelText({
    key: 'remote.common.goodsAtOfficialExpense',
    text: '官费商品'
  }),
  2: getLabelText({ key: 'remote.common.packageGoods', text: '套餐商品' })
}
const SENDWAYKEY = {
  REGISTER: '0',
  INVITATION: '1',
  PROMOTION: '2',
  LIKES: '3',
  RECRUITMENT: '4',
  EXCHANGE: '5',
  EXHIBITION: '6',
  VOUCHER_CENTER: '7',
  PROMOTION_ACTIVITY: '8',
  FULL_SEND: '9',
  BUY_SEND: '11',
  VIP_EXCLUSIVE: '12',
  LZ_QUESTION: '13'
}
// 1购物车，2订单确认页
const CART_TYPE = {
  CART: 1,
  ORDER_COMFIRM: 2
}
const sendWay = [
  {
    value: SENDWAYKEY.REGISTER,
    text: getLabelText({
      key: 'remote.common.signUpForRewards',
      text: '注册奖励'
    })
  },
  {
    value: SENDWAYKEY.INVITATION,
    text: getLabelText({
      key: 'remote.common.invitationReward',
      text: '邀请奖励'
    })
  },
  {
    value: SENDWAYKEY.PROMOTION,
    text: getLabelText({
      key: 'remote.common.promotionReward',
      text: '推广奖励'
    })
  },
  {
    value: SENDWAYKEY.LIKES,
    text: getLabelText({
      key: 'remote.common.userMarketingReward',
      text: '用户营销奖励'
    })
  },
  {
    value: SENDWAYKEY.RECRUITMENT,
    text: getLabelText({
      key: 'remote.common.recruitmentReward',
      text: '招募奖励'
    })
  },
  {
    value: SENDWAYKEY.EXHIBITION,
    text: getLabelText({
      key: 'remote.common.scanAndGetReward',
      text: '扫码即送奖励'
    })
  },
  {
    value: SENDWAYKEY.VOUCHER_CENTER,
    text: getLabelText({
      key: 'remote.common.couponCenterReward',
      text: '领券中心奖励'
    })
  },
  {
    value: SENDWAYKEY.PROMOTION_ACTIVITY,
    text: getLabelText({
      key: 'remote.common.promotionalActivityReward',
      text: '促销活动奖励'
    })
  },
  {
    value: SENDWAYKEY.FULL_SEND,
    text: getLabelText({
      key: 'remote.common.eventMarketingReward',
      text: '活动营销奖励'
    })
  },
  {
    value: SENDWAYKEY.BUY_SEND,
    text: getLabelText({
      key: 'remote.common.purchaseObtained',
      text: '购买获得'
    })
  },
  {
    value: SENDWAYKEY.VIP_EXCLUSIVE,
    text: getLabelText({
      key: 'remote.common.memberExclusiveReward',
      text: '会员专属奖励'
    })
  },
  {
    value: SENDWAYKEY.LZ_QUESTION,
    text: getLabelText({
      key: 'remote.common.submitRewardsForRetainingFunds',
      text: '留资提交奖励'
    })
  }
]
const fifterAwardIncident = sendWay
// 体验会员标识
const EXPERIENCE_VIP = {
  NO: 0, // 不是体验会员，但有可能是普通的会员
  EXPERIENCE_NO_DISCOUNT: -1, // 体验会员，但是没有商品会员价次数
  EXPERIENCE_HAS_DISCOUNT: 1, // 体验会员，有商品会员价次数
  EXPERIENCE_FIRST_PIECT: 2 // 首件体验会员
}
// 固定汇率的前缀
const FIXED_CURRENCY_PREFIX = {
  en: 'FX_',
  zh: getLabelText({ key: 'remote.common.fixed', text: '固定' })
}
// 会员类型
const VIP_TYPE = {
  NO: 0, // 非会员
  VIP: 1,
  SVIP: 2
}

// 会员类型反射
const VIP_TYPE_MAP = {
  [VIP_TYPE.NO]: getLabelText({
    key: 'remote.common.ordinaryUser',
    text: '普通用户'
  }),
  [VIP_TYPE.VIP]: 'VIP',
  [VIP_TYPE.SVIP]: 'SVIP'
}
// 体验会员类型
const EXPERIENCE_VIP_TYPE = {
  VIP: 3,
  SVIP: 4
}

const EXPERIENCE_VIP_TYPE_MAP = {
  [EXPERIENCE_VIP_TYPE.VIP]: getLabelText({
    key: 'remote.common.vipExperience',
    text: '体验VIP'
  }),
  [EXPERIENCE_VIP_TYPE.SVIP]: getLabelText({
    key: 'remote.common.svipExperience',
    text: '体验SVIP'
  })
}

// 所有的VIP类型
const ALL_VIP_TYPE_MAP = {
  ...VIP_TYPE_MAP,
  ...EXPERIENCE_VIP_TYPE_MAP
}
/* 商品会员体系
 *  1-会员体系
 *  2-非会员体系
 */
const PRICE_TYPE = {
  VIP: 1,
  NO_VIP: 2
}
const PRODUCTVALID = {
  0: getLabelText({ key: 'remote.common.offTheShelf', text: '下架' }),
  1: getLabelText({ key: 'remote.common.onTheShelf', text: '上架' })
}
const PRODUCTONSHOW = {
  0: getLabelText({ key: 'remote.common.doNotDisplay', text: '不显示' }),
  1: getLabelText({ key: 'remote.common.show', text: '显示' })
}
// 是否包含官费（0否，1是）
const OFFICIAL_IS_INCLUDE = {
  NO: '0',
  YES: '1'
}
const IS_BOOLEAN_NAME = {
  [OFFICIAL_IS_INCLUDE.NO]: getLabelText({
    key: 'remote.common.no.text',
    text: '否'
  }),
  [OFFICIAL_IS_INCLUDE.YES]: getLabelText({
    key: 'remote.common.yes',
    text: '是'
  })
}
const ISSALETYPE = {
  NOW: {
    key: 0,
    value: getLabelText({
      key: 'remote.common.startSellingImmediately',
      text: '立即开售'
    })
  },
  STOP: {
    key: 1,
    value: getLabelText({ key: 'remote.common.stopSelling', text: '停售' })
  },
  TIMING: {
    key: 2,
    value: getLabelText({
      key: 'remote.common.scheduleStartOfSales',
      text: '定时开售'
    })
  },
  DEPOSIT: {
    key: 3,
    value: getLabelText({
      key: 'remote.common.depositPre-sale',
      text: '定金预售'
    })
  }
}

//业务
const MODULE_TYPE_OBJ = {
  OST: '00',
  IPP: '01',
  XM: '04',
  LD: '08',
  TH: '13',
  LZ: '15',
  YS: '21',
  LY: '22',
  NB: '23'
}
// 商品中心，属性标记
const ATTRIBUTE_SIGN = {
  isIncludeDrawing: 'isIncludeDrawing', // 是否含绘图
  isAccelerate: 'isAccelerate', // 是否加速审查
  isAuthorize: 'isAuthorize', // 是否授权
  entityType: 'entityType', // 实体类型
  isConfigApply: 'isConfigApply', // 系列申请
  isApplyType: 'isApplyType' // 申请基底
}
// 外观专利-属性标记 美国商标注册申请基底-属性标记
const DESIGN_PATENT_ATTR_SIGN = {
  [ATTRIBUTE_SIGN.isIncludeDrawing]: true,
  [ATTRIBUTE_SIGN.isAccelerate]: true,
  [ATTRIBUTE_SIGN.isAuthorize]: true,
  [ATTRIBUTE_SIGN.entityType]: true,
  [ATTRIBUTE_SIGN.isConfigApply]: true,
  [ATTRIBUTE_SIGN.isApplyType]: true
}
const businessPlatform = new GenerateEnum({
  OST: {
    value: MODULE_TYPE_OBJ.OST,
    label: getLabelText({
      key: 'remote.common.VATEPRCompliance',
      text: 'VAT、EPR、合规'
    }),
    systemTypeLabel: getLabelText({
      key: 'remote.enumerate.vatEprPlus',
      text: 'VAT/EPR+'
    })
  },
  IPP: {
    value: MODULE_TYPE_OBJ.IPP,
    label: getLabelText({
      key: 'remote.common.trademarkAndPatent',
      text: '商标专利'
    }),
    systemTypeLabel: getLabelText({
      key: 'remote.common.trademarkAndPatent',
      text: '商标专利'
    })
  },
  XM: {
    value: MODULE_TYPE_OBJ.XM,
    label: getLabelText({
      key: 'remote.common.overseasIndustryAndCommerce',
      text: '境外工商'
    }),
    systemTypeLabel: getLabelText({
      key: 'remote.common.overseasIndustryAndCommerce',
      text: '境外工商'
    })
  },
  LZ: {
    value: MODULE_TYPE_OBJ.LZ,
    label: getLabelText({
      key: 'remote.common.productCertificationAndTesting',
      text: '产品认证与检测'
    }),
    systemTypeLabel: getLabelText({
      key: 'remote.common.productCertificationAndTesting',
      text: '产品认证与检测'
    })
  }
})
let mapImg = {
  [businessPlatform.XM]: process.env.VUE_APP_DEFAULTHEADER_XM,
  [businessPlatform.IPP]: process.env.VUE_APP_DEFAULTHEADER_IPP
}
const isDefaultImg = mapImg[globalThis().appName] ? mapImg[globalThis().appName] : process.env.VUE_APP_DEFAULTHEADER
const LIUDUTYPENAME = getLabelText({
  key: 'remote.common.sixDegreesInternational',
  text: '六度信息'
})

const HEADERSYSTEMTYPE = '99'
const specialOrderListEnum = new GenerateEnum({
  NOMAL: {
    value: 0,
    label: getLabelText({ key: 'remote.common.regularOrder', text: '普通订单' })
  },
  NEW: {
    value: 1,
    label:
      getLabelText({
        key: 'remote.common.universalOrder',
        text: '万能订单'
      }) +
      '-' +
      getLabelText({ key: 'remote.common.newService', text: '新服务' })
  },
  VAT_ADD: {
    value: 2,
    label:
      getLabelText({
        key: 'remote.common.universalOrder',
        text: '万能订单'
      }) +
      '-' +
      getLabelText({
        key: 'remote.common.vatValue-addedService',
        text: 'VAT增值服务'
      })
  },
  EPR_ADD: {
    value: 3,
    label:
      getLabelText({
        key: 'remote.common.universalOrder',
        text: '万能订单'
      }) +
      '-' +
      getLabelText({
        key: 'remote.common.eprValue-addedService',
        text: 'EPR增值服务'
      })
  },
  OC: {
    value: 4,
    label: getLabelText({
      key: 'remote.common.ocAccountingAudit',
      text: 'OC做账审计'
    })
  },
  OC_RENEW: {
    value: 5,
    label: getLabelText({ key: 'remote.common.ocRenewal', text: 'OC续费' })
  },
  LZ_ADD: {
    value: 7,
    label: getLabelText({
      key: 'remote.enumerate.addOrderType',
      text: '追加订单'
    })
  },
  LZ_PAY_TOGETHER: {
    value: 8,
    label: getLabelText({
      key: 'remote.enumerate.fixedPriceOrderType',
      text: '一口价订单'
    })
  }
})

const attachFeeTypeEnum = new GenerateEnum({
  SERVICE: {
    value: 1,
    label: getLabelText({ key: 'remote.common.serviceCharge', text: '服务费' })
  },
  OFFICIAL: {
    value: 2,
    label: getLabelText({ key: 'remote.common.officialExpenses', text: '官费' })
  },
  BOND: {
    value: 3,
    label: getLabelText({ key: 'remote.common.deposit', text: '保证金' })
  },
  REFUND: {
    value: 4,
    label: getLabelText({ key: 'remote.common.recoveryFee', text: '回收费' })
  }
})
const probabilityTask = new GenerateEnum({
  TASK: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.completeConfigurationTask',
      text: '完成配置任务'
    })
  },
  LOGIN: {
    value: 2,
    label: getLabelText({
      key: 'remote.common.newAndExistingUsersLoggingInWithinTheLimitedTime',
      text: '在限定的时间内登录的新老用户'
    })
  },
  PAYORDER: {
    value: 3,
    label: getLabelText({ key: 'remote.common.orderingUser', text: '下单用户' })
  },
  PAYORDERMONEY: {
    value: 4,
    label: getLabelText({
      key: 'remote.common.paidAmountAchieved',
      text: '付费金额达成'
    })
  }
})
const drawForm = new GenerateEnum({
  TURNTABLE: {
    value: 1,
    label: getLabelText({ key: 'remote.common.spinningWheel', text: '转盘' })
  },
  REDPACKET: {
    value: 2,
    label: getLabelText({ key: 'remote.common.redPacket', text: '拆红包' })
  },
  TREASUREHUNT: {
    value: 3,
    label: getLabelText({ key: 'remote.common.treasureHunt', text: '寻宝' })
  }
})
const luckyDrawOpportunity = new GenerateEnum({
  INVITE: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.forEachInvitedFriendsRegistration',
      text: '每邀请1位好友注册'
    }),
    icon: 'haoyouzhuce',
    type: 'other',
    btnText: getLabelText({ key: 'remote.common.toFinish', text: '去完成' })
  },
  SHAREANDPAY: {
    value: 10,
    label: getLabelText({
      key: 'remote.common.inviteFriendsToRegisterAndInvitedFriendsPay',
      text: '邀请好友注册，且受邀好友付费'
    }),
    icon: 'haoyouzhuce',
    type: 'other',
    btnText: getLabelText({ key: 'remote.common.toFinish', text: '去完成' })
  },
  PAYAMOUNT: {
    value: 2,
    label: getLabelText({
      key: 'remote.common.paidDuringTheEvent',
      text: '活动期间付费'
    }),
    icon: 'dingdan',
    type: 'other',
    btnText: getLabelText({ key: 'remote.common.toFinish', text: '去完成' })
  },
  XIAOMAOACCOUNT: {
    value: 3,
    label: getLabelText({
      key: 'remote.common.followXiaomaoChuhaiWechatPublicAccount',
      text: '关注小贸出海微信公众号'
    }),
    icon: 'xiaomaochuhai',
    type: 'other',
    btnText: getLabelText({ key: 'remote.common.toFinish', text: '去完成' })
  },
  XIAOMAOMP: {
    value: 4,
    label: getLabelText({
      key: 'remote.common.bindXiaomaoChuhaiWechatMiniProgram',
      text: '绑定小贸出海微信小程序'
    }),
    icon: 'bangding',
    type: 'bind',
    btnText: getLabelText({
      key: 'remote.common.bindXiaoMaoChuHai',
      text: '绑定小贸出海'
    })
  },
  XIAOMAOFIRSTPAY: {
    value: 5,
    label: getLabelText({
      key: 'remote.common.completeFirstPaymentOnXiaomaoChuhai',
      text: '在小贸出海完成首次付费'
    }),
    icon: 'xiaomaochuhai',
    type: 'firstBuy',
    btnText: getLabelText({ key: 'remote.common.toFinish', text: '去完成' })
  },
  SHAREOSTMP: {
    value: 6,
    label: getLabelText({
      key: 'remote.common.shareOuShuiTongWechatMiniProgram',
      text: '分享欧税通微信小程序'
    }),
    icon: 'xiaochengxu',
    type: 'share',
    btnText: getLabelText({
      key: 'remote.common.shareeVatMaster',
      text: '分享欧税通'
    })
  },
  OSTMP: {
    value: 7,
    label: getLabelText({
      key: 'remote.common.bindOuShuiTongWechatMiniProgram',
      text: '绑定欧税通微信小程序'
    }),
    icon: 'bangding',
    type: 'bind',
    btnText: getLabelText({
      key: 'remote.common.bindOuShuiTong',
      text: '绑定欧税通'
    })
  },
  SHAREIPPMP: {
    value: 8,
    label: getLabelText({
      key: 'remote.common.shareMaidTongWechatMiniProgram',
      text: '分享麦德通微信小程序'
    }),
    icon: 'xiaochengxu',
    type: 'share',
    btnText: getLabelText({
      key: 'remote.common.shareMaidTong',
      text: '分享麦德通'
    })
  },
  IPPMP: {
    value: 9,
    label: getLabelText({
      key: 'remote.common.bindMaidTongWechatMiniProgram',
      text: '绑定麦德通微信小程序'
    }),
    icon: 'bangding',
    type: 'bind',
    btnText: getLabelText({
      key: 'remote.common.bindMaidTong',
      text: '绑定麦德通'
    })
  },
  POINTSDRAW: {
    value: 11,
    label: getLabelText({
      key: 'remote.common.consumptionPoints',
      text: '消耗积分'
    }),
    icon: 'jifenmingxi',
    type: 'other',
    btnText: getLabelText({ key: 'remote.common.toExchange', text: '去兑换' })
  }
})
const cancellationType = new GenerateEnum({
  SIGNOUT: {
    value: '0',
    label: getLabelText({
      key: 'remote.common.cancelTheCategory',
      text: '注销品类'
    })
  },
  WEEECODE: {
    value: '1',
    label: getLabelText({
      key: 'remote.common.unregisterTheRegistrationCode',
      text: '套餐商品'
    })
  }
})
const couponisLimitCountType = new GenerateEnum({
  NO: {
    value: 0,
    label: getLabelText({ key: 'remote.common.unlimited', text: '不限' })
  },
  YES: {
    value: 1,
    label: getLabelText({ key: 'remote.common.restrictions', text: '限制' })
  },
  //每月限制
  MONTH: {
    value: 2,
    label: getLabelText({ key: 'remote.common.monthlyLimit', text: '套餐商品' })
  }
})
const couponBtnStatus = new GenerateEnum({
  DRAWDOWN: {
    value: 1,
    label: getLabelText({ key: 'remote.common.getItNow', text: '立即领取' })
  },
  USE: {
    value: 2,
    label: getLabelText({
      key: 'remote.common.useImmediately',
      text: '立即使用'
    })
  },
  USED: {
    value: 3,
    label: getLabelText({ key: 'remote.common.used', text: '已使用' }),
    disabled: true
  },
  EXPIRED: {
    value: 4,
    label: getLabelText({ key: 'remote.common.expired', text: '已过期' }),
    disabled: true
  }
})
const LS_KEY = {
  GF_MERGE_PAY_LIST: 'GF_MERGE_PAY_LIST', // 官费合并支付的id列表
  LOGIN_TYPE_KEY: 'loginType', // 登录类型
  LOGIN_DETAIL_TYPE: 'loginDetailType', // 登录详情类型
  deviceId: 'deviceId', // 设备id
  isProxyOrder: 'isProxyOrder' // admin代客户加购，会隐藏部分功能
}

// 申报相关信息 枚举又有问题 后端的declareType存的是number
const DECLARE_TYPE_ENUM_DATA = {
  VAT_DECLARE: {
    value: '0',
    label: getLabelText({
      key: 'remote.common.vatDeclaration',
      text: 'VAT申报'
    })
  },
  GERMANY_ANNUAL: {
    value: '1',
    label: getLabelText({ key: 'remote.common.germanAnnals', text: '德国年报' })
  },
  MANUAL_VAT: {
    value: '2',
    label: getLabelText({
      key: 'remote.common.manualVatDeclaration',
      text: '手动VAT申报'
    })
  },
  VAT_ZM_DECLARE: {
    value: '3',
    label: getLabelText({
      key: 'remote.common.vatBbDeclaration',
      text: 'VAT+B2B申报'
    })
  },
  ZM_DECLARE: {
    value: '4',
    label: getLabelText({ key: 'remote.common.bbDeclaration', text: 'B2B申报' })
  },
  ITALY_ANNUAL: {
    value: '5',
    label: getLabelText({
      key: 'remote.common.italianAnnualSummaryDeclaration',
      text: '意大利年度汇总申报'
    })
  },
  ES_YEAR_DECLARE: {
    value: '6',
    label: getLabelText({
      key: 'remote.common.spanishAnnualSummaryDeclaration',
      text: '西班牙年度汇总申报'
    })
  },
  DE_B2B_AMENDMENT: {
    value: '7',
    label: getLabelText({
      key: 'remote.common.germanB2bDeclarationCorrection',
      text: '德国B2B申报修正'
    })
  },
  AT_ANNUAL: {
    value: '8',
    label: getLabelText({
      key: 'remote.common.austrianAnnualSummaryDeclaration',
      text: '奥地利年度汇总申报'
    })
  },
  UK_MANUAL_DECLARE: {
    value: '9',
    label: getLabelText({
      key: 'remote.common.ukManualTaxDeclarationForOver2Years',
      text: '英国超过2年手动算税申报'
    })
  },
  YEAR_SUM_DECLARE: {
    value: '10',
    label: getLabelText({
      key: 'remote.common.summarizeTheAnnualReport',
      text: '汇总年报'
    })
  },
  PRE_PAYMENT: {
    value: '11',
    label: getLabelText({
      key: 'remote.declare.calculateTaxModalRevisionV2.prepayment',
      text: '预缴纳'
    })
  }
}
const CHINESE_AI_IDENTIFY_STATUS_ENUM_STR = '排队中,文件类型解析中,AI识别中,AI识别不完整,AI识别成功,AI识别失败,AI识别超时,AI识别取消,AI识别停用'
// 添加新的枚举
const AI_IDENTIFY_STATUS_ENUM = new GenerateEnum({
  WAIT_ANALYSE: {
    label: getLabelText({
      key: 'remote.declare.calculateTaxModalRevisionV2.aiIdentifyStatusEnum',
      text: CHINESE_AI_IDENTIFY_STATUS_ENUM_STR
    }).split(',')[0],
    value: 'wait_analyse'
  },
  FILE_TYPE_ANALYSE: {
    label: getLabelText({
      key: 'remote.declare.calculateTaxModalRevisionV2.aiIdentifyStatusEnum',
      text: CHINESE_AI_IDENTIFY_STATUS_ENUM_STR
    }).split(',')[2],
    value: 'file_type_analyse'
  },
  CONTENT_ANALYSE: {
    label: getLabelText({
      key: 'remote.declare.calculateTaxModalRevisionV2.aiIdentifyStatusEnum',
      text: CHINESE_AI_IDENTIFY_STATUS_ENUM_STR
    }).split(',')[2],
    value: 'content_analyse'
  },
  ANALYSE_INCOMPLETE: {
    label: getLabelText({
      key: 'remote.declare.calculateTaxModalRevisionV2.aiIdentifyStatusEnum',
      text: CHINESE_AI_IDENTIFY_STATUS_ENUM_STR
    }).split(',')[3],
    value: 'analyse_incomplete',
    color: '#F8AF17',
    icon: 'buwanzheng',
    className: 'ost-color-orange'
  },
  ANALYSE_SUCCESS: {
    label: getLabelText({
      key: 'remote.declare.calculateTaxModalRevisionV2.aiIdentifyStatusEnum',
      text: CHINESE_AI_IDENTIFY_STATUS_ENUM_STR
    }).split(',')[4],
    value: 'analyse_success',
    icon: 'zhengque',
    color: '#27C688',
    className: 'text-success fz18'
  },
  ANALYSE_FAIL: {
    label: getLabelText({
      key: 'remote.declare.calculateTaxModalRevisionV2.aiIdentifyStatusEnum',
      text: CHINESE_AI_IDENTIFY_STATUS_ENUM_STR
    }).split(',')[5],
    value: 'analyse_fail'
  },
  ANALYSE_TIMEOUT: {
    label: getLabelText({
      key: 'remote.declare.calculateTaxModalRevisionV2.aiIdentifyStatusEnum',
      text: CHINESE_AI_IDENTIFY_STATUS_ENUM_STR
    }).split(',')[6],
    value: 'analyse_timeout',
    icon: 'zhuyi',
    className: 'fz18',
    color: '#F5222D'
  },
  ANALYSE_CANCEL: {
    label: getLabelText({
      key: 'remote.declare.calculateTaxModalRevisionV2.aiIdentifyStatusEnum',
      text: CHINESE_AI_IDENTIFY_STATUS_ENUM_STR
    }).split(',')[7],
    value: 'analyse_cancel',
    icon: 'cha',
    color: '#F5222D'
  },
  ANALYSE_UNUSE: {
    label: getLabelText({
      key: 'remote.declare.calculateTaxModalRevisionV2.aiIdentifyStatusEnum',
      text: CHINESE_AI_IDENTIFY_STATUS_ENUM_STR
    }).split(',')[8],
    value: 'analyse_unuse',
    icon: 'cha',
    color: '#F5222D'
  }
})

const CHINESE_AI_IDENTIFY_DETAIL_STATUS_ENUM_STR = '待处理,处理中,识别成功,识别失败,文件损坏,识别失败'
const AI_IDENTIFY_DETAIL_STATUS_ENUM = new GenerateEnum({
  PENDING: {
    label: getLabelText({
      key: 'remote.declare.calculateTaxModalRevisionV2.aiIdentifyDetailStatusEnum',
      text: CHINESE_AI_IDENTIFY_DETAIL_STATUS_ENUM_STR
    }).split(',')[0],
    value: 0
  },
  PROCESSING: {
    label: getLabelText({
      key: 'remote.declare.calculateTaxModalRevisionV2.aiIdentifyDetailStatusEnum',
      text: CHINESE_AI_IDENTIFY_DETAIL_STATUS_ENUM_STR
    }).split(',')[1],
    value: 1
  },
  SUCCESS: {
    label: getLabelText({
      key: 'remote.declare.calculateTaxModalRevisionV2.aiIdentifyDetailStatusEnum',
      text: CHINESE_AI_IDENTIFY_DETAIL_STATUS_ENUM_STR
    }).split(',')[2],
    value: 2,
    className: 'text-success',
    icon: 'zhengque'
  },
  FAIL: {
    label: getLabelText({
      key: 'remote.declare.calculateTaxModalRevisionV2.aiIdentifyDetailStatusEnum',
      text: CHINESE_AI_IDENTIFY_DETAIL_STATUS_ENUM_STR
    }).split(',')[3],
    value: 3,
    color: '#F5222D',
    className: 'text-danger',
    icon: 'cha'
  },
  DAMAGED: {
    label: getLabelText({
      key: 'remote.declare.calculateTaxModalRevisionV2.aiIdentifyDetailStatusEnum',
      text: CHINESE_AI_IDENTIFY_DETAIL_STATUS_ENUM_STR
    }).split(',')[4],
    value: 4,
    color: '#F5222D',
    className: 'text-danger',
    icon: 'cha'
  },
  MANUAL: {
    label: getLabelText({
      key: 'remote.declare.calculateTaxModalRevisionV2.aiIdentifyDetailStatusEnum',
      text: CHINESE_AI_IDENTIFY_DETAIL_STATUS_ENUM_STR
    }).split(',')[5],
    value: 5,
    color: '#F5222D',
    className: 'text-danger',
    icon: 'cha'
  }
})

const DECLARE_TYPE_ENUM = Object.fromEntries(Object.entries(DECLARE_TYPE_ENUM_DATA).map(([, { value, label }]) => [value, label]))
const DECLARE_TYPE_OPTIONS = Object.keys(DECLARE_TYPE_ENUM)
  .map((item) => {
    if (['0', '3', '4', '10', '11'].includes(item)) {
      return { label: DECLARE_TYPE_ENUM[item], value: item }
    }
  })
  .filter((item) => item)
const recordListDeclaerType = DECLARE_TYPE_OPTIONS.filter((item) => !['3'].includes(item.value))
const ORDER_STATUS = new GenerateEnum({
  PENDING_PAYMENT: {
    value: 0,
    label: getLabelText({ key: 'remote.common.toBePaid', text: '待付款' })
  },
  PENDING_CONFIRM: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.paymentToBeConfirmed',
      text: '支付待确认'
    })
  },
  CANCELLED: {
    value: 2,
    label: getLabelText({ key: 'remote.common.cancelled', text: '已取消' })
  },
  PAID: {
    value: 3,
    label: getLabelText({ key: 'remote.common.paid', text: '已付款' })
  },
  COMPLETED: {
    value: 4,
    label: getLabelText({ key: 'remote.common.completed', text: '已完成' })
  },
  REFUNDED: {
    value: 5,
    label: getLabelText({ key: 'remote.common.refunded', text: '已退款' })
  },
  DEPOSIT_PENDING_PAYMENT: {
    value: 6,
    label: getLabelText({
      key: 'remote.common.depositToBePaid',
      text: '定金待付款'
    })
  },
  DEPOSIT_PENDING_CONFIRM: {
    value: 7,
    label: getLabelText({
      key: 'remote.common.depositPaymentToBeConfirmed',
      text: '定金支付待确认'
    })
  },
  ABLANCE_PENDING_PAYMENT: {
    value: 8,
    label: getLabelText({
      key: 'remote.common.depositToBePaid',
      text: '尾款待付款'
    })
  },
  ABLANCE_PENDING_CONFIRM: {
    value: 9,
    label: getLabelText({
      key: 'remote.common.finalPaymentToBeConfirmed',
      text: '尾款支付待确认'
    })
  },
  DEPOSIT_CANCELLED: {
    value: 10,
    label: getLabelText({
      key: 'remote.common.theDepositHasBeenCancelled',
      text: '定金已取消'
    })
  },
  ABLANCE_CANCELLED: {
    value: 11,
    label: getLabelText({
      key: 'remote.common.theFinalPaymentHasBeenCancelled',
      text: '尾款已取消'
    })
  },
  AFTER_PAY_ORDERED: {
    value: 12,
    label: getLabelText({
      key: 'remote.common.theOrderHasBeenPlaced',
      text: '已下单'
    })
  }
})
// 售后单状态
const afterSalesOrderStatus = new GenerateEnum({
  TOBESUBMITTED: {
    value: 0,
    label: getLabelText({ key: 'remote.common.toBeSubmitted', text: '待提交' })
  },
  AUDIT: {
    value: 1,
    label: getLabelText({ key: 'remote.common.toBeReviewed', text: '待审核' })
  },
  REFUNDING: {
    value: 2,
    label: getLabelText({
      key: 'remote.common.refundInProgress',
      text: '退款中'
    })
  },
  REFUNDED: {
    value: 3,
    label: getLabelText({ key: 'remote.common.refunded', text: '已退款' })
  },
  REJECT: {
    value: 4,
    label: getLabelText({ key: 'remote.common.rejected', text: '已驳回' })
  },
  CANCEL: {
    value: 5,
    label: getLabelText({ key: 'remote.common.cancelled', text: '已取消' })
  },
  EXCHANGE_FAIL: {
    value: 7,
    label: getLabelText({
      key: 'remote.common.exchangeFailed',
      text: '兑换失败'
    })
  }
})

// 订单类型
const ORDER_TYPE = {
  SERVER_ORDER: '0', // 服务订单
  OFFICIAL_ORDER: '1', // 官费订单
  OFFICIAL_SC_ORDER: '2', // 审查意见订单
  APPROVED_HZ_REGISTRATION: '3', // 核准注册订单
  INTENT_NOA_APPLY: '4', // 意向申请订单
  // 专利订单类型 v1.4 版本暂时取消
  //    PATENT_ORDER: "5", // 专利订单
  BALANCE_RECHARGE_ORDER: '6', // 余额充值订单
  AUTHORIZE_OFFICIAL_ORDER: '7', // 授权费用订单
  OBJECTION: '8', //异议答辩订单
  BOND_ORDER: '9' // 保证金订单
}

// EPR注销枚举
const EPR_LOG_OFF_LIST = {
  WEEE_LOG_OFF: '301',
  PACKAGE_LOG_OFF: '302',
  BATTERY_LOG_OFF: '303',
  TEXTILE_LOG_OFF: '315',
  HOME_HAIR_LOG_OFF: '316',
  TOY_LOG_OFF: '322',
  PAPER_LOG_OFF: '323',
  TYRE_LOG_OFF: '324',
  SPORT_LOG_OFF: '325',
  DIY_LOG_OFF: '326',
  PLASTIC_CANCELLATION_SERVCIE: '328'
}

// 枚举对应的值
const GET_LOG_OFF_W3ETYPE = {
  [EPR_LOG_OFF_LIST.WEEE_LOG_OFF]: 'weeeCancellation',
  [EPR_LOG_OFF_LIST.PACKAGE_LOG_OFF]: 'packingCancellation',
  [EPR_LOG_OFF_LIST.BATTERY_LOG_OFF]: 'batteryCancellation',
  [EPR_LOG_OFF_LIST.TEXTILE_LOG_OFF]: 'textileCancellation',
  [EPR_LOG_OFF_LIST.HOME_HAIR_LOG_OFF]: 'homeHairCancellation',
  [EPR_LOG_OFF_LIST.TOY_LOG_OFF]: 'toyCancellation',
  [EPR_LOG_OFF_LIST.PAPER_LOG_OFF]: 'paperCancellation',
  [EPR_LOG_OFF_LIST.TYRE_LOG_OFF]: 'tyreCancellation',
  [EPR_LOG_OFF_LIST.SPORT_LOG_OFF]: 'sportCancellation',
  [EPR_LOG_OFF_LIST.DIY_LOG_OFF]: 'diyCancellation',
  [EPR_LOG_OFF_LIST.PLASTIC_CANCELLATION_SERVCIE]: 'plasticTaxCancellation'
}
const DEADLINE_LIST = [
  {
    label: getLabelText({ key: 'remote.common.whole', text: '全部' }),
    value: ''
  },
  {
    label: getLabelText({ key: 'remote.common.deadline1', text: '7天内' }),
    value: '1'
  },
  {
    label: getLabelText({ key: 'remote.common.deadline2', text: '8-15天内' }),
    value: '2'
  },
  {
    label: getLabelText({ key: 'remote.common.deadline3', text: '16-30天内' }),
    value: '3'
  },
  {
    label: getLabelText({ key: 'remote.common.deadline4', text: '30天以上' }),
    value: '4'
  },
  {
    label: getLabelText({ key: 'remote.common.deadline5', text: '已超期' }),
    value: '5'
  },
  {
    label: getLabelText({ key: 'remote.common.deadline6', text: '无期限' }),
    value: '6'
  }
]
const InvoiceIdentifyEnum = new GenerateEnum({
  AUDIT_SUCCESS: {
    value: '-2',
    label: getLabelText({
      key: 'remote.common.offlinePaymentAuditPassed',
      text: '线下打款审核通过'
    })
  },
  WAIT_CONFIRM: {
    value: '-1',
    label: getLabelText({ key: 'remote.common.toBeConfirmed', text: '待确认' })
  },
  PEND_AUDIT: {
    value: '0',
    label: getLabelText({ key: 'remote.common.toBeReviewed', text: '待审核' })
  },
  PROCESS: {
    value: '1',
    label: getLabelText({ key: 'remote.common.invoicing', text: '开票中' })
  },
  SUCCESS: {
    value: '2',
    label: getLabelText({
      key: 'remote.common.invoicingSucceeded',
      text: '开票成功'
    })
  },
  FAIL: {
    value: '3',
    label: getLabelText({
      key: 'remote.common.invoicingFailed',
      text: '开票失败'
    })
  },
  CANCELLATION: {
    value: '4',
    label: getLabelText({ key: 'remote.common.voided', text: '已作废' })
  },
  WRITE_OFF: {
    value: '5',
    label: getLabelText({
      key: 'remote.common.fullAmountOfRedFlush',
      text: '全额红冲'
    })
  },
  REJECT: {
    value: '6',
    label: getLabelText({ key: 'remote.common.rejected2', text: '驳回' })
  },
  PEND_CUSTOMER_AUDIT: {
    value: '7',
    label: getLabelText({
      key: 'remote.common.pendingCustomerConfirmation',
      text: '待客户确认'
    })
  },
  CANCELED: {
    value: '8',
    label: getLabelText({ key: 'remote.common.cancelled', text: '已取消' })
  },
  MAINTENANCE: {
    value: '9',
    label: getLabelText({
      key: 'remote.common.operationsAndMaintenanceGeneration',
      text: '运维生成'
    })
  }
})

const residenceStateEnum = new GenerateEnum({
  AL: {
    value: '1',
    label: getLabelText({ key: 'remote.common.alabama', text: '阿拉巴马州' })
  },
  AK: {
    value: '2',
    label: getLabelText({ key: 'remote.common.alaska', text: '阿拉斯加州' })
  },
  AZ: {
    value: '3',
    label: getLabelText({ key: 'remote.common.arizona', text: '亚利桑那州' })
  },
  AR: {
    value: '4',
    label: getLabelText({ key: 'remote.common.arkansas', text: '阿肯色州' })
  },
  CA: {
    value: '5',
    label: getLabelText({
      key: 'remote.common.california',
      text: '加利福尼亚州'
    })
  },
  CO: {
    value: '6',
    label: getLabelText({ key: 'remote.common.colorado', text: '科罗拉多州' })
  },
  CT: {
    value: '7',
    label: getLabelText({
      key: 'remote.common.connecticut',
      text: '康涅狄格州'
    })
  },
  DE: {
    value: '8',
    label: getLabelText({ key: 'remote.common.delaware', text: '特拉华州' })
  },
  FL: {
    value: '9',
    label: getLabelText({ key: 'remote.common.florida', text: '佛罗里达州' })
  },
  GA: {
    value: '10',
    label: getLabelText({ key: 'remote.common.stateOfGeorgia', text: '乔治亚州' })
  },
  HI: {
    value: '11',
    label: getLabelText({ key: 'remote.common.hawaii', text: '夏威夷州' })
  },
  ID: {
    value: '12',
    label: getLabelText({ key: 'remote.common.idaho', text: '爱达荷州' })
  },
  IL: {
    value: '13',
    label: getLabelText({ key: 'remote.common.illinois', text: '伊利诺伊州' })
  },
  IN: {
    value: '14',
    label: getLabelText({ key: 'remote.common.indiana', text: '印第安纳州' })
  },
  IA: {
    value: '15',
    label: getLabelText({ key: 'remote.common.iowa', text: '衣阿华州' })
  },
  KS: {
    value: '16',
    label: getLabelText({ key: 'remote.common.kansas', text: '堪萨斯州' })
  },
  KY: {
    value: '17',
    label: getLabelText({ key: 'remote.common.kentucky', text: '肯塔基州' })
  },
  LA: {
    value: '18',
    label: getLabelText({
      key: 'remote.common.louisiana',
      text: '路易斯安那州'
    })
  },
  ME: {
    value: '19',
    label: getLabelText({ key: 'remote.common.maine', text: '缅因州' })
  },
  MD: {
    value: '20',
    label: getLabelText({ key: 'remote.common.maryland', text: '马里兰州' })
  },
  MA: {
    value: '21',
    label: getLabelText({
      key: 'remote.common.massachusetts',
      text: '马萨诸塞州'
    })
  },
  MI: {
    value: '22',
    label: getLabelText({ key: 'remote.common.michigan', text: '密歇根州' })
  },
  MN: {
    value: '23',
    label: getLabelText({ key: 'remote.common.minnesota', text: '明尼苏达州' })
  },
  MS: {
    value: '24',
    label: getLabelText({
      key: 'remote.common.mississippi',
      text: '密西西比州'
    })
  },
  MO: {
    value: '25',
    label: getLabelText({ key: 'remote.common.missouri', text: '密苏里州' })
  },
  MT: {
    value: '26',
    label: getLabelText({ key: 'remote.common.montana', text: '蒙大拿州' })
  },
  NE: {
    value: '27',
    label: getLabelText({ key: 'remote.common.nebraska', text: '内布拉斯加州' })
  },
  NV: {
    value: '28',
    label: getLabelText({ key: 'remote.common.nevada', text: '内华达州' })
  },
  NH: {
    value: '29',
    label: getLabelText({
      key: 'remote.common.newHampshire',
      text: '新罕布什尔州'
    })
  },
  NJ: {
    value: '30',
    label: getLabelText({ key: 'remote.common.newJersey', text: '新泽西州' })
  },
  NM: {
    value: '31',
    label: getLabelText({ key: 'remote.common.newMexico', text: '新墨西哥州' })
  },
  NY: {
    value: '32',
    label: getLabelText({ key: 'remote.common.newYorkState', text: '纽约州' })
  },
  NC: {
    value: '33',
    label: getLabelText({
      key: 'remote.common.northCarolina',
      text: '北卡罗来纳州'
    })
  },
  ND: {
    value: '34',
    label: getLabelText({
      key: 'remote.common.northDakota',
      text: '北达科他州'
    })
  },
  OH: {
    value: '35',
    label: getLabelText({ key: 'remote.common.ohio', text: '俄亥俄州' })
  },
  OK: {
    value: '36',
    label: getLabelText({ key: 'remote.common.oklahoma', text: '俄克拉荷马州' })
  },
  OR: {
    value: '37',
    label: getLabelText({ key: 'remote.common.oregon', text: '俄勒冈州' })
  },
  PA: {
    value: '38',
    label: getLabelText({
      key: 'remote.common.pennsylvania',
      text: '宾夕法尼亚州'
    })
  },
  RI: {
    value: '39',
    label: getLabelText({ key: 'remote.common.rhodeIsland', text: '罗德岛州' })
  },
  SC: {
    value: '40',
    label: getLabelText({
      key: 'remote.common.southCarolina',
      text: '南卡罗来纳州'
    })
  },
  SD: {
    value: '41',
    label: getLabelText({
      key: 'remote.common.southDakota',
      text: '南达科他州'
    })
  },
  TN: {
    value: '42',
    label: getLabelText({ key: 'remote.common.tennessee', text: '田纳西州' })
  },
  TX: {
    value: '43',
    label: getLabelText({ key: 'remote.common.texas', text: '德克萨斯州' })
  },
  UT: {
    value: '44',
    label: getLabelText({ key: 'remote.common.utah', text: '犹他州' })
  },
  VT: {
    value: '45',
    label: getLabelText({ key: 'remote.common.vermont', text: '佛蒙特州' })
  },
  VA: {
    value: '46',
    label: getLabelText({ key: 'remote.common.virginia', text: '弗吉尼亚州' })
  },
  WA: {
    value: '47',
    label: getLabelText({
      key: 'remote.common.washingtonState',
      text: '华盛顿州'
    })
  },
  WV: {
    value: '48',
    label: getLabelText({
      key: 'remote.common.westVirginia',
      text: '西弗吉尼亚州'
    })
  },
  WI: {
    value: '49',
    label: getLabelText({ key: 'remote.common.wisconsin', text: '威斯康辛州' })
  },
  WY: {
    value: '50',
    label: getLabelText({ key: 'remote.common.wyoming', text: '怀俄明州' })
  }
})

const legalEntityTypeEnum = new GenerateEnum({
  LIMITED: {
    value: '1',
    label: 'Limited company'
  },
  LLC: {
    value: '2',
    label: 'LLC'
  },
  INC: {
    value: '3',
    label: 'INC'
  },
  COR: {
    value: '4',
    label: 'Corporation'
  },
  SOLE: {
    value: '5',
    label: 'Sole proprietorship'
  },
  OTHER: {
    value: '6',
    label: getLabelText({
      key: 'remote.common.other',
      text: '其他'
    })
  }
})

const CUSTOM_APPLY_TYPE = new GenerateEnum({
  TRADEMARK: {
    value: '1',
    label:
      getLabelText({
        key: 'remote.common.trademark',
        text: '商标'
      }) +
      `（${getLabelText({
        key: 'remote.common.customsFiling',
        text: '海关备案'
      })}）`
  },
  PATENT: {
    value: '2',
    label:
      getLabelText({
        key: 'remote.common.patent',
        text: '专利'
      }) +
      `（${getLabelText({
        key: 'remote.common.customsFiling',
        text: '海关备案'
      })}）`
  },
  COPYRIGHT: {
    value: '3',
    label:
      getLabelText({
        key: 'remote.common.copyright',
        text: '版权'
      }) +
      `（${getLabelText({
        key: 'remote.common.customsFiling',
        text: '海关备案'
      })}）`
  }
})

/*
 * =========== common/common/env end ============
 */

/*
 * =========== common/admin/env start ============
 */
const entryCompanyEnumAdmin = new GenerateEnum({
  VAT_MASTER: {
    platform: ['00'],
    value: 0,
    label: getLabelText({
      key: 'remote.common.shenzhenOushuitongTechnologyCo.Ltd',
      text: '深圳欧税通技术有限公司'
    })
  },
  SHANGHAI_IPP: {
    platform: ['01'],
    value: 1,
    label: getLabelText({
      key: 'remote.common.shanghaiMetroSoftwareTechnologyCo.Ltd',
      text: '上海麦德通软件技术有限公司'
    })
  },
  SHENZHEN_IPP: {
    platform: ['01'],
    value: 2,
    label: getLabelText({
      key: 'remote.common.shenzhenMaidetongBusinessAgencyCo.Ltd',
      text: '深圳麦德通商务技术有限公司'
    })
  },
  HONG_KONG: {
    platform: ['01'],
    value: 5,
    label: getLabelText({
      key: 'remote.common.hongKongEurotax',
      text: '香港欧税通公司'
    })
  },
  SHENZHEN_LIDO: {
    platform: ['08'],
    value: 3,
    label: getLabelText({
      key: 'remote.common.shenzhenLiuduInformationServiceCo.Ltd',
      text: '深圳六度信息服务有限公司'
    })
  },
  SHENZHEN_XM: {
    platform: ['10'],
    value: 4,
    label: getLabelText({
      key: 'remote.common.shenzhenXiaomaoChuhaiTechnologyCoLtd',
      text: '深圳小贸出海科技有限公司'
    })
  },
  SHENZHEN_TH: {
    platform: ['13'],
    value: 6,
    label: getLabelText({
      key: 'remote.common.shenzhenTianheHaihaiTechnologyCo.Ltd',
      text: '深圳天合出海科技有限公司'
    })
  },
  LIKE_SUN_GMBH: {
    platform: ['21'],
    value: 6,
    label: getLabelText({
      key: 'remote.common.likeSunGmbH',
      text: 'Like Sun GmbH'
    })
  },
  SHENZHEN_LZ: {
    platform: ['15'],
    value: 15,
    label: getLabelText({ key: 'remote.common.greenBoat', text: '绿舟' })
  },
  VATAI_EU: {
    platform: ['16'],
    value: 16,
    label: 'VATAi' + getLabelText({ key: 'remote.common.euStation', text: '欧洲站' })
  },
  VATAI_US: {
    platform: ['17'],
    value: 17,
    label: 'VATAi' + getLabelText({ key: 'remote.common.usStation', text: '美国站' })
  }
})
const selectEntryCompanyEnum = entryCompanyEnumAdmin.enumArray.filter((item) => item.platform.includes(globalThis().platform))
const invoiceTypeEnum = new GenerateEnum({
  ORDINARY: {
    value: 0,
    label: getLabelText({
      key: 'remote.common.value-addedTaxPlainInvoice',
      text: '增值税普通发票'
    })
  },
  SPECIALLY: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.specialInvoiceForValue-addedTax',
      text: '增值税专用发票'
    })
  },
  INVOICE: {
    value: 2,
    label: 'invoice'
  }
})

const businessTypeEnum = new GenerateEnum({
  VAT: {
    value: 0,
    label: 'VAT+'
  },
  EPR: {
    value: 1,
    label: 'EPR'
  },
  GRC: {
    value: 2,
    label: 'RSP'
  },
  // OC: {
  //   value: 3,
  //   label: '海外公司'
  // },
  IPP: {
    value: 4,
    label: 'IPP'
  },
  XM_OC: {
    value: 5,
    label: 'OC'
  }
})

const currencyType = [
  getLabelText({ key: 'remote.common.pound', text: '英镑' }),
  getLabelText({
    key: 'remote.common.euro',
    text: '欧元'
  })
]

const businessType = [
  {
    label: getLabelText({ key: 'remote.common.lianlian', text: '连连' }),
    value: '2'
  },
  {
    label: 'pingpong',
    value: '3'
  },
  {
    label: getLabelText({
      key: 'remote.common.cloudsInTheSky',
      text: '空中云汇'
    }),
    value: '7'
  },
  {
    label: 'Payoneer',
    value: '9'
  }
]

const backTaxesType = [
  {
    label: getLabelText({
      key: 'remote.common.pendingTaxRefund',
      text: '待退税'
    }),
    value: 5
  },
  {
    label: getLabelText({ key: 'remote.common.processing', text: '处理中' }),
    value: 6
  },
  {
    label: getLabelText({
      key: 'remote.common.taxRefundInProgress',
      text: '退税中'
    }),
    value: 7
  },
  {
    label: getLabelText({ key: 'remote.common.taxRefunded', text: '已退税' }),
    value: 8
  }
]

const accountStatus = [
  {
    label: getLabelText({ key: 'remote.common.notAuthorized', text: '未授权' }),
    value: 0
  },
  {
    label: getLabelText({
      key: 'remote.common.authorizationInProgress',
      text: '授权中'
    }),
    value: 1
  },
  {
    label: getLabelText({ key: 'remote.common.authorized', text: '已授权' }),
    value: 2
  },
  {
    label: getLabelText({
      key: 'remote.common.authorizationCanceled',
      text: '已取消授权'
    }),
    value: 3
  }
]

const serverRateType = [
  '',
  getLabelText({
    key: 'remote.common.taxPaymentServiceFee',
    text: '缴税服务费'
  }),
  getLabelText({ key: 'remote.common.taxRefundServiceFee', text: '退税服务费' })
]

const autoMsg = {
  100000: getLabelText({
    key: 'remote.common.authorizationBindingSuccessful',
    text: '授权绑定成功'
  }),
  100001: getLabelText({
    key: 'remote.common.authorizationBindingFailedDueToException',
    text: '授权异常绑定失败'
  }),
  100002: getLabelText({
    key: 'remote.common.lianlianPayAuthorizationFailed',
    text: '连连支付授权失败'
  }),
  100003: getLabelText({
    key: 'remote.common.authorizationHasExpiredPleaseRe-initiateAuthorization',
    text: '授权已过有效时间，请重新发起授权'
  }),
  100004: getLabelText({
    key: 'remote.common.anAuthorizedAccountAlreadyExistsAuthorizationCannotProceed',
    text: '已经存在授权账户，授权无法进行'
  }),
  100005: getLabelText({
    key: 'remote.common.promptText1',
    text: '当前账户开通成功，但暂未认证，通过认证后可绑定正常使用'
  })
}
const companyType = {
  99: 0,
  0: 2,
  1: 3,
  2: 1,
  3: 1,
  5: 4,
  6: 5,
  7: 6,
  8: 7
}
const declarePeriodType = [
  getLabelText({ key: 'remote.common.processing', text: '处理中' }),
  getLabelText({ key: 'remote.common.success', text: '成功' }),
  getLabelText({ key: 'remote.common.cancel', text: '取消' }),
  getLabelText({ key: 'remote.common.failure', text: '失败' }),
  getLabelText({ key: 'remote.common.paid4', text: '已支付' })
]
const RPAApplyResult = [
  getLabelText({ key: 'remote.common.notExecuted', text: '未执行' }),
  getLabelText({ key: 'remote.common.success', text: '成功' }),
  getLabelText({ key: 'remote.common.failure', text: '失败' }),
  getLabelText({
    key: 'remote.common.rpaProcessingInProgress',
    text: 'RPA处理中'
  }),
  '',
  getLabelText({ key: 'remote.common.pendingExecution', text: '待执行' })
]

const officialCondition = [
  {
    label: getLabelText({
      key: 'remote.common.afterOfficialReceiptIsIssued',
      text: '官方受理回执下发后'
    }),
    value: '0'
  }
]
const officialCycle = [
  {
    label: getLabelText({ key: 'remote.common.everyMonth', text: '每月' }),
    value: '1'
  },
  {
    label: getLabelText({ key: 'remote.common.quarterly', text: '每季度' }),
    value: '2'
  }
]

// 官费币种
const officialCurrency = [
  {
    label: getLabelText({ key: 'remote.common.dollar', text: '美元' }),
    value: '1',
    countryId: '1'
  },
  {
    label: getLabelText({ key: 'remote.common.euro', text: '欧元' }),
    value: '2',
    countryId: '4'
  },
  {
    label: getLabelText({ key: 'remote.common.pound', text: '英镑' }),
    value: '3',
    countryId: '2'
  },
  {
    label: getLabelText({ key: 'remote.common.japaneseYen', text: '日元' }),
    value: '4',
    countryId: '3'
  },
  {
    label: getLabelText({ key: 'remote.common.rmb', text: '人民币' }),
    value: '5'
  },
  {
    label: getLabelText({ key: 'remote.common.won', text: '韩元' }),
    value: '6',
    countryId: '5'
  },
  {
    label: getLabelText({
      key: 'remote.common.philippinePesos',
      text: '菲律宾比索'
    }),
    value: '7',
    countryId: '6'
  },
  {
    label: getLabelText({ key: 'remote.common.indianRupee', text: '印度卢比' }),
    value: '8',
    countryId: '7'
  },
  {
    label: getLabelText({
      key: 'remote.common.australianDollar',
      text: '澳元'
    }),
    value: '9',
    countryId: '9'
  },
  {
    label: getLabelText({ key: 'remote.common.canadianDollars', text: '加元' }),
    value: '10',
    countryId: '10'
  },
  {
    label: getLabelText({
      key: 'remote.common.brazilianReal',
      text: '巴西雷亚尔'
    }),
    value: '11',
    countryId: '11'
  }
]

// 新增编辑时的商标服务类型
const SERVICE_TYPE_FOR_Add_LIST = [
  {
    value: COMMON_SERVICE_TYPE.TRADEMARK_REG,
    label: COMMON_SERVICE_TYPE.getValueToLabel(COMMON_SERVICE_TYPE.TRADEMARK_REG)
  },
  {
    value: COMMON_SERVICE_TYPE.TRADEMARK_OATH,
    label: COMMON_SERVICE_TYPE.getValueToLabel(COMMON_SERVICE_TYPE.TRADEMARK_OATH)
  },
  {
    value: COMMON_SERVICE_TYPE.TRADEMARK_ASSIGNMENT,
    label: COMMON_SERVICE_TYPE.getValueToLabel(COMMON_SERVICE_TYPE.TRADEMARK_ASSIGNMENT)
  }
]

// 服务项目
const SERVICE_ITEM = {
  ONE_ONE: 1, // 一标一类
  ONE_TWO: 2, // 一标二类
  ONE_THREE: 3, // 一标三类
  ONE_FOUR: 4, // 一标四类
  ONE_FIVE: 5, // 一标五类
  ONE_SIX: 6, // 一标六类
  ONE_SEVEN: 7, // 一标七类
  ONE_EIGHT: 8, // 一标八类
  ONE_NINE: 9, // 一标九类
  ONE_TEN: 10, // 一标十类
  US: 20, // 美国
  UK: 21, // 英国
  EU: 22, // 欧盟
  JP_APPLY: 23, // 申请中
  JP_REG: 24, // 已注册
  SVIP: 25 // SVIP
}

// 服务项目反射
const SERVICE_ITEM_MAP = {
  [SERVICE_ITEM.ONE_ONE]: getLabelText({
    key: 'remote.common.oneStandardAndOneCategory',
    text: '一标一类'
  }), // 一标一类
  [SERVICE_ITEM.ONE_TWO]: getLabelText({
    key: 'remote.common.theFirstStandardAndTheSecondStandard',
    text: '一标二类'
  }), // 一标二类
  [SERVICE_ITEM.ONE_THREE]: getLabelText({
    key: 'remote.common.oneStandardAndThreeCategories',
    text: '一标三类'
  }), // 一标三类
  [SERVICE_ITEM.ONE_FOUR]: getLabelText({
    key: 'remote.common.oneStandardAndFourCategories',
    text: '一标四类'
  }), // 一标四类
  [SERVICE_ITEM.ONE_FIVE]: getLabelText({
    key: 'remote.common.oneStandardAndFiveCategories',
    text: '一标五类'
  }), // 一标五类
  [SERVICE_ITEM.ONE_SIX]: getLabelText({
    key: 'remote.common.oneStandardAndSixCategories',
    text: '一标六类'
  }), // 一标六类
  [SERVICE_ITEM.ONE_SEVEN]: getLabelText({
    key: 'remote.common.oneStandardAndSevenCategories',
    text: '一标七类'
  }), // 一标七类
  [SERVICE_ITEM.ONE_EIGHT]: getLabelText({
    key: 'remote.common.oneStandardAndEightCategories',
    text: '一标八类'
  }), // 一标八类
  [SERVICE_ITEM.ONE_NINE]: getLabelText({
    key: 'remote.common.oneStandardAndNineCategories',
    text: '一标九类'
  }), // 一标九类
  [SERVICE_ITEM.ONE_TEN]: getLabelText({
    key: 'remote.common.oneStandardAndTenCategories',
    text: '一标十类'
  }), // 一标十类
  [SERVICE_ITEM.US]: getLabelText({
    key: 'remote.common.america',
    text: '美国'
  }), // 美国
  [SERVICE_ITEM.UK]: getLabelText({ key: 'remote.common.theUk', text: '英国' }), // 英国
  [SERVICE_ITEM.EU]: getLabelText({
    key: 'remote.common.europeanUnion',
    text: '欧盟'
  }), // 欧盟
  [SERVICE_ITEM.JP_APPLY]: getLabelText({
    key: 'remote.common.applicationInProgress',
    text: '申请中'
  }), // 申请中
  [SERVICE_ITEM.JP_REG]: getLabelText({
    key: 'remote.common.registered',
    text: '已注册'
  }), // 已注册
  [SERVICE_ITEM.SVIP]: getLabelText({
    key: 'remote.common.svipMember',
    text: 'SVIP会员'
  }) // SVIP
}

const YES_OR_NO = OFFICIAL_IS_INCLUDE

const YES_OR_NO_MAP = IS_BOOLEAN_NAME

const YES_OR_NO_LIST = [
  {
    value: YES_OR_NO.NO,
    label: YES_OR_NO_MAP[YES_OR_NO.NO]
  },
  {
    value: YES_OR_NO.YES,
    label: YES_OR_NO_MAP[YES_OR_NO.YES]
  }
]

const YES_OR_NO_NUM = {
  NO: 0,
  YES: 1
}
const YES_OR_NO_BOOLEAN = {
  NO: false,
  YES: true
}

// 客服类型
const CUSTOMER_TYPE = {
  BEFORE: 1, // 在线销售
  AFTER: 2 // 售后客服
}

const CUSTOMER_TYPE_MAP = {
  [CUSTOMER_TYPE.BEFORE]: getLabelText({
    key: 'remote.common.onlineSales',
    text: '在线销售'
  }),
  [CUSTOMER_TYPE.AFTER]: getLabelText({
    key: 'remote.common.after-salesCustomerService',
    text: '售后客服'
  })
}

const CUSTOMER_TYPE_LIST = createSelectList({
  constants: CUSTOMER_TYPE,
  map: CUSTOMER_TYPE_MAP
})

// 汇率类型
const EXCHANGE_RATE_TYPE = {
  FLOAT: '0', // 浮动汇率
  FIXED: '1', // 固定汇率
  ACTIVITY: '2' // 活动汇率
}

// 汇率类型反射
const EXCHANGE_RATE_TYPE_MAP = {
  [EXCHANGE_RATE_TYPE.FLOAT]: getLabelText({
    key: 'remote.common.floatingExchangeRate',
    text: '浮动汇率'
  }), // 浮动汇率
  [EXCHANGE_RATE_TYPE.FIXED]: getLabelText({
    key: 'remote.common.fixedExchangeRate',
    text: '固定汇率'
  }), // 固定汇率
  [EXCHANGE_RATE_TYPE.ACTIVITY]: getLabelText({
    key: 'remote.common.activeExchangeRate',
    text: '活动汇率'
  }) // 活动汇率
}

// 汇率类型列表
const EXCHANGE_RATE_LIST = createSelectList({
  constants: EXCHANGE_RATE_TYPE,
  map: EXCHANGE_RATE_TYPE_MAP
})

const VIP_TYPE_LIST = createSelectList({
  constants: VIP_TYPE,
  map: VIP_TYPE_MAP
})

const EXPERIENCE_VIP_TYPE_LIST = createSelectList({
  constants: EXPERIENCE_VIP_TYPE,
  map: EXPERIENCE_VIP_TYPE_MAP
})

// 会员来源 0-未知（原来的）1-购买 2-活动赠送 3-导入',
const VIP_SOURCE = {
  UN_KNOW: 0,
  BUY: 1,
  ACTIVITY: 2,
  IMPORT: 3
}

const VIP_SOURCE_MAP = {
  [VIP_SOURCE.UN_KNOW]: getLabelText({
    key: 'remote.common.unknown',
    text: '未知'
  }),
  [VIP_SOURCE.BUY]: getLabelText({
    key: 'remote.common.userPurchase',
    text: '用户购买'
  }),
  [VIP_SOURCE.ACTIVITY]: getLabelText({
    key: 'remote.common.complimentarySystem',
    text: '系统赠送'
  }),
  [VIP_SOURCE.IMPORT]: getLabelText({
    key: 'remote.common.businessImport',
    text: '业务导入'
  })
}

const VIP_SOURCE_LIST = createSelectList({
  constants: VIP_SOURCE,
  map: VIP_SOURCE_MAP
})

// 活动状态(0:未开始,1:进行中,2:已结束,3:已作废)
const ACTIVITY_STATUS = {
  NOT_STARTED: 0,
  PENDING: 1,
  ENDED: 2,
  VOIDED: 3
}

const ACTIVITY_STATUS_MAP = {
  [ACTIVITY_STATUS.NOT_STARTED]: getLabelText({
    key: 'remote.common.notStarted',
    text: '未开始'
  }),
  [ACTIVITY_STATUS.PENDING]: getLabelText({
    key: 'remote.common.inProgress',
    text: '进行中'
  }),
  [ACTIVITY_STATUS.ENDED]: getLabelText({
    key: 'remote.common.ended',
    text: '已结束'
  }),
  [ACTIVITY_STATUS.VOIDED]: getLabelText({
    key: 'remote.common.voided',
    text: '已作废'
  })
}

const ACTIVITY_STATUS_LIST = createSelectList({
  constants: ACTIVITY_STATUS,
  map: ACTIVITY_STATUS_MAP
})

// 是否是批量
const IS_BATCH = VALIDOBJ

// 导入用户的类型  0-商户账号导入 1-用户编码导入
const IMP_USER_TYPE = {
  ACCOUNT: 0, // 商户账号
  USER_CODE: 1 // 用户编码
}

// 会员活动类型，0-送VIP活动 1-VIP体验活动
const VIP_ACTIVITY_TYPE = {
  GIVE: 0,
  EXPERIENCE: 1
}
const VIP_ACTIVITY_TYPE_MAP = {
  [VIP_ACTIVITY_TYPE.GIVE]: getLabelText({
    key: 'remote.common.buyServiceGetMembershipActivity',
    text: '买服务送会员活动'
  }),
  [VIP_ACTIVITY_TYPE.EXPERIENCE]: getLabelText({
    key: 'remote.common.freeMembershipExperienceActivity',
    text: '免费体验会员活动'
  })
}

const VIP_ACTIVITY_TYPE_LIST = createSelectList({
  constants: VIP_ACTIVITY_TYPE,
  map: VIP_ACTIVITY_TYPE_MAP
})

// 体验限制 0-无限 1-仅首单limit 2-仅首件
const EXPERIENCE_VIP_PRICE_LIMIT = {
  INFINITE: 0,
  FIRST: 1,
  FIRST_PIECE: 2
}
const EXPERIENCE_VIP_PRICE_LIMIT_MAP = {
  [EXPERIENCE_VIP_PRICE_LIMIT.INFINITE]: getLabelText({
    key: 'remote.common.unlimited2',
    text: '无限制'
  }),
  [EXPERIENCE_VIP_PRICE_LIMIT.FIRST]: getLabelText({
    key: 'remote.common.firstOrder',
    text: '首个订单'
  }),
  [EXPERIENCE_VIP_PRICE_LIMIT.FIRST_PIECE]: getLabelText({
    key: 'remote.common.firstItem',
    text: '首件'
  })
}

const EXPERIENCE_VIP_PRICE_LIMIT_LIST = createSelectList({
  constants: EXPERIENCE_VIP_PRICE_LIMIT,
  map: EXPERIENCE_VIP_PRICE_LIMIT_MAP
})

// 会员活动累购统计方式 0-自己定义开始 1-1年 2-6个月 3-3个月 4-1个月
const COUNT_WAT = {
  ONE_YEAR: 1,
  SIX_MONTH: 2,
  THREE_MONTH: 3,
  ONE_MONTH: 4,
  CUSTOM: 0
}

const COUNT_WAT_MAP = {
  [COUNT_WAT.CUSTOM]: getLabelText({
    key: 'remote.common.customStartTime',
    text: '自定义开始时间'
  }),
  [COUNT_WAT.ONE_YEAR]: getLabelText({
    key: 'remote.common.past1Year',
    text: '过去1年'
  }),
  [COUNT_WAT.SIX_MONTH]: getLabelText({
    key: 'remote.common.past6Months',
    text: '过去6个月'
  }),
  [COUNT_WAT.THREE_MONTH]: getLabelText({
    key: 'remote.common.past3Months',
    text: '过去3个月'
  }),
  [COUNT_WAT.ONE_MONTH]: getLabelText({
    key: 'remote.common.past1Month',
    text: '过去1个月'
  })
}

const COUNT_WAT_LIST = createSelectList({
  constants: COUNT_WAT,
  map: COUNT_WAT_MAP
})

// 商标查询方式，0系统检索 1人工核名 2类别查询3宣誓检索
const TRADEMARK_QUERY_TYPE = {
  TRADEMARK: 0,
  // ARTIFICIAL_CHECK: 1,
  CATEGORY: 2
}

const TRADEMARK_QUERY_TYPE_MAP = {
  [TRADEMARK_QUERY_TYPE.TRADEMARK]: getLabelText({
    key: 'remote.common.checkTrademark',
    text: '查商标'
  }),
  [TRADEMARK_QUERY_TYPE.CATEGORY]: getLabelText({
    key: 'remote.common.checkCategory',
    text: '查类别'
  })
}

const TRADEMARK_QUERY_TYPE_LIST = createSelectList({
  constants: TRADEMARK_QUERY_TYPE,
  map: TRADEMARK_QUERY_TYPE_MAP
})

// 成本类型
const SUPPLIER_COST_TYPE = {
  REGISTRATION_FEE: '0', // 注册费
  DECLARATION_FEE: '1', // 申报费
  APOSTILLE_FEE: '2', // 海牙服务费
  OFFICIAL_TRANSLATION_FEE: '3', // 官方翻译费
  TRANSFER_AGENCY_FEE: '4', // 转代理费用
  SERVICE_FEE: '6', // 服务费
  OFFICIAL_FEE: '7', // 预存官费
  RECYCLING_COMPANY_SERVICE_FEE: '10', // 回收公司服务费
  MEMBERSHIP_FEE: '11', // 会员费
  MDT_SERVICE_FEE: '12', // 新申请服务费
  TRANSLATION_FEE: '13', // 翻译费
  NOTARY_FEE: '14', // 公证费
  TAX_NUMBER_MANAGEMENT_FEE: '15', // 税号管理费
  TAX_NUMBER_RENEWAL: '16', // 税号续费
  TAX_NUMBER_REGISTRATION_FEE: '17', // 税号注册费
  CANCELLATION_FEE: '18', // 注销费
  CUSTOM_VALUE_ADDED_SERVICE_FEE: '19', // 自定义增值服务费用
  OFFICIAL_TRANSLATION_SERVICE_FEE: '20', // 官翻服务费
  ADDITIONAL_MATERIAL_FEE: '21', // 追加材料及重量费
  RECOVERY_CHARGE_FEE: '22', // 回收费
  OST_OFFICIAL_FEE: '23', // 欧税通官费
  TESTING_FEE: '24', // 检测费用
  XM_SERVICE_FEE: '25', // 小贸服务费
  AUTH_SERVICE_FEE: '26', // 授权服务费
  NOA_SERVICE_FEE: '27', // NOA服务费
  BASE_COUNTRY_FEE: '28', // 基本州税
  GUARANTEE_FEE: '29', // 担保费
  QUART_SYSTEM_FEE: '30', // 季度系统使用费
  CHECK_GUARANTEE_FEE: '31', // 审核担保费
  CHECK_FEE: '32', // 审核费
  AUTH_FEE: '33', // 授权费
  APPEND_CATEGORY_FEE: '34', // 追加类别费
  APPEND_BRAND_FEE: '35', // 追加品牌费
  APPEND_WEIGHT_FEE: '36', // 追加重量费
  XM_HAGUE_CERTIFICATION_FEE: '39', // 海牙认证费用
  APPEND_DECLARATION_FEE: '40', // 追加申报费
  IPP_NEW_APPLY_OFFICIAL_FEE: '41', // 新申请官费
  IPP_FIRST_REVIEW_OPINION: '42', // 第1次审查意见
  IPP_SECOND_REVIEW_OPINION: '43', // 第2次审查意见
  IPP_THIRD_REVIEW_OPINION: '44', // 第3次审查意见
  IPP_PUBLIC_CERTIFICATION_FEE: '45', // 公认证费用
  IPP_OBJECTION_OR_INVALID_DEFENSE: '46', // 异议或无效答辩
  IPP_GRANT_OFFICIAL_FEE: '47', // 授权官费
  IPP_NOA_OFFICIAL_FEE: '48', // NOA官费
  IPP_LAWYER_LETTER_DEFENSE: '49', // 律师函答辩
  IPP_OBJECTION_OR_INVALID_SERVICE_FEE: '50', // 异议或无效服务费
  IPP_OBJECTION_OR_INVALID_OFFICIAL_FEE: '51', // 异议或无效官费
  CANCEL_CATEGORY_FEE: '52', // 注销品类费
  CANCEL_W3ECODE: '53', // 注销注册码
  OATH_TRANSLATION_FEE: '72' // 宣誓翻译费
}
const SUPPLIER_COST_TYPE_MAP = {
  [SUPPLIER_COST_TYPE.REGISTRATION_FEE]: '注册费',
  [SUPPLIER_COST_TYPE.DECLARATION_FEE]: '申报费',
  [SUPPLIER_COST_TYPE.APOSTILLE_FEE]: '海牙服务费',
  [SUPPLIER_COST_TYPE.OFFICIAL_TRANSLATION_FEE]: '官方翻译费',
  [SUPPLIER_COST_TYPE.TRANSFER_AGENCY_FEE]: '转代理费用',
  [SUPPLIER_COST_TYPE.SERVICE_FEE]: '服务费',
  [SUPPLIER_COST_TYPE.OFFICIAL_FEE]: '预存官费',
  [SUPPLIER_COST_TYPE.RECYCLING_COMPANY_SERVICE_FEE]: '回收公司服务费',
  [SUPPLIER_COST_TYPE.MEMBERSHIP_FEE]: '会员费',
  [SUPPLIER_COST_TYPE.MDT_SERVICE_FEE]: '新申请服务费',
  [SUPPLIER_COST_TYPE.TRANSLATION_FEE]: '翻译费',
  [SUPPLIER_COST_TYPE.NOTARY_FEE]: '公证费',
  [SUPPLIER_COST_TYPE.TAX_NUMBER_MANAGEMENT_FEE]: '税号管理费',
  [SUPPLIER_COST_TYPE.TAX_NUMBER_RENEWAL]: '税号续费',
  [SUPPLIER_COST_TYPE.TAX_NUMBER_REGISTRATION_FEE]: '税号注册费',
  [SUPPLIER_COST_TYPE.CANCELLATION_FEE]: '注销费',
  [SUPPLIER_COST_TYPE.CUSTOM_VALUE_ADDED_SERVICE_FEE]: '自定义增值服务费用',
  [SUPPLIER_COST_TYPE.OFFICIAL_TRANSLATION_SERVICE_FEE]: '官翻服务费',
  [SUPPLIER_COST_TYPE.ADDITIONAL_MATERIAL_FEE]: '追加材料及重量费',
  [SUPPLIER_COST_TYPE.RECOVERY_CHARGE_FEE]: '回收费',
  [SUPPLIER_COST_TYPE.OST_OFFICIAL_FEE]: '欧税通官费',
  [SUPPLIER_COST_TYPE.TESTING_FEE]: '检测费用',
  [SUPPLIER_COST_TYPE.XM_SERVICE_FEE]: '小贸服务费',
  [SUPPLIER_COST_TYPE.AUTH_SERVICE_FEE]: '授权服务费',
  [SUPPLIER_COST_TYPE.NOA_SERVICE_FEE]: 'NOA服务费',
  [SUPPLIER_COST_TYPE.BASE_COUNTRY_FEE]: '基本州税',
  [SUPPLIER_COST_TYPE.GUARANTEE_FEE]: '担保费',
  [SUPPLIER_COST_TYPE.QUART_SYSTEM_FEE]: '季度系统使用费',
  [SUPPLIER_COST_TYPE.CHECK_GUARANTEE_FEE]: '审核担保费',
  [SUPPLIER_COST_TYPE.CHECK_FEE]: '审核费',
  [SUPPLIER_COST_TYPE.AUTH_FEE]: '授权费',
  [SUPPLIER_COST_TYPE.APPEND_CATEGORY_FEE]: '追加类别费',
  [SUPPLIER_COST_TYPE.APPEND_BRAND_FEE]: '追加品牌费',
  [SUPPLIER_COST_TYPE.APPEND_WEIGHT_FEE]: '追加重量费',
  [SUPPLIER_COST_TYPE.XM_HAGUE_CERTIFICATION_FEE]: '海牙认证费用',
  [SUPPLIER_COST_TYPE.APPEND_DECLARATION_FEE]: '追加申报费',
  [SUPPLIER_COST_TYPE.CANCEL_CATEGORY_FEE]: '注销品类费',
  [SUPPLIER_COST_TYPE.CANCEL_W3ECODE]: '注销注册码',
  [SUPPLIER_COST_TYPE.OATH_TRANSLATION_FEE]: getLabelText({
    key: 'remote.admin.oathTranslationFee',
    text: '宣誓翻译费'
  })
}

const SUPPLIER_COST_TYPE_LIST = createSelectList({
  constants: SUPPLIER_COST_TYPE,
  map: SUPPLIER_COST_TYPE_MAP
})

// 成本获取方式
const COST_GET_TYPE = {
  FIX_AMT: '3', // 固定金额
  SERVICE_COMPLETE_MONTH: '4', // 基于（服务单完成）自然月的服务单完成数量阶梯报价
  OFFICIAL_TRANSLATION_MONTH: '5', // 基于官方翻译每月完成数量阶梯报价
  SPECIFIC_TIME_SERVICE: '6', // 基于特定时间累计服务单完成数量阶梯报价
  SERVICE_PAID_SHARE: '7', // 服务单实付金额分成
  REMOVE_OTHER_PAID_SHARE: '8', // 去除其他成本后的实付金额进行分成
  ONE_CUSTOMER_ONE_PRICE: '9', // 一客一价
  DE_ADD_PACKAGE_MATERIAL: '10', // 德国-包装法追加材料以及重量费
  DE_PACKAGE_RECOVERY: '11', // 德国-包装法-回收费
  FIX_AMT_CLEARING: '12', // 固定金额（清分）
  ONE_CUSTOMER_ONE_PRICE_CLEARING: '13', // 一客一价（清分）
  BASE_ASSIGN_SUPPLIER_MONTH: '14', // 基于（分配供应商）自然月的服务单递交数量阶梯报价
  SERVICE_PAID_FIXED_RATE: '15', // 服务单实付金额换算固定费率
  PACK_ADD_WEIGHT_RULE: '16', // 包装法追加重量计价规则
  BATTERY_ADD_WEIGHT_RULE: '17', //  电池法追加重量计价规则
  BATTERY_ADD_BRAND_NAME_RULE: '18', //  电池法追加品类计价规则
  BATTERY_RENEW_RULE: '19', //  电池法续费计价规则
  WEEE_RENEW_SERVICE_FEE_RULE: '20', //  WEEE续费服务费计价规则
  WEEE_RENEW_CHECK_FEE_RULE: '21', //  WEEE续费审核费计价规则
  SERVICE_TIME_FIX_FEE_RULE: '22', //  按服务年限的固定金额
  WEEE_RENEW_GUARANTEE_FEE_RULE: '23', //  WEEE续费DW3-1、DW3-2担保费计价规则
  WEEE_RENEW_GUARANTEE_FEE_RULE_DW3: '24', //  WEEE续费DW3-3担保费计价规则
  SERVICE_TIME_PAY_FEE_RULE: '25', //  按服务年限的服务单实付金额分成
  DE_WEEE_REGISTRATION_SERVICE_FEE_RULE: '26', //  德国WEEE新注册多品类服务费计价规则
  DE_REGISTRATION_GUARANTEE_FEE_RULE: '27', //  德国WEEE新注册一品一类担保费规则
  DE_WEEE_REGISTRATION_SYSTEM_FEE_RULE: '28', //  德国WEEE/电池法新注册系统季度使用费
  MULTI_REGISTRATION_GUARANTEE_FEE_RULE: '29', //  WEEE新注册多品类DW3-1、DW3-2担保费
  MULTI_REGISTRATION_GUARANTEE_FEE_RULE_DW3: '30', //  WEEE新注册多品类DW3-3担保费
  MULTI_REGISTRATION_CHECK_GUARANTEE_FEE_RULE: '31', //  WEEE新注册多品类审核担保费规则
  MULTI_REGISTRATION_FEE_RULE: '32', //  WEEE新注册多品类注册费
  IPP_OFFICIAL_FEE: '37', // 麦德通官费
  XM_OFFICIAL_FEE: '38', // 小贸通官费
  DE_WEEE_ADD_CATEGORY_FEE_RULE: '34', // 德国WEEE追加类别费计价规则
  DE_WEEE_ADD_BRAND_FEE_RULE: '35', // 德国WEEE追加品牌费计价规则
  DE_WEEE_ADD_BRAND_FEE_DW1_2_RULE: '36', // 德国WEEE追加品类DW3-1、DW3-2追加类别费计价规则
  DE_WEEE_ADD_BRAND_FEE_DW3_RULE: '39', // 德国WEEE追加品类DW3-3追加类别费计价规则
  DPS_ADD_WEIGHT_RULE: '40',
  DE_WEEE_BATTERY_LOGOUT_RULE: '41',
  DE_BATTERY_GREATER_1KG_RULE: '42',
  ES_BATTERY_ADD_WEIGHT_RULE: '43',
  IT_ADD_WEIGHT_RULE: '44',
  ES_PACKAGING_ADD_RULE: '45',
  DE_CANCEL_WEEE_CATEGORY_FEE_RULE: '46',
  DE_ADD_CATEGORY_REGISTRATION_FEE_RULE: '47',
  DE_CANCEL_WEEE_CODE_RULE: '48',
  DE_WEEE_ADD_WEIGHT_PACKAGE_RULE: '49', // 德国WEEE追加重量套餐计价
  EPR_ADD_WEIGHT_RULE: '50', // EPR追加重量服务计价规则
  CUSTOMER_REGISTRATION_COUNTRY_FIXED_AMOUNT: '51' // 按客户注册国家固定金额
}

const COST_GET_TYPE_ALL_COUNTRY_SERVICE_LIST = [{ countryList: ['*'], serviceTypeList: ['*'] }]

const COST_GET_TYPE_COUNTRY_SERVICE_MAP = {
  [COST_GET_TYPE.FIX_AMT]: COST_GET_TYPE_ALL_COUNTRY_SERVICE_LIST,
  [COST_GET_TYPE.SERVICE_COMPLETE_MONTH]: COST_GET_TYPE_ALL_COUNTRY_SERVICE_LIST,
  [COST_GET_TYPE.OFFICIAL_TRANSLATION_MONTH]: COST_GET_TYPE_ALL_COUNTRY_SERVICE_LIST,
  [COST_GET_TYPE.SPECIFIC_TIME_SERVICE]: COST_GET_TYPE_ALL_COUNTRY_SERVICE_LIST,
  [COST_GET_TYPE.SERVICE_PAID_SHARE]: COST_GET_TYPE_ALL_COUNTRY_SERVICE_LIST,
  [COST_GET_TYPE.REMOVE_OTHER_PAID_SHARE]: COST_GET_TYPE_ALL_COUNTRY_SERVICE_LIST,
  [COST_GET_TYPE.ONE_CUSTOMER_ONE_PRICE]: COST_GET_TYPE_ALL_COUNTRY_SERVICE_LIST,
  [COST_GET_TYPE.DE_ADD_PACKAGE_MATERIAL]: [
    {
      countryList: [COMMON_COUNTRY.DE],
      serviceTypeList: [COMMON_SERVICE_TYPE.PACKAGING_RENEW, COMMON_SERVICE_TYPE.PACKING_ADD_BRAND]
    }
  ],
  [COST_GET_TYPE.DE_PACKAGE_RECOVERY]: [
    {
      countryList: [COMMON_COUNTRY.DE],
      serviceTypeList: [COMMON_SERVICE_TYPE.PACKAGING_REGISTRATION_DECLARATION, COMMON_SERVICE_TYPE.PACKAGING_TRANSFORM_DECLARATION, COMMON_SERVICE_TYPE.PACKAGING_RENEW]
    }
  ],
  [COST_GET_TYPE.FIX_AMT_CLEARING]: COST_GET_TYPE_ALL_COUNTRY_SERVICE_LIST,
  [COST_GET_TYPE.ONE_CUSTOMER_ONE_PRICE_CLEARING]: COST_GET_TYPE_ALL_COUNTRY_SERVICE_LIST,
  [COST_GET_TYPE.BASE_ASSIGN_SUPPLIER_MONTH]: COST_GET_TYPE_ALL_COUNTRY_SERVICE_LIST,
  [COST_GET_TYPE.SERVICE_PAID_FIXED_RATE]: COST_GET_TYPE_ALL_COUNTRY_SERVICE_LIST,
  [COST_GET_TYPE.PACK_ADD_WEIGHT_RULE]: [{ countryList: [COMMON_COUNTRY.DE], serviceTypeList: [COMMON_SERVICE_TYPE.ADDITIONAL_WEIGHT_FOR_PACKAGING_METHOD] }],
  [COST_GET_TYPE.BATTERY_ADD_WEIGHT_RULE]: [{ countryList: [COMMON_COUNTRY.DE], serviceTypeList: [COMMON_SERVICE_TYPE.BATTERY_ADD_WEIGHT] }],
  [COST_GET_TYPE.BATTERY_ADD_BRAND_NAME_RULE]: [{ countryList: [COMMON_COUNTRY.DE], serviceTypeList: [COMMON_SERVICE_TYPE.BATTERY_ADD_BRAND] }],
  [COST_GET_TYPE.BATTERY_RENEW_RULE]: [{ countryList: [COMMON_COUNTRY.DE], serviceTypeList: [COMMON_SERVICE_TYPE.BATTERY_RENEW] }],
  [COST_GET_TYPE.WEEE_RENEW_SERVICE_FEE_RULE]: [{ countryList: [COMMON_COUNTRY.DE], serviceTypeList: [COMMON_SERVICE_TYPE.WEEE_RENEW] }],
  [COST_GET_TYPE.WEEE_RENEW_CHECK_FEE_RULE]: [{ countryList: [COMMON_COUNTRY.DE], serviceTypeList: [COMMON_SERVICE_TYPE.WEEE_RENEW] }],
  //
  [COST_GET_TYPE.SERVICE_TIME_FIX_FEE_RULE]: [
    {
      countryList: [COMMON_COUNTRY.DE],
      serviceTypeList: [
        COMMON_SERVICE_TYPE.WEEE_REGISTRATION_DECLARATION,
        COMMON_SERVICE_TYPE.WEEE_TRANSFORM_DECLARATION,
        COMMON_SERVICE_TYPE.WEEE_RENEW,
        COMMON_SERVICE_TYPE.WEEE_ADD_BRAND,
        COMMON_SERVICE_TYPE.WEEE_ADD_WEIGHT,
        COMMON_SERVICE_TYPE.WEEE_INCREMENT,
        COMMON_SERVICE_TYPE.WEEE_CANCELLATION_SERVCIE
      ]
    }
  ],
  [COST_GET_TYPE.WEEE_RENEW_GUARANTEE_FEE_RULE]: [{ countryList: [COMMON_COUNTRY.DE], serviceTypeList: [COMMON_SERVICE_TYPE.WEEE_RENEW] }],
  [COST_GET_TYPE.WEEE_RENEW_GUARANTEE_FEE_RULE_DW3]: [{ countryList: [COMMON_COUNTRY.DE], serviceTypeList: [COMMON_SERVICE_TYPE.WEEE_RENEW] }],
  [COST_GET_TYPE.SERVICE_TIME_PAY_FEE_RULE]: [
    {
      countryList: [COMMON_COUNTRY.DE],
      serviceTypeList: [
        COMMON_SERVICE_TYPE.WEEE_REGISTRATION_DECLARATION,
        COMMON_SERVICE_TYPE.WEEE_TRANSFORM_DECLARATION,
        COMMON_SERVICE_TYPE.WEEE_RENEW,
        COMMON_SERVICE_TYPE.WEEE_ADD_BRAND,
        COMMON_SERVICE_TYPE.WEEE_ADD_WEIGHT,
        COMMON_SERVICE_TYPE.WEEE_INCREMENT,
        COMMON_SERVICE_TYPE.WEEE_CANCELLATION_SERVCIE
      ]
    }
  ],
  [COST_GET_TYPE.DE_WEEE_REGISTRATION_SERVICE_FEE_RULE]: [{ countryList: [COMMON_COUNTRY.DE], serviceTypeList: [COMMON_SERVICE_TYPE.WEEE_REGISTRATION_DECLARATION] }],
  [COST_GET_TYPE.DE_REGISTRATION_GUARANTEE_FEE_RULE]: [{ countryList: [COMMON_COUNTRY.DE], serviceTypeList: [COMMON_SERVICE_TYPE.WEEE_REGISTRATION_DECLARATION] }],
  [COST_GET_TYPE.DE_WEEE_REGISTRATION_SYSTEM_FEE_RULE]: [
    {
      countryList: [COMMON_COUNTRY.DE],
      serviceTypeList: [COMMON_SERVICE_TYPE.WEEE_REGISTRATION_DECLARATION, COMMON_SERVICE_TYPE.BATTERY_REGISTRATION_DECLARATION]
    }
  ],
  [COST_GET_TYPE.MULTI_REGISTRATION_GUARANTEE_FEE_RULE]: [{ countryList: [COMMON_COUNTRY.DE], serviceTypeList: [COMMON_SERVICE_TYPE.WEEE_REGISTRATION_DECLARATION] }],
  [COST_GET_TYPE.MULTI_REGISTRATION_GUARANTEE_FEE_RULE_DW3]: [{ countryList: [COMMON_COUNTRY.DE], serviceTypeList: [COMMON_SERVICE_TYPE.WEEE_REGISTRATION_DECLARATION] }],
  [COST_GET_TYPE.MULTI_REGISTRATION_CHECK_GUARANTEE_FEE_RULE]: [{ countryList: [COMMON_COUNTRY.DE], serviceTypeList: [COMMON_SERVICE_TYPE.WEEE_REGISTRATION_DECLARATION] }],
  [COST_GET_TYPE.MULTI_REGISTRATION_FEE_RULE]: [{ countryList: [COMMON_COUNTRY.DE], serviceTypeList: [COMMON_SERVICE_TYPE.WEEE_REGISTRATION_DECLARATION] }],
  [COST_GET_TYPE.IPP_OFFICIAL_FEE]: COST_GET_TYPE_ALL_COUNTRY_SERVICE_LIST,
  [COST_GET_TYPE.XM_OFFICIAL_FEE]: COST_GET_TYPE_ALL_COUNTRY_SERVICE_LIST,
  [COST_GET_TYPE.DE_WEEE_ADD_CATEGORY_FEE_RULE]: [{ countryList: [COMMON_COUNTRY.DE], serviceTypeList: [COMMON_SERVICE_TYPE.WEEE_ADD_BRAND] }],
  [COST_GET_TYPE.DE_WEEE_ADD_BRAND_FEE_RULE]: [{ countryList: [COMMON_COUNTRY.DE], serviceTypeList: [COMMON_SERVICE_TYPE.WEEE_ADD_BRAND] }],
  [COST_GET_TYPE.DE_WEEE_ADD_BRAND_FEE_DW1_2_RULE]: [{ countryList: [COMMON_COUNTRY.DE], serviceTypeList: [COMMON_SERVICE_TYPE.WEEE_ADD_BRAND] }],
  [COST_GET_TYPE.DE_WEEE_ADD_BRAND_FEE_DW3_RULE]: [{ countryList: [COMMON_COUNTRY.DE], serviceTypeList: [COMMON_SERVICE_TYPE.WEEE_ADD_BRAND] }],
  [COST_GET_TYPE.DPS_ADD_WEIGHT_RULE]: [
    { countryList: [COMMON_COUNTRY.DE], serviceTypeList: [COMMON_SERVICE_TYPE.PLASTIC_TAX_ADD_WEIGHT, COMMON_SERVICE_TYPE.WEEE_ADD_WEIGHT] },
    { countryList: [COMMON_COUNTRY.PL], serviceTypeList: [COMMON_SERVICE_TYPE.BATTERY_ADD_WEIGHT] },
    { countryList: [COMMON_COUNTRY.ES], serviceTypeList: [COMMON_SERVICE_TYPE.WEEE_ADD_WEIGHT] }
  ],
  [COST_GET_TYPE.DE_WEEE_BATTERY_LOGOUT_RULE]: [{ countryList: [COMMON_COUNTRY.DE], serviceTypeList: [COMMON_SERVICE_TYPE.WEEE_CANCELLATION_SERVCIE, COMMON_SERVICE_TYPE.BATTERY_CANCELLATION] }],
  [COST_GET_TYPE.DE_BATTERY_GREATER_1KG_RULE]: [{ countryList: [COMMON_COUNTRY.DE], serviceTypeList: [COMMON_SERVICE_TYPE.BATTERY_REGISTRATION_DECLARATION] }],
  [COST_GET_TYPE.ES_BATTERY_ADD_WEIGHT_RULE]: [{ countryList: [COMMON_COUNTRY.ES], serviceTypeList: [COMMON_SERVICE_TYPE.BATTERY_ADD_WEIGHT] }],
  [COST_GET_TYPE.IT_ADD_WEIGHT_RULE]: [
    {
      countryList: [COMMON_COUNTRY.IT],
      serviceTypeList: [COMMON_SERVICE_TYPE.WEEE_ADD_WEIGHT, COMMON_SERVICE_TYPE.BATTERY_ADD_WEIGHT, COMMON_SERVICE_TYPE.ADDITIONAL_WEIGHT_FOR_PACKAGING_METHOD]
    }
  ],
  [COST_GET_TYPE.ES_PACKAGING_ADD_RULE]: [{ countryList: [COMMON_COUNTRY.ES], serviceTypeList: [COMMON_SERVICE_TYPE.PACKING_ADD_BRAND] }],
  [COST_GET_TYPE.DE_CANCEL_WEEE_CATEGORY_FEE_RULE]: [{ countryList: [COMMON_COUNTRY.DE], serviceTypeList: [COMMON_SERVICE_TYPE.WEEE_CANCELLATION_SERVCIE, COMMON_SERVICE_TYPE.BATTERY_CANCELLATION] }],
  [COST_GET_TYPE.DE_ADD_CATEGORY_REGISTRATION_FEE_RULE]: [{ countryList: [COMMON_COUNTRY.DE], serviceTypeList: [COMMON_SERVICE_TYPE.WEEE_ADD_BRAND] }],
  [COST_GET_TYPE.DE_CANCEL_WEEE_CODE_RULE]: [{ countryList: [COMMON_COUNTRY.DE], serviceTypeList: [COMMON_SERVICE_TYPE.WEEE_CANCELLATION_SERVCIE, COMMON_SERVICE_TYPE.BATTERY_CANCELLATION] }],
  [COST_GET_TYPE.DE_WEEE_ADD_WEIGHT_PACKAGE_RULE]: [{ countryList: [COMMON_COUNTRY.DE], serviceTypeList: [COMMON_SERVICE_TYPE.WEEE_ADD_WEIGHT] }],
  [COST_GET_TYPE.EPR_ADD_WEIGHT_RULE]: COST_GET_TYPE_ALL_COUNTRY_SERVICE_LIST,
  [COST_GET_TYPE.CUSTOMER_REGISTRATION_COUNTRY_FIXED_AMOUNT]: [
    {
      countryList: [COMMON_COUNTRY.PL],
      serviceTypeList: [COMMON_SERVICE_TYPE.VAT_TAX_NUMBER_APPLICATION, COMMON_SERVICE_TYPE.VAT_TRANSFORM_DECLARATION]
    }
  ]
}

const COST_GET_TYPE_MAP = {
  [COST_GET_TYPE.FIX_AMT]: getLabelText({
    key: 'remote.common.fixedAmount',
    text: '固定金额'
  }),
  [COST_GET_TYPE.SERVICE_COMPLETE_MONTH]: getLabelText({
    key: 'remote.common.promptText2',
    text: '基于（服务单完成）自然月的服务单完成数量阶梯报价'
  }),
  [COST_GET_TYPE.OFFICIAL_TRANSLATION_MONTH]: getLabelText({
    key: 'remote.common.ladderQuotationBasedOnTheNumberOfOfficialTranslationsCompletedPerMonth',
    text: '基于官方翻译每月完成数量阶梯报价'
  }),
  [COST_GET_TYPE.SPECIFIC_TIME_SERVICE]: getLabelText({
    key: 'remote.common.ladderQuotationBasedOnTheCumulativeServiceOrderCompletionQuantityAtASpecificTime',
    text: '基于特定时间累计服务单完成数量阶梯报价'
  }),
  [COST_GET_TYPE.SERVICE_PAID_SHARE]: getLabelText({
    key: 'remote.common.shareOfActuallyPaidAmountOfServiceOrder',
    text: '服务单实付金额分成'
  }),
  [COST_GET_TYPE.REMOVE_OTHER_PAID_SHARE]: getLabelText({
    key: 'remote.common.theActualAmountPaidAfterDeductingOtherCostsShallBeDivided',
    text: '去除其他成本后的实付金额进行分成'
  }),
  [COST_GET_TYPE.ONE_CUSTOMER_ONE_PRICE]: getLabelText({
    key: 'remote.common.onePriceForOneCustomer',
    text: '一客一价'
  }),
  [COST_GET_TYPE.DE_ADD_PACKAGE_MATERIAL]:
    getLabelText({
      key: 'remote.common.germany',
      text: '德国'
    }) +
    '--' +
    getLabelText({
      key: 'remote.common.additionalMaterialAndWeightChargesForPackagingMethod',
      text: '包装法追加材料以及重量费'
    }),
  [COST_GET_TYPE.DE_PACKAGE_RECOVERY]:
    getLabelText({ key: 'remote.common.germany', text: '德国' }) +
    '-' +
    getLabelText({ key: 'remote.common.packagingMethod', text: '包装法' }) +
    '-' +
    getLabelText({ key: 'remote.common.recoveryFee', text: '回收费' }),
  [COST_GET_TYPE.FIX_AMT_CLEARING]:
    getLabelText({
      key: 'remote.common.fixedAmount',
      text: '固定金额'
    }) + `（${getLabelText({ key: 'remote.common.sorting', text: '清分' })}）`,
  [COST_GET_TYPE.ONE_CUSTOMER_ONE_PRICE_CLEARING]:
    getLabelText({
      key: 'remote.common.onePriceForOneCustomer',
      text: '一客一价'
    }) + `（${getLabelText({ key: 'remote.common.sorting', text: '清分' })}）`,
  [COST_GET_TYPE.BASE_ASSIGN_SUPPLIER_MONTH]: getLabelText({
    key: 'remote.common.promptText71',
    text: '基于（分配供应商）自然月的服务单递交数量阶梯报价'
  }),
  [COST_GET_TYPE.SERVICE_PAID_FIXED_RATE]: getLabelText({
    key: 'remote.common.fixedRateConvertedFromActualPaymentAmountOfServiceOrder',
    text: '服务单实付金额换算固定费率'
  }),
  [COST_GET_TYPE.PACK_ADD_WEIGHT_RULE]: getLabelText({
    key: 'remote.common.additionalWeightPricingRulesForPackagingLaw',
    text: '德国--包装法追加重量计价规则'
  }),
  [COST_GET_TYPE.BATTERY_ADD_WEIGHT_RULE]: getLabelText({
    key: 'remote.common.additionalWeightPricingRulesForBatteryLaw',
    text: '德国--电池法追加重量计价规则'
  }),
  [COST_GET_TYPE.BATTERY_ADD_BRAND_NAME_RULE]: getLabelText({
    key: 'remote.common.additionalCategoryPricingRulesForBatteryLaw',
    text: '德国--电池法追加品类计价规则'
  }),
  [COST_GET_TYPE.BATTERY_RENEW_RULE]: getLabelText({
    key: 'remote.common.batteryRenewalPricingRules',
    text: '德国--电池法续费计价规则'
  }),
  [COST_GET_TYPE.WEEE_RENEW_SERVICE_FEE_RULE]: getLabelText({
    key: 'remote.common.pricingRulesForWEEERenewalServiceFees',
    text: '德国--WEEE续费服务费计价规则'
  }),
  [COST_GET_TYPE.WEEE_RENEW_CHECK_FEE_RULE]: getLabelText({
    key: 'remote.common.pricingRulesForWEEERenewalAuditFees',
    text: '德国--WEEE续费审核费计价规则'
  }),
  [COST_GET_TYPE.SERVICE_TIME_FIX_FEE_RULE]: getLabelText({
    key: 'remote.common.fixedAmountBasedOnServiceYearsRules',
    text: '德国WEEE--按服务年限的固定金额'
  }),
  [COST_GET_TYPE.WEEE_RENEW_GUARANTEE_FEE_RULE]: getLabelText({
    key: 'remote.common.valuatiOnRulesForWEEERenewalDW3_1AndDW3_2GuaranteeFeesRules',
    text: '德国--WEEE续费DW3-1、DW3-2担保费计价规则'
  }),
  [COST_GET_TYPE.WEEE_RENEW_GUARANTEE_FEE_RULE_DW3]: getLabelText({
    key: 'remote.common.valuationRulesForWEEERenewalDW3_3GuaranteeFee',
    text: 'WEEE续费DW3-3担保费计价规则'
  }),
  [COST_GET_TYPE.SERVICE_TIME_PAY_FEE_RULE]: getLabelText({
    key: 'remote.common.shareTheActualPaymentAmountOfServiceOrdersBasedOnTheLengthOfService',
    text: '德国WEEE--按服务年限的服务单实付金额分成'
  }),
  [COST_GET_TYPE.DE_WEEE_REGISTRATION_SERVICE_FEE_RULE]: getLabelText({
    key: 'remote.common.pricingRulesForMultiCategoryServiceFeesForNewlyRegisteredWEEEInGermany',
    text: '德国WEEE新注册多品类服务费计价规则'
  }),
  [COST_GET_TYPE.DE_REGISTRATION_GUARANTEE_FEE_RULE]: getLabelText({
    key: 'remote.common.germanysWEEENewRegistrationOneProductOneClassGuaranteeFeeRules',
    text: '德国WEEE新注册一品一类担保费规则'
  }),
  [COST_GET_TYPE.DE_WEEE_REGISTRATION_SYSTEM_FEE_RULE]: getLabelText({
    key: 'remote.common.quarterlyUsageFeeForTheNewRegistrationSystemOfWEEEInGermany',
    text: '德国WEEE/电池法新注册系统季度使用费'
  }),
  [COST_GET_TYPE.MULTI_REGISTRATION_GUARANTEE_FEE_RULE]: getLabelText({
    key: 'remote.common.ruleWEEENewRegistrationMultiCategoryDW3_1DW3_2GuaranteeFee',
    text: '德国--WEEE新注册多品类DW3-1、DW3-2担保费'
  }),
  [COST_GET_TYPE.MULTI_REGISTRATION_GUARANTEE_FEE_RULE_DW3]: getLabelText({
    key: 'remote.common.ruleWEEENewRegistrationMultiCategoryDW3_3GuaranteeFee',
    text: 'WEEE新注册多品类DW3-3担保费'
  }),
  [COST_GET_TYPE.MULTI_REGISTRATION_CHECK_GUARANTEE_FEE_RULE]: getLabelText({
    key: 'remote.common.theWEEENewRegistrationMultiCategoryAuditGuaranteeFeeRules',
    text: '德国--WEEE新注册多品类审核担保费规则'
  }),
  [COST_GET_TYPE.MULTI_REGISTRATION_FEE_RULE]: getLabelText({
    key: 'remote.common.theWEEENewRegistrationMultiCategoryRegistrationFeeRules',
    text: '德国--WEEE新注册多品类注册费'
  }),
  [COST_GET_TYPE.IPP_OFFICIAL_FEE]:
    getLabelText({
      key: 'remote.common.pricingRulesBasedOnOfficialFeeAllocation',
      text: '按官费配置计价规则'
    }) + '(IPP)',
  [COST_GET_TYPE.XM_OFFICIAL_FEE]:
    getLabelText({
      key: 'remote.common.pricingRulesBasedOnOfficialFeeAllocation',
      text: '按官费配置计价规则'
    }) + '(OC)',
  [COST_GET_TYPE.DE_WEEE_ADD_CATEGORY_FEE_RULE]: getLabelText({
    key: 'remote.common.pricingRulesForAdditionalCategoryFeesForWEEEinGermany',
    text: '德国WEEE追加类别费计价规则'
  }),
  [COST_GET_TYPE.DE_WEEE_ADD_BRAND_FEE_RULE]: getLabelText({
    key: 'remote.common.pricingRulesForAdditionalBrandFeesForWEEEinGermany',
    text: '德国WEEE追加品牌费计价规则'
  }),
  [COST_GET_TYPE.DE_WEEE_ADD_BRAND_FEE_DW1_2_RULE]: getLabelText({
    key: 'remote.common.pricingRulesForAdditionalCategoryFeesForGermanWEEEAdditionalCategoriesDW3_1AndDW3_2',
    text: '德国WEEE追加品类DW3-1、DW3-2追加类别费计价规则'
  }),
  [COST_GET_TYPE.DE_WEEE_ADD_BRAND_FEE_DW3_RULE]: getLabelText({
    key: 'remote.common.pricingRulesForAdditionalCategoryFeesForGermanWEEEAdditionalCategoryDW3_3',
    text: '德国WEEE追加品类DW3-3追加类别费计价规则'
  }),
  [COST_GET_TYPE.DPS_ADD_WEIGHT_RULE]: getLabelText({
    key: 'remote.common.debosiAdditionalWeightFeePricingRules',
    text: '德波西追加重量费计价规则'
  }),
  [COST_GET_TYPE.DE_WEEE_BATTERY_LOGOUT_RULE]: getLabelText({
    key: 'remote.common.valuationRulesForCancellationFeeTheGermanWEEEBatteryLaw',
    text: '德国WEEE/电池法注销费计价规则'
  }),
  [COST_GET_TYPE.DE_BATTERY_GREATER_1KG_RULE]: getLabelText({
    key: 'remote.common.pricingRulesServiceFeeBatteriesLargerThan1kgGermanBatteryLaw',
    text: '德国电池法大于1kg规格的服务费计价规则'
  }),
  [COST_GET_TYPE.ES_BATTERY_ADD_WEIGHT_RULE]: getLabelText({
    key: 'remote.common.esBatteryAddWeightRule',
    text: '西班牙电池法追加重量费计价规则'
  }),
  [COST_GET_TYPE.IT_ADD_WEIGHT_RULE]: getLabelText({
    key: 'remote.common.itAddWeightRule',
    text: '意大利追加重量费计价规则'
  }),
  [COST_GET_TYPE.ES_PACKAGING_ADD_RULE]: getLabelText({
    key: 'remote.common.esPackagingAddRule',
    text: '西班牙包装法追加申报费计价规则'
  }),
  [COST_GET_TYPE.DE_CANCEL_WEEE_CATEGORY_FEE_RULE]: '德国WEEE/电池法注销品类费计价规则',
  [COST_GET_TYPE.DE_ADD_CATEGORY_REGISTRATION_FEE_RULE]: '德国WEEE追加品类注册费计价规则',
  [COST_GET_TYPE.DE_CANCEL_WEEE_CODE_RULE]: '德国WEEE/电池法注销注册码计价规则',
  [COST_GET_TYPE.DE_WEEE_ADD_WEIGHT_PACKAGE_RULE]: '德国WEEE追加重量套餐计价',
  [COST_GET_TYPE.EPR_ADD_WEIGHT_RULE]: 'EPR追加重量服务计价规则',
  [COST_GET_TYPE.CUSTOMER_REGISTRATION_COUNTRY_FIXED_AMOUNT]: getLabelText({
    key: 'remote.admin.customerRegistrationCountryFixedAmount',
    text: '按客户注册国家固定金额'
  })
}

const COST_GET_TYPE_LIST = createSelectList({
  constants: COST_GET_TYPE,
  map: COST_GET_TYPE_MAP
})

// 规则节点
const DISPATCH_RULE_NODE = {
  SERVICE_OVER: '4',
  SERVICE_SUBMIT: '5',
  SERVICE_PASS: '6',
  NEXT_RECEIPT_TIME: '7',
  SERVICE_SUPPLY: '8',
  SERVICE_PAY: '9'
}

const DISPATCH_RULE_NODE_MAP = {
  [DISPATCH_RULE_NODE.SERVICE_OVER]: getLabelText({
    key: 'remote.common.serviceOrderHasCompletionTime',
    text: '服务单有完成时间'
  }),
  [DISPATCH_RULE_NODE.SERVICE_SUBMIT]: getLabelText({
    key: 'remote.common.customerHasSubmittedServiceMaterials',
    text: '客户已提交服务资料'
  }),
  [DISPATCH_RULE_NODE.SERVICE_PASS]: getLabelText({
    key: 'remote.common.customerServiceAuditMaterialsApproved',
    text: '客服审核资料通过'
  }),
  [DISPATCH_RULE_NODE.NEXT_RECEIPT_TIME]: getLabelText({
    key: 'remote.common.nextReceiptTime',
    text: '下回执时间'
  }),
  [DISPATCH_RULE_NODE.SERVICE_SUPPLY]: getLabelText({
    key: 'remote.common.serviceOrderAssignedToSupplierSuccessfully',
    text: '服务单分配供应商成功'
  }),
  [DISPATCH_RULE_NODE.SERVICE_PAY]:
    getLabelText({
      key: 'remote.common.serviceOrderHasPaymentTime',
      text: '服务单有付款时间'
    }) +
    `(${getLabelText({
      key: 'remote.common.includingPayLaterOrderTime',
      text: '包含先用后付下单时间'
    })})`
}

const DISPATCH_RULE_NODE_LIST = createSelectList({
  constants: DISPATCH_RULE_NODE,
  map: DISPATCH_RULE_NODE_MAP
})

// 兑换类型
const CONVERSION_TYPE = {
  ALL: '0',
  PART: '1',
  PART_TO_ALL: '2',
  ALL_NO_SERVICE: '3',
  PART_NO_SERVICE: '4',
  PART_NO_SERVICE_TO_ALL: '6'
}
const CONVERSION_TYPE_MAP = {
  [CONVERSION_TYPE.ALL]:
    getLabelText({
      key: 'remote.common.fullExchange',
      text: '全部兑换'
    }) +
    `(${getLabelText({
      key: 'remote.common.returnTheService',
      text: '退服务'
    })})`, // 全部兑换
  [CONVERSION_TYPE.PART]:
    getLabelText({
      key: 'remote.common.partialExchange',
      text: '部分兑换'
    }) +
    `(${getLabelText({
      key: 'remote.common.returnTheService',
      text: '退服务'
    })})`, // 部分兑换
  [CONVERSION_TYPE.PART_TO_ALL]:
    getLabelText({
      key: 'remote.common.partialExchange',
      text: '部分兑换'
    }) + '(退服务已全部兑换)', // 部分兑换(已全部兑换)
  [CONVERSION_TYPE.ALL_NO_SERVICE]:
    getLabelText({
      key: 'remote.common.fullExchange',
      text: '全部兑换'
    }) +
    `(${getLabelText({
      key: 'remote.common.non-refundableService',
      text: '不退服务'
    })})`,
  [CONVERSION_TYPE.PART_NO_SERVICE]:
    getLabelText({
      key: 'remote.common.partialExchange',
      text: '部分兑换'
    }) +
    `(${getLabelText({
      key: 'remote.common.non-refundableService',
      text: '不退服务'
    })})`,
  [CONVERSION_TYPE.PART_NO_SERVICE_TO_ALL]:
    getLabelText({
      key: 'remote.common.partialExchange',
      text: '部分兑换'
    }) +
    `(${getLabelText({
      key: 'remote.common.allNon-refundableServicesHaveBeenExchanged',
      text: '不退服务已全部兑换'
    })})`
}

const CONVERSION_TYPE_LIST = createSelectList({
  constants: CONVERSION_TYPE,
  map: CONVERSION_TYPE_MAP
})

// 区域
const REGION = {
  ALL: 'all', // 所有区域
  BJ: '110000', // '北京'
  TJ: '120000', // '天津'
  SH: '310000', // '上海'
  CQ: '500000', // '重庆'
  HEB: '130000', // '河北'
  HEN: '410000', // '河南'
  SHANX: '140000', // '山西'
  HLJ: '230000', // '黑龙江'
  JL: '220000', // '吉林'
  LN: '210000', // '辽宁'
  JS: '320000', // '江苏'
  ZJ: '330000', // '浙江'
  AH: '340000', // '安徽'
  FJ: '350000', // '福建'
  JX: '360000', // '江西'
  SD: '370000', // '山东'
  HUB: '420000', // '湖北'
  HUN: '430000', // '湖南'
  GD: '440000', // '广东'
  GX: '450000', // '广西'
  HAIN: '460000', // '海南'
  SC: '510000', // '四川'
  GZ: '520000', // '贵州'
  YN: '530000', // '云南'
  SX: '610000', // '陕西'
  GS: '620000', // '甘肃'
  QH: '630000', // '青海'
  TW: '710000', // '台湾'
  NMG: '150000', // '内蒙古'
  XZ: '540000', // '西藏'
  NX: '640000', // '宁夏'
  XJ: '650000' // '新疆'
}

const REGION_MAP = {
  [REGION.ALL]: getLabelText({
    key: 'remote.common.allAreas',
    text: '所有区域'
  }), // 所有区域
  [REGION.BJ]: getLabelText({ key: 'remote.common.beijing2', text: '北京' }), // 北京
  [REGION.TJ]: getLabelText({ key: 'remote.common.tianjin2', text: '天津' }), // 天津
  [REGION.SH]: getLabelText({ key: 'remote.common.shanghai', text: '上海' }), // 上海
  [REGION.CQ]: getLabelText({ key: 'remote.common.chongqing', text: '重庆' }), // 重庆
  [REGION.HEB]: getLabelText({ key: 'remote.common.hebei', text: '河北' }), // 河北
  [REGION.HEN]: getLabelText({ key: 'remote.common.henan', text: '河南' }), // 河南
  [REGION.SHANX]: getLabelText({ key: 'remote.common.shanxi', text: '山西' }), // 山西
  [REGION.HLJ]: getLabelText({
    key: 'remote.common.heilongjiang',
    text: '黑龙江'
  }), // 黑龙江
  [REGION.JL]: getLabelText({ key: 'remote.common.jilin', text: '吉林' }), // 吉林
  [REGION.LN]: getLabelText({ key: 'remote.common.liaoning', text: '辽宁' }), // 辽宁
  [REGION.JS]: getLabelText({ key: 'remote.common.jiangsu', text: '江苏' }), // 江苏
  [REGION.ZJ]: getLabelText({ key: 'remote.common.zhejiang', text: '浙江' }), // 浙江
  [REGION.AH]: getLabelText({ key: 'remote.common.anhui', text: '安徽' }), // 安徽
  [REGION.FJ]: getLabelText({ key: 'remote.common.fujian', text: '福建' }), // 福建
  [REGION.JX]: getLabelText({ key: 'remote.common.jiangxi', text: '江西' }), // 江西
  [REGION.SD]: getLabelText({ key: 'remote.common.shandong', text: '山东' }), // 山东
  [REGION.HUB]: getLabelText({ key: 'remote.common.hubei', text: '湖北' }), // 湖北
  [REGION.HUN]: getLabelText({ key: 'remote.common.hunan', text: '湖南' }), // 湖南
  [REGION.GD]: getLabelText({ key: 'remote.common.guangdong', text: '广东' }), // 广东
  [REGION.GX]: getLabelText({ key: 'remote.common.guangxi', text: '广西' }), // 广西
  [REGION.HAIN]: getLabelText({ key: 'remote.common.hainan', text: '海南' }), // 海南
  [REGION.SC]: getLabelText({ key: 'remote.common.szechwan', text: '四川' }), // 四川
  [REGION.GZ]: getLabelText({ key: 'remote.common.guizhou', text: '贵州' }), // 贵州
  [REGION.YN]: getLabelText({ key: 'remote.common.yunnan', text: '云南' }), // 云南
  [REGION.SX]: getLabelText({ key: 'remote.common.shaanxi', text: '陕西' }), // 陕西
  [REGION.GS]: getLabelText({ key: 'remote.common.gansu', text: '甘肃' }), // 甘肃
  [REGION.QH]: getLabelText({ key: 'remote.common.qinghai', text: '青海' }), // 青海
  [REGION.TW]: getLabelText({ key: 'remote.common.taiwan', text: '台湾' }), // 台湾
  [REGION.NMG]: getLabelText({
    key: 'remote.common.innerMongolia',
    text: '内蒙古'
  }), // 内蒙古
  [REGION.XZ]: getLabelText({ key: 'remote.common.tibet', text: '西藏' }), // 西藏
  [REGION.NX]: getLabelText({ key: 'remote.common.ningxia', text: '宁夏' }), // 宁夏
  [REGION.XJ]: getLabelText({ key: 'remote.common.xinjiang', text: '新疆' }) // 新疆
}

const REGION_LIST = createSelectList({ constants: REGION, map: REGION_MAP })

// 活动状态(0:未开始,1:进行中,2:已结束,3:已作废)
const INVITATION_STATUS = {
  WAITING: 0, // 未开始
  HANDING: 1, // 进行中
  ENDED: 2, // 已结束
  RESCINDED: 3 // 已撤销
}

const INVITATION_STATUS_MAP = {
  [INVITATION_STATUS.WAITING]: getLabelText({
    key: 'remote.common.notStarted',
    text: '未开始'
  }),
  [INVITATION_STATUS.HANDING]: getLabelText({
    key: 'remote.common.inProgress',
    text: '进行中'
  }),
  [INVITATION_STATUS.ENDED]: getLabelText({
    key: 'remote.common.ended',
    text: '已结束'
  }),
  [INVITATION_STATUS.RESCINDED]: getLabelText({
    key: 'remote.common.revoked',
    text: '已撤销'
  })
}

const INVITATION_STATUS_LIST = createSelectList({
  constants: INVITATION_STATUS,
  map: INVITATION_STATUS_MAP
})

// 被邀请者奖励 0-优惠券 1-券包 2-服务兑换券 3-满减券
const INVITATION_REWARD = {
  COUPON: 0 // 优惠券
}

const INVITATION_REWARD_MAP = {
  [INVITATION_REWARD.COUPON]: getLabelText({
    key: 'remote.common.coupons',
    text: '优惠券'
  })
}

const INVITATION_REWARD_LIST = createSelectList({
  constants: INVITATION_REWARD,
  map: INVITATION_REWARD_MAP
})
// 券类型， 0： 立减券， 1 券包，2：服务兑换券， 3满减券
const AWARY_TYPE = new GenerateEnum({
  DISCOUNTCOUPON: {
    value: '0',
    label: getLabelText({
      key: 'remote.common.reduceImmediately',
      text: '立减'
    })
  },
  MAXOUTCOUPON: {
    value: '3',
    label: getLabelText({ key: 'remote.common.fullMinus', text: '满减' })
  },
  COUPONBAG: {
    value: '1',
    label: getLabelText({ key: 'remote.common.couponBag', text: '券包' })
  },
  SERVICECOUPON: {
    value: '2',
    label: getLabelText({
      key: 'remote.common.voucherForService',
      text: '服务兑换券'
    })
  }
})
const fullDiscountType = new GenerateEnum({
  //普通满减，循环满减
  ordinary: {
    value: '0',
    label: getLabelText({
      key: 'remote.common.ordinaryFullDiscount',
      text: '普通满减'
    })
  },
  circulation: {
    value: '1',
    label: getLabelText({
      key: 'remote.common.cycleFullMinus',
      text: '循环满减'
    })
  }
})

const VIPLevel = {
  1: getLabelText({ key: 'remote.common.vipMember', text: 'VIP会员' }),
  2: getLabelText({ key: 'remote.common.svipMember', text: 'SVIP会员' })
}

// 奖励购买条件类型：0首个订单，1首个服务单
const REWARD_PURCHASE_TYPE = {
  FIRST_ORDER: 0,
  FIRST_PIECE: 1
}

const REWARD_PURCHASE_TYPE_MAP = {
  [REWARD_PURCHASE_TYPE.FIRST_ORDER]: getLabelText({
    key: 'remote.common.firstOrder',
    text: '首个订单'
  }),
  [REWARD_PURCHASE_TYPE.FIRST_PIECE]: getLabelText({
    key: 'remote.common.firstServiceOrder',
    text: '首个服务单'
  })
}

const REWARD_PURCHASE_TYPE_LIST = createSelectList({
  constants: REWARD_PURCHASE_TYPE,
  map: REWARD_PURCHASE_TYPE_MAP
})

const MSGKIND = {
  SMS: '0', // 短信验证
  VOICE_PHONE: '1', // 语音电话
  VOICE_VERIFY: '2' // 语音验证
}

const MSGKINDMAP = {
  [MSGKIND.SMS]: getLabelText({
    key: 'remote.common.smsVerification',
    text: '短信验证'
  }),
  [MSGKIND.VOICE_PHONE]: getLabelText({
    key: 'remote.common.voiceCall',
    text: '语音电话'
  }),
  [MSGKIND.VOICE_VERIFY]: getLabelText({
    key: 'remote.common.voiceAuthentication',
    text: '语音验证'
  })
}

// 发放状态 0：等待中，1：已发放，2：失败，3：已驳回，4：已取消
const SEND_STATUS = {
  WAIT: 0, // 等待中
  SENDED: 1, // 已发放
  FAIL: 2, // 失败
  REJECT: 3, // 已驳回
  CANCEL: 4 // 已取消
}

const SEND_STATUS_MAP = {
  [SEND_STATUS.WAIT]: getLabelText({
    key: 'remote.common.waiting',
    text: '等待中'
  }),
  [SEND_STATUS.SENDED]: getLabelText({
    key: 'remote.common.issued',
    text: '已发放'
  }),
  [SEND_STATUS.FAIL]: getLabelText({
    key: 'remote.common.failure',
    text: '失败'
  }),
  [SEND_STATUS.REJECT]: getLabelText({
    key: 'remote.common.rejected',
    text: '已驳回'
  }),
  [SEND_STATUS.CANCEL]: getLabelText({
    key: 'remote.common.cancelled',
    text: '已取消'
  })
}

const SEND_STATUS_LIST = createSelectList({
  constants: SEND_STATUS,
  map: SEND_STATUS_MAP
})

/*
订单状态
PENDING_PAYMENT("0", "待付款"),
PENDING_CONFIRM("1", "待确认"),
CANCELLED("2", "已取消"),
PAID("3", "已付款"),
COMPLETED("4", "已完成"),
REFUNDED("5", "已退款"),
DEPOSIT_PENDING_PAYMENT("6", "定金待付款"),
DEPOSIT_PENDING_CONFIRM("7", "定金支付待确认"),
ABLANCE_PENDING_PAYMENT("8", "尾款待付款"),
ABLANCE_PENDING_CONFIRM("9", "尾款支付待确认"),
DEPOSIT_CANCELLED("10", "定金已取消"),
ABLANCE_CANCELLED("11", "尾款已取消"),
AFTER_PAY_ORDERED("12", "已下单"),
*/
const ORDER_STATUS_ADMIN = {
  PENDING_PAYMENT: 0,
  PENDING_CONFIRM: 1,
  CANCELLED: 2,
  PAID: 3,
  COMPLETED: 4,
  REFUNDED: 5,
  DEPOSIT_PENDING_PAYMENT: 6,
  DEPOSIT_PENDING_CONFIRM: 7,
  ABLANCE_PENDING_PAYMENT: 8,
  ABLANCE_PENDING_CONFIRM: 9,
  DEPOSIT_CANCELLED: 10,
  ABLANCE_CANCELLED: 11,
  AFTER_PAY_ORDERED: 12 // 先用后付下单，还未付款时的状态
}

/**
 * 系统类型 00-欧税通  01 -麦德通   08-六度
 */
const PLAT_FORM = {
  VAT: '00',
  IPP: '01',
  LiDo: '08',
  XM: '10',
  // TH: '13',
  LZ: '15',
  VATAI_EU: '16',
  VATAI_US: '17',
  REME: '19',
  YS: '21',
  LY: '22',
  NB: '23'
}
const PLAT_FORM_MAP = {
  [PLAT_FORM.VAT]: getLabelText({
    key: 'remote.common.europeanTaxPass',
    text: '欧税通'
  }),
  [PLAT_FORM.IPP]: getLabelText({
    key: 'remote.common.metton',
    text: '麦德通'
  }),
  [PLAT_FORM.LiDo]: getLabelText({
    key: 'remote.common.sixDegreesInternational',
    text: '六度信息'
  }),
  [PLAT_FORM.XM]: getLabelText({
    key: 'remote.common.smallTradeGoesToSea',
    text: '小贸出海'
  }),
  [PLAT_FORM.LZ]: getLabelText({
    key: 'remote.common.greenBoat',
    text: '绿舟'
  }),
  [PLAT_FORM.VATAI_EU]: 'VATAi-' + getLabelText({ key: 'remote.common.euStation', text: '欧洲站' }),
  [PLAT_FORM.VATAI_US]: 'VATAi-' + getLabelText({ key: 'remote.common.usStation', text: '美国站' }),
  [PLAT_FORM.REME]: 'RecycleMe',
  [PLAT_FORM.YS]: '易思跨境',
  [PLAT_FORM.LY]: '乐鱼跨境',
  [PLAT_FORM.NB]: '能标检测'
}

const SYSTEM_TYPE = {
  VAT: '00',
  IPP: '01',
  XM: '04'
}

const BUSINESS_TYPE = [
  { name: 'VAT+', platform: PLAT_FORM.VAT, system: SYSTEM_TYPE.VAT, value: 0 },
  { name: 'EPR', platform: PLAT_FORM.VAT, system: SYSTEM_TYPE.VAT, value: 1 },
  { name: 'RSP', platform: PLAT_FORM.VAT, system: SYSTEM_TYPE.VAT, value: 2 },
  // { name: '海外公司', platform: PLAT_FORM.VAT, system: SYSTEM_TYPE.VAT, value: 3 },
  { name: 'IPP', platform: PLAT_FORM.IPP, system: SYSTEM_TYPE.IPP, value: 4 },
  { name: 'OC', platform: PLAT_FORM.XM, system: SYSTEM_TYPE.XM, value: 5 },
  { name: 'CI', platform: PLAT_FORM.LZ, system: SYSTEM_TYPE.LZ, value: 7 }
]

const PLAT_FORM_LIST = createSelectList({
  constants: PLAT_FORM,
  map: PLAT_FORM_MAP
})

const ORDER_STATUS_MAP = {
  [ORDER_STATUS_ADMIN.PENDING_PAYMENT]: getLabelText({
    key: 'remote.common.toBePaid',
    text: '待付款'
  }),
  [ORDER_STATUS_ADMIN.PENDING_CONFIRM]: getLabelText({
    key: 'remote.common.toBeConfirmed',
    text: '待确认'
  }),
  [ORDER_STATUS_ADMIN.CANCELLED]: getLabelText({
    key: 'remote.common.cancelled',
    text: '已取消'
  }),
  [ORDER_STATUS_ADMIN.PAID]: getLabelText({
    key: 'remote.common.paid',
    text: '已付款'
  }),
  [ORDER_STATUS_ADMIN.COMPLETED]: getLabelText({
    key: 'remote.common.completed',
    text: '已完成'
  }),
  [ORDER_STATUS_ADMIN.REFUNDED]: getLabelText({
    key: 'remote.common.refunded',
    text: '已退款'
  }),
  [ORDER_STATUS_ADMIN.DEPOSIT_PENDING_PAYMENT]: getLabelText({
    key: 'remote.common.depositToBePaid',
    text: '定金待付款'
  }),
  [ORDER_STATUS_ADMIN.DEPOSIT_PENDING_CONFIRM]: getLabelText({
    key: 'remote.common.depositPaymentToBeConfirmed',
    text: '定金支付待确认'
  }),
  [ORDER_STATUS_ADMIN.ABLANCE_PENDING_PAYMENT]: getLabelText({
    key: 'remote.common.depositToBePaid',
    text: '尾款待付款'
  }),
  [ORDER_STATUS_ADMIN.ABLANCE_PENDING_CONFIRM]: getLabelText({
    key: 'remote.common.finalPaymentToBeConfirmed',
    text: '尾款支付待确认'
  }),
  [ORDER_STATUS_ADMIN.DEPOSIT_CANCELLED]: getLabelText({
    key: 'remote.common.theDepositHasBeenCancelled',
    text: '定金已取消'
  }),
  [ORDER_STATUS_ADMIN.ABLANCE_CANCELLED]: getLabelText({
    key: 'remote.common.theFinalPaymentHasBeenCancelled',
    text: '尾款已取消'
  }),
  [ORDER_STATUS_ADMIN.AFTER_PAY_ORDERED]: getLabelText({
    key: 'remote.common.theOrderHasBeenPlaced',
    text: '已下单'
  })
}

const ORDER_STATUS_LIST = createSelectList({
  constants: ORDER_STATUS_ADMIN,
  map: ORDER_STATUS_MAP
})

// 开票税点
const TAX_POINT = {
  six: {
    value: '0.06',
    label: '6%'
  },
  thirteen: {
    value: '0.13',
    label: '13%'
  }
}

// 类目级别 1：一级，2：二级，3：三级
const REASON_GRADE = {
  FIRST: 1,
  SECOND: 2
}

const REASON_GRADE_MAP = {
  [REASON_GRADE.FIRST]: getLabelText({
    key: 'remote.common.level1',
    text: '一级'
  }),
  [REASON_GRADE.SECOND]: getLabelText({
    key: 'remote.common.level2',
    text: '二级'
  })
}

// 代理到中台地址的前缀
const CENTER_BASE_URL = '/base-api'

// 退款相关部门，品牌部、交付部、客服部、销售部、研发部、财务部、市场部、其它
const REFUND_DEPARTMENT = {
  BRAND_DEPT: 1, // 品牌部
  DELIVERY_DEPT: 2, // 交付部
  SERVICE_DEPT: 3, // 客服部
  SALES_DEPT: 4, // 销售部
  DEVELOPMENT_DEPT: 5, // 研发部
  FINANCE_DEPT: 6, // 财务部
  MARKETING_DEPT: 7, // 市场部
  USER: 8, // 用户原因
  OTHER: 0 // 其它
}

const REFUND_DEPARTMENT_MAP = {
  [REFUND_DEPARTMENT.BRAND_DEPT]: getLabelText({
    key: 'remote.common.brandDepartment',
    text: '品牌部'
  }),
  [REFUND_DEPARTMENT.DELIVERY_DEPT]: getLabelText({
    key: 'remote.common.deliveryDepartment',
    text: '交付部'
  }),
  [REFUND_DEPARTMENT.SERVICE_DEPT]: getLabelText({
    key: 'remote.common.customerServiceDepartment',
    text: '客服部'
  }),
  [REFUND_DEPARTMENT.SALES_DEPT]: getLabelText({
    key: 'remote.common.salesDepartment',
    text: '销售部'
  }),
  [REFUND_DEPARTMENT.DEVELOPMENT_DEPT]: getLabelText({
    key: 'remote.common.r&DDepartment',
    text: '研发部'
  }),
  [REFUND_DEPARTMENT.FINANCE_DEPT]: getLabelText({
    key: 'remote.common.financeDepartment',
    text: '财务部'
  }),
  [REFUND_DEPARTMENT.MARKETING_DEPT]: getLabelText({
    key: 'remote.common.marketingDepartment',
    text: '市场部'
  }),
  [REFUND_DEPARTMENT.USER]: getLabelText({
    key: 'remote.common.userReason',
    text: '用户原因'
  }),
  [REFUND_DEPARTMENT.OTHER]: getLabelText({
    key: 'remote.common.other2',
    text: '其它'
  })
}

// 去掉“市场部、财务部”
const { FINANCE_DEPT, MARKETING_DEPT, ...NEW_REFUND_DEPARTMENT } = REFUND_DEPARTMENT

const REFUND_DEPARTMENT_LIST = createSelectList({
  constants: NEW_REFUND_DEPARTMENT,
  map: REFUND_DEPARTMENT_MAP
})

const INTENTION_ENUM = {
  0: getLabelText({ key: 'remote.common.low', text: '低' }),
  1: getLabelText({ key: 'remote.common.medium', text: '中' }),
  2: getLabelText({ key: 'remote.common.high', text: '高' })
}

//支付方式
const ORDER_PAYMENT_METHOD_ENUM = {
  /** 对公转账 */
  TRANSFER_ACCOUNT: {
    key: '0',
    name: getLabelText({
      key: 'remote.common.corporateTransfer',
      text: '对公转账'
    })
  },
  /** 通联-微信 */
  TONG_LIAN_WECHAT: {
    key: '1',
    name:
      getLabelText({
        key: 'remote.common.communication',
        text: '通联'
      }) +
      '' +
      getLabelText({ key: 'remote.common.wechat', text: '微信' })
  },
  /** 通联-支付宝 */
  TONG_LIAN_ALIPAY: {
    key: '2',
    name:
      getLabelText({
        key: 'remote.common.communication',
        text: '通联'
      }) +
      '' +
      getLabelText({ key: 'remote.common.alipay', text: '支付宝' })
  },
  /** 有赞收款 */
  YOU_ZHAN: {
    key: '3',
    name: getLabelText({
      key: 'remote.common.thereIsACollectionOfPraise',
      text: '有赞收款'
    })
  },
  /** 微信收款 */
  WECHAT: {
    key: '4',
    name: getLabelText({
      key: 'remote.common.wechatCollection',
      text: '微信收款'
    })
  },
  /** 渠道结算 */
  CHANNEL_SETTLEMENT: {
    key: '5',
    name: getLabelText({
      key: 'remote.common.channelSettlement',
      text: '渠道结算'
    })
  },
  /** 现金收款 */
  CASH: {
    key: '6',
    name: getLabelText({ key: 'remote.common.cashReceipts', text: '现金收款' })
  },
  /** 运营赠送 */
  OPERATION_GIFT: {
    key: '7',
    name: getLabelText({ key: 'remote.common.operationGift', text: '运营赠送' })
  },
  /** 代金券抵扣 */
  VOUCHER_DEDUCTION: {
    key: '8',
    name: getLabelText({
      key: 'remote.common.voucherDeduction',
      text: '代金券抵扣'
    })
  },
  /** 服务兑换券抵扣 */
  VOUCHER_SERVICE: {
    key: '9',
    name: getLabelText({
      key: 'remote.common.deductionOfServiceVouchers',
      text: '服务兑换券抵扣'
    })
  },
  /**
   * 微店付款
   */
  WEDIAN: {
    key: '10',
    name: getLabelText({
      key: 'remote.common.micro-storePayment',
      text: '微店付款'
    })
  },
  /** 招商银行-微信 */
  MERCHANTS_BANK_WECHAT: {
    key: '11',
    name:
      getLabelText({
        key: 'remote.common.chinaMerchantsBank',
        text: '招商银行'
      }) + getLabelText({ key: 'remote.common.wechat', text: '微信' })
  },
  /** 招商银行-支付宝 */
  MERCHANTS_BANK_ALIPAY: {
    key: '12',
    name:
      getLabelText({
        key: 'remote.common.chinaMerchantsBank',
        text: '招商银行'
      }) + getLabelText({ key: 'remote.common.alipay', text: '支付宝' })
  },
  /** 招商银行-微信收款 */
  MERCHANTS_BANK_WECHAT_PAY: {
    key: '13',
    name:
      getLabelText({
        key: 'remote.common.chinaMerchantsBank',
        text: '招商银行'
      }) + getLabelText({ key: 'remote.common.wechatCollection', text: '微信收款' })
  },
  /** 招商银行-银联 */
  MERCHANTS_BANK_UNIONPAY: {
    key: '14',
    name:
      getLabelText({
        key: 'remote.common.chinaMerchantsBank',
        text: '招商银行'
      }) + getLabelText({ key: 'remote.common.unionpay', text: '银联' })
  },
  /** 商户账户余额支付 */
  BALANCE_RECHARGE_PAY: {
    key: '15',
    name: getLabelText({
      key: 'remote.common.balancePayment2',
      text: '余额付款'
    })
  },
  /** 企业支付宝 */
  COMPANY_ALIPAY: {
    key: '16',
    name: getLabelText({
      key: 'remote.common.enterpriseAlipay',
      text: '企业支付宝'
    })
  },
  /** 阿里后付 */
  ALIPAY_AFTER: {
    key: '17',
    name: getLabelText({ key: 'remote.common.aliPaysLater', text: '阿里后付' })
  },
  /** 速卖通结算支付 */
  ALIEXPRESS_SETTLEMENT_PAYMENT: {
    key: '19',
    name: getLabelText({ key: 'remote.common.smttdPaysLater', text: '速卖通结算支付' })
  },
  /** 服务兑换积分 目前仅在售后单有这个类型 */
  PRESENTED_SCORE: {
    key: '30',
    name: getLabelText({
      key: 'remote.common.serviceExchangePoints',
      text: '服务兑换积分'
    })
  },
  /** 连连-微信 */
  LIANLIAN_WECHAT: {
    key: '103',
    name:
      getLabelText({ key: 'remote.common.lianlian', text: '连连' }) +
      getLabelText({
        key: 'remote.common.wechat',
        text: '微信'
      })
  },
  /** 连连-支付宝 */
  LIANLIAN_ALPAY: {
    key: '104',
    name:
      getLabelText({ key: 'remote.common.lianlian', text: '连连' }) +
      getLabelText({
        key: 'remote.common.alipay',
        text: '支付宝'
      })
  },
  /** 通联-微信收款 */
  TONG_LIAN_WECHAT_PAY: {
    key: '105',
    name:
      getLabelText({
        key: 'remote.common.communication',
        text: '通联'
      }) + getLabelText({ key: 'remote.common.wechatCollection', text: '微信收款' })
  },
  EOB: {
    key: '106',
    name:
      getLabelText({
        key: 'remote.common.inviteInvestment',
        text: '招商'
      }) +
      '-' +
      getLabelText({
        key: 'remote.common.corporateOnlineBanking',
        text: '企业网银'
      })
  },
  ALLIN_PAY: {
    key: '107',
    name:
      getLabelText({
        key: 'remote.common.communication',
        text: '通联'
      }) +
      '-' +
      getLabelText({
        key: 'remote.common.corporateOnlineBanking',
        text: '企业网银'
      })
  }
}

/**订单来源*/
const ORDER_SOURCE_ENUM = {
  /** 官方网站 */
  OFFICIAL_WEBSITE: {
    key: '0',
    name: getLabelText({
      key: 'remote.common.officialWebsite2',
      text: '官方网站'
    })
  },
  /** 微信公众号 */
  WECHAT_SUBSCRIPTION: {
    key: '1',
    name: getLabelText({
      key: 'remote.common.wechatTheOfficialAccount',
      text: '微信公众号'
    })
  },
  /** 系统后台 */
  SYSTEM_BACKEND: {
    key: '2',
    name: getLabelText({
      key: 'remote.common.systemBackground',
      text: '系统后台'
    })
  },
  /** 微信小程序 */
  WECHAT_MINI: {
    key: '3',
    name: getLabelText({
      key: 'remote.common.wechatApplet',
      text: '微信小程序'
    })
  },

  /** 大客户批量创建 */
  BATCH_CREATE: {
    key: '4',
    name: getLabelText({
      key: 'remote.common.massCreationOfLargeCustomers',
      text: '大客户批量创建'
    })
  },
  /** 合规帮手 */
  COMPLIANCE_HRLPER: {
    key: '5',
    name: getLabelText({
      key: 'remote.common.complianceHelper',
      text: '合规帮手'
    })
  },
  /** 代客户加购 */
  PROXY_ORDER: {
    key: '6',
    name: getLabelText({
      key: 'remote.common.placeOrdersOnBehalfOfCustomers',
      text: '代客户加购'
    })
  },
  UNIVERSAL: {
    key: '7',
    name: getLabelText({
      key: 'remote.common.universalOrder',
      text: '万能订单'
    })
  },
  PRICE_DIF: {
    key: '8',
    name: getLabelText({
      key: 'remote.common.makeUpTheDifference',
      text: '补差价'
    })
  },
  IMPORT_BUY_ORDER: {
    key: '9',
    name:
      getLabelText({
        key: 'remote.common.importOrders',
        text: '导入订单'
      }) +
      '_' +
      getLabelText({ key: 'remote.common.purchasedOrders', text: '已购订单' })
  },
  IMPORT_WAIT_PAYMENT: {
    key: '10',
    name:
      getLabelText({
        key: 'remote.common.importOrders',
        text: '导入订单'
      }) +
      '_' +
      getLabelText({ key: 'remote.common.receivables', text: '已购订单' })
  },
  ISFROMLIUDU: {
    key: '13',
    name: getLabelText({ key: 'remote.common.sixDegreeMigration', text: '六度迁移' })
  }
}

//订单状态
const ORDER_STATUS_ENUM = {
  /** 待付款 */
  PENDING_PAYMENT: {
    key: '0',
    name: getLabelText({ key: 'remote.common.toBePaid', text: '待付款' })
  },

  /** 待确认 */
  PENDING_CONFIRM: {
    key: '1',
    name: getLabelText({
      key: 'remote.common.paymentToBeConfirmed',
      text: '支付待确认'
    })
  },
  /** 已取消 */
  CANCELLED: {
    key: '2',
    name: getLabelText({ key: 'remote.common.cancelled', text: '已取消' })
  },
  /** 已付款 */
  PAID: {
    key: '3',
    name: getLabelText({ key: 'remote.common.paid', text: '已付款' })
  },
  /** 已完成 */
  COMPLETED: {
    key: '4',
    name: getLabelText({ key: 'remote.common.completed', text: '已完成' })
  },
  /** 已退款 */
  REFUNDED: {
    key: '5',
    name: getLabelText({ key: 'remote.common.refunded', text: '已退款' })
  },
  // /** 定金待付款 */
  // DEPOSIT_PENDING_PAYMENT: {
  //   key: '6',
  //   name: '定金待付款'
  // },
  //
  // /** 定金支付待确认 */
  // DEPOSIT_PENDING_CONFIRM: {
  //   key: '7',
  //   name: '定金支付待确认'
  // },
  // /** 尾款待付款 */
  // ABLANCE_PENDING_PAYMENT: {
  //   key: '8',
  //   name: '尾款待付款'
  // },
  // /** 尾款待付款 */
  // ABLANCE_PENDING_CONFIRM: {
  //   key: '9',
  //   name: '尾款支付待确认'
  // },
  // /** 定金已取消 */
  // DEPOSIT_CANCELLED: {
  //   key: '10',
  //   name: '定金已取消'
  // },
  // /** 尾款已取消 */
  // ABLANCE_CANCELLED: {
  //   key: '11',
  //   name: '尾款已取消'
  // },
  /**
   * 先用后付下单，还未付款时的状态
   */
  AFTER_PAY_ORDERED: {
    key: '12',
    name: getLabelText({
      key: 'remote.common.theOrderHasBeenPlaced',
      text: '已下单'
    })
  }
}

const CURRENCY_LIST = [
  {
    label: getLabelText({ key: 'remote.common.america', text: '美国' }),
    currency: 'USD',
    value: '1'
  },
  {
    label: getLabelText({ key: 'remote.common.europeanUnion', text: '欧盟' }),
    currency: 'EUR',
    value: '4'
  },
  {
    label: getLabelText({ key: 'remote.common.theUk', text: '英国' }),
    currency: 'GBP',
    value: '2'
  },
  {
    label: getLabelText({ key: 'remote.common.japan.text', text: '日本' }),
    currency: 'JPY',
    value: '3'
  },
  {
    label: getLabelText({ key: 'remote.common.germany', text: '德国' }),
    currency: 'EUR',
    value: '8'
  },
  {
    label: getLabelText({ key: 'remote.common.canada', text: '加拿大' }),
    currency: 'CAD',
    value: '10'
  },
  {
    label: getLabelText({ key: 'remote.common.australia', text: '澳大利亚' }),
    currency: 'AUD',
    value: '9'
  },
  {
    label: getLabelText({ key: 'remote.common.korea', text: '韩国' }),
    currency: 'KRW',
    value: '5'
  },
  {
    label: getLabelText({ key: 'remote.common.philippines', text: '菲律宾' }),
    currency: 'PHP',
    value: '6'
  },
  {
    label: getLabelText({ key: 'remote.common.india', text: '印度' }),
    currency: 'INR',
    value: '7'
  },
  {
    label: getLabelText({ key: 'remote.common.brazil', text: '巴西' }),
    currency: 'BRL',
    value: '11'
  }
]

const NEED_PRICE_LIST = [
  {
    code: 0,
    name: getLabelText({
      key: 'remote.common.configuredBySpuDimension',
      text: '按spu维度配置'
    })
  },
  {
    code: 1,
    name: getLabelText({
      key: 'remote.common.configuredBySkuDimension',
      text: '按sku维度配置'
    })
  }
]
const COST_TYPE = {
  OFFICIAL_FEE: {
    name: getLabelText({ key: 'remote.common.officialExpenses', text: '官费' }),
    code: 7
  },
  SERVICE_CHARGE: {
    name: getLabelText({ key: 'remote.common.serviceCharge', text: '服务费' }),
    code: 12
  }
}

// 【注销状态】：未申请、申请中、已注销
const WRITE_OFF_STATE = {
  NOT_APPLY: 0,
  APPLYING: 1,
  CANCELED: 2
}

const WRITE_OFF_STATE_MAP = {
  [WRITE_OFF_STATE.NOT_APPLY]: getLabelText({
    key: 'remote.common.notApplied',
    text: '未申请'
  }),
  [WRITE_OFF_STATE.APPLYING]: getLabelText({
    key: 'remote.common.applicationInProgress',
    text: '申请中'
  }),
  [WRITE_OFF_STATE.CANCELED]: getLabelText({
    key: 'remote.common.loggedOut',
    text: '已注销'
  })
}

const WRITE_OFF_STATE_LIST = createSelectList({
  constants: WRITE_OFF_STATE,
  map: WRITE_OFF_STATE_MAP
})

const CONTRACTING_ENTITY = {
  E_VAT_MASTER: '0',
  E_SERVICE_NAVIGATEUR: '1',
  E_VAT_MASTER_CONSULTING_GMBH: '2',
  OST_CONSULTING_FRANCE: '3',
  SIX_DU: '4',
  OST_CONSULTING_GMBH: '5',
  OST_SIMPLE: '6'
}

const CONTRACTING_ENTITY_MAP = {
  [CONTRACTING_ENTITY.E_VAT_MASTER]: getLabelText({
    key: 'remote.common.shenzhenOushuitongTechnologyCo.Ltd',
    text: '深圳欧税通技术有限公司'
  }),
  [CONTRACTING_ENTITY.E_SERVICE_NAVIGATEUR]: 'E-SERVICE NAVIGATEUR',
  [CONTRACTING_ENTITY.E_VAT_MASTER_CONSULTING_GMBH]: 'eVatmaster Consulting GmbH',
  [CONTRACTING_ENTITY.OST_CONSULTING_FRANCE]: 'OST Consulting France',
  [CONTRACTING_ENTITY.SIX_DU]: getLabelText({
    key: 'remote.common.sixDegrees',
    text: '六度'
  }),
  [CONTRACTING_ENTITY.OST_CONSULTING_GMBH]: 'OST Consulting GmbH',
  [CONTRACTING_ENTITY.OST_SIMPLE]: getLabelText({
    key: 'remote.common.ouShuiTongLimited',
    text: '欧税通有限公司'
  })
}

const CONTRACTING_ENTITY_LIST = createSelectList({
  constants: CONTRACTING_ENTITY,
  map: CONTRACTING_ENTITY_MAP
})

const MDT_CONTRACTING_ENTITY = {
  SHANGHAI_SOFTWARE: '7',
  SHANGHAI_SOFTWARE_SHENZHEN_AGENT: '8',
  SHENZHEN_AGENT: '9',
  SHENZHEN_SKILL: '10',
  SHENZHEN_SKILL_SHANGHAI_SOFTWARE: '11',
  HONGKONG_OST: '12'
}

const MDT_CONTRACTING_ENTITY_MAP = {
  [MDT_CONTRACTING_ENTITY.SHANGHAI_SOFTWARE]: getLabelText({
    key: 'remote.common.shanghaiSoftware',
    text: '上海软件'
  }),
  [MDT_CONTRACTING_ENTITY.SHANGHAI_SOFTWARE_SHENZHEN_AGENT]:
    getLabelText({
      key: 'remote.common.shanghaiSoftware',
      text: '上海软件'
    }) +
    '&' +
    getLabelText({ key: 'remote.common.shenzhenAgent', text: '深圳代理' }),
  [MDT_CONTRACTING_ENTITY.SHENZHEN_AGENT]: getLabelText({
    key: 'remote.common.shenzhenAgent',
    text: '深圳代理'
  }),
  [MDT_CONTRACTING_ENTITY.SHENZHEN_SKILL]: getLabelText({
    key: 'remote.common.shenzhenTechnology',
    text: '深圳技术'
  }),
  [MDT_CONTRACTING_ENTITY.SHENZHEN_SKILL_SHANGHAI_SOFTWARE]:
    getLabelText({
      key: 'remote.common.shenzhenTechnology',
      text: '深圳技术'
    }) +
    '&' +
    getLabelText({ key: 'remote.common.shanghaiSoftware', text: '上海软件' }),
  [MDT_CONTRACTING_ENTITY.HONGKONG_OST]: getLabelText({ key: 'remote.common.hongKong', text: '香港' }) + 'OST'
}

const MDT_CONTRACTING_ENTITY_LIST = createSelectList({
  constants: MDT_CONTRACTING_ENTITY,
  map: MDT_CONTRACTING_ENTITY_MAP
})

const LIDO_CONTRACTING_ENTITY = {
  LIDO_CONSULTING_GMBH: '13',
  LIDO_COMPANY: '14',
  TANMET_INTL_BUSINESS_LTD: '15',
  EUBRIDGE_ADVISORY_GMBH: '16'
}

const LIDO_CONTRACTING_ENTITY_MAP = {
  [LIDO_CONTRACTING_ENTITY.LIDO_CONSULTING_GMBH]: 'Lido Consulting GmbH',
  [LIDO_CONTRACTING_ENTITY.LIDO_COMPANY]: getLabelText({
    key: 'remote.common.shenzhenLiuduInformationServiceCo.Ltd',
    text: '深圳六度信息服务有限公司'
  }),
  [LIDO_CONTRACTING_ENTITY.TANMET_INTL_BUSINESS_LTD]: `TANMET INT'L BUSINESS LTD`,
  [LIDO_CONTRACTING_ENTITY.EUBRIDGE_ADVISORY_GMBH]: 'EUBRIDGE ADVISORY GMBH'
}

const LIDO_CONTRACTING_ENTITY_LIST = createSelectList({
  constants: LIDO_CONTRACTING_ENTITY,
  map: LIDO_CONTRACTING_ENTITY_MAP
})

const TH_CONTRACTING_ENTITY = {
  TH_SHENZHEN: '17'
}
const TH_CONTRACTING_ENTITY_MAP = {
  [TH_CONTRACTING_ENTITY.TH_SHENZHEN]: getLabelText({
    key: 'remote.common.shenzhenTianheHaihaiTechnologyCo.Ltd',
    text: '深圳天合出海科技有限公司'
  })
}

const TH_CONTRACTING_ENTITY_LIST = createSelectList({
  constants: TH_CONTRACTING_ENTITY,
  map: TH_CONTRACTING_ENTITY_MAP
})

const XM_CONTRACTING_ENTITY = {
  XM_SHENZHEN: '18',
  XM_SHENZHEN_ZH: '19',
  XM_SHENZHEN_OTHER: '20'
}
const XM_CONTRACTING_ENTITY_MAP = {
  [XM_CONTRACTING_ENTITY.XM_SHENZHEN]: getLabelText({
    key: 'remote.common.shenzhenSmallTradeTechnologyCo.Ltd',
    text: '深圳小贸出海技术有限公司'
  }),
  [XM_CONTRACTING_ENTITY.XM_SHENZHEN_ZH]: getLabelText({
    key: 'remote.common.shenzhenZhongheLeadingInternationalBusinessConsultingCoLtd',
    text: '深圳众和领航国际商务咨询有限公司'
  }),
  [XM_CONTRACTING_ENTITY.XM_SHENZHEN_OTHER]: getLabelText({
    key: 'remote.common.chuanghuiEnterpriseManagementConsultingCoLtd',
    text: '创汇企业管理咨询有限公司'
  })
}

const XM_CONTRACTING_ENTITY_LIST = createSelectList({
  constants: XM_CONTRACTING_ENTITY,
  map: XM_CONTRACTING_ENTITY_MAP
})

const COST_ESTIMATION = {
  WAIT_CONFIRM: '0',
  WAIT_SETTLEMENT: '1',
  NOT_SETTLEMENT: '2',
  HAS_SETTLED: '3',
  PARTIALLY_SETTLED: '4',
  WRITE_OFF: '9'
}

const COST_ESTIMATION_MAP = {
  [COST_ESTIMATION.WAIT_CONFIRM]: getLabelText({
    key: 'remote.common.estimatedAndPendingConfirmation',
    text: '已预估待确认'
  }),
  [COST_ESTIMATION.WAIT_SETTLEMENT]: getLabelText({
    key: 'remote.common.confirmedAndPendingSettlement',
    text: '已确认待结算'
  }),
  [COST_ESTIMATION.NOT_SETTLEMENT]: getLabelText({
    key: 'remote.common.confirmedAndNoNeedForSettlement',
    text: '已确认无需结算'
  }),
  [COST_ESTIMATION.HAS_SETTLED]: getLabelText({
    key: 'remote.admin.settled',
    text: '已结算'
  }),
  [COST_ESTIMATION.PARTIALLY_SETTLED]: getLabelText({
    key: 'remote.admin.partSettled',
    text: '已部分结算'
  }),
  [COST_ESTIMATION.WRITE_OFF]: getLabelText({
    key: 'remote.common.offset',
    text: '已冲销'
  })
}

const COST_TIME_DIMENSIONAL_MAP = new GenerateEnum({
  PAY_TIME: {
    value: '0',
    label: getLabelText({
      key: 'remote.common.timeOfPayment2',
      text: '付款时间'
    })
  },
  SERVICE_TIME: {
    value: '1',
    label: getLabelText({
      key: 'remote.common.serviceOrderCompletionTime',
      text: '服务单完成时间'
    })
  },
  TRANSLATE_TIME: {
    value: '2',
    label: getLabelText({
      key: 'remote.common.officialTranslationCompletionTime',
      text: '官方翻译完成时间'
    })
  },
  PERSON_TIME: {
    value: '3',
    label: getLabelText({
      key: 'remote.common.legalEntityNumberCompletionTime',
      text: '法人番号完成时间'
    })
  },
  AUTHORIZATION_CYCLE: {
    value: '4',
    label: getLabelText({
      key: 'remote.common.authorizationPeriodStartTime',
      text: '授权周期开始时间'
    })
  },
  DECLARE_CYCLE: {
    value: '5',
    label: getLabelText({
      key: 'remote.common.declarablePeriodStartTime',
      text: '可申报周期开始时间'
    })
  }
})

const MESSAGE_TYPES = [
  {
    title: `${getLabelText({
      key: 'remote.admin.manualMessage',
      text: '业务通知'
    })}-${getLabelText({ key: 'remote.admin.businessNotice', text: '业务通知' })}`,
    templateType: 0,
    messageType: 0
  },
  {
    title: `${getLabelText({
      key: 'remote.admin.manualMessage',
      text: '业务通知'
    })}-${getLabelText({ key: 'remote.admin.industryInformation', text: '行业信息' })}`,
    templateType: 0,
    messageType: 2
  },
  {
    title: `${getLabelText({
      key: 'remote.admin.eventMessage',
      text: '事件消息'
    })}-${getLabelText({ key: 'remote.admin.businessNotice', text: '业务通知' })}`,
    templateType: 1,
    messageType: 0
  },
  {
    title: `${getLabelText({
      key: 'remote.admin.eventMessage',
      text: '事件消息'
    })}-${getLabelText({ key: 'remote.admin.systemNotifications', text: '系统通知' })}`,
    templateType: 1,
    messageType: 1
  },
  {
    title: `${getLabelText({
      key: 'remote.admin.eventMessage',
      text: '事件消息'
    })}-${getLabelText({ key: 'remote.admin.industryInformation', text: '行业信息' })}`,
    templateType: 1,
    messageType: 2
  }
]

const BILLING_STATUS = {
  NOT_INVOICED: {
    value: '-1',
    label: getLabelText({ key: 'remote.common.notInvoiced', text: '未开票' })
  },
  BE_REVIEWED: {
    value: '0',
    label: getLabelText({ key: 'remote.common.toBeReviewed', text: '待审核' })
  },
  INVOICING: {
    value: '1',
    label: getLabelText({ key: 'remote.common.invoicing', text: '开票中' })
  },
  HAS_INVOICE: {
    value: '2',
    label: getLabelText({ key: 'remote.common.invoiced', text: '已开票' })
  },
  BILLING_FAILURE: {
    value: '3',
    label: getLabelText({
      key: 'remote.common.invoicingFailed',
      text: '开票失败'
    })
  },
  cancellation: {
    value: '4',
    label: getLabelText({ key: 'remote.common.voided', text: '已作废' })
  },
  FULL_FLUSH: {
    value: '5',
    label: getLabelText({
      key: 'remote.common.fullAmountOfRedFlush',
      text: '全额红冲'
    })
  }
}

const RED_INVOICE_STATUS = {
  RED_CONFIRM: {
    value: '01',
    label: getLabelText({
      key: 'remote.common.noConfirmationNeeded',
      text: '无需确认'
    })
  },
  CONFIRMED: {
    value: '04',
    label: getLabelText({
      key: 'remote.common.bothBuyerAndSellerHaveConfirmed',
      text: '购销双方已确认'
    })
  },
  UNDERWAY: {
    value: '15',
    label: getLabelText({
      key: 'remote.common.applicationInProgress',
      text: '申请中'
    })
  },
  PURCHASER_CONFIRM: {
    value: '02',
    label: getLabelText({
      key: 'remote.common.sellerEnteredAwaitingBuyersConfirmation',
      text: '销方录入待购方确认'
    })
  },
  SELLER_CONFIRM: {
    value: '03',
    label: getLabelText({
      key: 'remote.common.buyerEnteredAwaitingSellersConfirmation',
      text: '购方录入待销方确认'
    })
  },
  PURCHASER_REFUSE: {
    value: '05',
    label: getLabelText({
      key: 'remote.common.sellerEnteredBuyerDenied',
      text: '销方录入购方否认'
    })
  },
  SELLER_REFUSE: {
    value: '06',
    label: getLabelText({
      key: 'remote.common.buyerEnteredSellerDenied',
      text: '购方录入销方否认'
    })
  },
  UNCONFIRMED: {
    value: '07',
    label: getLabelText({
      key: 'remote.common.notConfirmedAfter72Hours',
      text: '超72小时未确认'
    })
  },
  INITIATOR_REPEAL: {
    value: '08',
    label: getLabelText({
      key: 'remote.common.initiatorHasWithdrawn',
      text: '发起方已撤销'
    })
  },
  CONFIRM_REPEAL: {
    value: '09',
    label: getLabelText({
      key: 'remote.common.withdrawnAfterConfirmation',
      text: '确认后撤销'
    })
  },
  FAILED: {
    value: '16',
    label: getLabelText({
      key: 'remote.common.theApplicationFailed',
      text: '申请失败'
    })
  },
  NOT_REQUIRED: {
    value: '99',
    label: getLabelText({
      key: 'remote.common.noNeedForRedCharge',
      text: '无需红冲'
    })
  },
  NOT_START: {
    value: '00',
    label: getLabelText({
      key: 'remote.common.awaitingRedChargeInvoicing',
      text: '待红冲开票'
    })
  },
  SUCCESS: {
    value: '66',
    label: getLabelText({
      key: 'remote.common.redChargeSuccessful',
      text: '红冲成功'
    })
  },
  CONFIRMED_OR_UNCONFIRMED: {
    value: '02_07',
    label:
      getLabelText({
        key: 'remote.common.awaitingBuyersConfirmation',
        text: '待购方确认'
      }) +
      '&' +
      getLabelText({
        key: 'remote.common.unconfirmedAfterTimeout',
        text: '超时未确认'
      })
  }
}

const WORK_TYPE_ENUM = new GenerateEnum({
  FEEDBACK_BUG: {
    value: '0',
    label: getLabelText({ key: 'remote.common.reportABug', text: '提bug' })
  },
  SUPPLEMENT_INFORMATION: {
    value: '1',
    label: getLabelText({
      key: 'remote.common.supplementAndModifyInformation',
      text: '补充修改资料'
    })
  },
  UK_EORI_APPLY: {
    value: '2',
    label: getLabelText({
      key: 'remote.common.ukEoriApplication',
      text: '英国EORI申请'
    })
  },
  GE_EORI_APPLY: {
    value: '3',
    label: getLabelText({
      key: 'remote.common.germanEoriApplication',
      text: '德国EORI申请'
    })
  },
  FR_EORI_APPLY: {
    value: '4',
    label: getLabelText({
      key: 'remote.common.frenchEoriApplication',
      text: '法国EORI申请'
    })
  },
  IT_EORI_APPLY: {
    value: '5',
    label: getLabelText({
      key: 'remote.common.italianEoriApplication',
      text: '意大利EORI申请'
    })
  },
  TAX_DEREGISTER_OR_CANCEL_AUTHORIZATION: {
    value: '6',
    label: getLabelText({
      key: 'remote.common.TIca',
      text: '税号注销/移除授权'
    })
  },
  PAYMENT_OR_REFUND: {
    value: '7',
    label: getLabelText({
      key: 'remote.common.paymentrefundQuestion',
      text: '付款/退款问题'
    })
  },
  CAN_NOT_BUILD_MTD: {
    value: '8',
    label: getLabelText({
      key: 'remote.common.unableToCreateMTD',
      text: '无法创建MTD'
    })
  },
  SPAIN_HAGUE_CERTIFICATION: {
    value: '9',
    label: getLabelText({
      key: 'remote.common.theHagueCertificationSpain',
      text: '西班牙海牙认证'
    })
  },
  QUESTIONNAIRE: {
    value: '10',
    label: getLabelText({
      key: 'remote.common.questionnaire',
      text: '调查问卷'
    })
  },
  TRANSACTIONAL_REQUIREMENTS: {
    value: '11',
    label: getLabelText({
      key: 'remote.common.transactionalRequirements',
      text: '事务性需求'
    })
  },
  FEEDBACK: {
    value: '13',
    label: getLabelText({
      key: 'remote.common.feedbackIsCourteous',
      text: '反馈有礼'
    })
  },
  REQUIREMENT: {
    value: '14',
    label: getLabelText({ key: 'remote.common.raiseDemand', text: '提需求' })
  },
  SP_EORI_APPLY: {
    value: '15',
    label: getLabelText({
      key: 'remote.common.spanishEoriApplication',
      text: '西班牙EORI申请'
    })
  },

  COMPLAINT: {
    value: '16',
    label: getLabelText({
      key: 'remote.common.customerComplaints',
      text: '客户投诉'
    })
  },
  SP_EU_TAX_NUMBER_APPLY: {
    value: '17',
    label: getLabelText({
      key: 'remote.common.spanishEuTaxIdApplication',
      text: '西班牙欧盟税号申请'
    })
  },
  FR_SEARCH_SIRET_AND_VAT: {
    value: '18',
    label: getLabelText({
      key: 'remote.common.frenchTaxNumberQuery',
      text: '法国税号查询'
    })
  },
  CUSTOMER_RENEW: {
    value: '19',
    label: getLabelText({
      key: 'remote.common.businessNumberRenewal',
      text: '业务号续期'
    })
  },

  EPR_CODE_RECOVER_USE: {
    value: '20',
    label: getLabelText({
      key: 'remote.common.RoErnr',
      text: 'EPR注册号恢复使用审核'
    })
  },
  RSP_CODE_RECOVER_USE: {
    value: '21',
    label: getLabelText({
      key: 'remote.common.authorizedRepresentativeRecoveryUseAudit',
      text: '授权代表恢复使用审核'
    })
  },
  GB_VAT_RESUME_AUDIT: {
    value: '22',
    label: getLabelText({
      key: 'remote.common.ukVatRestorationForUseReview',
      text: '英国VAT恢复使用审核'
    })
  },
  DE_VAT_RESUME_AUDIT: {
    value: '23',
    label: getLabelText({
      key: 'remote.common.germanVatRestorationForUseReview',
      text: '德国VAT恢复使用审核'
    })
  },
  FR_VAT_RESUME_AUDIT: {
    value: '24',
    label: getLabelText({
      key: 'remote.common.frenchVatRestorationForUseReview',
      text: '法国VAT恢复使用审核'
    })
  },
  IT_VAT_RESUME_AUDIT: {
    value: '25',
    label: getLabelText({
      key: 'remote.common.italianVatRestorationForUseReview',
      text: '意大利VAT恢复使用审核'
    })
  },
  ES_VAT_RESUME_AUDIT: {
    value: '26',
    label: getLabelText({
      key: 'remote.common.spanishVatRestorationForUseReview',
      text: '西班牙VAT恢复使用审核'
    })
  },
  OTHER_VAT_RESUME_AUDIT: {
    value: '27',
    label: getLabelText({
      key: 'remote.common.otherVatRestorationForUseReview',
      text: '其他VAT恢复使用审核'
    })
  },
  DE_WEEE_SPOA: {
    value: '28',
    label: getLabelText({
      key: 'remote.common.GWSPoA',
      text: '德国WEEE补充授权书'
    })
  },
  UPDATE_LOGIN: {
    value: '30',
    label: getLabelText({
      key: 'remote.common.changeTheAccountNumberOfTheBoundMerchant',
      text: '换绑商户账号'
    })
  }
})

const ostEntryCompanyEnum = new GenerateEnum({
  VAT_MASTER: {
    value: 0,
    label: getLabelText({
      key: 'remote.common.shenzhenOushuitongTechnologyCo.Ltd',
      text: '深圳欧税通技术有限公司'
    })
  },
  SHANGHAI_IPP: {
    value: 1,
    label: '(EPR)深圳麦德通商务技术有限公司'
  },
  HONG_KONG_MASTER: {
    value: 5,
    label: getLabelText({
      key: 'remote.common.hongKongEurotax',
      text: '香港欧税通公司'
    })
  }
})

const mdtEntryCompanyEnum = new GenerateEnum({
  VAT_MASTER: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.shanghaiMetroSoftwareTechnologyCo.Ltd',
      text: '上海麦德通软件技术有限公司'
    })
  },
  SHANGHAI_IPP: {
    value: 2,
    label: getLabelText({
      key: 'remote.common.shenzhenMaidetongBusinessAgencyCo.Ltd',
      text: '深圳麦德通商务技术有限公司'
    })
  }
})

const TRACK_CODE = {
  0: getLabelText({
    key: 'remote.common.refundsOrBalanceExchangesForCompletedServiceOrders',
    text: '已完成服务单退款或兑换余额'
  }),
  1: getLabelText({
    key: 'remote.common.refundsOrBalanceExchangesForPendingServiceOrders',
    text: '申请中服务单退款或兑换余额'
  }),
  2: getLabelText({
    key: 'remote.common.re-assignmentOfSuppliersForCompletedServiceOrders',
    text: '已完成服务单改派供应商'
  }),
  3: getLabelText({
    key: 'remote.common.changeInAuthorizationPeriod',
    text: '变更授权周期'
  }),
  4: getLabelText({
    key: 'remote.common.reversalOfCompletedServiceOrdersToPendingStatus',
    text: '已完成服务单逆向至申请中'
  }),
  5: getLabelText({
    key: 'remote.common.pendingServiceOrderStatusRejectedBackToAwaitingDocumentation',
    text: '申请中服务单状态驳回至待提交资料'
  }),
  6: getLabelText({
    key: 'remote.common.serviceOrdersAssignedToSuppliersRejectedBackToAwaitingCustomerServiceReview',
    text: '已分配供应商服务单驳回至待客服审核资料'
  }),
  7: getLabelText({
    key: 'remote.common.serviceApplicationCompleted',
    text: '服务申请完成'
  }),
  8: getLabelText({
    key: 'remote.common.cancellationOfPay-laterMerchandiseServiceOrders',
    text: '先用后付商品服务取消订单'
  }),
  9: getLabelText({
    key: 'remote.common.changeOfServiceTypeForPaidServiceOrders',
    text: '已付款服务单的服务类型变更'
  }),
  10: getLabelText({
    key: 'remote.common.promptText70',
    text: '实付金额（余额+其它）为0元的服务单'
  }),
  11: getLabelText({
    key: 'remote.common.promptText48',
    text: '已付款服务单修改销售属性（请在订单管理查询服务单对照）'
  }),
  12: getLabelText({
    key: 'remote.common.pendingCaseStatusRejectedBackToAwaitingDocumentation',
    text: '申请中案件状态驳回至待提交资料'
  })
}

const lidoEntryCompanyEnum = new GenerateEnum({
  SHENZHEN_LIDO: {
    value: 3,
    label: getLabelText({
      key: 'remote.common.shenzhenLiuduInformationServiceCo.Ltd',
      text: '深圳六度信息服务有限公司'
    })
  },
  HONG_KONG_OST_MASTER: {
    value: 5,
    label: getLabelText({
      key: 'remote.common.hongKongEurotax',
      text: '香港欧税通公司'
    })
  }
})

const xmEntryCompanyEnum = new GenerateEnum({
  SHENZHEN_XM: {
    value: 4,
    label: getLabelText({
      key: 'remote.common.shenzhenSmallTradeTechnologyCo.Ltd',
      text: '深圳小贸出海技术有限公司'
    })
  }
})

const thEntryCompanyEnum = new GenerateEnum({
  SHENZHEN_XM: {
    value: 6,
    label: getLabelText({
      key: 'remote.common.shenzhenTianheHaihaiTechnologyCo.Ltd',
      text: '深圳天合出海科技有限公司'
    })
  }
})

// 开票类型
const invoiceTypeMap = {
  1: getLabelText({ key: 'remote.common.invoicedInFull', text: '全额开票' }),
  2: '官费invoice'
}

// const OrderMergeType = new GenerateEnum({
//   NO_MERGE: {
//     value: 0,
//     label: '不允许合并支付订单'
//   },
//   OFFICIAL: {
//     value: 1,
//     label: '官费类型'
//   },
//   OFFICIAL_INVOICE: {
//     value: 2,
//     label: '清分类型'
//   },
//   OTHER: {
//     value: 3,
//     label: '服务费类型'
//   }
// })

// 供应商授权内容枚举
const supplierAuthInfoMap = {
  0: getLabelText({
    key: 'remote.common.basicInformationOfSuppliers',
    text: '供应商基本信息'
  }),
  1: getLabelText({
    key: 'remote.common.invoiceInformation',
    text: '发票信息'
  }),
  2: getLabelText({
    key: 'remote.common.paymentInformation2',
    text: '收款信息'
  }),
  3: getLabelText({
    key: 'remote.common.associationTableOfSupplierCountryProductsAndCostTypes',
    text: '供应商国家产品及成本类型关联表'
  }),
  4: getLabelText({
    key: 'remote.common.costPricingRules',
    text: '成本计价规则'
  }),
  5: getLabelText({
    key: 'remote.common.estimatedCostsOfOtherSuppliersMappedBasedOnServiceOrderAllocation',
    text: '基于服务单分配供应商映射的其他供应商的预估成本'
  }),
  6: getLabelText({
    key: 'remote.common.recordsOfOfficialFeePre-paymentsToSupplierCollectionAccounts',
    text: '供应商收款账户官费预存记录'
  }),
  8: getLabelText({
    key: 'remote.common.associatedCountriesOfSuppliers',
    text: '供应商关联国家'
  }),
  9: getLabelText({
    key: 'remote.common.associatedServiceTypesOfSuppliers',
    text: '供应商关联服务类型'
  }),
  10: getLabelText({
    key: 'remote.common.supplierCodingRules',
    text: '供应商编码规则'
  }),
  11: getLabelText({
    key: 'remote.common.ivaDeclarationFileParameters',
    text: 'IVA申报文件参数'
  }),
  12: getLabelText({
    key: 'remote.admin.czechXmlDeclarationParams',
    text: '捷克申报XML参数'
  })
}

const EPR_DECLARE_PERIOD_ENUM = {
  MONTH: {
    value: '0',
    label: getLabelText({ key: 'remote.common.monthlyReport', text: '月报' })
  },
  QUARTER: {
    value: '1',
    label: getLabelText({ key: 'remote.common.quarterlyReport', text: '季报' })
  },
  YEAR_MIDDLE: {
    value: '7',
    label: getLabelText({
      key: 'remote.common.mid-yearDeclaration',
      text: '年中申报'
    })
  },
  YEAR: {
    value: '2',
    label: getLabelText({ key: 'remote.common.annualReport', text: '年报' })
  },
  YEAR_SUM: {
    value: '3',
    label: getLabelText({
      key: 'remote.common.annualSummaryDeclaration',
      text: '年度汇总申报'
    })
  },
  PRE: {
    value: '4',
    label: getLabelText({
      key: 'remote.common.pre-declaration',
      text: '预申报'
    })
  }
}

const EPR_DECLARE_PERIOD_ENUM_MAP = new GenerateEnum(EPR_DECLARE_PERIOD_ENUM)

/*
 * =========== common/admin/env end ============
 */

/*
 * =========== common/merchant/env start ============
 */

const APPLY_STATUS_MAP = {
  NOT_STARTED: {
    key: '0',
    value: getLabelText({ key: 'remote.common.notStarted', text: '未开始' })
  }, // 商标注册
  TO_SUBMIT_SERVICE_INFO: {
    key: '1',
    value: getLabelText({
      key: 'remote.common.serviceDataToBeSubmitted',
      text: '待提交服务资料'
    })
  },
  APPLYING: {
    key: '2',
    value: getLabelText({
      key: 'remote.common.applicationInProgress',
      text: '申请中'
    })
  },
  SUCCESSFULLY_APPLY: {
    key: '3',
    value: getLabelText({
      key: 'remote.common.theApplicationWasSuccessful',
      text: '申请成功'
    })
  },
  APPLY_FAILED: {
    key: '4',
    value: getLabelText({
      key: 'remote.common.theApplicationFailed',
      text: '申请失败'
    })
  },
  REFUNDED: {
    key: '5',
    value: getLabelText({ key: 'remote.common.refunded', text: '已退款' })
  },
  REFUNDING: {
    key: '6',
    value: getLabelText({
      key: 'remote.common.refundInProgress',
      text: '退款中'
    })
  },
  CANCELED: {
    key: '7',
    value: getLabelText({ key: 'remote.common.cancelled', text: '已取消' })
  },
  FROZE: {
    key: '8',
    value: getLabelText({ key: 'remote.common.frozen', text: '已冻结' })
  }
}

const declareType = [
  getLabelText({ key: 'remote.common.vatDeclaration', text: 'VAT申报' }),
  getLabelText({ key: 'remote.common.germanAnnals', text: '德国年报' }),
  '手动报税',
  getLabelText({ key: 'remote.common.vatBbDeclaration', text: 'VAT+B2B申报' }),
  getLabelText({ key: 'remote.common.bbDeclaration', text: 'B2B申报' })
]

const tradeClassType = [
  '',
  getLabelText({
    key: 'remote.common.payTaxes',
    text: '缴税'
  }),
  getLabelText({ key: 'remote.common.taxRefund', text: '退税' })
]
const orderStatus = [
  getLabelText({ key: 'remote.common.processing', text: '处理中' }),
  getLabelText({ key: 'remote.common.paymentHasBeenMade', text: '已打款' }),
  getLabelText({ key: 'remote.common.cancel', text: '取消' }),
  getLabelText({ key: 'remote.common.failure', text: '失败' }),
  getLabelText({
    key: 'remote.common.paymentOperationSucceeded',
    text: '支付操作成功'
  })
]

const currentPayCounty = [
  getLabelText({ key: 'remote.common.theUk', text: '英国' }),
  getLabelText({ key: 'remote.common.france', text: '法国' }),
  getLabelText({ key: 'remote.common.germany', text: '德国' }),
  getLabelText({ key: 'remote.common.italy', text: '意大利' }),
  getLabelText({ key: 'remote.common.spain', text: '西班牙' }),
  getLabelText({ key: 'remote.common.poland', text: '波兰' }),
  getLabelText({ key: 'remote.common.czechRepublic', text: '捷克' }),
  getLabelText({ key: 'remote.common.netherlands', text: '荷兰' }),
  getLabelText({ key: 'remote.common.austria', text: '奥地利' }),
  getLabelText({ key: 'remote.common.belgium', text: '比利时' }),
  getLabelText({ key: 'remote.common.sweden', text: '瑞典' }),
  getLabelText({ key: 'remote.common.saudiArabia', text: '沙特' }),
  getLabelText({ key: 'remote.common.unitedArabEmirates', text: '阿联酋' })
]

const currentPayCountyItem = [
  {
    label: getLabelText({ key: 'remote.common.theUk', text: '英国' }),
    value: 0
  },
  {
    label: getLabelText({ key: 'remote.common.france', text: '法国' }),
    value: 1
  },
  {
    label: getLabelText({ key: 'remote.common.germany', text: '德国' }),
    value: 2
  },
  {
    label: getLabelText({ key: 'remote.common.italy', text: '意大利' }),
    value: 3
  },
  {
    label: getLabelText({ key: 'remote.common.spain', text: '西班牙' }),
    value: 4
  },
  {
    label: getLabelText({ key: 'remote.common.netherlands', text: '荷兰' }),
    value: 7
  },
  {
    label: getLabelText({ key: 'remote.common.austria', text: '奥地利' }),
    value: 8
  },
  {
    label: getLabelText({
      key: 'remote.common.unitedArabEmirates',
      text: '阿联酋'
    }),
    value: 12
  },
  //     波兰、捷克、沙特、阿联酋、墨西哥、日本
  {
    label: getLabelText({ key: 'remote.common.poland', text: '波兰' }),
    value: 5
  },
  {
    value: 6,
    label: getLabelText({ key: 'remote.common.czechRepublic', text: '捷克' })
  },
  {
    value: 11,
    label: getLabelText({ key: 'remote.common.saudiArabia', text: '沙特' })
  },
  {
    value: 34,
    label: getLabelText({ key: 'remote.common.mexico', text: '墨西哥' })
  },
  {
    value: 100,
    label: getLabelText({ key: 'remote.common.japan.text', text: '日本' })
  },
  {
    value: 105,
    label: getLabelText({ key: 'remote.common.australia', text: '澳大利亚' })
  }
]
const businessTypeText = [
  getLabelText({ key: 'remote.common.offlinePayment', text: '线下支付' }),
  'Qbit',
  getLabelText({ key: 'remote.common.lianlian', text: '连连' }),
  'pingpong',
  '',
  getLabelText({ key: 'remote.common.wanlihui', text: '万里汇' }),
  '',
  getLabelText({ key: 'remote.common.cloudsInTheSky', text: '空中云汇' }),
  '',
  'Payoneer',
  '',
  getLabelText({
    key: 'remote.common.taxAuthorityCreditCardPayment',
    text: '税局信用卡支付'
  })
]

const countyList = currentPayCounty

// 网络错误提示信息
const MSG_NETWORK_ERR = getLabelText({
  key: 'remote.common.TsibPtal',
  text: '系统繁忙，请稍后重试'
})

// 公共的数值类型是、否
const COMMON_YES_NO = VALIDOBJ

// 注册方式
const REGISTER_TYPE = {
  WX: 1, // 微信
  PHONE: 2 // 手机号
}
const COUPON_DISCOUNT_TYPE = new GenerateEnum({
  MONEY: {
    value: 1,
    label: getLabelText({ key: 'remote.common.amount', text: '金额' }),
    title: ''
  },
  PERCENT: {
    value: 2,
    label: getLabelText({ key: 'remote.common.discount2', text: '折扣' }),
    title: getLabelText({ key: 'remote.common.discount2', text: '折扣' })
  }
})
/* INACTIVATED("0", "未激活"),
UNUSED("1", "未使用"),
USED("2", "已使用"),
EXPIRED("3", "已过期"),
ABOLISHED("4", "已作废"),
LOSE_EFFICACY("5", "已失效"),
NOT_AVAILABLE("6", "不可用"), */

//发送验证码类型
const SEND_CODE_TYPE = {
  UNBIND: 3, //解绑账号
  BING: 4 //绑定账号
}

// 获取验证码
const SEND_TYPE = {
  SMS: 0, // 短信验证
  VOICE: 1 // 语音验证
}

const DECLARATION_STATUS = {
  TO_BE_SUBMITTED: {
    value: '0',
    label: getLabelText({ key: 'remote.common.toBeSubmitted', text: '待提交' })
  },
  DECLARING: {
    value: '1',
    label: getLabelText({
      key: 'remote.common.declarationInProgress',
      text: '申报中'
    })
  },
  SUCCESSFULLY_DECLARED: {
    value: '2',
    label: getLabelText({
      key: 'remote.common.theDeclarationWasSuccessful',
      text: '申报成功'
    })
  },
  TAX_PAID: {
    value: '3',
    label: getLabelText({ key: 'remote.common.dutyPaid', text: '已完税' })
  },
  FAILED_TO_DECLARE: {
    value: '4',
    label: getLabelText({
      key: 'remote.common.declarationFailed',
      text: '申报失败'
    })
  },
  CANCELLED: {
    value: '5',
    label: getLabelText({ key: 'remote.common.cancelled', text: '已取消' })
  },
  PENDING_REVIEW: {
    value: '6',
    label: getLabelText({ key: 'remote.common.toBeReviewed', text: '待审核' })
  },
  TO_BE_DECLARED: {
    value: '7',
    label: getLabelText({ key: 'remote.common.toBeDeclared', text: '待申报' })
  },
  TO_THE_TAX_OFFICE: {
    value: '8',
    label: getLabelText({ key: 'remote.admin.sentToTheTaxOffice', text: '已发送税局' })
  },
  HAD_REJECT: {
    value: '9',
    label: getLabelText({ key: 'remote.common.rejected4', text: '已驳回' })
  },

  TO_PAY_TAXES: {
    value: '11',
    label: getLabelText({ key: 'remote.common.toBeTaxed', text: '待缴税' })
  },
  SA_GATHER_REVIEW: {
    value: '14',
    label: getLabelText({
      key: 'remote.common.toBeApprovedForCollection',
      text: '待收款审核'
    })
  }, // (仅沙特、阿联酋)
  SA_REJECT_PAY: {
    value: '15',
    label: getLabelText({
      key: 'remote.common.theCollectionApprovalIsRejected',
      text: '收款审核驳回'
    })
  }, // (仅沙特、阿联酋)
  NO_NEED_DECLARING: {
    value: '16',
    label: getLabelText({
      key: 'remote.common.noNeedToDeclare',
      text: '不需要申报'
    })
  }
}
// VAT申报周期枚举
const DECLARE_PERIOD_ENUM = {
  MONTHLY: {
    value: '0',
    label: getLabelText({ key: 'remote.common.monthly', text: '月度' }),
    showName: getLabelText({ key: 'remote.declare.monthlyDeclaration', text: '月度申报' }),
    intro: getLabelText({ key: 'remote.declare.calculateTaxModalRevisionV2.oneMonth', text: '一个月' })
  },
  QUARTERLY: {
    value: '1',
    label: getLabelText({ key: 'remote.common.quarter', text: '季度' }),
    showName: getLabelText({ key: 'remote.common.quarterlyDeclaration2', text: '季度申报' }),
    intro: getLabelText({ key: 'remote.declare.calculateTaxModalRevisionV2.oneQuarter', text: '一个季度' })
  },
  ANNUAL: {
    value: '2',
    label: getLabelText({ key: 'remote.common.year2', text: '年度' })
  },
  SUMMARY_ANNUAL: {
    value: '3',
    label: getLabelText({
      key: 'remote.common.summarizeTheAnnualReport',
      text: '汇总年报'
    })
  },
  HALF_YEAR: {
    value: '6',
    label: getLabelText({
      key: 'remote.common.semi-annualDeclaration',
      text: '半年申报'
    }),
    intro: getLabelText({ key: 'remote.declare.calculateTaxModalRevisionV2.halfYear', text: '半年' })
  }
}

const DECLARE_PERIOD_ENUM_MAP = new GenerateEnum(DECLARE_PERIOD_ENUM)

// 新增枚举日本JCT中间申报
const JP_DECLARE_TYPE_ENUM = {
  HISTORY_MIDDLE_DECLARE: {
    value: 0,
    label: getLabelText({
      key: 'remote.common.intermediateDeclarationHistoricalData',
      text: '中间申报历史数据'
    })
  },
  PRE_PAY_MIDDLE_DECLARE: {
    value: 5,
    label: getLabelText({
      key: 'remote.common.prepaidVatIntermediateDeclaration',
      text: '预缴式VAT中间申报'
    })
  },
  REAL_PAY_MIDDLE_DECLARE: {
    value: 6,
    label: getLabelText({
      key: 'remote.common.paidVatIntermediateDeclaration',
      text: '实缴式VAT中间申报'
    })
  },
  YEAR_DECLARE_OF_MIDDLE: {
    value: 7,
    label: getLabelText({
      key: 'remote.common.annualVatDeclarationIncludingIntermediateDeclarations',
      text: '含中间申报的年度VAT申报'
    })
  },
  YEAR_DECLARE_NOT_OF_MIDDLE: {
    value: 8,
    label: getLabelText({
      key: 'remote.common.annualVatDeclarationExcludingIntermediateDeclarations',
      text: '不含中间申报的年度VAT申报'
    })
  }
}

const JCT_PAY_TAX_WAY_ENUM = new GenerateEnum({
  REAL: {
    value: 1,
    label: getLabelText({ key: 'remote.declare.calculateTaxModalRevisionV2.ActualPayment', text: '实缴式' })
  },
  PRE: {
    value: 2,
    label: getLabelText({ key: 'remote.common.prepaid', text: '预缴式' })
  }
})

const JCT_DECLARE_WAY_ENUM = new GenerateEnum({
  STANDARD: {
    value: 0,
    label: getLabelText({
      key: 'remote.common.standardDeclaration',
      text: '标准申报'
    })
  },
  EASY: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.simpleDeclaration',
      text: '简易申报'
    })
  },
  ANNUAL_DECLARE_QUARTER_PAY: {
    value: 6,
    label: getLabelText({
      key: 'remote.common.annualReportQuarterlyPayment',
      text: '年报季缴'
    })
  }
})

const DEDUCTION_TYPE_LIST = {
  CROSS_B2B_DEDUCTION: {
    value: '16',
    label: getLabelText({
      key: 'remote.common.cross-borderB2bProcurementDeduction',
      text: '跨境B2B采购抵扣'
    })
  },
  NEGATIVE: {
    value: '11',
    label: getLabelText({
      key: 'remote.common.negativeDeductionOfPreviousPeriod',
      text: '前期负数抵扣'
    })
  },
  C79_OR_C88: {
    value: '12',
    label: 'C79/C88' + getLabelText({ key: 'remote.common.deduction', text: '抵扣' })
  },
  NOON: {
    value: '19',
    label:
      'NOON' +
      getLabelText({
        key: 'remote.common.thePlatformIsDeductible',
        text: '平台可抵扣'
      })
  }
}

//申报本版
const TAX_CALCULATE_VERSION = {
  ONE: 1, // 历史数据
  TWO: 2 // 新数据
}

const DECLARATION_STATUS_OPTIONS = Object.keys(DECLARATION_STATUS).map((item) => ({
  label: DECLARATION_STATUS[item].label,
  value: DECLARATION_STATUS[item].value
}))
let DECLARATION_STATUS_MAP = {}
Object.keys(DECLARATION_STATUS).forEach((item) => (DECLARATION_STATUS_MAP[DECLARATION_STATUS[item].value] = DECLARATION_STATUS[item].label))

const COUNTRY_NEW = {
  US: '101', //  美国,
  UK: '0', //  英国
  JP: '100', //  日本
  EU: '99', //  欧盟
  KR: '102', //  韩国
  PH: '103', //  菲律宾
  IN: '104', //  印度
  DE: '2', //  德国
  AU: '105', //  澳大利亚
  CA: '106', //  加拿大
  BR: '107', //  巴西
  MX: '34', //  墨西哥
  MY: '113', //  马来西亚
  AE: '12', //  阿联酋
  SA: '11', //  沙特
  TH: '116', //  泰国
  VN: '117',
  // KH: '18',
  ID: '119',
  SG: '120',
  TU: '33',
  // MO: '22',
  // TW: '23',
  // NZ: '24',
  FR: '1',
  // QA: '26',
  // KW: '27',
  PL: '5',
  // RU: '29',
  CH: '32',
  // HK: '31',
  EG: '31',
  // NG: '33',
  ES: '4',
  // ZA: '35',
  IT: '3',
  TE: '30', // 北爱尔兰
  AL: '137', // 阿尔巴尼亚
  DZ: '138', // 阿尔及利亚
  AF: '139', // 阿富汗
  AR: '140', // 阿根廷
  OM: '141', // 阿曼
  AZ: '142', // 阿塞拜疆
  ET: '143', // 埃塞俄比亚
  IE: '17', // 爱尔兰
  EE: '28', // 爱沙尼亚
  AD: '146', // 安道尔
  AO: '147', // 安哥拉
  AG: '148', // 安提瓜和巴布达
  AT: '8', // 奥地利
  BB: '150', // 巴巴多斯
  PG: '151', // 巴布亚新几内亚
  BS: '152', // 巴哈马
  PK: '153', // 巴基斯坦
  PY: '154', // 巴拉圭
  BH: '155', // 巴林
  PA: '156', // 巴拿马
  BY: '157', // 白俄罗斯
  BG: '25', // 保加利亚
  MK: '159', // 北马其顿
  BJ: '160', // 贝宁
  BE: '9', // 比利时
  PE: '162', // 秘鲁
  IS: '163', // 冰岛
  BA: '164', // 波黑
  BZ: '165', // 伯利兹
  BW: '166', // 博茨瓦纳
  BT: '167', // 不丹
  BF: '168', // 布基纳法索
  BI: '169', // 布隆迪
  KP: '170', // 朝鲜
  CQ: '171', // 赤道几内亚
  DK: '14', // 丹麦
  TP: '173', // 东帝汶
  TG: '174', // 多哥
  DO: '175', // 多米尼加
  PS: '176', // 巴勒斯坦
  BO: '177', // 玻利维亚
  EC: '178', // 厄瓜多尔
  ER: '179', // 厄立特里亚
  FJ: '180', // 斐济
  FI: '13', // 芬兰
  CV: '182', // 佛得角
  GM: '183', // 冈比亚
  CG: '184', // 刚果
  CD: '185', // 刚果
  CO: '186', // 哥伦比亚
  CR: '187', // 哥斯达黎加
  GD: '188', // 格林纳达
  GE: '189', // 格鲁吉亚
  CU: '190', // 古巴
  GY: '191', // 圭亚那
  KZ: '192', // 哈萨克斯坦
  HT: '193', // 海地
  NL: '7', // 荷兰
  ME: '195', // 黑山
  HN: '196', // 洪都拉斯
  KI: '197', // 基里巴斯
  DJ: '198', // 吉布提
  KG: '199', // 吉尔吉斯斯坦
  GN: '200', // 几内亚
  GW: '201', // 几内亚比绍
  GH: '202', // 加纳
  GA: '203', // 加蓬
  CZ: '6', // 捷克
  ZW: '205', // 津巴布韦
  CM: '206', // 喀麦隆
  KM: '207', // 科摩罗
  CI: '208', // 科特迪瓦
  HR: '27', // 克罗地亚
  KE: '210', // 肯尼亚
  CK: '211', // 库克群岛
  LV: '29', // 拉脱维亚
  LS: '213', // 莱索托
  LA: '214', // 老挝
  LB: '215', // 黎巴嫩
  LT: '21', // 立陶宛
  LR: '217', // 利比里亚
  LY: '218', // 利比亚
  LI: '219', // 列支敦士登
  LU: '18', // 卢森堡
  RW: '221', // 卢旺达
  VA: '222', // 梵蒂冈
  RO: '22', // 罗马尼亚
  MG: '224', // 马达加斯加
  MV: '225', // 马尔代夫
  MT: '19', // 马耳他
  MW: '227', // 马拉维
  ML: '228', // 马里
  MH: '229', // 马绍尔群岛
  MU: '230', // 毛里求斯
  MR: '231', // 毛里塔尼亚
  MN: '232', // 蒙古
  BD: '233', // 孟加拉国
  MM: '234', // 缅甸
  MD: '235', // 摩尔多瓦
  MA: '236', // 摩洛哥
  MC: '237', // 摩纳哥
  MZ: '238', // 莫桑比克
  NA: '239', // 纳米比亚
  NR: '240', // 瑙鲁
  NP: '241', // 尼泊尔
  NI: '242', // 尼加拉瓜
  NE: '243', // 尼日尔
  NU: '244', // 纽埃
  NO: '245', // 挪威
  PT: '20', // 葡萄牙
  SE: '10', // 瑞典
  EV: '248', // 萨尔瓦多
  WS: '249', // 萨摩亚
  RS: '250', // 塞尔维亚
  SL: '251', // 塞拉利昂
  SN: '252', // 塞内加尔
  CY: '26', // 塞浦路斯
  SC: '254', // 塞舌尔
  ST: '255', // 圣多美和普林西比
  KN: '256', // 圣基茨和尼维斯
  LC: '257', // 圣卢西亚
  SM: '258', // 圣马力诺
  VC: '259', // 圣文森特和格林纳丁斯
  LK: '260', // 斯里兰卡
  SK: '23', // 斯洛伐克
  SI: '24', // 斯洛文尼亚
  SZ: '263', // 斯威士兰
  SD: '264', // 苏丹
  SS: '265', // 南苏丹
  SR: '266', // 苏里南
  SB: '267', // 所罗门群岛
  SO: '268', // 索马里
  TJ: '269', // 塔吉克斯坦
  TZ: '270', // 坦桑尼亚
  TO: '271', // 汤加
  TT: '272', // 特立尼达和多巴哥
  TN: '273', // 突尼斯
  TV: '274', // 图瓦卢
  TM: '275', // 土库曼斯坦
  VU: '276', // 瓦努阿图
  GT: '277', // 危地马拉
  VE: '278', // 委内瑞拉
  BN: '279', // 文莱
  UG: '280', // 乌干达
  UA: '281', // 乌克兰
  UY: '282', // 乌拉圭
  UZ: '283', // 乌兹别克斯坦
  GR: '15', // 希腊
  HU: '16', // 匈牙利
  SY: '286', // 叙利亚
  JM: '287', // 牙买加
  AM: '288', // 亚美尼亚
  YE: '289', // 也门
  IQ: '290', // 伊拉克
  IR: '291', // 伊朗
  IL: '292', // 以色列
  JO: '293', // 约旦
  ZM: '294', // 赞比亚
  TD: '295', // 乍得
  CL: '296', // 智利
  CF: '297', // 中非
  CN: '298', // 中国
  OAPI: '299', // 非洲知识产权组织
  BOIP: '300', // 比荷卢知识产权组织
  ARIPO: '301', // 非洲地区工业产权组织
  EARTH: '999' // 全球
}
const COUNTRY_NEW_MAP = {
  [COUNTRY_NEW.US]: getLabelText({
    key: 'remote.common.america',
    text: '美国'
  }), //  美国
  [COUNTRY_NEW.UK]: getLabelText({ key: 'remote.common.theUk', text: '英国' }), //  英国
  [COUNTRY_NEW.JP]: getLabelText({
    key: 'remote.common.japan.text',
    text: '日本'
  }), //  日本
  [COUNTRY_NEW.EU]: getLabelText({
    key: 'remote.common.europeanUnion',
    text: '欧盟'
  }), //  欧盟
  [COUNTRY_NEW.KR]: getLabelText({ key: 'remote.common.korea', text: '韩国' }), //  韩国
  [COUNTRY_NEW.PH]: getLabelText({
    key: 'remote.common.philippines',
    text: '菲律宾'
  }), //  菲律宾
  [COUNTRY_NEW.IN]: getLabelText({ key: 'remote.common.india', text: '印度' }), //  印度
  [COUNTRY_NEW.DE]: getLabelText({
    key: 'remote.common.germany',
    text: '德国'
  }), //  德国
  [COUNTRY_NEW.AU]: getLabelText({
    key: 'remote.common.australia',
    text: '澳大利亚'
  }), //  澳大利亚
  [COUNTRY_NEW.CA]: getLabelText({
    key: 'remote.common.canada',
    text: '加拿大'
  }), //  加拿大
  [COUNTRY_NEW.BR]: getLabelText({ key: 'remote.common.brazil', text: '巴西' }), //  巴西
  [COUNTRY_NEW.MX]: getLabelText({
    key: 'remote.common.mexico',
    text: '墨西哥'
  }), //  墨西哥
  [COUNTRY_NEW.MY]: getLabelText({
    key: 'remote.common.malaysia',
    text: '马来西亚'
  }), //  马来西亚
  [COUNTRY_NEW.AE]: getLabelText({
    key: 'remote.common.unitedArabEmirates',
    text: '阿联酋'
  }), //  阿联酋
  [COUNTRY_NEW.SA]: getLabelText({
    key: 'remote.common.saudiArabia',
    text: '沙特'
  }), //  沙特
  [COUNTRY_NEW.TH]: getLabelText({
    key: 'remote.common.thailand',
    text: '泰国'
  }), //  泰国
  [COUNTRY_NEW.VN]: getLabelText({
    key: 'remote.common.vietnam',
    text: '越南'
  }), //  越南
  // [COUNTRY_NEW.KH]: '柬埔寨', //  柬埔寨
  [COUNTRY_NEW.ID]: getLabelText({
    key: 'remote.common.indonesia',
    text: '印度尼西亚'
  }), //  印度尼西亚
  [COUNTRY_NEW.SG]: getLabelText({
    key: 'remote.common.singapore',
    text: '新加坡'
  }), //  新加坡
  [COUNTRY_NEW.TU]: getLabelText({
    key: 'remote.common.turkey',
    text: '土耳其'
  }), //  土耳其
  // [COUNTRY_NEW.MO]: '中国澳门', //  中国澳门
  // [COUNTRY_NEW.TW]: '中国台湾', //  中国台湾
  // [COUNTRY_NEW.NZ]: '新西兰', //  新西兰
  [COUNTRY_NEW.FR]: getLabelText({ key: 'remote.common.france', text: '法国' }), //  法国
  // [COUNTRY_NEW.QA]: '卡塔尔', //  卡塔尔
  // [COUNTRY_NEW.KW]: '科威特', //  科威特
  [COUNTRY_NEW.PL]: getLabelText({ key: 'remote.common.poland', text: '波兰' }), //  波兰
  // [COUNTRY_NEW.RU]: '俄罗斯', //  俄罗斯
  [COUNTRY_NEW.CH]: getLabelText({
    key: 'remote.common.switzerland',
    text: '瑞士'
  }), //  瑞士
  // [COUNTRY_NEW.HK]: '中国香港', //  中国香港
  [COUNTRY_NEW.EG]: getLabelText({ key: 'remote.common.egypt', text: '埃及' }), //  埃及
  // [COUNTRY_NEW.NG]: '尼日利亚', //  尼日利亚
  [COUNTRY_NEW.ES]: getLabelText({
    key: 'remote.common.spain',
    text: '西班牙'
  }), //  西班牙
  // [COUNTRY_NEW.ZA]: '南非', //  南非
  [COUNTRY_NEW.IT]: getLabelText({
    key: 'remote.common.italy',
    text: '意大利'
  }), //  意大利
  [COUNTRY_NEW.AL]: getLabelText({
    key: 'remote.common.albania',
    text: '阿尔巴尼亚'
  }),
  [COUNTRY_NEW.DZ]: getLabelText({
    key: 'remote.common.algeria',
    text: '阿尔及利亚'
  }),
  [COUNTRY_NEW.AF]: getLabelText({
    key: 'remote.common.afghanistan',
    text: '阿富汗'
  }),
  [COUNTRY_NEW.AR]: getLabelText({
    key: 'remote.common.argentina',
    text: '阿根廷'
  }),
  [COUNTRY_NEW.OM]: getLabelText({ key: 'remote.common.oman', text: '阿曼' }),
  [COUNTRY_NEW.AZ]: getLabelText({
    key: 'remote.common.azerbaijan',
    text: '阿塞拜疆'
  }),
  [COUNTRY_NEW.ET]: getLabelText({
    key: 'remote.common.ethiopia',
    text: '埃塞俄比亚'
  }),
  [COUNTRY_NEW.IE]: getLabelText({
    key: 'remote.common.ireland',
    text: '爱尔兰'
  }),
  [COUNTRY_NEW.EE]: getLabelText({
    key: 'remote.common.estoniance',
    text: '爱沙尼亚'
  }),
  [COUNTRY_NEW.AD]: getLabelText({
    key: 'remote.common.andorra',
    text: '安道尔'
  }),
  [COUNTRY_NEW.AO]: getLabelText({
    key: 'remote.common.angola',
    text: '安哥拉'
  }),
  [COUNTRY_NEW.AG]: getLabelText({
    key: 'remote.common.antiguaAndBarbuda',
    text: '安提瓜和巴布达'
  }),
  [COUNTRY_NEW.AT]: getLabelText({
    key: 'remote.common.austria',
    text: '奥地利'
  }),
  [COUNTRY_NEW.BB]: getLabelText({
    key: 'remote.common.barbados',
    text: '巴巴多斯'
  }),
  [COUNTRY_NEW.PG]: getLabelText({
    key: 'remote.common.papuaNewGuinea',
    text: '巴布亚新几内亚'
  }),
  [COUNTRY_NEW.BS]: getLabelText({
    key: 'remote.common.theBahamas',
    text: '巴哈马'
  }),
  [COUNTRY_NEW.PK]: getLabelText({
    key: 'remote.common.pakistan',
    text: '巴基斯坦'
  }),
  [COUNTRY_NEW.PY]: getLabelText({
    key: 'remote.common.paraguay',
    text: '巴拉圭'
  }),
  [COUNTRY_NEW.BH]: getLabelText({
    key: 'remote.common.bahrain',
    text: '巴林'
  }),
  [COUNTRY_NEW.PA]: getLabelText({
    key: 'remote.common.panama',
    text: '巴拿马'
  }),
  [COUNTRY_NEW.BY]: getLabelText({
    key: 'remote.common.belarus',
    text: '白俄罗斯'
  }),
  [COUNTRY_NEW.BG]: getLabelText({
    key: 'remote.common.bulgaria',
    text: '保加利亚'
  }),
  [COUNTRY_NEW.MK]: getLabelText({
    key: 'remote.common.northMacedonia',
    text: '北马其顿'
  }),
  [COUNTRY_NEW.BJ]: getLabelText({ key: 'remote.common.benin', text: '贝宁' }),
  [COUNTRY_NEW.BE]: getLabelText({
    key: 'remote.common.belgium',
    text: '比利时'
  }),
  [COUNTRY_NEW.PE]: getLabelText({ key: 'remote.common.peru', text: '秘鲁' }),
  [COUNTRY_NEW.IS]: getLabelText({
    key: 'remote.common.iceland',
    text: '冰岛'
  }),
  [COUNTRY_NEW.BA]: getLabelText({
    key: 'remote.common.bosniaAndHerzegovina',
    text: '波黑'
  }),
  [COUNTRY_NEW.BZ]: getLabelText({
    key: 'remote.common.belize',
    text: '伯利兹'
  }),
  [COUNTRY_NEW.BW]: getLabelText({
    key: 'remote.common.botswana',
    text: '博茨瓦纳'
  }),
  [COUNTRY_NEW.BT]: getLabelText({ key: 'remote.common.bhutan', text: '不丹' }),
  [COUNTRY_NEW.BF]: getLabelText({
    key: 'remote.common.burkinaFaso',
    text: '布基纳法索'
  }),
  [COUNTRY_NEW.BI]: getLabelText({
    key: 'remote.common.burundi',
    text: '布隆迪'
  }),
  [COUNTRY_NEW.KP]: getLabelText({
    key: 'remote.common.northKorea',
    text: '朝鲜'
  }),
  [COUNTRY_NEW.CQ]: getLabelText({
    key: 'remote.common.equatorialGuinea',
    text: '赤道几内亚'
  }),
  [COUNTRY_NEW.DK]: getLabelText({
    key: 'remote.common.denmark',
    text: '丹麦'
  }),
  [COUNTRY_NEW.TP]: '东帝汶',
  [COUNTRY_NEW.TG]: '多哥',
  [COUNTRY_NEW.DO]: '多米尼加',
  [COUNTRY_NEW.PS]: '巴勒斯坦',
  [COUNTRY_NEW.BO]: '玻利维亚',
  [COUNTRY_NEW.EC]: '厄瓜多尔',
  [COUNTRY_NEW.ER]: '厄立特里亚',
  [COUNTRY_NEW.FJ]: '斐济',
  [COUNTRY_NEW.FI]: '芬兰',
  [COUNTRY_NEW.CV]: '佛得角',
  [COUNTRY_NEW.GM]: '冈比亚',
  [COUNTRY_NEW.CG]: '刚果',
  [COUNTRY_NEW.CD]: '刚果',
  [COUNTRY_NEW.CO]: '哥伦比亚',
  [COUNTRY_NEW.CR]: '哥斯达黎加',
  [COUNTRY_NEW.GD]: '格林纳达',
  [COUNTRY_NEW.GE]: '格鲁吉亚',
  [COUNTRY_NEW.CU]: '古巴',
  [COUNTRY_NEW.GY]: '圭亚那',
  [COUNTRY_NEW.KZ]: '哈萨克斯坦',
  [COUNTRY_NEW.HT]: '海地',
  [COUNTRY_NEW.NL]: getLabelText({
    key: 'remote.common.netherlands',
    text: '荷兰'
  }),
  [COUNTRY_NEW.ME]: '黑山',
  [COUNTRY_NEW.HN]: '洪都拉斯',
  [COUNTRY_NEW.KI]: '基里巴斯',
  [COUNTRY_NEW.DJ]: '吉布提',
  [COUNTRY_NEW.KG]: '吉尔吉斯斯坦',
  [COUNTRY_NEW.GN]: '几内亚',
  [COUNTRY_NEW.GW]: '几内亚比绍',
  [COUNTRY_NEW.GH]: '加纳',
  [COUNTRY_NEW.GA]: '加蓬',
  [COUNTRY_NEW.CZ]: getLabelText({
    key: 'remote.common.czechRepublic',
    text: '捷克'
  }),
  [COUNTRY_NEW.ZW]: '津巴布韦',
  [COUNTRY_NEW.CM]: '喀麦隆',
  [COUNTRY_NEW.KM]: '科摩罗',
  [COUNTRY_NEW.CI]: '科特迪瓦',
  [COUNTRY_NEW.HR]: '克罗地亚',
  [COUNTRY_NEW.KE]: '肯尼亚',
  [COUNTRY_NEW.CK]: '库克群岛',
  [COUNTRY_NEW.LV]: '拉脱维亚',
  [COUNTRY_NEW.LS]: '莱索托',
  [COUNTRY_NEW.LA]: '老挝',
  [COUNTRY_NEW.LB]: '黎巴嫩',
  [COUNTRY_NEW.LT]: '立陶宛',
  [COUNTRY_NEW.LR]: '利比里亚',
  [COUNTRY_NEW.LY]: '利比亚',
  [COUNTRY_NEW.LI]: '列支敦士登',
  [COUNTRY_NEW.LU]: '卢森堡',
  [COUNTRY_NEW.RW]: '卢旺达',
  [COUNTRY_NEW.VA]: '梵蒂冈',
  [COUNTRY_NEW.RO]: '罗马尼亚',
  [COUNTRY_NEW.MG]: '马达加斯加',
  [COUNTRY_NEW.MV]: '马尔代夫',
  [COUNTRY_NEW.MT]: '马耳他',
  [COUNTRY_NEW.MW]: '马拉维',
  [COUNTRY_NEW.ML]: '马里',
  [COUNTRY_NEW.MH]: '马绍尔群岛',
  [COUNTRY_NEW.MU]: '毛里求斯',
  [COUNTRY_NEW.MR]: '毛里塔尼亚',
  [COUNTRY_NEW.MN]: '蒙古',
  [COUNTRY_NEW.BD]: '孟加拉国',
  [COUNTRY_NEW.MM]: '缅甸',
  [COUNTRY_NEW.MD]: '摩尔多瓦',
  [COUNTRY_NEW.MA]: '摩洛哥',
  [COUNTRY_NEW.MC]: '摩纳哥',
  [COUNTRY_NEW.MZ]: '莫桑比克',
  [COUNTRY_NEW.NA]: '纳米比亚',
  [COUNTRY_NEW.NR]: '瑙鲁',
  [COUNTRY_NEW.NP]: '尼泊尔',
  [COUNTRY_NEW.NI]: '尼加拉瓜',
  [COUNTRY_NEW.NE]: '尼日尔',
  [COUNTRY_NEW.NU]: '纽埃',
  [COUNTRY_NEW.NO]: '挪威',
  [COUNTRY_NEW.PT]: '葡萄牙',
  [COUNTRY_NEW.SE]: getLabelText({ key: 'remote.common.sweden', text: '瑞典' }),
  [COUNTRY_NEW.EV]: '萨尔瓦多',
  [COUNTRY_NEW.WS]: '萨摩亚',
  [COUNTRY_NEW.RS]: '塞尔维亚',
  [COUNTRY_NEW.SL]: '塞拉利昂',
  [COUNTRY_NEW.SN]: '塞内加尔',
  [COUNTRY_NEW.CY]: '塞浦路斯',
  [COUNTRY_NEW.SC]: '塞舌尔',
  [COUNTRY_NEW.ST]: '圣多美和普林西比',
  [COUNTRY_NEW.KN]: '圣基茨和尼维斯',
  [COUNTRY_NEW.LC]: '圣卢西亚',
  [COUNTRY_NEW.SM]: '圣马力诺',
  [COUNTRY_NEW.VC]: '圣文森特和格林纳丁斯',
  [COUNTRY_NEW.LK]: '斯里兰卡',
  [COUNTRY_NEW.SK]: '斯洛伐克',
  [COUNTRY_NEW.SI]: '斯洛文尼亚',
  [COUNTRY_NEW.SZ]: '斯威士兰',
  [COUNTRY_NEW.SD]: '苏丹',
  [COUNTRY_NEW.SS]: '南苏丹',
  [COUNTRY_NEW.SR]: '苏里南',
  [COUNTRY_NEW.SB]: '所罗门群岛',
  [COUNTRY_NEW.SO]: '索马里',
  [COUNTRY_NEW.TJ]: '塔吉克斯坦',
  [COUNTRY_NEW.TZ]: '坦桑尼亚',
  [COUNTRY_NEW.TO]: '汤加',
  [COUNTRY_NEW.TT]: '特立尼达和多巴哥',
  [COUNTRY_NEW.TN]: '突尼斯',
  [COUNTRY_NEW.TV]: '图瓦卢',
  [COUNTRY_NEW.TM]: '土库曼斯坦',
  [COUNTRY_NEW.VU]: '瓦努阿图',
  [COUNTRY_NEW.GT]: '危地马拉',
  [COUNTRY_NEW.VE]: '委内瑞拉',
  [COUNTRY_NEW.BN]: '文莱',
  [COUNTRY_NEW.UG]: '乌干达',
  [COUNTRY_NEW.UA]: '乌克兰',
  [COUNTRY_NEW.UY]: '乌拉圭',
  [COUNTRY_NEW.UZ]: '乌兹别克斯坦',
  [COUNTRY_NEW.GR]: '希腊',
  [COUNTRY_NEW.HU]: '匈牙利',
  [COUNTRY_NEW.SY]: '叙利亚',
  [COUNTRY_NEW.JM]: '牙买加',
  [COUNTRY_NEW.AM]: '亚美尼亚',
  [COUNTRY_NEW.YE]: '也门',
  [COUNTRY_NEW.IQ]: '伊拉克',
  [COUNTRY_NEW.IR]: '伊朗',
  [COUNTRY_NEW.IL]: '以色列',
  [COUNTRY_NEW.JO]: '约旦',
  [COUNTRY_NEW.ZM]: '赞比亚',
  [COUNTRY_NEW.TD]: '乍得',
  [COUNTRY_NEW.CL]: '智利',
  [COUNTRY_NEW.CF]: '中非',
  [COUNTRY_NEW.CN]: '中国',
  [COUNTRY_NEW.OAPI]: '非洲知识产权组织',
  [COUNTRY_NEW.BOIP]: '比荷卢知识产权组织',
  [COUNTRY_NEW.ARIPO]: '非洲地区工业产权组织',
  [COUNTRY_NEW.EARTH]: '全球'
}

const systemTypeName = {
  [MODULE_TYPE_OBJ.OST]: getLabelText({
    key: 'remote.common.europeanTaxPass',
    text: '欧税通'
  }),
  [MODULE_TYPE_OBJ.IPP]: getLabelText({
    key: 'remote.common.metton',
    text: '麦德通'
  }),
  [MODULE_TYPE_OBJ.XM]: getLabelText({
    key: 'remote.common.smallTradeGoesToSea',
    text: '小贸出海'
  }),
  [MODULE_TYPE_OBJ.LD]: getLabelText({
    key: 'remote.common.sixDegreesInternational',
    text: '六度信息'
  }),
  [MODULE_TYPE_OBJ.TH]: getLabelText({
    key: 'remote.common.tianheGoesToSea',
    text: '天合出海'
  }),
  [MODULE_TYPE_OBJ.LZ]: getLabelText({
    key: 'remote.common.greenBoat',
    text: '绿舟'
  }),
  [MODULE_TYPE_OBJ.YS]: getLabelText({
    key: 'remote.common.YSCrossBorder',
    text: '易思跨境'
  }),
  [MODULE_TYPE_OBJ.LY]: getLabelText({
    key: 'remote.common.LYCrossBorder',
    text: '乐鱼'
  })
}

// postMessage类型
const POST_MSG_TYPE = {
  PROXY_MESSAGE: 'proxyMessage', // 代理订单页面消息
  PROXY_ORDER_TAB: 'proxyOrderTab', // 切换tab
  PROXY_ORDER_REFRESH_TAB: 'proxyOrderRefreshTab', // 刷新tab，使tab重新回到初始的页面
  PROXY_ORDER_TO_PAY: 'proxyOrderToPay', // 在订单支付页
  TO_ORDER_DETAIL: 'toOrderDetail', // 去订单详情页
  PROXY_ORDER_LOGOUT: 'proxyOrderLogout', // token失效，回到上一级
  ROUTE_REPLACE: 'routeReplace', // 路由替换
  CLEAR_QRCODE_TIMER: 'clearQrcodeTimer', // 清除支付订单的定时器
  PAY_QUERY_ORDER_SCORE: 'payQueryOrderScore', // 支付订单查询积分
  USER_CLIENT_LOADED: 'userClientLoaded', // 商户端是否加载完成
  AI_MERCHANT_PRODUCT_AUTH_EXPIRED: 'merchant-product-detail:auth-expired', // AI 商品卡片内登录失效，通知父级商户端统一重登
  TO_PAY: 'toPay',
  INTERNATIONAL_PAYMENTS: 'InternationalPayments'
}

const TRADEMARK_COUNTRY_LIST = [
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.US),
    value: COMMON_COUNTRY.US
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.EU),
    value: COMMON_COUNTRY.EU
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.DE),
    value: COMMON_COUNTRY.DE
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.GB),
    value: COMMON_COUNTRY.GB
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.CN),
    value: COMMON_COUNTRY.CN
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.JP),
    value: COMMON_COUNTRY.JP
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.KR),
    value: COMMON_COUNTRY.KR
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.PH),
    value: COMMON_COUNTRY.PH
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.IN),
    value: COMMON_COUNTRY.IN
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.AU),
    value: COMMON_COUNTRY.AU
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.CA),
    value: COMMON_COUNTRY.CA
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.BR),
    value: COMMON_COUNTRY.BR
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.MX),
    value: COMMON_COUNTRY.MX
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.MY),
    value: COMMON_COUNTRY.MY
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.TH),
    value: COMMON_COUNTRY.TH
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.KH),
    value: COMMON_COUNTRY.KH
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.ID),
    value: COMMON_COUNTRY.ID
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.SG),
    value: COMMON_COUNTRY.SG
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.TUR),
    value: COMMON_COUNTRY.TUR
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.MO),
    value: COMMON_COUNTRY.MO
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.NZ),
    value: COMMON_COUNTRY.NZ
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.FR),
    value: COMMON_COUNTRY.FR
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.CH),
    value: COMMON_COUNTRY.CH
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.HK),
    value: COMMON_COUNTRY.HK
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.ES),
    value: COMMON_COUNTRY.ES
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.IT),
    value: COMMON_COUNTRY.IT
  }
].map((item) => ({
  ...item,
  label: item.country
}))

const OrderType = new GenerateEnum({
  NO_MERGE: {
    value: 0,
    label: getLabelText({
      key: 'remote.common.mergingPaymentOrdersNotAllowed',
      text: '不允许合并支付订单'
    })
  },
  OFFICIAL: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.officialFeeType',
      text: '官费类型'
    })
  },
  OFFICIAL_INVOICE: {
    value: 2,
    label: getLabelText({
      key: 'remote.common.settlementType',
      text: '清分类型'
    })
  },
  OTHER: {
    value: 3,
    label: getLabelText({
      key: 'remote.common.serviceFeeType',
      text: '服务费类型'
    })
  },
  GREEN_BOAT_UNIVERSAL_FOREIGN_INVOICE: {
    value: 4,
    label: getLabelText({
      key: 'remote.common.greenBoatUniversalForeignInvoice',
      text: '绿舟外币万能订单'
    })
  }
})
const OrderMergeType = OrderType
const CATEGORY_LIST = [
  {
    categoryName: getLabelText({
      key: 'remote.common.chemicalRawMaterials',
      text: '化学原料 '
    }),
    categoryNumber: '01'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.pigmentAndPaint',
      text: '颜料油漆'
    }),
    categoryNumber: '02'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.makeUpAndClean',
      text: '化妆清洁'
    }),
    categoryNumber: '03'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.fuelGrease',
      text: '燃料油脂'
    }),
    categoryNumber: '04'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.pharmaceuticalPreparations',
      text: '药品制剂'
    }),
    categoryNumber: '05'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.hardwareAndMetal',
      text: '五金金属'
    }),
    categoryNumber: '06'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.machineryAndEquipment',
      text: '机械设备'
    }),
    categoryNumber: '07'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.manualInstruments',
      text: '手工器械'
    }),
    categoryNumber: '08'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.scientificInstruments',
      text: '科学仪器'
    }),
    categoryNumber: '09'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.medicalDevices',
      text: '医疗器械'
    }),
    categoryNumber: '10'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.householdAppliances',
      text: '家用电器'
    }),
    categoryNumber: '11'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.meansOfTransport',
      text: '运输工具'
    }),
    categoryNumber: '12'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.armsAndFireworks',
      text: '军火烟火'
    }),
    categoryNumber: '13'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.jewelryClocks',
      text: '珠宝钟表'
    }),
    categoryNumber: '14'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.musicalInstrumentsAndMusicAids',
      text: '乐器乐辅'
    }),
    categoryNumber: '15'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.officeTools',
      text: '办公工具'
    }),
    categoryNumber: '16'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.rubberProducts',
      text: '橡胶制品'
    }),
    categoryNumber: '17'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.leatherBags',
      text: '皮革箱包'
    }),
    categoryNumber: '18'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.buildingMaterials',
      text: '建筑材料'
    }),
    categoryNumber: '19'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.furnitureCraft',
      text: '家具工艺'
    }),
    categoryNumber: '20'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.kitchenSanitaryWare',
      text: '厨房洁具'
    }),
    categoryNumber: '21'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.ropeNetBagCanopy',
      text: '绳网袋蓬'
    }),
    categoryNumber: '22'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.textileYarn',
      text: '纺织纱线'
    }),
    categoryNumber: '23'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.clothSheets',
      text: '布料床单'
    }),
    categoryNumber: '24'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.clothingShoesAndHats',
      text: '服装鞋帽'
    }),
    categoryNumber: '25'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.laceAccessories',
      text: '花边配饰'
    }),
    categoryNumber: '26'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.carpetMat',
      text: '地毯席垫'
    }),
    categoryNumber: '27'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.sportsToys',
      text: '体育玩具'
    }),
    categoryNumber: '28'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.foodAndMeat',
      text: '食品肉类'
    }),
    categoryNumber: '29'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.snackIngredients',
      text: '小食配料'
    }),
    categoryNumber: '30'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.fruitsFlowersAndTrees',
      text: '水果花木'
    }),
    categoryNumber: '31'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.beerAndDrinks',
      text: '啤酒饮料'
    }),
    categoryNumber: '32'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.alcoholicBeverages',
      text: '酒精饮料'
    }),
    categoryNumber: '33'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.tobaccoSmokingSet',
      text: '烟草烟具'
    }),
    categoryNumber: '34'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.advertisingTrade',
      text: '广告贸易'
    }),
    categoryNumber: '35'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.financialPropertyManagement',
      text: '金融物管'
    }),
    categoryNumber: '36'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.buildingRepair',
      text: '建筑修理'
    }),
    categoryNumber: '37'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.communicationMedia',
      text: '通讯传媒'
    }),
    categoryNumber: '38'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.transportTravel',
      text: '运输旅行'
    }),
    categoryNumber: '39'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.materialHandling',
      text: '材料处理'
    }),
    categoryNumber: '40'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.educationAndEntertainment',
      text: '教育娱乐'
    }),
    categoryNumber: '41'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.technicalServices',
      text: '技术服务'
    }),
    categoryNumber: '42'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.cateringHotel',
      text: '餐饮酒店'
    }),
    categoryNumber: '43'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.medicalGardening',
      text: '医疗园艺'
    }),
    categoryNumber: '44'
  },
  {
    categoryName: getLabelText({
      key: 'remote.common.legalSecurity',
      text: '法律安全'
    }),
    categoryNumber: '45'
  }
]

const CATEGORY_MAP = {}
CATEGORY_LIST.forEach((item) => {
  CATEGORY_MAP[Number(item.categoryNumber)] = item.categoryName
})

// 商标查类别，分类的描述
const TRADEMARK_CATEGORY_DESC = {
  '01': '用于工业、科学、摄影、农业、园艺和林业的化学品；未加工人造合成树脂，未加工塑料物质；灭火和防火用合成物；淬火和焊接用制剂；鞣制动物皮毛用物质；工业用粘合剂；油灰及其他膏状填料；堆肥，肥料，化肥；工业和科学用生物制剂。',
  '02': '颜料，清漆，漆；防锈剂和木材防腐剂；着色剂，染料；印刷、标记和雕刻用油墨；未加工的天然树脂；绘画、装饰、印刷和艺术用金属箔及金属粉。',
  '03': '不含药物的化妆品和梳洗用制剂；不含药物的牙膏；香料，香精油；洗衣用漂白剂及其他物料；清洁、擦亮、去渍及研磨用制剂。',
  '04': '工业用油和油脂，蜡；润滑剂；吸收、润湿和粘结灰尘用合成物；燃料和照明材料；照明用蜡烛和灯芯。',
  '05': '药品，医用和兽医用制剂；医用卫生制剂；医用或兽医用营养食物和物质，婴儿食品；人用和动物用膳食补充剂；膏药，绷敷材料；填塞牙孔用料，牙科用蜡；消毒剂；消灭有害动物制剂；杀真菌剂，除莠剂。',
  '06': '普通金属及其合金，金属矿石；金属建筑材料；可移动金属建筑物；普通金属制非电气用缆线；金属小五金具；存储和运输用金属容器；保险箱。',
  '07': '机器，机床，电动工具；马达和引擎（陆地车辆用的除外）；机器联结器和传动机件（陆地车辆用的除外）；除手动手工具以外的农业器具；孵化器；自动售货机。',
  '08': '手工具和器具（手动的）；刀、叉和匙餐具；除火器外的随身武器；剃刀。',
  '09': '科学、研究、导航、测量、摄影、电影、视听、光学、衡具、量具、信号、侦测、测试、检验、救生和教学用装置及仪器；处理、开关、转换、积累、调节或控制电的配送或使用的装置和仪器；录制、传送、重放或处理声音、影像或数据的装置和仪器；已录制和可下载的媒体，计算机软件，录制和存储用空白的数字或模拟介质；投币启动设备用机械装置；收银机，计算设备；计算机和计算机外围设备；潜水服，潜水面罩，潜水用耳塞，潜水和游泳用鼻夹，潜水。员手套，潜水呼吸器；灭火设备。',
  10: '外科、医疗、牙科和兽医用仪器及器械；假肢，假眼和假牙；矫形用物品；缝合材料；残疾人专用治疗装置；按摩器械；婴儿护理用器械、器具及用品；性生活用器械、器具及用品。',
  11: '照明、加热、冷却、蒸汽发生、烹饪、干燥、通风、供水以及卫生用装置和设备。',
  12: '运载工具；陆、空、海用运载装置。',
  13: '火器；军火及弹药；炸药；焰火。',
  14: '贵金属及其合金; 首饰，宝石和半宝石;钟表和计时仪器。',
  15: '乐器；乐谱架和乐器架；指挥棒。',
  16: '纸和纸板；印刷品；书籍装订材料；照片；文具和办公用品（家具除外）；文具用或家庭用粘合剂；绘画材料和艺术家用材料；画笔；教育或教学用品；包装和打包用塑料纸、塑料膜和塑料袋；印刷铅字，印版。',
  17: '未加工和半加工的橡胶、古塔胶、树胶、石棉、云母及这些材料的代用品；生产用成型塑料和树脂制品；包装、填充和绝缘用材料；非金属软管和非金属柔性管。',
  18: '皮革和人造皮革;动物皮; 行李箱和背包;雨伞和阳伞;手杖; 鞭，马具和鞍具；动物用项圈、皮带和衣服。',
  19: '非金属的建筑材料；建筑用非金属硬管；柏油，沥青；可移动非金属建筑物；非金属纪念碑。',
  20: '家具，镜子，相框; 未加工或半加工的骨、角、鲸骨或珍珠母;贝壳;海泡石;黄琥珀；存储或运输用非金属容器。',
  21: '家用或厨房用器具和容器;梳子和海绵;刷子(画笔除外);制刷原料;清洁用具;未加工或半加工玻璃(建筑用玻璃除外);玻璃器皿、瓷器和陶器；烹饪用具和餐具（刀、叉、匙除外）。',
  22: '绳索和细绳；网；帐篷和防水遮布；纺织品或合成材料制遮篷；帆；运输和贮存散装物用麻袋；衬垫和填充材料（纸或纸板、橡胶、塑料制除外）；纺织用纤维原料及其替代品。',
  23: '纺织用纱和线、毛线。',
  24: '织物及其替代品；家庭日用纺织品；纺织品制或塑料制帘。',
  25: '服装，鞋，帽、手套、围巾、纱巾',
  26: '花边，编带和刺绣品，缝纫用饰带和蝴蝶结；纽扣，领钩扣，饰针和缝针；人造花；发饰；假发。',
  27: '地毯，地席，亚麻油地毡及其他铺在已建成地板上的材料；非纺织品制壁挂。',
  28: '游戏器具和玩具;；视频游戏装置；体育和运动用品;圣诞树用装饰品。',
  29: '肉，鱼，家禽和野味;肉汁;腌渍、冷冻、干制及煮熟的水果和蔬菜;果冻，果酱，蜜饯;蛋;奶，奶酪，黄油，酸奶和其他奶制品;食用油和油脂。',
  30: '咖啡、茶、可可及其代用品；米，意式面食，面条；食用淀粉和西米；面粉和谷类制品；面包、糕点和甜食；巧克力；冰淇淋，果汁刨冰和其他食用冰；糖，蜂蜜，糖浆；鲜酵母，发酵粉；食盐，调味料，香辛料，腌制香草；醋，调味酱汁和其他调味品；冰（冻结的水）。',
  31: '未加工的农业、水产养殖业、园艺、林业产品；未加工的谷物和种子；新鲜水果和蔬菜，新鲜芳香草本植物；草木和花卉；种植用球茎、幼苗和种子；活动物；动物的饮食；麦芽。',
  32: '啤酒；无酒精饮料；矿泉水和汽水；水果饮料及果汁；糖浆及其他用于制作无酒精饮料的制剂。',
  33: '酒精饮料（啤酒除外）；制饮料用酒精制剂。',
  34: '烟草和烟草代用品；香烟和雪茄；电子香烟和吸烟者用口腔雾化器；烟具；火柴。',
  35: '广告；商业经营、组织和管理；办公事务。',
  36: '金融，货币和银行服务；保险服务；不动产事务。',
  37: '建筑服务；安装和修理服务；采矿，石油和天然气钻探。',
  38: '电信服务，主要包括至少能使二人之间通过感觉方式进行通讯的服务',
  39: '运输；商品包装和贮藏；旅行安排。',
  40: '材料处理；废物和垃圾的回收利用；空气净化和水处理；印刷服务；食物和饮料的防腐处理。',
  41: '教育；提供培训；娱乐；文体活动。',
  42: '科学技术服务和与之相关的研究与设计服务；工业分析、工业研究和工业品外观设计服务；质量控制和质量认证服务；计算机硬件与软件的设计与开发。',
  43: '为消费者提供餐饮及临时住所的服务。',
  44: '医疗服务；兽医服务；人或动物的卫生和美容服务；农业、水产养殖、园艺和林业服务',
  45: '法律服务；为有形财产和个人提供实体保护的安全服务；由他人提供的为满足个人需要的私人和社会服务。'
}

/*
 * =========== common/merchant/env end ============
 */

/*
 * =========== admin/env start ============
 */

const PLAT_FORM_ENUM = new GenerateEnum({
  OST: {
    value: '00',
    label: getLabelText({
      key: 'remote.common.europeanTaxPass',
      text: '欧税通'
    }),
    proxyBase: process.env.VUE_APP_API_BASE_URL,
    systemType: '00'
  },
  IPP: {
    value: '01',
    label: getLabelText({ key: 'remote.common.metton', text: '麦德通' }),
    proxyBase: process.env.VUE_APP_MDT_API_BASE_URL,
    systemType: '01'
  },
  XM: {
    value: '10',
    label: getLabelText({
      key: 'remote.common.smallTradeGoesToSea',
      text: '小贸出海'
    }),
    proxyBase: process.env.VUE_APP_API_BASE_URL,
    systemType: '04'
  },
  SIX_DU: {
    value: '08',
    label: getLabelText({
      key: 'remote.common.sixDegreesInternational',
      text: '六度信息'
    }),
    proxyBase: process.env.VUE_APP_API_BASE_URL,
    systemType: '00'
  },
  GROUP_REPORT: {
    value: '11',
    label: getLabelText({
      key: 'remote.common.groupReportingCenter',
      text: '集团报表中心'
    }),
    proxyBase: process.env.VUE_APP_API_BASE_URL,
    systemType: '11'
  },
  TH: {
    value: '13',
    label: getLabelText({
      key: 'remote.common.tianheGoesToSea',
      text: '天合出海'
    }),
    proxyBase: process.env.VUE_APP_API_BASE_URL,
    systemType: '00'
  },
  ACCOUNTING_END: {
    value: '14',
    label: getLabelText({ key: 'remote.common.accountingEnd', text: '会计端' }),
    proxyBase: process.env.VUE_APP_API_BASE_URL,
    systemType: '04'
  },
  GREEN_BOAT: {
    value: '15',
    label: getLabelText({ key: 'remote.common.greenBoat', text: '绿舟' }),
    proxyBase: process.env.VUE_APP_API_BASE_URL,
    systemType: '00'
  },
  GJT_EU: {
    value: '16',
    label: 'VATAi' + `${getLabelText({ key: 'remote.common.euStation', text: '欧洲站' })}`,
    proxyBase: process.env.VUE_APP_API_BASE_URL,
    systemType: '00'
  },
  GJT_US: {
    value: '17',
    label: 'VATAi' + `${getLabelText({ key: 'remote.common.usStation', text: '美国站' })}`,
    proxyBase: process.env.VUE_APP_API_BASE_URL,
    systemType: '00'
  },
  SUPPLIER_CENTER: {
    value: '18',
    label: '供应链中心',
    proxyBase: process.env.VUE_APP_API_BASE_URL,
    systemType: '18'
  },
  REME: {
    value: '19',
    label: 'RecycleMe',
    proxyBase: process.env.VUE_APP_API_BASE_URL,
    systemType: '00'
  },
  SHUYOU: {
    value: '20',
    label: '数游',
    proxyBase: process.env.VUE_APP_API_BASE_URL,
    systemType: '20'
  },
  YS: {
    value: '21',
    label: getLabelText({ key: 'remote.common.YSCrossBorder', text: '易思跨境' }),
    proxyBase: process.env.VUE_APP_API_BASE_URL,
    systemType: '00'
  },
  LY: {
    value: '22',
    label: '乐鱼',
    proxyBase: process.env.VUE_APP_API_BASE_URL,
    systemType: '00'
  },
  NB: {
    value: '23',
    label: '能标检测',
    proxyBase: process.env.VUE_APP_API_BASE_URL,
    systemType: '00'
  },
  IFMS: {
    value: '24',
    label: '内外账一体化',
    proxyBase: process.env.VUE_APP_API_BASE_URL,
    systemType: '00'
  }
})

const userSystemType = {
  '01': '01',
  10: '04'
}

const SELF_PLAT_FORM_ENUM = PLAT_FORM_ENUM.generateEnumValue(
  ...Object.keys(PLAT_FORM_ENUM.enumData).filter((v) => {
    return PLAT_FORM_ENUM.enumData[v]?.value === globalThis().platform
  })
)

/**
 * 生成下拉列表项，比如：{ 0: { value: 0, label: '待支付' }, 1: { value: 1, label: '已支付' } }
 * @param {Object} options 选项
 * @param {Object} options.constants 常量枚举
 * @param {Object} options.map 常量枚举的映射
 * @param {boolean} options.isMap 是否使用map的值作为下拉列表项的key，默认为false
 * @return {Object} 下拉列表项
 */
function createSelectItem({ constants, map, isMap = false }) {
  const result = {}

  Object.keys(constants).forEach((key) => {
    const value = constants[key]
    const prop = isMap ? value : key

    result[prop] = {
      value: value,
      label: map[value]
    }
  })

  return result
}

const moneyTypeData = {
  GBP: getLabelText({ key: 'remote.common.pound', text: '英镑' }),
  EUR: getLabelText({ key: 'remote.common.euro', text: '欧元' }),
  AED: getLabelText({ key: 'remote.common.uaeDirham', text: '阿联酋迪拉姆' })
}

const tradeType = [
  {
    label: getLabelText({
      key: 'remote.common.paymentHasBeenMade',
      text: '已打款'
    }),
    value: 1
  },
  {
    label: getLabelText({
      key: 'remote.common.paymentOperationSucceeded',
      text: '支付操作成功'
    }),
    value: 4
  }
]

const taxesType = [
  {
    label: getLabelText({ key: 'remote.common.toBeTaxed', text: '待缴税' }),
    value: 2
  },
  {
    label: getLabelText({
      key: 'remote.common.taxesAreBeingPaid',
      text: '缴税中'
    }),
    value: 0
  },
  {
    label: getLabelText({
      key: 'remote.common.paid4',
      text: '已支付'
    }),
    value: 1
  }
]

const payClassTwo = [
  {
    value: 'GBP',
    label: getLabelText({ key: 'remote.common.pound', text: '英镑' })
  },
  {
    value: 'EUR',
    label: getLabelText({ key: 'remote.common.euro', text: '欧元' })
  }
]

/*
渠道类型：
worldfirst渠道、
baiduKP渠道、
ZINIAOeco渠道、
合规帮手、
H5/小程序渠道注册页、
PC渠道注册页
 */
const CHANNEL_TYPE = {
  WORLD_FIRST: 'common_land4_worldfirst', // worldfirst渠道banner图片配置
  BAIDU_KP: 'common_land4_baiduKP', // baiduKP渠道banner图片配置
  ZINIAO_ECO: 'common_land4_ZINIAOeco', // ZINIAOeco渠道banner图片配置
  OTHER_BANNER: 'common_land4_banner', // 其他banner图片配置
  CONTENT: 'common_land4_img', // 内容图片配置
  COMPLIANCE_HELPER: 'common_land10_img' // 合规帮手
}

// 渠道类型映射
const CHANNEL_TYPE_MAP = {
  [CHANNEL_TYPE.WORLD_FIRST]: getLabelText({
    key: 'remote.common.worldfirstChannelBannerImageConfiguration',
    text: 'worldfirst渠道banner图片配置'
  }),
  [CHANNEL_TYPE.BAIDU_KP]: getLabelText({
    key: 'remote.common.baiduKpChannelBannerImageConfiguration',
    text: 'baiduKP渠道banner图片配置'
  }),
  [CHANNEL_TYPE.ZINIAO_ECO]: getLabelText({
    key: 'remote.common.ziniaoecoChannelBannerImageConfiguration',
    text: 'ZINIAOeco渠道banner图片配置'
  }),
  [CHANNEL_TYPE.OTHER_BANNER]: getLabelText({
    key: 'remote.common.otherBannerImageConfigurations',
    text: '其他banner图片配置'
  }),
  [CHANNEL_TYPE.CONTENT]: getLabelText({
    key: 'remote.common.contentPictureConfiguration',
    text: '内容图片配置'
  }),
  [CHANNEL_TYPE.COMPLIANCE_HELPER]: getLabelText({
    key: 'remote.common.complianceHelper',
    text: '合规帮手'
  })
}

// 渠道类型下拉列表
const CHANNEL_TYPE_LIST = createSelectList({
  constants: CHANNEL_TYPE,
  map: CHANNEL_TYPE_MAP
})

const platformMappingList = [
  {
    // 用户中心
    platform: '06',
    systemType: '00',
    userType: '06',
    url: process.env.VUE_APP_USER_CENTER_URL
  }
]

//归属
const BELONG_TO = {
  // COMMON: {
  //   key: 0,
  //   value: '公共'
  // },
  OST: {
    key: 1,
    value: getLabelText({
      key: 'remote.common.europeanTaxPass',
      text: '欧税通'
    })
  },
  MDT: {
    key: 2,
    value: getLabelText({ key: 'remote.common.metton', text: '麦德通' })
  },
  XM: {
    key: 3,
    value: getLabelText({
      key: 'remote.common.smallTradeGoesToSea',
      text: '小贸出海'
    })
  },
  LIUDU: {
    key: 8,
    value: getLabelText({
      key: 'remote.common.sixDegreesInternational',
      text: '六度信息'
    })
  },
  TH: {
    key: 13,
    value: getLabelText({
      key: 'remote.common.tianheGoesToSea',
      text: '天合出海'
    })
  },
  LZ: {
    key: 15,
    value: getLabelText({ key: 'remote.common.greenBoat', text: '绿舟' })
  },
  GJTEU: {
    key: 16,
    value: 'VATAi'
  },
  GJTUS: {
    key: 17,
    value: 'VATAi'
  },
  YS: {
    key: 21,
    value: '易思跨境'
  },
  LY: {
    key: 22,
    value: '乐鱼跨境'
  },
  NB: {
    key: 23,
    value: '能标检测'
  }
}
//归属
const CONFIG_TYPE = {
  COMMON: {
    key: 1,
    value: getLabelText({
      key: 'remote.common.generalConfiguration',
      text: '通用配置'
    })
  },
  CUSTOM: {
    key: 2,
    value: getLabelText({
      key: 'remote.common.customConfiguration',
      text: '自定义配置'
    })
  }
}

function ObjectToArray(obj) {
  return Object.keys(obj).map((v) => obj[v])
}

const BELONG_TO_LIST = ObjectToArray(BELONG_TO)
const CONFIG_TYPE_LIST = ObjectToArray(CONFIG_TYPE)
const TARGET_DATA = {
  0: getLabelText({ key: 'remote.common.thresholdValue', text: '门槛值' }),
  1: getLabelText({ key: 'remote.common.standardValue', text: '达标值' }),
  2: getLabelText({ key: 'remote.common.expectation', text: '期望值' }),
  3: getLabelText({ key: 'remote.common.challengeValue', text: '挑战值' })
}
//对应后端取值
const TARGET_DATA_VALUE = {
  threshold: getLabelText({
    key: 'remote.common.thresholdValue',
    text: '门槛值'
  }),
  standard: getLabelText({
    key: 'remote.common.standardValue',
    text: '达标值'
  }),
  expecte: getLabelText({ key: 'remote.common.expectation', text: '期望值' }),
  challenge: getLabelText({
    key: 'remote.common.challengeValue',
    text: '挑战值'
  })
}

const CALL_CENTER_SERVICE_TYPE = {
  renewalTask: 1,
  renewalTurnover: 2,
  repurchaseTask: 3,
  consultingData: 4
}

const USER_DEPT_TYPE = {
  user: 0,
  dept: 1
}

// vat税号有效性，查询状态 (0：失效，1：有效，2：查询失败，3：注销)
const VAT_ACTIVE = {
  INVALID: 0,
  VALID: 1,
  QUERY_FAIL: 2,
  CANCEL: 3
}

const PLATFORM = PLAT_FORM_ENUM

const PLATFORM_MAP = Object.values(PLAT_FORM_ENUM).reduce((acc, cur) => {
  acc[cur] = PLAT_FORM_ENUM.getValueToLabel(cur)
  return acc
}, {})
// const PLATFORM_LIST = createSelectList({ constants: PLATFORM, map: PLATFORM_MAP }).filter((v) => v.value !== PLATFORM.XM)

const platform = globalThis().platform || PLAT_FORM_ENUM.OST
const platforms =
  platform === PLAT_FORM_ENUM.SIX_DU
    ? ['SIX_DU']
    : platform === PLAT_FORM_ENUM.XM
    ? ['OST', 'IPP', 'XM']
    : platform === PLAT_FORM_ENUM.TH
    ? ['TH']
    : platform === PLAT_FORM_ENUM.YS
    ? ['YS']
    : platform === PLAT_FORM_ENUM.LY
    ? ['LY']
    : platform === PLAT_FORM_ENUM.NB
    ? ['NB']
    : platform === PLAT_FORM_ENUM.GREEN_BOAT
    ? ['GREEN_BOAT']
    : ['OST', 'IPP']
// 不含小贸
const PLATFORM_LIST = PLAT_FORM_ENUM.generateEnumValue(...platforms).enumArray
//含小贸
const morePlatforms = [...platforms]
// platform !== PLAT_FORM_ENUM.SIX_DU && morePlatforms.push('XM')
const PLATFORM_MORE_LIST = PLAT_FORM_ENUM.generateEnumValue(...morePlatforms).enumArray

// 申报任务国家列表
const DECLARE_COUNTRY_LIST = [
  {
    value: COMMON_COUNTRY.DE,
    label: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.DE)
  },
  {
    value: COMMON_COUNTRY.IT,
    label: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.IT)
  },
  {
    value: COMMON_COUNTRY.ES,
    label: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.ES)
  },
  {
    value: COMMON_COUNTRY.GB,
    label: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.GB)
  },
  {
    value: COMMON_COUNTRY.FR,
    label: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.FR)
  },
  {
    value: COMMON_COUNTRY.AT,
    label: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.AT)
  },
  {
    value: COMMON_COUNTRY.PL,
    label: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.PL)
  },
  {
    value: COMMON_COUNTRY.CZ,
    label: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.CZ)
  },
  {
    value: COMMON_COUNTRY.NL,
    label: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.NL)
  },
  {
    value: COMMON_COUNTRY.SA,
    label: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.SA)
  },
  {
    value: COMMON_COUNTRY.UAE,
    label: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.UAE)
  }
]

// 申报大类  1:VAT;2:WEEE;3:包装法;4:电池法
const DECLARE_BUSINESS_TYPE = {
  VAT: '1', // VAT
  WEEE: '2', // WEEE
  PACKAGING: '3', // 包装法
  BATTERY: '4' // 电池法
}

const DECLARE_BUSINESS_TYPE_MAP = {
  [DECLARE_BUSINESS_TYPE.VAT]: 'VAT',
  [DECLARE_BUSINESS_TYPE.WEEE]: 'WEEE',
  [DECLARE_BUSINESS_TYPE.PACKAGING]: getLabelText({
    key: 'remote.common.packagingMethod',
    text: '包装法'
  }),
  [DECLARE_BUSINESS_TYPE.BATTERY]: getLabelText({
    key: 'remote.common.batteryMethod',
    text: '电池法'
  })
}

const DECLARE_BUSINESS_TYPE_LIST = createSelectList({
  constants: DECLARE_BUSINESS_TYPE,
  map: DECLARE_BUSINESS_TYPE_MAP
})

const DECLARE_BUSINESS_TYPE_SELECT_ITEM = createSelectItem({
  constants: DECLARE_BUSINESS_TYPE,
  map: DECLARE_BUSINESS_TYPE_MAP
})
const DECLARE_BUSINESS_TYPE_MAP_SELECT_ITEM = createSelectItem({
  constants: DECLARE_BUSINESS_TYPE,
  map: DECLARE_BUSINESS_TYPE_MAP,
  isMap: true
})

// 申报类型 0-预申报 1-年报 2-汇总年报
const DECLARE_SERVICE_TYPE = {
  PRE_DECLARE: '0', // 预申报
  ANNUAL_DECLARE: '1', // 年报
  SUMMARY_ANNUAL_DECLARE: '2' // 汇总年报
}

const DECLARE_SERVICE_TYPE_MAP = {
  [DECLARE_SERVICE_TYPE.PRE_DECLARE]: getLabelText({
    key: 'remote.common.pre-declaration',
    text: '预申报'
  }),
  [DECLARE_SERVICE_TYPE.ANNUAL_DECLARE]: getLabelText({
    key: 'remote.common.annualReport',
    text: '年报'
  }),
  [DECLARE_SERVICE_TYPE.SUMMARY_ANNUAL_DECLARE]: getLabelText({
    key: 'remote.common.summarizeTheAnnualReport',
    text: '汇总年报'
  })
}

const DECLARE_SERVICE_TYPE_LIST = createSelectList({
  constants: DECLARE_SERVICE_TYPE,
  map: DECLARE_SERVICE_TYPE_MAP
})

const DECLARE_SERVICE_TYPE_SELECT_ITEM = createSelectItem({
  constants: DECLARE_SERVICE_TYPE,
  map: DECLARE_SERVICE_TYPE_MAP
})

const DECLARE_SERVICE_TYPE_MAP_SELECT_ITEM = createSelectItem({
  constants: DECLARE_SERVICE_TYPE,
  map: DECLARE_SERVICE_TYPE_MAP,
  isMap: true
})

// 全用户申报任务状态 （1-进行中 2-已结束 3-已撤销）
const ALL_DECLARE_TASK_STATUS = {
  PENDING: 1,
  FINISHED: 2,
  CANCEL: 3
}

const SHOW_USER_DECLARE_RECORD = {
  SHOW: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.setToDisplayOnTheMerchantSide',
      text: '设置为商户端展示'
    })
  },
  HIDE: {
    value: 0,
    label: getLabelText({
      key: 'remote.common.setToHideOnTheMerchantSide',
      text: '设置为商户端隐藏'
    })
  }
}

const ALL_DECLARE_TASK_STATUS_MAP = {
  [ALL_DECLARE_TASK_STATUS.PENDING]: getLabelText({
    key: 'remote.common.inProgress',
    text: '进行中'
  }),
  [ALL_DECLARE_TASK_STATUS.FINISHED]: getLabelText({
    key: 'remote.common.ended',
    text: '已结束'
  }),
  [ALL_DECLARE_TASK_STATUS.CANCEL]: getLabelText({
    key: 'remote.common.revoked',
    text: '已撤销'
  })
}

const ALL_DECLARE_TASK_STATUS_LIST = createSelectList({
  constants: ALL_DECLARE_TASK_STATUS,
  map: ALL_DECLARE_TASK_STATUS_MAP
})

// zm申报周期 0=：月申报，1：季度申报，2：年申报
const ZM_DECLARE_PERIOD_TYPE = {
  MONTH: '0',
  QUARTER: '1',
  YEAR: '2'
}

const ZM_DECLARE_PERIOD_TYPE_MAP = {
  [ZM_DECLARE_PERIOD_TYPE.MONTH]: getLabelText({
    key: 'remote.common.monthlyDeclaration',
    text: '月申报'
  }),
  [ZM_DECLARE_PERIOD_TYPE.QUARTER]: getLabelText({
    key: 'remote.common.quarterlyDeclaration',
    text: '季度申报'
  }),
  [ZM_DECLARE_PERIOD_TYPE.YEAR]: getLabelText({
    key: 'remote.common.annualDeclaration2',
    text: '年申报'
  })
}

const ZM_DECLARE_PERIOD_TYPE_LIST = createSelectList({
  constants: ZM_DECLARE_PERIOD_TYPE,
  map: ZM_DECLARE_PERIOD_TYPE_MAP
})

// 状态 （0-未完成 1-已完成 2-已关闭）
const DECLARE_STATUS = {
  UNFINISHED: 0,
  FINISHED: 1,
  CLOSED: 2
}

const DECLARE_STATUS_MAP = {
  [DECLARE_STATUS.UNFINISHED]: getLabelText({
    key: 'remote.common.incomplete',
    text: '未完成'
  }),
  [DECLARE_STATUS.FINISHED]: getLabelText({
    key: 'remote.common.completed',
    text: '已完成'
  }),
  [DECLARE_STATUS.CLOSED]: getLabelText({
    key: 'remote.common.closed',
    text: '已关闭'
  })
}

const DECLARE_STATUS_LIST = createSelectList({
  constants: DECLARE_STATUS,
  map: DECLARE_STATUS_MAP
})

// 常规任务关闭标记，系统自动关闭、多次联系后用户不处理、无法联系到用户
const TASK_CLOSE_TAG = {
  SYSTEM_CLOSE: getLabelText({
    key: 'remote.common.systemAutomaticallyClosed',
    text: '系统自动关闭'
  }),
  USER_NOT_HANDLE: getLabelText({
    key: 'remote.common.userDoesNotHandleAfterMultipleContacts',
    text: '多次联系后用户不处理'
  }),
  NO_CONTACT: getLabelText({
    key: 'remote.common.unableToContactTheUser',
    text: '无法联系到用户'
  })
}

const TASK_CLOSE_TAG_LIST = [
  {
    label: TASK_CLOSE_TAG.SYSTEM_CLOSE,
    value: TASK_CLOSE_TAG.SYSTEM_CLOSE
  },
  {
    label: TASK_CLOSE_TAG.USER_NOT_HANDLE,
    value: TASK_CLOSE_TAG.USER_NOT_HANDLE
  },
  {
    label: TASK_CLOSE_TAG.NO_CONTACT,
    value: TASK_CLOSE_TAG.NO_CONTACT
  }
]

// 申报任务日志类型 0-全用户 1-常规
const TASK_LOG_TYPE = {
  ALL_DECLARE: 0,
  CONVENTION: 1
}

// 商户类型: ['普通商户', '税务代理', '林小姐', '合作供应商', '线下客户']
const MERC_TYPE = {
  NORMAL: '0',
  TAX_AGENT: '1',
  // LIN: '2',
  SUPPLIER: '3',
  OFFLINE: '4'
}

const MERC_TYPE_MAP = {
  [MERC_TYPE.NORMAL]: getLabelText({
    key: 'remote.common.ordinaryMerchants',
    text: '普通商户'
  }),
  [MERC_TYPE.TAX_AGENT]: getLabelText({
    key: 'remote.common.taxAgency',
    text: '税务代理'
  }),
  [MERC_TYPE.LIN]: getLabelText({ key: 'remote.common.msLin', text: '林小姐' }),
  [MERC_TYPE.SUPPLIER]: getLabelText({
    key: 'remote.common.partnerSupplier',
    text: '合作供应商'
  }),
  [MERC_TYPE.OFFLINE]: getLabelText({
    key: 'remote.common.offlineCustomer',
    text: '线下客户'
  })
}

const MERC_TYPE_LIST = createSelectList({
  constants: MERC_TYPE,
  map: MERC_TYPE_MAP
})

// 商户等级: [{ value: '1', name: '待体验用户' },{ value: '2', name: '体验用户' },{ value: '3', name: '初级用户' },{ value: '4', name: '一星用户' },{ value: '5', name: '二星用户' },{ value: '6', name: '三星用户' },{ value: '7', name: '五星用户' },{ value: '8', name: '铜星' },{ value: '9', name: '银星' },{ value: '10', name: '金星' },{ value: '11', name: '钻星' }],
const MERC_LEVEL = {
  WAIT_EXPERIENCE: '1',
  EXPERIENCE: '2',
  PRIMARY: '3',
  ONE_STAR: '4',
  TWO_STAR: '5',
  THREE_STAR: '6',
  FIVE_STAR: '7',
  COPPER_STAR: '8',
  SILVER_STAR: '9',
  GOLD_STAR: '10',
  DIAMOND_STAR: '11'
}

const MERC_LEVEL_MAP = {
  [MERC_LEVEL.WAIT_EXPERIENCE]: getLabelText({
    key: 'remote.common.usersAwaitingExperience',
    text: '待体验用户'
  }),
  [MERC_LEVEL.EXPERIENCE]: getLabelText({
    key: 'remote.common.experiencedUsers',
    text: '体验用户'
  }),
  [MERC_LEVEL.PRIMARY]: getLabelText({
    key: 'remote.common.beginnerUsers',
    text: '初级用户'
  }),
  [MERC_LEVEL.ONE_STAR]: getLabelText({
    key: 'remote.common.one-starUsers',
    text: '一星用户'
  }),
  [MERC_LEVEL.TWO_STAR]: getLabelText({
    key: 'remote.common.two-starUsers',
    text: '二星用户'
  }),
  [MERC_LEVEL.THREE_STAR]: getLabelText({
    key: 'remote.common.three-starUsers',
    text: '三星用户'
  }),
  [MERC_LEVEL.FIVE_STAR]: getLabelText({
    key: 'remote.common.five-starUsers',
    text: '五星用户'
  }),
  [MERC_LEVEL.COPPER_STAR]: getLabelText({
    key: 'remote.common.bronzeStar',
    text: '铜星'
  }),
  [MERC_LEVEL.SILVER_STAR]: getLabelText({
    key: 'remote.common.silverStar',
    text: '银星'
  }),
  [MERC_LEVEL.GOLD_STAR]: getLabelText({
    key: 'remote.common.goldStar',
    text: '金星'
  }),
  [MERC_LEVEL.DIAMOND_STAR]: getLabelText({
    key: 'remote.common.diamondStar',
    text: '钻星'
  })
}

const MERC_LEVEL_LIST = createSelectList({
  constants: MERC_LEVEL,
  map: MERC_LEVEL_MAP
})

// saleDataType 配置成了number有问题 saleDataType后端存的是数字类型，但是前端却用成了字符串，因此就只能新增一个val为数值类型
export const PLATFORM_LIST_ENUM_ENUM = {
  AMAZON: {
    label: getLabelText({ key: 'remote.common.amazon.text', text: '亚马逊' }),
    value: '1',
    iconClass: 'yamaxun',
    width: '70px',
    height: '20px',
    disCircleIcon: 'yamaxuntubiao-weishouquan',
    circleIcon: 'yamaxuntubiao-shouquan',
    val: 1
  },
  ALI_EXPRESS: {
    label: getLabelText({ key: 'remote.common.aliexpress', text: '速卖通' }),
    value: '2',
    width: '60px',
    iconClass: 'sumaitong',
    val: 2
  },
  NOON_PLATFORM: { label: 'NOON', value: '5', width: '50px', iconClass: 'noon', val: 5 },
  EBAY: { label: 'eBay', value: '6', width: '40px', iconClass: 'logo-eBay', val: 6 },
  ALLEGRO: { label: 'Allegro', value: '7', width: '48px', iconClass: 'logo-allegro', val: 7, disCircleIcon: 'allegrotubiao-weishouquan', circleIcon: 'allegrotubiao-shouquan' },
  WISH: { label: 'Wish', value: '8', width: '48px', iconClass: 'logo-Wish', val: 8 },
  SHOPEE: { label: 'Shopee', value: '9', width: '53px', iconClass: 'logo-shopee', val: 9 },
  INDEPENDENCE_SITE: {
    label: getLabelText({
      key: 'remote.common.independentStation',
      text: '独立站'
    }),
    value: '10',

    width: '18px',
    iconClass: 'logo-dulizhan',
    val: 10
  },
  LOTTE: { label: 'Rakuten', value: '12', width: '60px', iconClass: 'rakuten', val: 12 },
  MERCADO_LIBRE: { label: 'Mercado Libre', value: '13', width: '90px', iconClass: 'a-pingtai-mercadolibre', val: 13 },
  STANDARD_SALES_DATA: {
    label: getLabelText({
      key: 'remote.common.standardSalesData',
      text: '标准销售数据'
    }),
    value: '14',
    icon: '',
    width: '18px',
    val: 14
  },
  SHOPIFY: {
    label: 'Shopify',
    value: '15',
    iconClass: 'shopify-logo',
    width: '50px',
    height: '22px',
    circleIcon: 'shopifytubiao-shouquan',
    disCircleIcon: 'shopifytubiao-weishouquan',
    tip: getLabelText({ key: 'remote.declare.calculateTaxModalRevisionV2.shopfiyTip', text: '' }),
    val: 15
  },
  SHEIN: {
    label: 'SHEIN',
    value: '16',
    val: 16,
    disCircleIcon: 'sheintubiao-weishouquan',
    circleIcon: 'sheintubiao-shouquan',
    iconClass: 'shein-logo',
    width: '60px'
  },
  C_DISCOUNT: {
    label: 'Cdiscount',
    value: '17',
    val: 17,
    disCircleIcon: 'Cdiscounttubiao-weishouquan',
    circleIcon: 'Cdiscounttubiao-yishouquan',
    iconClass: 'cdiscount-logo',
    width: '60px'
  },
  OTTO: {
    label: 'OTTO',
    value: '18',
    val: 18,
    disCircleIcon: 'Ottotubiao-weishouquan',
    circleIcon: 'Ottotubiao-yishouquan',
    iconClass: 'Otto',
    width: '40px'
  },
  WAL_MART: {
    value: '19',
    val: 19,
    label: getLabelText({
      key: 'remote.common.WalMart',
      text: '沃尔玛'
    }),
    iconClass: 'Walmart',
    width: '60px'
  },
  TEMU: {
    value: '20',
    val: 20,
    label: 'TEMU',
    iconClass: 'TEMU',
    width: '24px'
  },
  TIKTOK_SHOP: {
    value: '21',
    val: 21,
    label: 'TikTok SHOP',
    iconClass: 'TikTokShop',
    width: '30px'
  },
  OZON: {
    value: '22',
    val: 22,
    label: 'OZON',
    iconClass: 'ozon',
    width: '50px'
  },
  LAZADA: {
    value: '23',
    val: 23,
    label: 'Lazada',
    iconClass: 'lazada',
    width: '60px'
  },
  WILDBERRIES: {
    value: '24',
    val: 24,
    label: 'Wildberries',
    iconClass: 'wildberries',
    width: '60px'
  },
  ETSY: {
    value: '25',
    val: 25,
    label: 'Etsy',
    iconClass: 'Etsy',
    width: '35px'
  },
  WAYFAIR: {
    value: '26',
    val: 26,
    label: 'Wayfair',
    iconClass: 'Wayfair-square-active',
    width: '60px'
  },
  ZALANDO: {
    value: '27',
    val: 27,
    label: 'Zalando',
    iconClass: 'zalando',
    width: '60px'
  },
  TRENDYOL: {
    value: '28',
    val: 28,
    label: 'Trendyol',
    iconClass: 'trendyol',
    width: '60px'
  },
  COUPANG: {
    value: '29',
    val: 29,
    label: 'Coupang',
    iconClass: 'logo-coupang',
    width: '60px'
  },
  JUMIA: {
    value: '30',
    val: 30,
    label: 'Jumia',
    iconClass: 'jumia--',
    width: '60px'
  },
  MIRAKL: {
    value: '31',
    val: 31,
    label: 'MIRAKL',
    iconClass: 'Mirakl',
    width: '60px'
  },
  // 继续新增平台
  FNAC: {
    value: '32',
    val: 32,
    label: 'FNAC',
    iconClass: 'FNAC',
    width: '60px'
  },
  ALIBABA: {
    value: '33',
    val: 33,
    label: getLabelText({
      key: 'remote.common.Alibaba',
      text: '阿里巴巴'
    }),
    iconClass: 'alibaba',
    width: '60px'
  },
  VOGHION: {
    value: '34',
    val: 34,
    label: 'Voghion',
    iconClass: 'Voghion',
    width: '60px'
  },
  E_MAG: {
    value: '35',
    val: 35,
    label: 'eMAG',
    iconClass: 'EMAG',
    width: '60px'
  },
  OCTOPIA: {
    value: '36',
    val: 36,
    label: 'Octopia',
    iconClass: 'octopia',
    width: '60px'
  },
  LEROY_MERLIN: {
    value: '37',
    val: 37,
    label: 'Leroy Merlin',
    iconClass: 'a-LeroyMerlin',
    width: '60px'
  },
  MANO_MANO: {
    value: '38',
    val: 38,
    label: 'ManoMano',
    iconClass: 'ManoMano',
    width: '100px'
  },
  KAUFLAND: {
    value: '39',
    val: 39,
    label: 'Kaufland',
    iconClass: 'kaufland',
    width: '40px'
  },
  BACK_MARKET: {
    value: '40',
    val: 40,
    label: 'Back Market',
    iconClass: 'a-BackMarket',
    width: '60px'
  },
  ON_BUY: {
    value: '41',
    val: 41,
    label: 'OnBuy',
    iconClass: 'Onbuy',
    width: '60px'
  },
  OTHER_SITE: {
    label: getLabelText({
      key: 'remote.common.otherPlatforms',
      text: '其他平台'
    }),
    value: '11',
    icon: '',
    width: '18px',
    val: 11
  }
}

// START 新增枚举 allegro SHEIN
let SALES_PLAT_FORM = {}
Object.keys(PLATFORM_LIST_ENUM_ENUM).forEach(
  (key) =>
    (SALES_PLAT_FORM[key] = {
      value: PLATFORM_LIST_ENUM_ENUM[key].val,
      label: PLATFORM_LIST_ENUM_ENUM[key].label
    })
)
// END
export const SALES_PLAT_FORM_ENUM = new GenerateEnum(SALES_PLAT_FORM)
export const B2B_DECLARE_WAYS_ENUM = new GenerateEnum({
  AUTO_SALES_PURCHASES_TRANSFER: {
    label: getLabelText({
      key: 'remote.declare.auto.salesPurchasesTransfer',
      text: '自动申报(销售+采购+移仓)'
    }),
    value: '4'
  },
  AUTO_SALES_PURCHASES: {
    label: getLabelText({
      key: 'remote.declare.auto.salesPurchases',
      text: '自动申报(销售+采购)'
    }),
    value: '0'
  },
  AUTO_PURCHASES: {
    label: getLabelText({
      key: 'remote.declare.auto.purchases',
      text: '自动申报(采购)'
    }),
    value: '2'
  },
  MANUAL_SALES_PURCHASES_TRANSFER: {
    label: getLabelText({
      key: 'remote.declare.manual.salesPurchasesTransfer',
      text: '手动申报(销售+采购+移仓)'
    }),
    value: '5'
  },
  MANUAL_SALES_PURCHASES: {
    label: getLabelText({
      key: 'remote.declare.manual.salesPurchases',
      text: '手动申报(销售+采购)'
    }),
    value: '1'
  },
  MANUAL_PURCHASES: {
    label: getLabelText({
      key: 'remote.declare.manual.purchases',
      text: '手动申报(采购)'
    }),
    value: '3'
  }
})
const DE_DECLARE_DATA_ORIGIN = {
  OTHER: {
    value: 0,
    label: getLabelText({ key: 'remote.common.addManually', text: '手动添加' })
  },
  SYSTEM: {
    value: 1,
    label: getLabelText({ key: 'remote.common.system', text: '系统' })
  }
}

const DE_VAT_YEAR_DECLARE_TYPE = {
  NEW_REGISTER: {
    value: '0',
    label: getLabelText({
      key: 'remote.common.newRegistrationForGermanVatConsolidatedAnnualReport',
      text: '德国VAT汇总年报新注册'
    })
  },
  TO_PROXY: {
    value: '1',
    label: getLabelText({
      key: 'remote.common.transferOfGermanVatConsolidatedAnnualReportToAgency',
      text: '德国VAT汇总年报转代理'
    })
  }
}

// 跨境B2B销售（系统）
const B2B_SALES_SYSTEM = {
  GREATER_THAN_100000: {
    key: 5,
    value: '≥10万'
  },
  GREATER_THAN_50000: {
    key: 4,
    value: '≥5万 且 <10万'
  },
  LESS_THAN_50000: {
    key: 3,
    value: '>0 且 <5万'
  },
  GREATER: {
    key: 0,
    value: '>0'
  },
  EQUAL: {
    key: 1,
    value: '=0'
  },
  LESS_THAN: {
    key: 2,
    value: '<0'
  },
  UNEQUAL_TO: {
    key: 10,
    value: getLabelText({ key: 'remote.admin.actualAmountReported7631', text: '≠实报金额' })
  }
}

const DECLARE_STATUS_ENUM = Object.fromEntries(Object.entries(DECLARATION_STATUS).map(([, { value, label }]) => [value, label]))

const DECLARE_DATA_ORIGIN = {
  OST: {
    value: '0',
    label: 'OST'
  },
  PROXY: {
    value: '1',
    label: getLabelText({ key: 'remote.common.previousAgency', text: '前代理' })
  },
  MANUAL_ADD: {
    value: '2',
    label: getLabelText({ key: 'remote.common.addManually', text: '手动添加' })
  },
  IMPORT: {
    value: '3',
    label: '导入'
  }
}

const FILE_STATUS_MAP = {
  HAS_GENERATE: {
    label: getLabelText({ key: 'remote.common.generated', text: '已生成' }),
    value: 1
  },
  FAILED_GENERATE: {
    label: getLabelText({
      key: 'remote.common.generationFailed',
      text: '生成失败'
    }),
    value: 0
  }
}
const FILE_STATUS_ENUM = new GenerateEnum(FILE_STATUS_MAP)

// 新增评分类型

const SCORE_TYPE_ENUM = new GenerateEnum({
  ALL_SCORE: {
    value: 1,
    label: getLabelText({ key: 'remote.common.allRatings', text: '全部评分' })
  },
  REPEAT_SCORE: {
    value: 2,
    label: getLabelText({
      key: 'remote.common.de-weightScoring',
      text: '去重评分'
    })
  },
  ALL_SCORE_NPS: {
    value: 3,
    label: getLabelText({ key: 'remote.common.allRatings', text: '全部评分' }) + '（NPS）'
  },
  REPEAT_SCORE_NPS: {
    value: 4,
    label:
      getLabelText({
        key: 'remote.common.de-weightScoring',
        text: '去重评分'
      }) + '（NPS）'
  }
})

// 获取options

const DECLARE_DATA_ORIGIN_ENUM = Object.fromEntries(Object.entries(DECLARE_DATA_ORIGIN).map(([, { value, label }]) => [value, label]))
const DECLARATION_CYCLE_TYPE = {
  MONTH: {
    value: '0',
    label: getLabelText({
      key: 'remote.common.monthlyDeclaration',
      text: '月度申报'
    })
  },
  QUARTER: {
    value: '1',
    label: getLabelText({
      key: 'remote.common.quarterlyDeclaration',
      text: '季度申报'
    })
  },
  YEAR: {
    value: '2',
    label: getLabelText({
      key: 'remote.common.annualDeclaration',
      text: '年度申报'
    })
  },
  TWO_MONTH: {
    value: '3',
    label: getLabelText({
      key: 'remote.common.two-monthDeclaration',
      text: '两月申报'
    })
  },
  CUSTOM_QUARTER: {
    value: '4',
    label: getLabelText({
      key: 'remote.common.non-naturalQuarterlyFiling',
      text: '非自然季度申报'
    })
  },
  CUSTOM_YEAR_CYCLE: {
    value: '5',
    label: getLabelText({
      key: 'remote.common.non-naturalYearDeclaration',
      text: '非自然年度申报'
    })
  },
  HALF_YEAR: {
    value: '6',
    label: getLabelText({
      key: 'remote.common.semi-annualDeclaration',
      text: '半年申报'
    })
  }
}

const DECLARATION_CYCLE_TYPE_ENUM = GenerateEnum(DECLARATION_CYCLE_TYPE)

// EPR中电池法，包装法，纺织法中待申报是用的7，所以有两个对应的枚举值
const EPR_DECLARATION_STATUS = {
  TO_BE_SUBMITTED: {
    value: '0',
    label: getLabelText({ key: 'remote.common.toBeSubmitted', text: '待提交' })
  },
  DECLARING: {
    value: '1',
    label: getLabelText({
      key: 'remote.common.declarationInProgress',
      text: '申报中'
    })
  },
  SUCCESSFULLY_DECLARED: {
    value: '2',
    label: getLabelText({
      key: 'remote.common.theDeclarationWasSuccessful',
      text: '申报成功'
    })
  },
  CANCELLED: {
    value: '5',
    label: getLabelText({ key: 'remote.common.cancelled', text: '已取消' })
  },
  // 待缴费
  NEED_PAYMENT_FEES: {
    value: '14',
    label: getLabelText({
      key: 'remote.common.toBePaid2',
      text: '待缴费'
    })
  },
  IS_PAYING: {
    value: '15',
    label: getLabelText({
      key: 'remote.common.paymentInProgress',
      text: '缴费中'
    })
  },
  HAS_PAY: {
    value: '16',
    label: getLabelText({ key: 'remote.common.paid2', text: '已缴费' })
  },
  TO_BE_DECLARED: {
    value: '7',
    label: getLabelText({ key: 'remote.common.toBeDeclared', text: '待申报' })
  },
  DECLARE_FAILED: {
    value: '4',
    label: getLabelText({
      key: 'remote.common.declarationFailed',
      text: '申报失败'
    })
  },
  HAD_REJECT: {
    value: '9',
    label: getLabelText({ key: 'remote.common.rejected', text: '已驳回' })
  },
  PAY_REVIEW: {
    value: '17',
    label: getLabelText({ key: 'remote.admin.paymentReview', text: '缴费审核' })
  },
  PAY_REJECT: {
    value: '18',
    label: getLabelText({ key: 'remote.admin.paymentRejection', text: '缴费驳回' })
  }
}

const EPR_DECLARATION_STATUS_ENUM = new GenerateEnum(EPR_DECLARATION_STATUS)

const RESPONSE_STATUS_CODE = {
  SUCCESS: {
    label: getLabelText({
      key: 'remote.common.operationSucceeded',
      text: '操作成功'
    }),
    value: 0
  }
}

// EPR中W3E中待申报是用的1
const ES_EPR_DECLARATION_STATUS = {
  TO_BE_DECLARED: {
    value: '1',
    label: getLabelText({ key: 'remote.common.toBeDeclared', text: '待申报' })
  }
}

const B2B_ACCOUNT_STATUS_ENUM = {
  NOT_REGISTERED: {
    value: 1,
    label: getLabelText({ key: 'remote.common.notRegistered', text: '未注册' })
  },
  NOT_ACTIVE: {
    value: 2,
    label: getLabelText({ key: 'remote.common.notActivated', text: '未激活' })
  },
  NOT_INFORMATION: {
    value: 3,
    label: getLabelText({
      key: 'remote.common.informationNotProvided',
      text: '未填写信息'
    })
  },
  DONE: {
    value: 4,
    label: getLabelText({ key: 'remote.common.completed', text: '已完成' })
  }
}

const B2B_ACCOUNT_STATUS_ENUM_OBJ = new GenerateEnum(B2B_ACCOUNT_STATUS_ENUM)

const PACK_CH_NAME_INPUT_LIMIT = [
  {
    packageChName: getLabelText({ key: 'remote.common.steel', text: '钢' }),
    min: 0.1,
    max: 10000
  },
  {
    packageChName: getLabelText({ key: 'remote.common.aluminium', text: '铝' }),
    min: 0.1,
    max: 10000
  },
  {
    packageChName:
      getLabelText({
        key: 'remote.common.cardboard',
        text: '纸板'
      }) +
      `(${getLabelText({
        key: 'remote.common.excludesBeveragePaperboardCartons',
        text: '不包括饮料纸盒'
      })})`,
    min: 0.1,
    max: 5000
  },
  {
    packageChName: getLabelText({
      key: 'remote.common.beveragePaperboardCartons',
      text: '饮料纸盒'
    }),
    min: 0.1,
    max: 5000
  },
  {
    packageChName: getLabelText({
      key: 'remote.common.aluminium',
      text: '玻璃'
    }),
    min: 0.1,
    max: 10000
  },
  {
    packageChName: getLabelText({
      key: 'remote.common.transparentPetBottles',
      text: '透明PET瓶'
    }),
    min: 0.1,
    max: 5000
  },
  {
    packageChName:
      getLabelText({ key: 'remote.common.promptText65', text: 'PE或PP' }) +
      `${getLabelText({
        key: 'remote.common.darkColor',
        text: '深色'
      })}/${getLabelText({
        key: 'remote.common.opaque',
        text: '不透明'
      })}/${getLabelText({
        key: 'remote.common.coloredPetBottles',
        text: '彩色PET瓶'
      })}`,
    min: 0.1,
    max: 5000
  },
  {
    packageChName: `${getLabelText({
      key: 'remote.common.darkColor',
      text: '深色'
    })}/${getLabelText({
      key: 'remote.common.opaque',
      text: '不透明'
    })}/${getLabelText({
      key: 'remote.common.coloredPetBottles',
      text: '彩色PET瓶'
    })}`,
    min: 0.1,
    max: 5000
  },
  {
    packageChName: getLabelText({
      key: 'remote.common.promptText66',
      text: '其他非PVC瓶（PLA、复合瓶等）'
    }),
    min: 0.1,
    max: 5000
  },
  {
    packageChName:
      'PE PP' +
      getLabelText({
        key: 'remote.common.rigidPlasticPackaging',
        text: '硬质塑料包装'
      }),
    min: 0.1,
    max: 5000
  },
  {
    packageChName:
      'PET' +
      getLabelText({
        key: 'remote.common.rigidPlasticPackaging',
        text: '硬质塑料包装'
      }),
    min: 0.1,
    max: 5000
  },
  {
    packageChName:
      'PS' +
      getLabelText({
        key: 'remote.common.rigidPlasticPackaging',
        text: '硬质塑料包装'
      }),
    min: 0.1,
    max: 5000
  },
  {
    packageChName: getLabelText({
      key: 'remote.common.promptText67',
      text: '其他非PVC硬质塑料包装（PLA、复合物等）'
    }),
    min: 0.1,
    max: 5000
  },
  {
    packageChName: 'PP' + getLabelText({ key: 'remote.common.flexiblePackaging', text: '软包装' }),
    min: 0.1,
    max: 5000
  },
  {
    packageChName: 'PE' + +getLabelText({ key: 'remote.common.flexiblePackaging', text: '软包装' }),
    min: 0.1,
    max: 5000
  },
  {
    packageChName: getLabelText({
      key: 'remote.common.promptText68',
      text: '其他非PVC软包装（PLA、复合物等）'
    }),
    min: 0.1,
    max: 5000
  },
  {
    packageChName: getLabelText({
      key: 'remote.common.promptText69',
      text: '含有 PVC 的包装（软性和硬性，包括瓶子）'
    }),
    min: 0.1,
    max: 5000
  },
  {
    packageChName: getLabelText({
      key: 'remote.common.rawWoodCork',
      text: '原木、软木'
    }),
    min: 0.1,
    max: 10000
  },
  {
    packageChName: getLabelText({
      key: 'remote.common.textilesNon-woodEtc',
      text: '纺织品、非原木等'
    }),
    min: 0.1,
    max: 5000
  },
  {
    packageChName: getLabelText({
      key: 'remote.common.earthenwarePorcelainCeramicProducts',
      text: '粗陶器,瓷器，陶瓷制品'
    }),
    min: 0.1,
    max: 10000
  }
]

const COMMON_BUSINESS_TYPE = new GenerateEnum({
  FA_B2B_DECLARE_ACCOUNT_DISCARD: {
    label: getLabelText({
      key: 'remote.common.disposeOfDeclarationAccount',
      text: '弃置申报账户'
    }),
    value: '41'
  },
  FA_B2B_DECLARE_ACCOUNT_IMPORT: {
    label: getLabelText({
      key: 'remote.common.importDeclarationAccount',
      text: '导入申报账户'
    }),
    value: '42'
  },
  FA_B2B_DECLARE_ACCOUNT_RPA_REGISTER: {
    label:
      'RPA' +
      getLabelText({
        key: 'remote.common.registerDeclarationAccount',
        text: '注册申报账户'
      }),
    value: '43'
  },
  FA_B2B_DECLARE_ACCOUNT_UPDATE: {
    label: getLabelText({
      key: 'remote.common.updateDeclarationAccount',
      text: '更新申报账户'
    }),
    value: '44'
  }
})

const HANDLE_EVENT_TYPE = {
  IS_ADD_EVENT: {
    value: 0,
    label: getLabelText({ key: 'remote.common.addTo', text: '添加' })
  },
  IS_VIEW_EVENT: {
    value: 1,
    label: getLabelText({ key: 'remote.common.check', text: '查看' })
  }
}

const DECLARE_COUNTRY_OPTIONS = Object.keys(COUNTRY_NEW_MAP)
  .filter((code) =>
    [
      COUNTRY_NEW.UK,
      COUNTRY_NEW.DE,
      COUNTRY_NEW.FR,
      COUNTRY_NEW.IT,
      COUNTRY_NEW.ES,
      COUNTRY_NEW.CZ,
      COUNTRY_NEW.PL,
      COUNTRY_NEW.NL,
      COUNTRY_NEW.AT,
      COUNTRY_NEW.SA,
      COUNTRY_NEW.AE,
      COUNTRY_NEW.JP,
      COUNTRY_NEW.MX,
      COUNTRY_NEW.IE,
      COUNTRY_NEW.SE,
      COUNTRY_NEW.AU
    ].includes(code)
  )
  .map((item) => ({ label: COUNTRY_NEW_MAP[item], value: item }))

const DECLARE_TYPE = {
  //  0：vat申报
  VAT_DECLARE: '0',
  //  1：德国年报
  GERMANY_ANNUAL: '1',
  //  2：手动vat申报
  MANUAL_VAT: '2',
  //  3：vat/zm申报
  VAT_ZM_DECLARE: '3',
  //  4：zm申报
  ZM_DECLARE: '4',
  //  5：意大利年度汇总申报
  ITALY_ANNUAL: '5',
  //  6：西班牙年度汇总申报
  ES_YEAR_DECLARE: '6',
  //  7：德国b2b申报修正
  DE_B2B_AMENDMENT: '7',
  //  8：奥地利年度汇总申报
  AT_ANNUAL: '8',
  //  9：英国超过2年手动算税申报
  UK_MANUAL_DECLARE: '9',
  //  10：汇总年报
  YEAR_SUM_DECLARE: '10',
  // 包装法注册申报
  PACKAGING_REGISTRATION_DECLARE: '102',
  // 电池法注册申报
  BATTERY_REGISTRATION_DECLARE: '103',
  // WEEE续费
  WEEE_RENEW: '201'
}

const OPERATION_TYPE_ENUM = new GenerateEnum({
  DATA: {
    value: 0,
    label: getLabelText({
      key: 'remote.common.submissionOfInformation',
      text: '提交资料'
    })
  },
  DECLARE: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.submitADeclaration',
      text: '提交申报'
    })
  }
})

const EPR_DECLARE_STATUS_ENUM = new GenerateEnum({
  IS_USING: {
    value: '0',
    label: getLabelText({ key: 'remote.common.inUse', text: '使用中' })
  },
  IS_DEPRECATED: {
    value: '1',
    label: getLabelText({ key: 'remote.common.discard', text: '弃用' })
  }
})

const EPR_IMPORT_STATUS_ENUM = new GenerateEnum({
  BE_HANDLE: {
    value: '0',
    label: getLabelText({ key: 'remote.common.pending', text: '待处理' })
  },
  IMPORT_SUC: {
    value: '2',
    label: getLabelText({
      key: 'remote.common.importSuccessful',
      text: '导入成功'
    })
  },
  IMPORT_FAILED: {
    value: '3',
    label: getLabelText({ key: 'remote.common.importFailed', text: '导入失败' })
  }
})

function createdEnumOptions(enumItem) {
  return Object.keys(enumItem).map((item) => ({
    value: enumItem[item].value,
    label: enumItem[item].label
  }))
}

const EPR_DECLARE_PERIOD_OPTIONS = createdEnumOptions(EPR_DECLARE_PERIOD_ENUM)
const EPR_DECLARE_PERIOD_MAP = new GenerateEnum(EPR_DECLARE_PERIOD_ENUM)
// // 欧税通或者麦德通的入账主体
// const type = globalThis.platform === PLAT_FORM_ENUM.OST?['VAT_MASTER']:['SHANGHAI_IPP', 'SHENZHEN_IPP']
// const entryCompanyList = entryCompanyEnum.generateEnumValue(...type).enumArray

//发票类型枚举
const TICKET_TYPE_ENUM = new GenerateEnum({
  VAT_GENERAL_INVOICE: {
    value: '0',
    label: getLabelText({
      key: 'remote.common.value-addedTaxPlainInvoice',
      text: '增值税普通发票'
    })
  },
  VALUE_ADDED_TAX_INVOICE: {
    value: '1',
    label: getLabelText({
      key: 'remote.common.specialInvoiceForValue-addedTax',
      text: '增值税专用发票'
    })
  },
  RED_FLUSH_INVOICE: {
    value: '2',
    label: getLabelText({
      key: 'remote.common.electronicRedFlush',
      text: '电子红冲'
    })
  },
  PAPER_RED_FLUSH_INVOICE: {
    value: '3',
    label: getLabelText({
      key: 'remote.common.paperRedFlush',
      text: '纸质红冲'
    })
  },
  OFFICIAL_FEE_INVOICE: {
    value: '5',
    label:
      getLabelText({
        key: 'remote.common.officialExpenses',
        text: '官费'
      }) + 'Invoice'
  }
})

const PAYMENT_BUSINESS_ENUM = new GenerateEnum({
  VAT: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.taxPaymentAndRefund',
      text: '缴税退税'
    })
  },
  BUY: {
    value: 2,
    label:
      getLabelText({
        key: 'remote.common.merchantSide',
        text: '商户端'
      }) +
      '-' +
      getLabelText({ key: 'remote.common.serviceCharge', text: '服务费' })
  },
  EPR: {
    value: 3,
    label: 'EPR' + getLabelText({ key: 'remote.common.officialExpenses', text: '官费' })
  },
  OFFICIAL: {
    value: 4,
    label:
      getLabelText({
        key: 'remote.common.merchantSide',
        text: '商户端'
      }) +
      '-' +
      getLabelText({ key: 'remote.common.officialExpenses', text: '官费' })
  },
  WECHAT: {
    value: 5,
    label:
      getLabelText({
        key: 'remote.common.miniProgram',
        text: '小程序'
      }) +
      '-' +
      getLabelText({ key: 'remote.common.serviceCharge', text: '服务费' })
  },
  UAE: {
    value: 6,
    label: getLabelText({
      key: 'remote.common.uaeTaxPayment',
      text: '阿联酋缴税'
    })
  },
  MERGE_BUY: {
    value: 7,
    label:
      getLabelText({
        key: 'remote.common.merchantSide',
        text: '商户端'
      }) +
      '-' +
      getLabelText({
        key: 'remote.common.combinedPaymentOfOfficialFeesAndServiceCharges',
        text: '官费服务费合并支付'
      })
  },
  MERGE_WECHAT: {
    value: 8,
    label:
      getLabelText({
        key: 'remote.common.miniProgram',
        text: '商户端'
      }) +
      '-' +
      getLabelText({
        key: 'remote.common.combinedPaymentOfOfficialFeesAndServiceCharges',
        text: '官费服务费合并支付'
      })
  },
  EOB: {
    value: 9,
    label:
      getLabelText({
        key: 'remote.common.inviteInvestment',
        text: '招商'
      }) +
      '-' +
      getLabelText({
        key: 'remote.common.corporateOnlineBanking',
        text: '企业网银'
      })
  },
  ID_INFO: {
    value: 10,
    label: getLabelText({
      key: 'remote.common.cross-borderIdentityInformationWhitelist',
      text: '跨境身份信息白名单'
    })
  },
  ALLINPAY_CLOUD: {
    value: 11,
    label:
      getLabelText({
        key: 'remote.common.communication',
        text: '通联'
      }) +
      '-' +
      getLabelText({
        key: 'remote.common.corporateOnlineBanking',
        text: '企业网银'
      })
  },
  EPR_HK: {
    value: 13,
    label: getLabelText({
      key: 'remote.common.EPRHKOfficialFees',
      text: 'EPR香港官费'
    })
  },
  ALLINPAY_BANK: {
    value: 14,
    label: getLabelText({
      key: 'remote.common.masterCardEnumMastercardDomesticCardPayment',
      text: '万事达国内卡支付'
    })
  }
})

//缴税退税渠道
const PAY_CHANNEL_ENUM = new GenerateEnum({
  // 缴税退税渠道
  OFFLINE: {
    value: 0,
    label: getLabelText({
      key: 'remote.common.offlineTransfer',
      text: '线下转账'
    })
  },
  LIANLIAN: {
    value: 2,
    label: getLabelText({
      key: 'remote.common.lianlianInternational',
      text: '纸质红冲'
    })
  },
  PINGPONG: {
    value: 3,
    label: 'PingPong'
  },
  SHANGHAI: {
    value: 4,
    label: getLabelText({
      key: 'remote.common.bankOfShanghai',
      text: '上海银行'
    })
  },
  WORLDFIRST: {
    value: 5,
    label: getLabelText({ key: 'remote.common.wanlihui', text: '万里汇' })
  },
  AIRWALLEX: {
    value: 7,
    label: getLabelText({
      key: 'remote.common.cloudsInTheSky',
      text: '空中云汇'
    })
  },
  PAYONEER: {
    value: 9,
    label: 'Payoneer'
  },
  UAE: {
    value: 11,
    label: 'UAE',
    remark: getLabelText({
      key: 'remote.common.taxAuthorityCreditCardPayment',
      text: '税局信用卡支付'
    })
  },
  //付款支付渠道
  CMB_PAY: {
    value: 6,
    label: getLabelText({
      key: 'remote.common.zhaoshangPay',
      text: '招商银行聚合支付'
    })
  },
  ALLINPAY: {
    value: 8,
    label: getLabelText({ key: 'remote.common.allinpay', text: '通联支付' })
  },
  ALLINPAY_24: {
    value: 24,
    label: getLabelText({ key: 'remote.common.allinpay', text: '通联支付' })
  },
  WEICHAT: {
    value: 10,
    label: getLabelText({
      key: 'remote.common.wechatPayment',
      text: '微信支付'
    })
  },
  LIANLIAN_PAYMENT: {
    value: 12,
    label: getLabelText({
      key: 'remote.common.lianlianPayDomesticPayment',
      text: '微信支付'
    })
  },
  BALANCE_RECHARGE_PAY: {
    value: 15,
    label: getLabelText({
      key: 'remote.common.balancePayment2',
      text: '余额付款'
    })
  },
  EOB_PAY: {
    value: 17,
    label: '网银对公转账',
    remark: '通联-企业网银'
  },
  CMB_DIRECT: {
    value: 99,
    label: getLabelText({
      key: 'remote.common.merchantDirectConnection',
      text: '招商直连'
    })
  },
  CHINA_PAY: {
    value: 101,
    label: getLabelText({ key: 'remote.common.unionpay', text: '银联' })
  },
  //结算渠道
  CHINA_PAY_SETTLE: {
    value: 102,
    label:
      getLabelText({
        key: 'remote.common.unionpay',
        text: '银联'
      }) +
      '-' +
      getLabelText({ key: 'remote.common.settlement', text: '结算' })
  },
  ALLINPAY_SETTLE: {
    value: 108,
    label:
      getLabelText({
        key: 'remote.common.communication',
        text: '通联'
      }) +
      '-' +
      getLabelText({ key: 'remote.common.cross-border', text: '跨境' })
  },
  LIANLIAN_SETTLE: {
    value: 103,
    label:
      getLabelText({
        key: 'remote.common.lianlian',
        text: '连连'
      }) +
      '-' +
      getLabelText({ key: 'remote.common.cross-border', text: '跨境' })
  }
})

const REFUND_TYPE = {
  ALL: '0',
  PART: '1',
  ONLY_REFUND: '2',
  ALL_NO_SERVER: '3',
  PART_NO_SERVER: '4'
}

const ENTRY_ACCOUNT = new GenerateEnum({
  RECOVERY_MECHANISM: {
    value: 2,
    label: getLabelText({
      key: 'remote.common.recyclingOrganization',
      text: '回收机构'
    })
  },
  HONG_KONG_ACCOUNT: {
    value: 4,
    label: getLabelText({
      key: 'remote.common.hongKongMainAccount',
      text: '香港主体账户'
    })
  }
})

const serviceStatusEnum = new GenerateEnum({
  WAIT_SUBMIT_INFO: {
    value: '1',
    label: getLabelText({
      key: 'remote.common.serviceDataToBeSubmitted',
      text: '待提交服务资料'
    })
  },
  APPLYING: {
    value: '2',
    label: getLabelText({
      key: 'remote.common.applicationInProgress',
      text: '申请中'
    })
  },
  APPLY_SUCCESS: {
    value: '3',
    label: getLabelText({
      key: 'remote.common.theApplicationWasSuccessful',
      text: '申请成功'
    })
  },
  REFUNDED: {
    value: '5',
    label: getLabelText({ key: 'remote.common.refunded', text: '已退款' })
  },
  REFUNDING: {
    value: '6',
    label: getLabelText({
      key: 'remote.common.refundInProgress',
      text: '退款中'
    })
  },
  CANCELED: {
    value: '7',
    label: getLabelText({ key: 'remote.common.cancelled', text: '已取消' })
  },
  FROZEN: {
    value: '8',
    label: getLabelText({ key: 'remote.common.frozen', text: '已冻结' })
  },
  REFUNDED_POINT: {
    value: '999',
    label:
      getLabelText({
        key: 'remote.common.refunded',
        text: '已退款'
      }) +
      `(${getLabelText({
        key: 'remote.common.redeemPoints',
        text: '兑换积分'
      })})`
  }
})

// 终止类型  1：客服审核终止，2：截止到期终止，
const terminationTypeEnum = new GenerateEnum({
  CUSTOMER_CHECK: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.customerServiceReviewTerminated',
      text: '客服审核终止'
    })
  },
  TIME_OVER: {
    value: 2,
    label: getLabelText({
      key: 'remote.common.terminateAsOfExpiration',
      text: '截止到期终止'
    })
  }
})

// 终止结果：1内部转代理，2注销，3移除代理
const terminationResultEnum = new GenerateEnum({
  INNER_TRANSFORM_PROXY: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.internalAgencyTransfer',
      text: '内部转代理'
    })
  },
  LOG_OFF: {
    value: 2,
    label: getLabelText({ key: 'remote.common.logoff', text: '注销' })
  },
  REMOVE_PROXY: {
    value: 3,
    label: getLabelText({ key: 'remote.common.removeAgency', text: '移除代理' })
  }
})

// 是否离职改派任务 0否，1是
const leaveReassignFlagEnum = new GenerateEnum({
  NORMAL: {
    value: 0,
    label: getLabelText({
      key: 'remote.common.generalReassignment',
      text: '一般改派'
    })
  },
  DEPART: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.resignationAndReassignment',
      text: '离职改派'
    })
  }
})

/*
 * =========== admin/env end ============
 */

/*
 * =========== merchant/env start ============
 */

const taxesTypeMerchant = [
  {
    label: getLabelText({ key: 'remote.common.toBeTaxed', text: '待缴税' }),
    value: 2
  },
  {
    label: getLabelText({
      key: 'remote.common.taxesAreBeingPaid',
      text: '缴税中'
    }),
    value: 0
  },
  {
    label: getLabelText({
      key: 'remote.common.taxHasBeenPaid',
      text: '已缴税'
    }),
    value: 1
  }
]

const SYSTEM_SERVICE_TYPE_MAP = {
  PACKAGE: {
    value: '102',
    label: getLabelText({
      key: 'remote.common.packagingMethod',
      text: '包装法'
    })
  },
  PACKAGE_RENEW: {
    value: '202',
    label: getLabelText({
      key: 'remote.common.packagingMethodRenewal',
      text: '包装法续费'
    })
  },
  PACKAGE_ADD: {
    value: '107',
    label: getLabelText({
      key: 'remote.common.additionOfPackagingMethod',
      text: '包装法追加'
    })
  },
  PACKAGE_TO_PROXY: {
    value: '105',
    label: getLabelText({
      key: 'remote.common.transferOfPackagingLawToAgency',
      text: '包装法转代理'
    })
  }
}

const PAY_TAX_METHOD = {
  RECYCLING_COMPANY_ACCOUNT_PAY: {
    value: 0,
    label: getLabelText({
      key: 'remote.common.taxPaymentForRecyclingCompanyAccount',
      text: '回收公司账号缴税'
    })
  },
  HONG_KONG_ACCOUNT_PAY: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.taxPaymentForHongKongAccount',
      text: '香港账号缴税'
    })
  },
  NEED_NOT_PAY: {
    value: 2,
    label:
      getLabelText({
        key: 'remote.common.noNeedToRedirectToPaymentPageForTaxPayment',
        text: '无需跳转支付页面进行缴税'
      }) +
      `(${getLabelText({
        key: 'remote.common.taxAmountIs0DirectlyTax-paidSituation',
        text: '税金为0,直接已完税的情况'
      })})`
  }
}

const DE_PACK_DECLARE_MATERIAL = new GenerateEnum({
  PAPER: {
    value: '2001',
    label: getLabelText({ key: 'remote.common.paper2', text: '纸皮' })
  },
  PLASTICS: {
    value: '2002',
    label: getLabelText({ key: 'remote.common.plastic', text: '塑料' })
  },
  GLASS: {
    value: '2003',
    label: getLabelText({ key: 'remote.common.glass', text: '玻璃' })
  },

  IRON: {
    value: '2004',
    label: getLabelText({ key: 'remote.common.iron', text: '铁' })
  },
  ALUMINIUM: {
    value: '2005',
    label: getLabelText({ key: 'remote.common.aluminium', text: '铝' })
  },
  BEVERAGE: {
    value: '2006',
    label: getLabelText({
      key: 'remote.common.beverageCartonPackaging',
      text: '饮料纸盒包装'
    })
  },
  OTHER_PACK: {
    value: '2007',
    label: getLabelText({
      key: 'remote.common.otherCompositePackaging',
      text: '其他复合包装'
    })
  },
  OTHER_MATERIAL: {
    value: '2008',
    label: getLabelText({
      key: 'remote.common.otherMaterials',
      text: '其他材料'
    })
  }
})

const IS_NEED_DECLARE = {
  NEED_DECLARE: {
    value: '1',
    label: getLabelText({
      key: 'remote.common.needToDeclare',
      text: '需要申报'
    })
  },
  NOT_NEED_DECLARE: {
    value: '0',
    label: getLabelText({
      key: 'remote.common.noNeedToDeclare',
      text: '不需要申报'
    })
  }
}

const W3E_CODE_STATE_ENUM = {
  UNAUTHORIZED: {
    value: 1,
    label: getLabelText({ key: 'remote.common.notAuthorized', text: '未授权' })
  },
  AUTHORIZATION_IN_PROGRESS: {
    value: 2,
    label: getLabelText({
      key: 'remote.common.authorizationInProgress',
      text: '授权中'
    })
  },
  AUTHORIZED: {
    value: 3,
    label: getLabelText({ key: 'remote.common.authorized', text: '已授权' })
  },
  BE_IN_PROGRESS: {
    value: 4,
    label: getLabelText({ key: 'remote.common.toBeRenewed', text: '待续费' })
  },
  TERMINATION_IN_PROGRESS: {
    value: 5,
    label: getLabelText({ key: 'remote.common.terminating', text: '终止中' })
  },
  TERMINATED: {
    value: 6,
    label: getLabelText({ key: 'remote.common.terminated', text: '已终止' })
  },
  LOGOUT_IN_PROGRESS: {
    value: 7,
    label: getLabelText({ key: 'remote.common.loggingOut', text: '注销中' })
  },
  LOGGED_OFF: {
    value: 8,
    label: getLabelText({ key: 'remote.common.loggedOut', text: '已注销' })
  },
  REVOKED: {
    value: 9,
    label: getLabelText({ key: 'remote.common.revoked', text: '已撤销' })
  }
}

const W3E_CODE_STATE_MAP = new GenerateEnum(W3E_CODE_STATE_ENUM)

const WE3_CODE_STATE = W3E_CODE_STATE_MAP.getEnumFilter('UNAUTHORIZED', 'AUTHORIZATION_IN_PROGRESS').enumArray

const DE_PACK_DECLARE_DATA_ORIGIN = {
  SYSTEM: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.system-generated',
      text: '系统带出'
    })
  },
  MANUAL: {
    value: 2,
    label: getLabelText({ key: 'remote.common.addManually', text: '手动添加' })
  }
}

const PLANTTYPEOBJ = {
  OST: '00',
  IPP: '01',
  XM: '10',
  LD: '08',
  TH: '13',
  LAW: '01',
  LZ: '15',
  GJT: '16',
  GJTEU: '16',
  GJTUS: '17',
  YS: '21',
  LY: '22',
  NB: '23',
  MDTPRO: '01'
}

const BILLING_DATA_ENUM = BILLING_DATA.getEnumFilter('PURE_OFFICIAL_INVOICE')

const CATEGORY_MAP_EN = {
  1: 'Chemicals',
  2: 'Paints',
  3: 'Cosmetics and cleaning preparations',
  4: 'Lubricants and fuels',
  5: 'Pharmaceuticals',
  6: 'Metal goods',
  7: 'Machinery',
  8: 'Hand tools',
  9: 'Electrical and scientific apparatus',
  10: 'Medical apparatus',
  11: 'Environmental control apparatus',
  12: 'Vehicles',
  13: 'Firearms',
  14: 'Jewelry',
  15: 'Musical instruments',
  16: 'Paper goods and printed matter',
  17: 'Rubber goods',
  18: 'Leather goods',
  19: 'Non-metallic building materials',
  20: 'Furniture and articles not otherwise classified',
  21: 'Housewares and glass',
  22: 'Cordage and fibers',
  23: 'Yarns and threads',
  24: 'Fabrics',
  25: 'Clothing',
  26: 'Fancy good',
  27: 'Floor coverings',
  28: 'Toys and sporting goods',
  29: 'Meats and processed foods',
  30: 'Staple foods',
  31: 'Natural agricultural products',
  32: 'Light beverages',
  33: 'Wines and spirits',
  34: 'Smokers’ articles',
  35: 'Advertising and business',
  36: 'Insurance and financial',
  37: 'Building construction and repair',
  38: 'Telecommunications',
  39: 'Transportation and storage',
  40: 'Treatment of materials',
  41: 'Education and entertainment',
  42: 'Computer and scientific',
  43: 'Hotels and restaurants',
  44: 'Medical, beauty and agricultural',
  45: 'Personal and legal'
}

/*
 * =========== merchant/env end ============
 */

const SETTLEMENT_CHANNEL = {
  UNIONPAY: {
    label: getLabelText({
      key: 'remote.common.unionpaySettlement',
      text: '银联结算'
    }),
    value: 102
  },
  ALLINPAY: {
    label: getLabelText({
      key: 'remote.common.allipaySettlement',
      text: '通联结算'
    }),
    value: 108
  },
  LIANLIANPAY: {
    label: getLabelText({
      key: 'remote.common.lianlianPaySettlement',
      text: '连连结算'
    }),
    value: 103
  }
}

const LAWYER_TYPE_LIST = [
  {
    label: getLabelText({
      key: 'remote.common.designatedStandardProductLawyer',
      text: '指定标品律师'
    }),
    value: 1
  },
  {
    label: getLabelText({
      key: 'remote.common.randomForeignLawyer',
      text: '随机外籍律师'
    }),
    value: 2
  },
  {
    label: getLabelText({
      key: 'remote.common.designatedForeignLawyer',
      text: '指定外籍律师'
    }),
    value: 3
  },
  {
    label: getLabelText({
      key: 'remote.common.seniorFirm/institution',
      text: '资深事务所/机构'
    }),
    value: 4
  },
  {
    label: getLabelText({
      key: 'remote.common.amazonBrandAccelerationLawFirm',
      text: '亚马逊品牌加速律所'
    }),
    value: 5
  }
]

const CLOSURE_REASON_LIST = [
  {
    label: getLabelText({
      key: 'remote.common.noReplyToTheReviewOpinion',
      text: '审查意见未答复'
    }),
    value: 1
  },
  {
    label: getLabelText({
      key: 'remote.common.unpaidTrademarkLicenseFeeInJapan',
      text: '日本商标领证费未缴纳'
    }),
    value: 2
  },
  {
    label: getLabelText({
      key: 'remote.common.unhandledByObjection',
      text: '被异议未处理'
    }),
    value: 3
  },
  {
    label: 'NOA' + getLabelText({ key: 'remote.common.unpaid2', text: '未缴费' }),
    value: 4
  },
  {
    label:
      'NOA' +
      getLabelText({
        key: 'remote.common.failureToSubmitProofOfUse',
        text: '未提交使用证明'
      }),
    value: 5
  },
  {
    label: getLabelText({
      key: 'remote.common.transferTheCaseHalfwayToAnotherHome',
      text: '中途转案到别家'
    }),
    value: 6
  },
  {
    label: getLabelText({ key: 'remote.common.other', text: '其他' }),
    value: 7
  }
]

const CLOSURE_REASON_MAP = {
  1: getLabelText({
    key: 'remote.common.noReplyToTheReviewOpinion',
    text: '审查意见未答复'
  }),
  2: getLabelText({
    key: 'remote.common.unpaidTrademarkLicenseFeeInJapan',
    text: '日本商标领证费未缴纳'
  }),
  3: getLabelText({
    key: 'remote.common.unhandledByObjection',
    text: '被异议未处理'
  }),
  4: 'NOA' + getLabelText({ key: 'remote.common.unpaid2', text: '未缴费' }),
  5:
    'NOA' +
    getLabelText({
      key: 'remote.common.failureToSubmitProofOfUse',
      text: '未提交使用证明'
    }),
  6: getLabelText({
    key: 'remote.common.transferTheCaseHalfwayToAnotherHome',
    text: '中途转案到别家'
  }),
  7: getLabelText({ key: 'remote.common.other', text: '其他' })
}

const CLOSURE_REASON_EN_MAP = {
  1: 'No response timely filed to the Office Rejection, application has been abandoned.',
  2: 'No registration fee timely paid to the Office, application has been abandoned.',
  3: 'No response timely filed to the Opposition, application has been abandoned.',
  4: 'No Official fees timely paid to Statement of Use, application has been abandoned.',
  5: 'No Statement of Use timely filed, application has been abandoned.',
  6: 'Application transfered to other agency/attorney, case closed.',
  7: 'Other'
}

const OST_BUY_TYPE = {
  VAT: '0', // VAT服务
  EPR: '1', // EPR服务
  PRODUCT_COMPLIANCE: '3' // 产品合规
}

const WX_TYPE = {
  WX: 1, // 微信
  OFFICIAL_ACCOUNT: 2 // 公众号
}

const QR_CODE_TYPE = {
  LOGIN: 'login', // 登录
  REGISTERED: 'registered' // 注册
}

const LOGIN_TYPE = {
  ACCOUNT: 'a', // 账号登录
  QR_CODE: 'w' // 扫码登录
}

const LOGIN_DETAIL_TYPE = {
  WX: 'w', // 微信扫码登录，对应旧的：tab3
  PHONE: 'p', // 手机号验证码登录，对应旧的：tab2
  ACCOUNT: 'a' // 账号、密码登录，对应旧的：tab1
}

// 首次登录提示
const FIRST_LOGIN_TIP = {
  BIND_WX: Symbol(
    getLabelText({
      key: 'remote.common.pop-upWechatBindingWindow',
      text: '弹出绑定微信窗口'
    })
  ),
  FLLOW_OFFICIAL_ACCOUNT: Symbol(
    getLabelText({
      key: 'remote.common.pop-upFollowPublicAccountWindow',
      text: '弹出关注公众号窗口'
    })
  ),
  SET_PWD: Symbol(
    getLabelText({
      key: 'remote.common.pop-upPasswordSettingWindow',
      text: '弹出设置密码窗口'
    })
  )
}

const CART_OP_CODE = {
  ALL_UN_CHECKED: -2, // 反全选
  UN_CHECKED: -1, // 单个未选中
  CHANGE_NUM: 0, // 改变数量，可省略不传
  CHECKED: 1, // 单个选中
  ALL_CHECKED: 2 // 全选
}

const PAYMENT_METHOD_MAP = {
  [payWay.WX]: getLabelText({
    key: 'remote.common.wechatPayment',
    text: '微信支付'
  }),
  [payWay.ALIPAY]: getLabelText({
    key: 'remote.common.payByAlipay',
    text: '支付宝支付'
  }),
  [payWay.OFFLINE]: getLabelText({
    key: 'remote.common.offlineCorporateTransfer',
    text: '线下对公转账'
  }),
  [payWay.BALANCE]: getLabelText({
    key: 'remote.common.balancePayment',
    text: '余额支付'
  }),
  [payWay.EOB_PAY]:
    getLabelText({
      key: 'remote.common.inviteInvestment',
      text: '招商'
    }) +
    '-' +
    getLabelText({
      key: 'remote.common.corporateOnlineBanking',
      text: '企业网银'
    }),
  [payWay.ALLIN_PAY]:
    getLabelText({
      key: 'remote.common.communication',
      text: '通联'
    }) +
    '-' +
    getLabelText({
      key: 'remote.common.corporateOnlineBanking',
      text: '企业网银'
    }),
  [payWay.AIRWALLEX_INTERNATIONAL]: 'pingpong',
  [payWay.PINGPONG_INTERNATIONAL]: getLabelText({
    key: 'remote.common.cloudsInTheSky',
    text: '空中云汇'
  }),
  [payWay.ZELLE]: getLabelText({
    key: 'remote.common.ZELLE',
    text: 'ZELLE'
  })
}

const PAYMENT_METHOD_LIST = [
  {
    icon: 'weixinzhifu',
    label: PAYMENT_METHOD_MAP[payWay.WX],
    value: payWay.WX
  },
  {
    icon: 'zhifubaozhifu',
    label: PAYMENT_METHOD_MAP[payWay.ALIPAY],
    value: payWay.ALIPAY
  },
  {
    icon: 'duigongzhuanzhang',
    label: PAYMENT_METHOD_MAP[payWay.OFFLINE],
    value: payWay.OFFLINE
  },
  {
    icon: 'yuezhifu',
    label: PAYMENT_METHOD_MAP[payWay.BALANCE],
    value: payWay.BALANCE
  }
]

const HAND_STATE = {
  BEGIN: '0', // "未开始",
  UN_SUBMIT_MATERIAL: '110', // "待提交服务资料",
  CUSTOMER_HANDLE: '210', // "客服审核",
  CLERK_HANDLE: '220', // "交付审核",
  LAWYER_HANDLE: '245', // "律师审核",

  MERCHANT_OFFICIAL: '240', // "官费处理",
  MERCHANT_OFFICIAL_PAY_ING: '241', // "商户官费待支付",
  MERCHANT_OFFICIAL_PAY_END: '242', // "商户官费已支付",

  //RPA: "250", // "自动化RPA处理",
  //RPA_ING: "251", // "RPA处理中",

  SUBMIT_OFFICIAL: '250', // "待递交官方",
  //CLERK_OFFICIAL: "260", // "交付官费处理",

  RWECEIPT_OFFICIAL: '270', // "回执处理",
  RWECEIPT_OFFICIAL_END: '271', // "已下回执",
  //CLERK_OFFICIAL: "260", // "交付官费处理",

  OFFICIAL_HANDLE: '310', // "官方处理",
  OFFICIAL_RECEIPT: '330', // "官方回执",
  OFFICIAL_REVIEW: '340', // "官方审查",
  OFFICIAL_REVIEW_OPINION: '341', // "审查意见",
  DOWN_OFFICIAL_REVIEW_OPINION: '342', // "下审查意见",
  OFFICIAL_REVIEW_CUSTOMER_HANDLE: '343', // "官方答复客服人员处理",
  OFFICIAL_REVIEW_CLERK_HANDLE: '345', // "官方答复交付人员处理",
  //WAIT_OFFICIAL_REVIEW_REPLY: "346", // "待官方审查答复",
  //OFFICIAL_REVIEW_REPLY_FINISH: "347", // "官方审查答复完成",

  // 350别名: 公告中 意向申请在公告后还需要提交使用证据，非意向申请则在上面的审查前已提交
  APPLY_SUCCESS: '350', // "申请成功",

  /* 以下是只有美国的意向申请才有的状态(美国意向申请在公告后才提交使用证据) */
  HZ_NOA_ORDER_DEAL: '380', // "意向申请补递使用证据通知",
  NOA_OFFICIAL_PAY_ING: '381', // "意向申请待补递提交使用证据官费(未支付)",
  PENDING_SUBMISSION_STATEMENT_OF_USE: '383', // "意向申请待补递使用证据提交",
  STATEMENT_OF_USE_CUSTOMER_HANDLE: '384', // "意向申请补递使用证据客服审核",
  STATEMENT_OF_USE_CLERK_HANDLE: '385', // "意向申请补递使用证据交付审核",
  STATEMENT_OF_USE_LAWYER_HANDLE: '386', // "意向申请补递使用证据律师审核",
  PENDING_SUBMISSION_OFFICIAL: '387', // "意向申请补递使用证据待提交官方",
  STATEMENT_OF_USE_OFFICIAL_REVIEW: '388', // "意向申请补递使用证据官方审查",
  STATEMENT_OF_USE_OFFICIAL_REVIEW_PASS: '389', // "意向申请补递使用证据官方审查通过",

  /* 以下是只有日本核准注册才有的状态 */
  APPROVED_HZ_REGISTRATION_NODE: '390', // "核准注册",
  HZ_OFFICIAL_PAY_ING: '391', // "核准注册(未支付)",
  APPROVED_HZ_REGISTRATION: '392', // "核准注册",

  /* 以下是只有美国的意向申请才有的状态(美国意向申请在公告后才提交使用证据) */
  NOA_OFFICIAL_REVIEW: '400', // "意向申请补递使用证据审查意见",
  NOA_OFFICIAL_REVIEW_OPINION: '401', // "意向申请补递使用证据下审查意见",
  NOA_DOWN_OFFICIAL_REVIEW_OPINION: '402', // "意向申请补递使用证据官方答复客服人员处理",
  NOA_OFFICIAL_REVIEW_CUSTOMER_HANDLE: '403', // "意向申请补递使用证据官方答复交付人员处理",
  NOA_OFFICIAL_REVIEW_CLERK_HANDLE: '404' // "意向申请补递使用证据官方答复律师处理",
}

const EVENT_BUS = {
  RECEIVE_EEXPERIENCE_VIP: 'RECEIVE_EEXPERIENCE_VIP' // 领取体验会员
}

const PRODUCT_DESC_TYPE = {
  TEXT: 1,
  TAG: 2
}

const COMP_HELPER_DOMAIN_NAME = 'openapi.ippmaster.com'

const isBooleanModule = new GenerateEnum({
  YES: {
    value: 1,
    label: getLabelText({ key: 'remote.common.yesly', text: '是' })
  },
  NO: {
    value: 0,
    label: getLabelText({ key: 'remote.common.no.text', text: '否' })
  }
})

// eprRsp终止类型  1：客服审核终止，2：截止到期终止，
const eprRspTerminationTypeEnum = new GenerateEnum({
  CUSTOMER_CHECK: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.customerServiceReviewTerminated',
      text: '客服审核终止'
    })
  },
  TIME_OVER_CUSTOMER_SERVICE: {
    value: 2,
    label:
      getLabelText({
        key: 'remote.common.terminateAsOfExpiration',
        text: '截止到期终止'
      }) +
      `(${getLabelText({
        key: 'remote.common.customerService',
        text: '客服'
      })})`
  },
  TIME_OVER_DELIVERY: {
    value: 3,
    label:
      getLabelText({
        key: 'remote.common.terminateAsOfExpiration',
        text: '截止到期终止'
      }) + `(${getLabelText({ key: 'remote.common.delivery', text: '交付' })})`
  },
  TIME_OVER_CUSTOMER_SERVICE_DELIVERY: {
    value: 4,
    label:
      getLabelText({
        key: 'remote.common.terminateAsOfExpiration',
        text: '截止到期终止'
      }) +
      `(${getLabelText({
        key: 'remote.common.delivery',
        text: '交付'
      })}&${getLabelText({
        key: 'remote.common.customerService',
        text: '客服'
      })})`
  }
})

// 官费服务类型值数组。有些地方官费显示要不一样:)
const GF_SERVICE_TYPE_VALUES = [
  COMMON_SERVICE_TYPE.GF_SERVICE_REG,
  COMMON_SERVICE_TYPE.GF_SERVICE_OATH,
  COMMON_SERVICE_TYPE.GF_SERVICE_RENEWAL_OATH,
  COMMON_SERVICE_TYPE.GF_SERVICE_ASSIGN,
  COMMON_SERVICE_TYPE.APPROVED_HZ_REGISTRATION,
  COMMON_SERVICE_TYPE.INTENT_NOA_APPLY,
  COMMON_SERVICE_TYPE.GF_PATENT_APPLICATION
]

// 会员相关的服务类型，包含：会员、会员升级
const VIP_SERVICE_TYPE_VALUES = [COMMON_SERVICE_TYPE.VIP_SERVICE, COMMON_SERVICE_TYPE.VIP_UPGRADE]

// 商户的服务类型
const SERVICE_TYPE_FOR_USER_LIST = [
  {
    value: '',
    label: getLabelText({ key: 'remote.common.whole', text: '全部' })
  },
  {
    value: COMMON_SERVICE_TYPE.TRADEMARK_REG,
    label: COMMON_SERVICE_TYPE.getValueToLabel(COMMON_SERVICE_TYPE.TRADEMARK_REG)
  },
  {
    value: COMMON_SERVICE_TYPE.TRADEMARK_OATH,
    label: COMMON_SERVICE_TYPE.getValueToLabel(COMMON_SERVICE_TYPE.TRADEMARK_OATH)
  },
  {
    value: COMMON_SERVICE_TYPE.TRADEMARK_ASSIGNMENT,
    label: COMMON_SERVICE_TYPE.getValueToLabel(COMMON_SERVICE_TYPE.TRADEMARK_ASSIGNMENT)
  },
  {
    value: COMMON_SERVICE_TYPE.PATENT_APPLICATION,
    label: COMMON_SERVICE_TYPE.getValueToLabel(COMMON_SERVICE_TYPE.PATENT_APPLICATION)
  }
]

const CURRENTCY_MAP = {
  USD: getLabelText({ key: 'remote.common.dollar', text: '美元' }),
  EUR: getLabelText({ key: 'remote.common.euro', text: '欧元' }),
  GBP: getLabelText({ key: 'remote.common.pound', text: '英镑' }),
  JPY: getLabelText({ key: 'remote.common.japaneseYen', text: '日元' }),
  KRW: getLabelText({ key: 'remote.common.won', text: '韩元' }),
  PHP: getLabelText({
    key: 'remote.common.philippinePesos',
    text: '菲律宾比索'
  }),
  INR: getLabelText({ key: 'remote.common.indianRupee', text: '印度卢比' }),
  AUD: getLabelText({ key: 'remote.common.australianDollar', text: '澳元' }),
  CAD: getLabelText({ key: 'remote.common.canadianDollars', text: '加元' }),
  BRL: getLabelText({ key: 'remote.common.brazilianReal', text: '巴西雷亚尔' }),
  NOK: getLabelText({ key: 'remote.common.norwegianKrone', text: '挪威克朗' }),
  MMK: '缅甸元'
}

const thirdProductType = new GenerateEnum({
  CARD: {
    value: '1',
    label: getLabelText({
      key: 'remote.common.electronicVouchers',
      text: '电子卡券'
    }),
    needPhone: true
  },
  PHONE: {
    value: '2',
    label: getLabelText({
      key: 'remote.common.directTop-upForPhoneBills',
      text: '直冲话费'
    }),
    needPhone: true
  }
})

const convertTypeLabel = new GenerateEnum({
  ORIGINAL_WAY: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.refundToOriginalPaymentMethod',
      text: '原路退回'
    })
  },
  SCORE_WAY: {
    value: 2,
    label: getLabelText({ key: 'remote.common.redeemPoints', text: '兑换积分' })
  },
  BALANCE_WAY: {
    value: 3,
    label: getLabelText({
      key: 'remote.common.exchangeBalance',
      text: '兑换余额'
    })
  }
})

const ES_BUTTERY_PRODUCT_TYPE_ENUM = {
  BUTTON: {
    value: '7901',
    label: getLabelText({
      key: 'remote.common.buttonBattery',
      text: '纽扣电池'
    })
  }
}

const RULE_TYPE_ENUM = new GenerateEnum({
  NUMBER: {
    value: 1,
    label: getLabelText({ key: 'eprDeclare.detail.text451', text: '({currentSymbol}/个)' })
  },
  WEIGHT: {
    value: 2,
    label: getLabelText({ key: 'eprDeclare.detail.text45020260718', text: '({currentSymbol}/kg)' })
  }
})

const ES_W3E_RULE_TYPE_ENUM = new GenerateEnum({
  WEIGHT: {
    value: 1,
    label: getLabelText({ key: 'eprDeclare.detail.text450', text: '(￥/kg)' })
  },
  NUMBER: {
    value: 2,
    label: getLabelText({ key: 'eprDeclare.detail.text4511', text: '(￥/件)' })
  }
})

const DEDUCTION_ITEM_TAX_RATE = {
  TAX_89: {
    value: 0,
    label: `89（19%${getLabelText({
      key: 'remote.common.taxRate',
      text: '税率'
    })}）`
  },
  TAX_95: {
    value: 1,
    label: `95（${getLabelText({
      key: 'remote.common.otherTaxRates',
      text: '其他税率'
    })}）`
  }
}

// 以后改动这个枚举，只用改这个，DEDUCTION_ITEM_TAX_RATE不用改
const DEDUCTION_ITEM_TAX_RATE_DE = {
  TAX_89: {
    value: '0',
    label: '89'
  },
  TAX_95: {
    value: '1',
    label: '95'
  }
}

const DEDUCTION_ITEM_TAX_RATE_ENUM = new GenerateEnum(DEDUCTION_ITEM_TAX_RATE)
const DEDUCTION_ITEM_TAX_RATE_ENUM_DE = new GenerateEnum(DEDUCTION_ITEM_TAX_RATE_DE)

const CLOSURE_REASON_OPTIONS = [
  {
    value: '1',
    label: getLabelText({
      key: 'remote.common.noReplyToTheReviewOpinion',
      text: '审查意见未答复'
    }),
    children: [
      {
        value: '1',
        label: getLabelText({
          key: 'remote.common.abandonTheBid',
          text: '弃标'
        }),
        enContent:
          'Regarding the following U.S. trademark examination opinion notification reminder, since we received instructions to abandon on ***, our company will close the case for the following U.S. trademark. After the deadline of ***, the case will become invalid, and there will be no further reminders. Please be informed',
        content: getLabelText({
          key: 'remote.common.promptText72',
          text: '针对以下美国商标审查意见通知提醒，因于***日收到放弃的指示，我司将针对以下美国商标做结案处理，于截止日期***之后案件将会失效，后续不再提醒，请知悉。'
        })
      },
      {
        value: '2',
        label: getLabelText({
          key: 'remote.common.theSuccessRateIsLow',
          text: '成功率低'
        }),
        enContent:
          'Regarding the following U.S. trademark examination opinion notification reminder, since we received instructions to abandon on ***, our company will close the case for the following U.S. trademark. After the deadline of ***, the case will become invalid, and there will be no further reminders. Please be informed',
        content: getLabelText({
          key: 'remote.common.promptText72',
          text: '针对以下美国商标审查意见通知提醒，因于***日收到放弃的指示，我司将针对以下美国商标做结案处理，于截止日期***之后案件将会失效，后续不再提醒，请知悉。'
        })
      },
      {
        value: '3',
        label: getLabelText({
          key: 'remote.common.theCostIsHigh',
          text: '费用高'
        }),
        enContent:
          'Regarding the following U.S. trademark examination opinion notification reminder, since we received instructions to abandon on ***, our company will close the case for the following U.S. trademark. After the deadline of ***, the case will become invalid, and there will be no further reminders. Please be informed',
        content: getLabelText({
          key: 'remote.common.promptText72',
          text: '针对以下美国商标审查意见通知提醒，因于***日收到放弃的指示，我司将针对以下美国商标做结案处理，于截止日期***之后案件将会失效，后续不再提醒，请知悉。'
        })
      },
      {
        value: '4',
        label: getLabelText({
          key: 'remote.common.iCan.tGetInTouch',
          text: '联系不上'
        }),
        enContent:
          'Regarding the reminder of the trademark examination opinion notice in ** (country), telephone reminders / work order reminders have been made on *** and *** respectively, but no response has been received. Our company will close the trademark case in ** (country). The case will become invalid after the deadline of ***, and there will be no further reminders. Please be noted.',
        content:
          '针对以下**（国家）商标审查意见通知提醒，已于***日和***日电话提醒/工单提醒，均未收到回应，我司将针对以下**（国家）商标做结案处理，于截止日期***之后案件将会失效，后续不再提醒，请知悉。'
      },
      {
        value: '5',
        label: getLabelText({
          key: 'remote.common.transferToAnotherAgentForProcessing',
          text: '转其他代理处理'
        }),
        enContent:
          'Regarding the reminder of the trademark examination opinion notice in ** (country), telephone reminders / work order reminders have been made on *** and *** respectively, but no response has been received. Our company will close the trademark case in ** (country). The case will become invalid after the deadline of ***, and there will be no further reminders. Please be noted.',
        content: '针对以下**（国家）商标审查意见通知提醒，经查询，案件已转到非我司代理律师案件名下，我司将针对以下**（国家）商标做结案处理，于截止日期***之后案件将会失效，后续不再提醒，请知悉。'
      },
      {
        value: '6',
        label: getLabelText({
          key: 'remote.common.multipleContactsWithoutResponse',
          text: '多次联系未答复'
        }),
        enContent:
          'Regarding the reminder of the trademark examination opinion notice in ** (country), reminders were given on *** and *** respectively, but no reply instructions have been received. Our company will close the trademark case in ** (country). The case will become invalid after the deadline of ***, and there will be no further reminders. Please be noted.',
        content: '针对以下**（国家）商标审查意见通知提醒，已于***日和***日进行提醒，未收到答复指示，我司将针对以下**（国家）商标做结案处理，于截止日期***之后案件将会失效，后续不再提醒，请知悉。'
      },
      {
        value: '7',
        enContent: '',
        label: getLabelText({ key: 'remote.common.other', text: '其他' }),
        content: ''
      }
    ]
  },
  {
    value: '2',
    label: getLabelText({
      key: 'remote.common.unpaidTrademarkLicenseFeeInJapan',
      text: '日本商标领证费未缴纳'
    }),
    children: [
      {
        value: '1',
        label: getLabelText({
          key: 'remote.common.abandonTheBid',
          text: '弃标'
        }),
        enContent:
          'Regarding the reminder for the failure to pay the official fee for obtaining the trademark certificate in Japan, as it has been informed recently that this trademark will be abandoned, our company will close the case of the following Japanese trademarks, and there will be no further reminders. Please be noted.',
        content: '针对以下日本商标未缴纳领证官费提醒，因近期告知放弃此商标，我司将针对以下日本商标做结案处理，后续不再提醒，请知悉。'
      },
      {
        value: '2',
        label: getLabelText({
          key: 'remote.common.iCan.tGetInTouch',
          text: '联系不上'
        }),
        enContent:
          'Regarding the reminder for the failure to pay the official fee for obtaining the trademark certificate of the following Japanese trademarks, since no instructions have been received after the due date, our company will close the case of the following Japanese trademarks and there will be no further reminders. Please be noted.',
        content: '针对以下日本商标未缴纳领证官费提醒，因逾期未收到指示，我司将针对以下日本商标做结案处理，后续不再提醒，请知悉。'
      },
      {
        value: '3',
        label: getLabelText({
          key: 'remote.common.transferToAnotherAgentForProcessing',
          text: '转其他代理处理'
        }),
        enContent:
          "Regarding the reminder of the Japanese trademark examination opinion notice, upon inquiry, the case has been transferred to the name of the attorney who is not our company's agent. Our company will close the case for the following trademarks. The case will become invalid after the deadline, and there will be no further reminders. Please be noted.",
        content: '针对以下日本商标审查意见通知提醒，经查询，案件已转到非我司代理律师案件名下，我司将针对以下商标做结案处理，于截止日期之后案件将会失效，后续不再提醒，请知悉。'
      }
    ]
  },
  {
    value: '3',
    label: getLabelText({
      key: 'remote.common.unhandledByObjection',
      text: '被异议未处理'
    }),
    children: [
      {
        value: '1',
        label: getLabelText({
          key: 'remote.common.abandonTheBid',
          text: '弃标'
        }),
        enContent:
          'Regarding the reminder of the notice of opposition to the following U.S. trademarks, as it has been informed recently that this trademark will be abandoned, our company will close the case for the following U.S. trademarks, and there will be no further reminders. Please be noted.',
        content: '针对以下美国商标被异议通知提醒，因近期告知放弃此商标，我司将针对以下美国商标做结案处理，后续不再提醒，请知悉。'
      },
      {
        value: '2',
        label: getLabelText({ key: 'remote.common.noReply', text: '未答复' }),
        enContent:
          'Regarding the reminder of the notice of opposition to the following ** trademarks, since no instructions have been received after the due date, our company will close the cases for the following ** trademarks and there will be no further reminders. Please be noted.',
        content: '针对以下**商标被异议通知提醒，因逾期未收到指示，我司将针对以下**商标做结案处理，后续不再提醒，请知悉。'
      },
      {
        value: '3',
        label: getLabelText({
          key: 'remote.common.theCostIsHigh',
          text: '费用高'
        }),
        enContent:
          'Regarding the reminder of the trademark opposition notice, since no instructions have been received after the due date, our company will close the cases for the following ** trademarks and there will be no further reminders. Please be noted.',
        content: '针对以下商标异议通知提醒，因逾期未收到指示，我司将针对以下**商标做结案处理，后续不再提醒，请知悉。'
      },
      {
        value: '4',
        label: getLabelText({
          key: 'remote.common.theSuccessRateIsLow',
          text: '成功率低'
        }),
        enContent:
          'Regarding the reminder of the notice that the following trademarks have been opposed, since no instructions have been received after the due date, our company will close the cases for the following ** trademarks and there will be no further reminders. Please be noted.',
        content: '针对以下商标被异议的通知提醒，因逾期未收到指示，我司将针对以下**商标做结案处理，后续不再提醒，请知悉。'
      },
      {
        value: '5',
        label: getLabelText({
          key: 'remote.common.transferToAnotherAgentForProcessing',
          text: '转其他代理处理'
        }),
        enContent:
          "Regarding the reminder of the notice that the following trademarks have been opposed, upon inquiry, the case has been transferred to the name of the attorney who is not our company's agent. Our company will close the cases for the following ** (country) trademarks. The case will become invalid after the deadline of ***, and there will be no further reminders. Please be noted.",
        content: '针对以下商标被异议通知提醒，经查询，案件已转到非我司代理律师案件名下，我司将针对以下**（国家）商标做结案处理，于截止日期***之后案件将会失效，后续不再提醒，请知悉。'
      },
      {
        value: '6',
        enContent: '',
        label: getLabelText({ key: 'remote.common.other', text: '其他' }),
        content: ''
      }
    ]
  },
  {
    value: '4',
    label: 'NOA' + getLabelText({ key: 'remote.common.unpaid2', text: '未缴费' }),
    children: [
      {
        value: '1',
        enContent:
          'Regarding the reminder of the NOA notice for the following U.S. trademarks, as it has been informed recently that this trademark will be abandoned, our company will close the cases for the following U.S. trademarks, and there will be no further reminders. Please be noted.',
        label: getLabelText({
          key: 'remote.common.abandonTheBid',
          text: '弃标'
        }),
        content: '针对以下美国商标被NOA通知提醒，因近期告知放弃此商标，我司将针对以下美国商标做结案处理，后续不再提醒，请知悉。'
      },
      {
        value: '2',
        enContent:
          'Regarding the reminder of the notice that the following ** trademarks have been opposed, since no instructions have been received after the due date, our company will close the cases for the following ** trademarks and there will be no further reminders. Please be noted.',
        label: getLabelText({ key: 'remote.common.noReply', text: '未答复' }),
        content: '针对以下**商标被异议通知提醒，因逾期未收到指示，我司将针对以下**商标做结案处理，后续不再提醒，请知悉。'
      },
      {
        value: '3',
        enContent:
          "Regarding the reminder of the notice that the trademarks have been opposed, upon inquiry, the case has been transferred to the name of the attorney who is not our company's agent. Our company will close the cases for the following U.S. trademarks. After the deadline, the cases will become invalid, and there will be no further reminders. Please be noted.",
        label: getLabelText({
          key: 'remote.common.transferToAnotherAgentForProcessing',
          text: '转其他代理处理'
        }),
        content: '针对以下商标被异议通知提醒，经查询，案件已转到非我司代理律师案件名下，我司将针对以下美国商标做结案处理，于截止日期之后案件将会失效，后续不再提醒，请知悉。'
      },
      {
        value: '4',
        enContent: '',
        label: getLabelText({ key: 'remote.common.other', text: '其他' }),
        content: ''
      }
    ]
  },
  {
    value: '5',
    label:
      'NOA-' +
      getLabelText({
        key: 'remote.common.evidenceOfUseNotSubmitted',
        text: '未提交使用证据'
      }),
    children: [
      {
        value: '1',
        enContent:
          'Regarding the reminder of the notice of using evidence in the NOA for the following U.S. trademarks, as it has been informed recently that we are unable to provide the relevant evidence materials and will abandon it, our company will close the cases for the following U.S. trademarks, and there will be no further reminders. Please be noted.',
        label: getLabelText({
          key: 'remote.common.abandonTheBid',
          text: '弃标'
        }),
        content: '针对以下美国商标被NOA使用证据通知提醒，因近期告知放弃无法相关证据资料，我司将针对以下美国商标做结案处理，后续不再提醒，请知悉。'
      },
      {
        value: '2',
        enContent:
          "Regarding the reminder of submitting the use evidence at the NOA stage for the following trademarks, upon inquiry, the case has been transferred to the name of the attorney who is not our company's agent. Our company will close the cases for the following U.S. trademarks. After the deadline, the cases will become invalid, and there will be no further reminders. Please be noted.",
        label: '转代理到其他家',
        content: '针对以下商标NOA阶段提交使用证据提醒，经查询，案件已转到非我司代理律师案件名下，我司将针对以下美国商标做结案处理，于截止日期之后案件将会失效，后续不再提醒，请知悉。'
      },
      {
        value: '3',
        enContent: '',
        label: getLabelText({ key: 'remote.common.other', text: '其他' }),
        content: ''
      }
    ]
  }
]

const PLASTIC_LIST = new GenerateEnum({
  FOOD_PACKAGING: {
    label: getLabelText({
      key: 'remote.enumerate.foodPackagingBox',
      text: '食品包装'
    }),
    value: '1001'
  },
  BAGS_AND_FOIL_PACKAGING: {
    label: getLabelText({
      key: 'remote.common.bagsAndAluminumFoilPack',
      text: '袋子和铝箔包装'
    }),
    value: '1002'
  },
  BEVERAGE_CONTAINERS_EMPTY_BOTTLES: {
    label: getLabelText({
      key: 'remote.common.beverageContainersEmptyBottles',
      text: '饮料容器（空瓶）'
    }),
    value: '1003'
  },
  BEVERAGE_CONTAINERS_INCLUDING_BEVERAGES: {
    label: getLabelText({
      key: 'remote.common.beverageContainersWithBevs',
      text: '饮料容器（含饮料）'
    }),
    value: '1004'
  },
  DRINK_CUP: {
    label: getLabelText({ key: 'remote.common.beverageCup', text: '饮料杯' }),
    value: '1005'
  },
  LIGHTWEIGHT_PLASTIC_TOTE_BAG: {
    label: getLabelText({
      key: 'remote.common.lightweightPlasticShopBags',
      text: '轻质塑料手提袋'
    }),
    value: '1006'
  },
  WET_WIPES: {
    label: getLabelText({ key: 'remote.common.wetWps', text: '湿纸巾' }),
    value: '1007'
  },
  BALLOON: {
    label: getLabelText({ key: 'remote.common.balloons', text: '气球' }),
    value: '1008'
  },
  TOBACCO_PRODUCTS_WITH_FILTERS_AND_FILTERS_FOR_TOBACCO_PRODUCTS: {
    label: getLabelText({
      key: 'remote.common.tobaccoProdsWithAndForFilters',
      text: '带有过滤嘴的烟草制品和用于烟草制品的过滤嘴'
    }),
    value: '1009'
  }
})

const PLASTIC_STATUS_LIST = [
  {
    label: '待授权',
    value: '0',
    key: 'eprRegistration.tab.pendingAuthorization'
  },
  {
    label: '授权中',
    value: '1',
    key: 'remote.common.authorizationInProgress'
  },
  {
    label: '已授权',
    value: '2',
    key: 'remote.common.authorized'
  },
  {
    label: '待续费',
    value: '3',
    key: 'remote.common.toBeRenewed'
  },
  {
    label: '注销中',
    value: '4',
    key: 'remote.common.loggingOut'
  },
  {
    label: '已注销',
    value: '5',
    key: 'remote.common.loggedOut'
  },
  {
    label: '已终止',
    value: '6',
    key: 'remote.common.terminated'
  },
  {
    label: '已撤销',
    value: '7',
    key: 'remote.common.revoked'
  },
  {
    label: '已失效',
    value: '8',
    key: 'remote.common.expired3'
  }
]

const W3E_LIST = [
  {
    name: getLabelText({
      key: 'remote.enumerate.temperatureExchangeEquipment',
      text: '温度交换设备'
    }),
    value: '1001',
    type: false,
    status: '1001',
    id: '0',
    alreadyKey: 'alreadyHeatWeight',
    w3eKey: 'heatWeight',
    weightKey: 'actualHeatWeight',
    differenceKey: 'promiseHeatWeight'
  },
  {
    name: getLabelText({ key: 'remote.common.displayScreen', text: '显示屏' }),
    value: '1002',
    type: false,
    status: '1002',
    id: '1',
    alreadyKey: 'alreadyPrivateWeight',
    w3eKey: 'privateWeight',
    weightKey: 'actualPrivateWeight',
    differenceKey: 'promisePrivateWeight'
  },
  {
    name: getLabelText({
      key: 'remote.enumerate.nonAasDischargeLamp',
      text: '非气体放电灯'
    }),
    value: '1003',
    type: false,
    status: '1003',
    id: '2',
    alreadyKey: 'alreadyLampWeight',
    w3eKey: 'lampWeight',
    weightKey: 'actualLampWeight',
    differenceKey: 'promiseLampWeight'
  },
  {
    name: getLabelText({
      key: 'remote.enumerate.largeNonPhotovoltaicEquipment',
      text: '大型非光伏设备'
    }),
    value: '1004',
    type: false,
    status: '1004',
    id: '3',
    alreadyKey: 'alreadyLagreWeight',
    w3eKey: 'lagreWeight',
    weightKey: 'actualLagreWeight',
    differenceKey: 'promiseLagreWeight'
  },
  {
    name: getLabelText({
      key: 'remote.enumerate.smallNonPvEquipment',
      text: '小型非光伏设备'
    }),
    value: '1005',
    type: false,
    status: '1005',
    id: '4',
    alreadyKey: 'alreadySmallEquipmentWeight',
    w3eKey: 'smallEquipmentWeight',
    weightKey: 'actualSmallEquipmentWeight',
    differenceKey: 'promiseSmallEquipmentWeight'
  },
  {
    name: getLabelText({
      key: 'remote.enumerate.smallItTelecomEquipment',
      text: '小型IT和电信设备'
    }),
    value: '1006',
    type: false,
    status: '1006',
    id: '5',
    alreadyKey: 'alreadySmallItWeight',
    w3eKey: 'smallItWeight',
    weightKey: 'actualSmallItWeight',
    differenceKey: 'promiseSmallItWeight'
    // 添加新字段
  },
  {
    name: getLabelText({
      key: 'remote.enumerate.gasDischargeLamps',
      text: '气体放电灯'
    }),
    value: '1007',
    type: false,
    status: '1007',
    id: '6',
    alreadyKey: 'alreadyGasDischargeLampWeight',
    w3eKey: 'gasDischargeLampWeight',
    weightKey: 'actualGasDischargeLampWeight',
    differenceKey: 'promiseGasDischargeLampWeight'
  },
  {
    name: getLabelText({
      key: 'remote.enumerate.largePvEquipment',
      text: '大型光伏设备'
    }),
    value: '1008',
    type: false,
    status: '1008',
    id: '7',
    alreadyKey: 'alreadyLargePhotovoltaicEquipmentWeight',
    w3eKey: 'largePhotovoltaicEquipmentWeight',
    weightKey: 'actualLargePhotovoltaicEquipmentWeight',
    differenceKey: 'promiseLargePhotovoltaicEquipmentWeight'
  },
  {
    name: getLabelText({
      key: 'remote.enumerate.smallPvEquipment',
      text: '小型光伏设备'
    }),
    value: '1009',
    type: false,
    status: '1009',
    id: '8',
    alreadyKey: 'alreadySmallPhotovoltaicEquipmentWeight',
    w3eKey: 'smallPhotovoltaicEquipmentWeight',
    weightKey: 'actualSmallPhotovoltaicEquipmentWeight',
    differenceKey: 'promiseSmallPhotovoltaicEquipmentWeight'
  }
]

// w3eCode进度相关的枚举
const QUERY_W3E_PROGRESS = new GenerateEnum({
  HAS_VERIFIED: {
    value: '0',
    label: getLabelText({
      key: 'remote.common.theCertificateHasBeenIssued',
      text: '已下证'
    })
  },
  CANCELLING: {
    value: '1',
    label: getLabelText({ key: 'remote.common.loggingOut', text: '注销中' })
  },
  CANCELLED: {
    value: '2',
    label: getLabelText({ key: 'remote.common.loggedOut', text: '已注销' })
  },
  TO_BE_DECLARE: {
    value: '3',
    label: getLabelText({
      key: 'remote.common.pendingApplication',
      text: '待申请'
    })
  },
  HAS_CANCELLED: {
    value: '4',
    label: getLabelText({ key: 'remote.common.loggedOut', text: '已注销' })
  },
  TO_BE_CANCEL: {
    value: '5',
    label: getLabelText({
      key: 'remote.common.pendingWrite-off',
      text: '待注销'
    })
  },
  EXPIRED: {
    value: '7',
    label: getLabelText({ key: 'remote.common.expired', text: '已过期' })
  },
  TO_BE_SUBMIT: {
    value: '8',
    label: getLabelText({
      key: 'remote.common.informationToBeSubmitted',
      text: '待提交资料'
    })
  },
  HAS_NUMBER: {
    value: '9',
    label: getLabelText({ key: 'remote.common.numberAssigned', text: '已下号' })
  },
  HAS_INVALID: {
    value: '10',
    label: getLabelText({ key: 'remote.common.expired3', text: '已失效' })
  }
})

const EPR_FILE_IDENTIFY_STATUS = new GenerateEnum({
  ACTING: {
    value: 1,
    label: getLabelText({ key: 'remote.common.identifying', text: '识别中' })
  },
  SUCCESS: {
    value: 2,
    label: getLabelText({
      key: 'remote.common.identificationSuccessful',
      text: '识别成功'
    })
  },
  FAILED: {
    value: 3,
    label: getLabelText({
      key: 'remote.common.identificationFailed',
      text: '识别失败'
    })
  }
})

const payType = [
  {
    code: 1,
    label: 'Qbit' + getLabelText({ key: 'remote.common.payment', text: '支付' }),
    logoUrl: 'https://cdn.evatmaster.com/ost/2407105c401e1e67b5414a98aca2c85e0d51cb.png'
  },
  {
    code: 2,
    label: getLabelText({ key: 'remote.common.lianlianpay', text: '连连支付' }),
    logoUrl: 'https://cdn.evatmaster.com/ost/240710790f5c0d00b14e8ca332c26705b809cb.svg'
  },
  {
    code: 3,
    label: 'PingPong',
    logoUrl: 'https://cdn.evatmaster.com/ost/24071082463028e0ce4f3fb47aa37bc1fb5ce9.svg'
  },
  {
    code: 4,
    label: getLabelText({
      key: 'remote.common.bankOfShanghai',
      text: '上海银行'
    }),
    logoUrl: 'https://cdn.evatmaster.com/ost/2407104fd5cb2e70894819bbf1de7493101755.svg'
  },
  {
    code: 5,
    label: getLabelText({ key: 'remote.common.wanlihui', text: '万里汇' }),
    logoUrl: 'https://cdn.evatmaster.com/ost/240710f2118ceae20e4f1d8d3129af9e3c3934.svg'
  },
  {
    code: 7,
    label: getLabelText({
      key: 'remote.common.cloudsInTheSky',
      text: '空中云汇'
    }),
    logoUrl: 'https://cdn.evatmaster.com/ost/2407102e33cb57da2146939df42810471e4715.svg'
  },
  {
    code: 9,
    label: 'Payoneer',
    logoUrl: 'https://cdn.evatmaster.com/ost/24071047f5c9af51b84e829e25191dda750f31.png'
  }
]

const paySettleDetailStatusEnum = new GenerateEnum({
  TO_RECON: {
    value: 0,
    label: getLabelText({
      key: 'remote.common.pendingReconciliation',
      text: '待对账'
    })
  },
  RECON_FAIL: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.reconciliationFailed',
      text: '对账失败'
    })
  },
  SETTLE_SUCCESS: {
    value: 2,
    label: getLabelText({ key: 'remote.common.settled', text: '已结算' })
  },
  TO_SETTLE: {
    value: 3,
    label: getLabelText({
      key: 'remote.common.pendingSettlement',
      text: '待结算'
    })
  }
})
const errorCodeEnum = new GenerateEnum({
  NO_ORDER_PRODUCT: {
    value: 1,
    label: '订单无对应商品信息'
  },
  NO_MERC_INFO: {
    value: 2,
    label: '商户身份信息不存在'
  },
  IS_HX_ORDER: {
    value: 3,
    label: '订单结算金额已核销官费退款'
  },
  IS_REFUND_ORDER: {
    value: 4,
    label: '退款订单，用来核销结算订单'
  },
  IS_PATENT_ORDER: {
    value: 5,
    label: '专利订单不结算'
  },
  THIRD_ERROR: {
    value: 6,
    label: '第三方错误'
  },
  OTHER_ERROR: {
    value: 7,
    label: '其他错误'
  },
  ERROR_PAY_METHOD: {
    value: 8,
    label: '错误的支付方式'
  },
  IS_HX_PART_ORDER: {
    value: 9,
    label: '该订单部分结算金额已核销官费退款'
  }
})

const VAT_DRAWBACK_TAX_STATUS = new GenerateEnum({
  TO_BE_HANDLE: {
    value: '0',
    label: getLabelText({ key: 'remote.common.pending', text: '待处理' })
  },
  HAS_SUBMIT_TAX: {
    value: '1',
    label: getLabelText({
      key: 'remote.common.submittedToTaxAuthority',
      text: '已递交税局'
    })
  },
  HAS_REFUSE: {
    value: '2',
    label: getLabelText({ key: 'remote.common.rejected', text: '已驳回' })
  }
})

// tipsText:条件说明，
// needCondition： 是否有条件参数配置
// changeJoinNum：是否可修改参与次数，否默认为1||-，是展示输入框
//defaultJoinNum: cahngeJoinNum为否又分两种展示情况，1和-
//tipsErr不满足完成任务条件，点击报错提示语
//conditionType条件参数配置的类型，默认为input
const taskTypeEnum = new GenerateEnum({
  FIRST_LOGIN: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.logInToAnotherPlatform',
      text: '登录其他平台'
    }),
    tipsText: '首次登录{{plantType}}，即可获得{{score}}积分',
    adminTaskTipsText: getLabelText({
      key: 'remote.common.promptText49',
      text: '所属平台不展示该任务，其他平台校验用户从未登录所属平台，则展示'
    }),
    needCondition: false,
    changeJoinNum: false,
    defaultJoinNum: 1,
    plantTypeList: [systemTypeEnum.VAT, systemTypeEnum.IPP, systemTypeEnum.XM]
  },
  FIRST_BINDING: {
    value: 2,
    label: getLabelText({
      key: 'remote.common.bindingWechatApplet',
      text: '绑定微信小程序'
    }),
    tipsText: '首次绑定{{plantType}}微信小程序，即可获得{{score}}积分',
    adminTaskTipsText: getLabelText({
      key: 'remote.common.promptText651',
      text: '用户从未绑定所属平台微信小程序'
    }),
    needCondition: false,
    changeJoinNum: false,
    defaultJoinNum: 1,
    plantTypeList: [systemTypeEnum.VAT, systemTypeEnum.IPP, systemTypeEnum.XM]
  },
  FIRST_ATTENTION: {
    value: 3,
    label: getLabelText({
      key: 'remote.common.followTheOfficialAccount',
      text: '关注公众号'
    }),
    tipsText: '首次关注{{plantType}}公众号，即可获得{{score}}积分',
    adminTaskTipsText: getLabelText({
      key: 'remote.common.promptText50',
      text: '用户从未关注任务所属平台公众号（关注后取消=关注过）'
    }),
    needCondition: false,
    changeJoinNum: false,
    defaultJoinNum: 1,
    plantTypeList: [systemTypeEnum.VAT, systemTypeEnum.IPP, systemTypeEnum.XM]
  },
  DAILY_READ: {
    value: 5,
    label: getLabelText({
      key: 'remote.common.viewInternalMessageNotifications',
      text: '查看站内信通知'
    }),
    tipsText: '每日查看{{plantType}}所有站内信通知，即可获得{{score}}积分',
    adminTaskTipsText: getLabelText({
      key: 'remote.common.promptText51',
      text: '用户当日在所属平台有未读站内信通知，则显示所属平台任务'
    }),
    needCondition: false,
    changeJoinNum: false,
    defaultJoinNum: 1,
    tipsErr: getLabelText({
      key: 'remote.common.noInternalMessagesToReadAtTheMoment',
      text: '当前没有需要阅读的站内信'
    }),
    plantTypeList: [systemTypeEnum.VAT, systemTypeEnum.IPP]
  },
  FIRST_PURCHASE: {
    value: 9,
    label: getLabelText({
      key: 'remote.common.firstServicePurchase',
      text: '首次购买服务'
    }),
    tipsText: '首次付款成功，即可获得{{score}}积分',
    adminTaskTipsText: getLabelText({
      key: 'remote.common.promptText52',
      text: '用户在所属平台没有金额＞0的付款订单（已付款、已完成、已退款）（剔除余额充值订单）'
    }),
    needCondition: false,
    changeJoinNum: false,
    defaultJoinNum: 1,
    plantTypeList: [systemTypeEnum.VAT, systemTypeEnum.IPP, systemTypeEnum.XM]
  },
  EVALUATE_SUBMIT: {
    value: 11,
    label: getLabelText({
      key: 'remote.common.submitMaterialEvaluation',
      text: '提交资料评价'
    }),
    tipsText: '',
    adminTaskTipsText: getLabelText({
      key: 'remote.common.promptText53',
      text: '用户端不可见，评价自动触发发送积分'
    }),
    needCondition: false,
    changeJoinNum: false,
    plantTypeList: [systemTypeEnum.VAT]
  },
  DECLARE_GIVE_SCORE: {
    value: 12,
    label: getLabelText({
      key: 'remote.common.submitDeclarationEvaluation',
      text: '提交申报评价'
    }),
    tipsText: '',
    adminTaskTipsText: getLabelText({
      key: 'remote.common.promptText53',
      text: '用户端不可见，评价自动触发发送积分'
    }),
    needCondition: false,
    changeJoinNum: false,
    plantTypeList: [systemTypeEnum.VAT]
  },
  BUY_AGAIN: {
    value: 13,
    label: getLabelText({
      key: 'remote.common.purchaseOfServices',
      text: '购买服务'
    }),
    tipsText: '付款成功，即可获得{{score}}积分',
    adminTaskTipsText: '所属平台，用户已存在金额＞0的付款订单，且超过{{num}}天没有付款，（剔除余额充值订单）',
    needCondition: true,
    changeJoinNum: false,
    defaultJoinNum: 1,
    plantTypeList: [systemTypeEnum.VAT, systemTypeEnum.IPP, systemTypeEnum.XM]
  },
  RENEWAL: {
    value: 14,
    label: getLabelText({ key: 'remote.common.renewEarly', text: '提前续费' }),
    tipsText: '距离续费到期日提前{{day}}天完成续费，即可获得{{score}}积分',
    adminTaskTipsText: '所属平台， 用户存在距离服务到期日{{num}}天到期的服务',
    needCondition: true,
    changeJoinNum: true,
    tipsErr: getLabelText({
      key: 'remote.common.promptText62',
      text: '当前没有可续费的业务号'
    }),
    plantTypeList: [systemTypeEnum.VAT, systemTypeEnum.XM]
  },
  EXPERIENCE_BUY_GUIDE: {
    value: 15,
    label: getLabelText({
      key: 'remote.common.experienceTheBuyingGuide',
      text: '体验购买指南'
    }),
    tipsText: '体验购买指南，生成合规报告，即可获得{{score}}积分',
    adminTaskTipsText: '-',
    needCondition: false,
    changeJoinNum: true,
    plantTypeList: [systemTypeEnum.VAT]
  },
  SUBMIT_SERVICE_DATA: {
    value: 16,
    label: getLabelText({
      key: 'remote.common.submissionOfInformation',
      text: '提交资料'
    }),
    tipsText: '及时提交服务资料，即可获得{{score}}积分',
    adminTaskTipsText: '所属平台，用户存在大于{{num}}天未提交资料服务单（即距离完成付款时间{{num}}天）',
    needCondition: true,
    changeJoinNum: true,
    tipsErr: getLabelText({
      key: 'remote.common.promptText63',
      text: '当前没有需要提交资料的服务单'
    }),
    plantTypeList: [systemTypeEnum.VAT, systemTypeEnum.IPP, systemTypeEnum.XM]
  },
  OFFICIAL_PAY: {
    value: 17,
    label: getLabelText({
      key: 'remote.common.payOfficialFees',
      text: '缴纳官费'
    }),
    tipsText: '及时缴纳官费，即可获得{{score}}积分',
    adminTaskTipsText: '所属平台，用户存在大于{{num}}天未缴费的官费订单（即距离订单创建时间{{num}}天）',
    needCondition: true,
    changeJoinNum: true,
    tipsErr: getLabelText({
      key: 'remote.common.promptText64',
      text: '当前没有需要缴纳官费的数据'
    }),
    plantTypeList: [systemTypeEnum.IPP]
  },
  SUBMIT_DECLARATION: {
    value: 18,
    label: getLabelText({
      key: 'remote.common.submitVatDeclaration',
      text: '提交VAT申报'
    }),
    tipsText: '及时提交VAT申报，即可获得{{score}}积分',
    adminTaskTipsText: getLabelText({
      key: 'remote.common.promptText54',
      text: '所属平台，用户在工作台的待申报统计＞0'
    }),
    needCondition: false,
    changeJoinNum: true,
    tipsErr: getLabelText({
      key: 'remote.common.promptText55',
      text: '当前没有需要提交申报的数据'
    }),
    plantTypeList: [systemTypeEnum.VAT]
  },
  HANDLE_LETTER: {
    value: 19,
    label: getLabelText({
      key: 'remote.common.handleCorrespondence',
      text: '处理信件'
    }),
    tipsText: '及时处理信件，即可获得{{score}}积分',
    adminTaskTipsText: getLabelText({
      key: 'remote.common.promptText56',
      text: '所属平台，用户在工作台的待处理信件＞0'
    }),
    needCondition: false,
    changeJoinNum: true,
    tipsErr: getLabelText({
      key: 'remote.common.noCorrespondenceToHandleAtTheMoment',
      text: '当前没有需要处理的信件'
    }),
    plantTypeList: [systemTypeEnum.VAT]
  },
  HANDLE_TICKET: {
    value: 20,
    label: getLabelText({
      key: 'remote.common.processTheWorkOrder',
      text: '处理工单'
    }),
    tipsText: '及时处理工单，即可获得{{score}}积分',
    adminTaskTipsText: getLabelText({
      key: 'remote.common.promptText57',
      text: '所属平台，用户在工作台的待处理工单＞0'
    }),
    needCondition: false,
    changeJoinNum: true,
    tipsErr: getLabelText({
      key: 'remote.common.promptText73',
      text: '当前没有需要处理的工单'
    }),
    plantTypeList: [systemTypeEnum.VAT, systemTypeEnum.IPP]
  },
  QUESTION_ROLL: {
    value: 21,
    label: getLabelText({
      key: 'remote.common.completeSurvey',
      text: '填写问卷调查'
    }),
    tipsText: '提交问卷调查，即可获得{{score}}积分',
    adminTaskTipsText: getLabelText({
      key: 'remote.common.promptText58',
      text: '选择启用状态的问卷标题-编码（可选），该问卷编码的问卷对象可见'
    }),
    needCondition: true,
    conditionType: 'select',
    changeJoinNum: false,
    defaultJoinNum: 1,
    plantTypeList: [systemTypeEnum.VAT, systemTypeEnum.IPP]
  }
})
const taskRefreshInterval = new GenerateEnum({
  NOREFRESH: {
    value: 0,
    label: getLabelText({ key: 'remote.common.doNotRefresh', text: '不刷新' })
  },
  MONTH: {
    value: 3,
    label: getLabelText({
      key: 'remote.common.monthlyRefresh',
      text: '每月刷新'
    })
  },
  QUARTER: {
    value: 5,
    label: getLabelText({
      key: 'remote.common.quarterlyRefresh',
      text: '每季度刷新'
    })
  },
  HALFYEAR: {
    value: 6,
    label: getLabelText({
      key: 'remote.common.semi-annualRefresh',
      text: '每半年刷新'
    })
  }
})
// 活动状态
const taskActivityStatus = new GenerateEnum({
  NOACTIVITY: {
    value: 0,
    label: getLabelText({ key: 'remote.common.notStarted', text: '未开始' })
  },
  ACTIVITY: {
    value: 1,
    label: getLabelText({ key: 'remote.common.inProgress', text: '进行中' })
  },
  END: {
    value: 2,
    label: getLabelText({ key: 'remote.common.ended', text: '已结束' })
  },
  CANCEL: {
    value: 3,
    label: getLabelText({ key: 'remote.common.revoked', text: '已撤销' })
  }
})

const BASE_STATUS = new GenerateEnum({
  CLOSED: {
    value: 0,
    label: getLabelText({ key: 'remote.common.failure2', text: '失效' })
  },
  OPEN: {
    value: 1,
    label: getLabelText({ key: 'remote.common.takeEffect', text: '生效' })
  }
})

const BLACK_ADD_METHODS = new GenerateEnum({
  MANUAL: {
    value: 0,
    label: getLabelText({ key: 'remote.common.addManually', text: '手动添加' })
  },
  AUTOMATIC: {
    value: 1,
    label: getLabelText({ key: 'remote.common.auto-add', text: '自动添加' })
  }
})

const languageEnum = [
  {
    label: 'enum.language.Chinese',
    value: 0,
    symbol: 'zh-CN',
    dateMark: 'Asia/Hong_Kong',
    lang: '中文',
    pathCode: 'cn',
    code: 'cn'
  },
  {
    label: 'enum.language.English',
    value: 1,
    symbol: 'en-US',
    dateMark: 'Europe/London',
    icon: 'country_UK',
    lang: '英语',
    pathCode: 'en',
    code: 'us'
  },
  {
    label: 'enum.language.German',
    value: 2,
    symbol: 'de-DE',
    dateMark: 'Europe/Berlin',
    icon: 'country_Germany',
    lang: '德语',
    code: 'de'
  },
  {
    label: 'enum.language.Japanese',
    value: 6,
    symbol: 'ja-JP',
    dateMark: 'Europe/Berlin',
    icon: 'country_Germany',
    lang: '日语',
    code: 'jp'
  },
  {
    label: 'enum.language.Japanese',
    value: 4,
    symbol: 'it-IT',
    dateMark: 'Europe/Berlin',
    icon: 'country_Germany',
    lang: '意大利语',
    code: 'it'
  },
  {
    label: 'enum.language.Spanish',
    value: 5,
    symbol: 'es-ES',
    dateMark: 'Europe/Madrid',
    icon: '',
    lang: '西班牙语',
    code: 'es'
  }
]

const CATEGORY_COUNTRY_LIST = [
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.US),
    value: COMMON_COUNTRY.US
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.EU),
    value: COMMON_COUNTRY.EU
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.GB),
    value: COMMON_COUNTRY.GB
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.CN),
    value: COMMON_COUNTRY.CN
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.JP),
    value: COMMON_COUNTRY.JP
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.KR),
    value: COMMON_COUNTRY.KR
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.PH),
    value: COMMON_COUNTRY.PH
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.IN),
    value: COMMON_COUNTRY.IN
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.DE),
    value: COMMON_COUNTRY.DE
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.AU),
    value: COMMON_COUNTRY.AU
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.CA),
    value: COMMON_COUNTRY.CA
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.BR),
    value: COMMON_COUNTRY.BR
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.MX),
    value: COMMON_COUNTRY.MX
  }
].map((item) => ({
  ...item,
  label: item.country
}))

// 活动状态
const withdrawTypeEnum = new GenerateEnum({
  CAPITAL_POOL: {
    value: 0,
    label: getLabelText({
      key: 'remote.common.cashWithdrawalFromFundPool',
      text: '资金池提现'
    })
  },
  ORDER: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.orderCashWithdrawal',
      text: '订单提现'
    })
  },
  SERVICES: {
    value: 2,
    label: getLabelText({
      key: 'remote.admin.serviceCashWithdrawal',
      text: '服务单提现'
    })
  }
})
const orderExportTypeEnum = new GenerateEnum({
  aliExpressOrder: {
    value: 'aliExpressOrder',
    label: getLabelText({ key: 'remote.common.aliexpress', text: '速卖通' }),
    listType: 1,
    needCookie: true
  },
  aliInternationOrder: {
    value: 'aliInternationOrder',
    label: getLabelText({
      key: 'remote.common.alibabaInternationalStation',
      text: '阿里国际站'
    }),
    listType: 2,
    needCookie: true
  },
  temuOrder: {
    value: 'temuOrder',
    label: getLabelText({
      key: 'TEMU',
      text: 'TEMU'
    }),
    listType: 3
  }
})
const aliExportCategoryList = new GenerateEnum({
  CERTIFICATE: {
    value: 'MP_CERTIFICATE_PRODUCT_TEST_3PL',
    label: getLabelText({
      key: 'remote.common.promptText59',
      text: '产品检测认证服务3PL'
    })
  },
  COMPLIANCE_VAT: {
    value: 'MP_COMPLIANCE_VAT_3PL',
    label: getLabelText({
      key: 'remote.common.promptText60',
      text: 'VAT服务3PL'
    })
  },
  RP_COMPLIANCE_3PL: {
    value: 'MP_RP_COMPLIANCE_3PL',
    label: getLabelText({
      key: 'remote.common.promptText61',
      text: '欧盟负责人3PL'
    })
  }
})

//开票类型枚举

const isVatAi = [PLAT_FORM.VATAI_EU, PLAT_FORM.VATAI_US].includes(globalThis().platform)
const billingTypeEnum = new GenerateEnum({
  COMPANY: {
    label: getLabelText(
      isVatAi
        ? {
            key: 'remote.common.commercialInvoice',
            text: '商业发票'
          }
        : {
            key: 'remote.common.company',
            text: '公司'
          }
    ),
    value: 0
  },
  INDIVIDUAL: {
    label: getLabelText(
      isVatAi
        ? {
            key: 'remote.common.personalInvoice',
            text: '个人发票'
          }
        : { key: 'remote.common.individual', text: '个人' }
    ),
    value: 1
  }
})
const PRODUCTTYPEOBJ = new GenerateEnum({
  ORDINARY: {
    value: 0,
    label: getLabelText({ key: 'remote.common.commonGoods', text: '普通商品' })
  },
  OFFICIAL: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.goodsAtOfficialExpense',
      text: '官费商品'
    })
  },
  SETMEAL: {
    value: 2,
    label: getLabelText({ key: 'remote.common.packageGoods', text: '套餐商品' })
  }
})

const dictTypeEnum = {
  1: '后台词典',
  2: '正常词典配置',
  3: '服务资料词典',
  4: '商户端静态资源词典',
  5: '算税配置词典',
  6: '终止服务词典',
  7: '商品配置词典',
  8: '服务进度',
  9: '后台静态资源词典',
  10: '服务资料驳回词典'
}

const FINANCIAL_AUDIT_TYPE = {
  MANUAL: {
    value: 0,
    label: '人工审核'
  },
  AUTOMATIC: {
    value: 1,
    label: '自动审核'
  }
}

const payerType = new GenerateEnum({
  distributor: {
    label: getLabelText({
      key: 'remote.buyModel.distributorName',
      text: '分销商名称'
    }),
    adminLabel: getLabelText({
      key: 'remote.common.distributor',
      text: '分销商'
    }),
    value: 2
  },
  merchant: {
    label: getLabelText({
      key: 'remote.buyModel.customerMerchantNumber',
      text: '客户商户号'
    }),
    adminLabel: getLabelText({ key: 'remote.common.customer', text: '客户' }),
    value: 1
  }
})
const distributionCenterWithdrawTypeEnum = new GenerateEnum({
  //余额
  BALANCE: {
    value: 0,
    label: getLabelText({ key: 'remote.common.balance', text: '余额' }),
    label1: getLabelText({
      key: 'remote.admin.withdrawalOfBalance',
      text: '余额提现'
    })
  },
  COMMISSION: {
    value: 1,
    label: getLabelText({ key: 'remote.admin.commission', text: '佣金' }),
    label1: getLabelText({
      key: 'remote.admin.commissionWithdrawal',
      text: '佣金提现'
    })
  }
})
const settlementType = new GenerateEnum({
  //余额
  SETTLE: {
    value: 1,
    label: getLabelText({
      key: 'remote.admin.settlementType',
      text: '结算类型'
    })
  },
  COMMISSION: {
    value: 2,
    label: getLabelText({
      key: 'remote.admin.distributor_82',
      text: '返佣类型'
    })
  }
})

const PATENT_SEARCH_COUNTRY = new GenerateEnum({
  US: {
    value: 'US',
    label: '美国',
    type: 1
  },
  EU: {
    value: 'EU',
    label: '欧盟',
    type: 1
  },
  GB: {
    value: 'GB',
    label: '英国',
    type: 1
  },
  JP: {
    value: 'JP',
    label: '日本',
    type: 1
  },
  CA: {
    value: 'CA',
    label: '加拿大',
    type: 1
  },
  MX: {
    value: 'MX',
    label: '墨西哥',
    type: 1
  },
  KR: {
    value: 'KR',
    label: '韩国',
    type: 1
  },
  IN: {
    value: 'IN',
    label: '印度',
    type: 1
  },
  PH: {
    value: 'PH',
    label: '菲律宾',
    type: 1
  },
  MY: {
    value: 'MY',
    label: '马来西亚',
    type: 1
  },
  VN: {
    value: 'VN',
    label: '越南',
    type: 1
  },
  TH: {
    value: 'TH',
    label: '泰国',
    type: 1
  },
  SG: {
    value: 'SG',
    label: '新加坡',
    type: 1
  },
  ID: {
    value: 'ID',
    label: '印度尼西亚',
    type: 1
  },
  AU: {
    value: 'AU',
    label: '澳大利亚'
  },
  DE: {
    value: 'DE',
    label: '德国'
  },
  FR: {
    value: 'FR',
    label: '法国'
  },
  BR: {
    value: 'BR',
    label: '巴西'
  },
  PL: {
    value: 'PL',
    label: '波兰'
  },
  RU: {
    value: 'RU',
    label: '俄罗斯'
  },
  SA: {
    value: 'SA',
    label: '沙特阿拉伯'
  },
  AE: {
    value: 'AE',
    label: '阿拉伯联合酋长国'
  },
  OTHER: {
    value: 'OTHER',
    label: '其他国家（150）'
  }
})

const OTHER_PATENT_SEARCH_COUNTRY = [
  'WO',
  'AT',
  'BX',
  'CH',
  'DK',
  'ES',
  'FI',
  'HK',
  'IE',
  'IL',
  'MO',
  'NO',
  'NZ',
  'SE',
  'TW',
  'AP',
  'AR',
  'BA',
  'BG',
  'BN',
  'CO',
  'CR',
  'CS',
  'CU',
  'CY',
  'CZ',
  'EA',
  'EE',
  'GE',
  'GR',
  'HR',
  'HU',
  'IS',
  'IT',
  'JO',
  'KE',
  'KH',
  'KZ',
  'LA',
  'LT',
  'LV',
  'MA',
  'MD',
  'ME',
  'MN',
  'MT',
  'PE',
  'PT',
  'RO',
  'RS',
  'SI',
  'SK',
  'TN',
  'TR',
  'UA',
  'AL',
  'CN'
]

const OTHER_PATENT_TEXT_SEARCH_COUNTRY = [...OTHER_PATENT_SEARCH_COUNTRY, 'AL', 'AZ', 'BO', 'BW', 'CL', 'DO', 'EC', 'GT', 'HN', 'MK', 'PG', 'RW', 'SM', 'UY', 'ZA', 'LI', 'NI', 'MZ', 'BE']

const PATENT_SEARCH_ALL_COUNTRY = new GenerateEnum({
  WO: {
    value: 'WO',
    label: '世界知识产权组织'
  },
  AT: {
    value: 'AT',
    label: '奥地利'
  },
  AU: {
    value: 'AU',
    label: '澳大利亚'
  },
  BX: {
    value: 'BX',
    label: '比荷卢经济联盟'
  },
  CA: {
    value: 'CA',
    label: '加拿大'
  },
  CH: {
    value: 'CH',
    label: '瑞士'
  },
  CN: {
    value: 'CN',
    label: '中国'
  },
  DE: {
    value: 'DE',
    label: '德国'
  },
  DK: {
    value: 'DK',
    label: '丹麦'
  },
  ES: {
    value: 'ES',
    label: '西班牙'
  },
  EU: {
    value: 'EU',
    label: '欧盟'
  },
  FI: {
    value: 'FI',
    label: '芬兰'
  },
  FR: {
    value: 'FR',
    label: '法国'
  },
  GB: {
    value: 'GB',
    label: '英国'
  },
  HK: {
    value: 'HK',
    label: '中国香港'
  },
  IE: {
    value: 'IE',
    label: '爱尔兰'
  },
  IL: {
    value: 'IL',
    label: '以色列'
  },
  IN: {
    value: 'IN',
    label: '印度'
  },
  JP: {
    value: 'JP',
    label: '日本'
  },
  KR: {
    value: 'KR',
    label: '韩国'
  },
  MO: {
    value: 'MO',
    label: '中国澳门'
  },
  NO: {
    value: 'NO',
    label: '挪威'
  },
  NZ: {
    value: 'NZ',
    label: '新西兰'
  },
  PL: {
    value: 'PL',
    label: '波兰'
  },
  RU: {
    value: 'RU',
    label: '俄罗斯'
  },
  SE: {
    value: 'SE',
    label: '瑞典'
  },
  SG: {
    value: 'SG',
    label: '新加坡'
  },
  TH: {
    value: 'TH',
    label: '泰国'
  },
  TW: {
    value: 'TW',
    label: '中国台湾'
  },
  US: {
    value: 'US',
    label: '美国'
  },
  AE: {
    value: 'AE',
    label: '阿拉伯联合酋长国'
  },
  AP: {
    value: 'AP',
    label: '非洲地区工业产权组织'
  },
  AR: {
    value: 'AR',
    label: '阿根廷'
  },
  BA: {
    value: 'BA',
    label: '波斯尼亚和黑塞哥维那'
  },
  BG: {
    value: 'BG',
    label: '保加利亚'
  },
  BN: {
    value: 'BN',
    label: '文莱'
  },
  BR: {
    value: 'BR',
    label: '巴西'
  },
  CO: {
    value: 'CO',
    label: '哥伦比亚'
  },
  CR: {
    value: 'CR',
    label: '哥斯达黎加'
  },
  CS: {
    value: 'CS',
    label: '捷克和斯洛伐克共和国'
  },
  CU: {
    value: 'CU',
    label: '古巴'
  },
  CY: {
    value: 'CY',
    label: '塞浦路斯'
  },
  CZ: {
    value: 'CZ',
    label: '捷克'
  },
  EA: {
    value: 'EA',
    label: '欧亚专利局'
  },
  EE: {
    value: 'EE',
    label: '爱沙尼亚'
  },
  GE: {
    value: 'GE',
    label: '格鲁吉亚'
  },
  GR: {
    value: 'GR',
    label: '希腊'
  },
  HR: {
    value: 'HR',
    label: '克罗地亚'
  },
  HU: {
    value: 'HU',
    label: '匈牙利'
  },
  ID: {
    value: 'ID',
    label: '印度尼西亚'
  },
  IS: {
    value: 'IS',
    label: '冰岛'
  },
  IT: {
    value: 'IT',
    label: '意大利'
  },
  JO: {
    value: 'JO',
    label: '约旦'
  },
  KE: {
    value: 'KE',
    label: '肯尼亚'
  },
  KH: {
    value: 'KH',
    label: '柬埔寨'
  },
  KZ: {
    value: 'KZ',
    label: '哈萨克斯坦'
  },
  LA: {
    value: 'LA',
    label: '老挝'
  },
  LT: {
    value: 'LT',
    label: '立陶宛'
  },
  LV: {
    value: 'LV',
    label: '拉脱维亚'
  },
  MA: {
    value: 'MA',
    label: '摩洛哥'
  },
  MD: {
    value: 'MD',
    label: '摩尔多瓦'
  },
  ME: {
    value: 'ME',
    label: '黑山共和国'
  },
  MN: {
    value: 'MN',
    label: '蒙古'
  },
  MT: {
    value: 'MT',
    label: '马耳他'
  },
  MX: {
    value: 'MX',
    label: '墨西哥'
  },
  MY: {
    value: 'MY',
    label: '马来西亚'
  },
  PE: {
    value: 'PE',
    label: '秘鲁'
  },
  PH: {
    value: 'PH',
    label: '菲律宾'
  },
  PT: {
    value: 'PT',
    label: '葡萄牙'
  },
  RO: {
    value: 'RO',
    label: '罗马尼亚'
  },
  RS: {
    value: 'RS',
    label: '塞尔维亚共和国'
  },
  SA: {
    value: 'SA',
    label: '沙特阿拉伯'
  },
  SI: {
    value: 'SI',
    label: '斯洛文尼亚'
  },
  SK: {
    value: 'SK',
    label: '斯洛伐克'
  },
  TN: {
    value: 'TN',
    label: '突尼斯'
  },
  TR: {
    value: 'TR',
    label: '土耳其'
  },
  UA: {
    value: 'UA',
    label: '乌克兰'
  },
  VN: {
    value: 'VN',
    label: '越南'
  },
  AL: {
    value: 'AL',
    label: '阿尔巴尼亚'
  },
  LI: {
    value: 'LI',
    label: '列支敦士登'
  },
  AZ: {
    value: 'AZ',
    label: '阿塞拜疆'
  },
  BO: {
    value: 'BO',
    label: '玻利维亚'
  },
  BW: {
    value: 'BW',
    label: '博茨瓦纳'
  },
  CL: {
    value: 'CL',
    label: '智利'
  },
  DO: {
    value: 'DO',
    label: '多米尼加共和国'
  },
  EC: {
    value: 'EC',
    label: '厄瓜多尔'
  },
  GT: {
    value: 'GT',
    label: '危地马拉'
  },
  HN: {
    value: 'HN',
    label: '洪都拉斯'
  },
  MK: {
    value: 'MK',
    label: '北马其顿共和国'
  },
  PG: {
    value: 'PG',
    label: '巴布亚新几内亚'
  },
  RW: {
    value: 'RW',
    label: '卢旺达'
  },
  SM: {
    value: 'SM',
    label: '圣马力诺'
  },
  UY: {
    value: 'UY',
    label: '乌拉圭'
  },
  ZA: {
    value: 'ZA',
    label: '南非'
  },
  NI: {
    value: 'NI',
    label: '尼加拉瓜'
  },
  MZ: {
    value: 'MZ',
    label: '莫桑比克'
  },
  BE: {
    value: 'BE',
    label: '比利时'
  }
})

// cookie时间字符串，一个月过期
const COOKIE_TIME_STR = ';max-age=2592000;SameSite=None;Secure'
const COOKIE_TIME_OBJ = { maxAge: 2592000, sameSite: 'none', secure: true }
// js-cookie库不支持maxAge(https://github.com/js-cookie/js-cookie/issues/618)，必须用expires
const COOKIE_TIME_BY_JS_COOKIE = {
  expires: 30,
  sameSite: 'none',
  secure: true
} // 30，表示天数

const VATAI_REGISTER_ENUM = new GenerateEnum({
  EMAIL: {
    value: 'emailRegister',
    label: getLabelText({
      key: 'remote.admin.registerByEmail',
      text: '邮箱注册'
    })
  },
  GOOGLE: {
    value: 'googleAccredit',
    label: getLabelText({
      key: 'remote.admin.registerByGoogle',
      text: '谷歌授权注册'
    })
  }
})

const SUBPOSITION_ENUM = new GenerateEnum({
  DEFAULT: {
    value: -1,
    label: '-',
    show: false
  },
  WIDE: {
    value: 0,
    label: getLabelText({
      key: 'remote.admin.wideScreen',
      text: '宽屏广告'
    }),
    widthTips: `1800 * 110(${getLabelText({
      key: 'remote.admin.contentWidth',
      text: '内容宽度'
    })}:1000)`,
    show: true
  },
  LEFT: {
    value: 1,
    label: getLabelText({
      key: 'remote.admin.bannerLeftRegion',
      text: '分区广告-左区'
    }),
    widthTips: `1190 * 110(${getLabelText({
      key: 'remote.admin.contentWidth',
      text: '内容宽度'
    })}:600)`,
    show: true
  },
  RIGHT: {
    value: 2,
    label: getLabelText({
      key: 'remote.admin.bannerRightRegion',
      text: '分区广告-右区'
    }),
    widthTips: `590 * 110(${getLabelText({
      key: 'remote.admin.contentWidth',
      text: '内容宽度'
    })}:300)`,
    show: true
  }
})

const linkSafeSourceType = new GenerateEnum({
  AWS: {
    value: '00',
    label: '亚马逊'
  },
  SMT: {
    value: '01',
    label: '速卖通'
  },
  XY: {
    value: '02',
    label: '阿里国际'
  },
  EBAY: {
    value: '03',
    label: 'Ebay'
  }
})

const linkSafePlatformType = new GenerateEnum({
  OST: {
    value: '00',
    label: '欧税通'
  },
  MDT: {
    value: '01',
    label: '麦德通'
  }
})

const OA_TYPE = [
  {
    value: '1',
    label: getLabelText({ key: 'remote.common.trademark', text: '商标' }),
    children: [
      {
        value: '101',
        label: getLabelText({ key: 'remote.common.similarityReason', text: '近似理由' }),
        parent: '1'
      },
      {
        value: '102',
        label: getLabelText({ key: 'remote.common.significanceProblem', text: '显著性问题' }),
        parent: '1'
      },
      {
        value: '103',
        label: getLabelText({ key: 'remote.common.useOfEvidence', text: '使用证据' }),
        parent: '1'
      },
      {
        value: '104',
        label: getLabelText({ key: 'remote.common.usAddressFormalIssue', text: '美国地址-形式问题' }),
        parent: '1'
      },
      {
        value: '105',
        label: getLabelText({ key: 'remote.common.declarationFormalIssue', text: '声明书-形式问题' }),
        parent: '1'
      },
      {
        value: '106',
        label: getLabelText({ key: 'remote.common.trademarkDescriptionFormalIssue', text: '商标描述-形式问题' }),
        parent: '1'
      },
      {
        value: '107',
        label: getLabelText({ key: 'remote.common.applicantTypeFormalIssue', text: '申请人类型-形式问题' }),
        parent: '1'
      },
      {
        value: '108',
        label: getLabelText({ key: 'remote.common.goodsItemFormalIssue', text: '商品项-形式问题' }),
        parent: '1'
      },
      {
        value: '109',
        label: getLabelText({ key: 'remote.common.exclusiveRightFormalIssue', text: '专用权-形式问题' }),
        parent: '1'
      },
      {
        value: '110',
        label: getLabelText({ key: 'remote.common.nameDeclarationFormalIssue', text: '人名声明-形式问题' }),
        parent: '1'
      },
      {
        value: '111',
        label: getLabelText({
          key: 'remote.common.trademarkMeaningTranslationFormalIssue',
          text: '商标含义/翻译-形式问题'
        }),
        parent: '1'
      },
      {
        value: '112',
        label: getLabelText({ key: 'remote.common.individualBusinessDeclaration', text: '个体户声明' }),
        parent: '1'
      },
      {
        value: '113',
        label: getLabelText({ key: 'remote.common.reexamination', text: '重审' }),
        parent: '1'
      },
      {
        value: '114',
        label: getLabelText({ key: 'remote.common.geographicalLocationDeclaration', text: '地理位置声明' }),
        parent: '1'
      },
      {
        value: '115',
        label: getLabelText({ key: 'remote.common.other', text: '其他' }),
        parent: '1'
      },
      {
        value: '116',
        label: getLabelText({ key: 'remote.common.opposedInvalidated', text: '被异议/被无效' }),
        parent: '1'
      },
      {
        value: '118',
        label: getLabelText({ key: 'remote.common.similarityReminder', text: '近似提醒' }),
        parent: '1'
      }
    ]
  },
  {
    value: '2',
    label: getLabelText({ key: 'remote.common.patent', text: '专利' }),
    children: [
      {
        value: '201',
        label: getLabelText({ key: 'remote.common.priorSimilarity', text: '在先近似' }),
        parent: '2'
      },
      {
        value: '202',
        label: getLabelText({ key: 'remote.common.drawingIssue', text: '绘图问题' }),
        parent: '2'
      },
      {
        value: '203',
        label: getLabelText({ key: 'remote.common.appearanceName', text: '外观名称' }),
        parent: '2'
      },
      {
        value: '204',
        label: getLabelText({ key: 'remote.common.entityTypeInDoubt', text: '实体类型存疑' }),
        parent: '2'
      },
      {
        value: '205',
        label: getLabelText({ key: 'remote.common.caseSplit', text: '拆案' }),
        parent: '2'
      },
      {
        value: '206',
        label: getLabelText({ key: 'remote.common.priorityNotMet', text: '优先权不符合' }),
        parent: '2'
      },
      {
        value: '207',
        label: getLabelText({ key: 'remote.common.reexamination', text: '重审' }),
        parent: '2'
      },
      {
        value: '208',
        label: getLabelText({ key: 'remote.common.patentDuplication', text: '专利重复' }),
        parent: '2'
      },
      {
        value: '209',
        label: getLabelText({ key: 'remote.common.other', text: '其他' }),
        parent: '2'
      }
    ]
  },
  {
    value: '3',
    label: getLabelText({ key: 'remote.common.copyright', text: '版权' }),
    children: [
      {
        value: '301',
        label: getLabelText({ key: 'remote.common.priorSimilarity', text: '在先近似' }),
        parent: '3'
      },
      {
        value: '302',
        label: getLabelText({ key: 'remote.common.significanceProblem', text: '显著性问题' }),
        parent: '3'
      },
      {
        value: '303',
        label: getLabelText({ key: 'remote.common.other', text: '其他' }),
        parent: '3'
      }
    ]
  }
]

const OBJECTION_OA_TYPE = [
  {
    value: '116',
    label: getLabelText({ key: 'remote.common.opposed', text: '被异议' })
  },
  {
    value: '117',
    label: getLabelText({ key: 'remote.common.invalidated', text: '被无效' })
  }
]
const specialQueryTypeEnum = new GenerateEnum({
  annualAndAuditRenewalFee: {
    value: 1,
    label: getLabelText({ key: 'remote.common.annualAndAuditRenewalFee', text: '公司年审续费+做账审计续费（其他国家）' })
  },
  makeAccountAuditAndRenew: {
    value: 2,
    label: getLabelText({ key: ['remote.common.makeAccountAuditAndRenew', '（', 'remote.common.hongKongChina', ')'], text: '做账审计续费（中国香港）' })
  }
})
/** 官网首页配置 — 模块标题多语言行（活动 / 集团业务 / 品牌优势 / 合作平台） */
const homePageModuleTitleTypeEnum = new GenerateEnum({
  activityModule: {
    value: 1,
    label: '活动模块'
  },
  groupBusinessModule: {
    value: 2,
    label: '集团业务'
  },
  brandAdvantageModule: {
    value: 3,
    label: '品牌优势'
  },
  cooperationPlatformModule: {
    value: 4,
    label: '合作平台'
  }
})
const spaceDataSourceType = new GenerateEnum({
  purchasedService: {
    value: 1,
    isMainBody: true,
    label: getLabelText({
      key: 'remote.common.purchasedService',
      text: '已购服务'
    }),
    bindOldData: '1'
  },
  extensionRenewal: {
    value: 2,
    isMainBody: true,
    label: getLabelText({
      key: 'remote.common.manualEntry',
      text: '手动录入'
    }),
    bindOldData: '2,3'
  },
  openData: {
    value: 3,
    label: getLabelText({
      key: 'remote.common.openData',
      text: '公开数据'
    }),
    bindOldData: '4,6'
  },
  transferredService: {
    value: 4,
    isMainBody: true,
    label: getLabelText({
      key: 'remote.common.transferredService',
      text: '受让服务'
    }),
    bindOldData: '7'
  }
})
const spaceDataRangeType = new GenerateEnum({
  viewAll: {
    value: '',
    allowEmptyValue: true,
    label: getLabelText({
      key: 'remote.common.viewAll',
      text: '查看全部'
    })
  },
  viewUpdatedDataPastDays: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.viewUpdatedDataPastDays',
      text: '只看近30天更新数据'
    })
  }
})

const licenseNumberValidStatusType = new GenerateEnum({
  invalid: {
    value: 0,
    label: getLabelText({ key: 'remote.common.notValid', text: '无效' })
  },
  valid: {
    value: 1,
    label: getLabelText({ key: 'remote.common.valid', text: '有效' })
  },
  //未知
  unknown: {
    value: 2,
    label: getLabelText({ key: 'remote.common.unknown', text: '未知' })
  }
})

const assetRecognitionStatusType = new GenerateEnum({
  // 无需确认
  noNeed: {
    value: 6,
    label: getLabelText({ key: 'remote.common.noNeedConfirm', text: '无需确认' }),
    // 无需确认：蓝色
    color: '#666',
    isMerchant: true
  },
  toBeConfirmed: {
    value: 1,
    label: getLabelText({ key: 'remote.common.toBeConfirmed', text: '待确认' }),
    // 待确认：红色
    color: '#F5222D',
    userColor: '#F5222D',
    userBg: '#FBE0E0',
    isMerchant: true
  },
  confirmed: {
    value: 2,
    label: getLabelText({ key: 'remote.common.confirmed', text: '已确认' }),
    // 已确认：绿色
    color: '#27C688',
    isMerchant: true
  },
  notMyself: {
    value: 4,
    label: getLabelText({ key: 'remote.common.complianceAssetOwnershipNotMyselfMonitor', text: '非本人，需监控' }),
    // 非本人：深灰色
    color: '#808080',
    userColor: '#333333',
    userBg: '#E7E7E7',
    isMerchant: true
  },
  ignored: {
    value: 3,
    label: getLabelText({ key: 'remote.common.complianceAssetOwnershipNotMyselfIgnore2', text: '非本人，已忽略' }),
    // 已忽略：灰色
    color: '#c7c7c7',
    userColor: '#333333',
    userBg: '#E7E7E7',
    isMerchant: true
  },
  delete: {
    value: 5,
    label: getLabelText({ key: 'remote.common.deleted', text: '已删除' }),
    // 已删除：黑色
    color: '#000000'
  },
  transferred: {
    value: 7,
    label: getLabelText({ key: 'remote.common.transferred', text: '已转让' }),
    // 已转让：灰色
    color: '#808080',
    userColor: '#333333',
    userBg: '#E7E7E7',
    isMerchant: true
  }
})
const complianceAssetClickType = new GenerateEnum({
  uploadBusinessLicense: {
    value: 1,
    label: getLabelText({ key: 'remote.complianceAsset.uploadBusinessLicense', text: '上传营业执照点击量' })
  },
  confirmAddSubject: {
    value: 2,
    label: getLabelText({ key: 'remote.complianceAsset.confirmAddSubject', text: '确认添加主体点击量' })
  },
  batchMergeCompany: {
    value: 3,
    label: getLabelText({ key: 'remote.complianceAsset.batchMergeCompany', text: '批量合并公司点击量' })
  },
  subjectPageSubject: {
    value: 4,
    label: getLabelText({ key: 'remote.complianceAsset.subjectPageSubject', text: '主体页主体点击量' })
  },
  subjectPageStore: {
    value: 5,
    label: getLabelText({ key: 'remote.complianceAsset.subjectPageStore', text: '主体页店铺点击量' })
  },
  subjectPageVat: {
    value: 6,
    label: getLabelText({ key: 'remote.complianceAsset.subjectPageVat', text: '主体页VAT点击量' })
  },
  subjectPageEpr: {
    value: 7,
    label: getLabelText({ key: 'remote.complianceAsset.subjectPageEpr', text: '主体页EPR点击量' })
  },
  subjectPageAuthorizedRepresentative: {
    value: 8,
    label: getLabelText({ key: 'remote.complianceAsset.subjectPageAuthorizedRepresentative', text: '主体页授权代表点击量' })
  },
  subjectPageTrademark: {
    value: 9,
    label: getLabelText({ key: 'remote.complianceAsset.subjectPageTrademark', text: '主体页商标专利点击量' })
  },
  subjectPageEori: {
    value: 10,
    label: getLabelText({ key: 'remote.complianceAsset.subjectPageEori', text: '主体页EORI点击量' })
  },
  subjectPageOverseasBusiness: {
    value: 11,
    label: getLabelText({ key: 'remote.complianceAsset.subjectPageOverseasBusiness', text: '主体页境外工商点击量' })
  },
  assetOverview: {
    value: 12,
    label: getLabelText({ key: 'remote.complianceAsset.assetOverview', text: '资产全景图点击量' })
  },
  baseInfo: {
    value: 13,
    label: getLabelText({ key: 'remote.complianceAsset.baseInfo', text: '资产基础资料点击量' })
  },
  storeInfo: {
    value: 14,
    label: getLabelText({ key: 'remote.complianceAsset.storeInfo', text: '资产店铺点击量' })
  },
  vatInfo: {
    value: 15,
    label: getLabelText({ key: 'remote.complianceAsset.vatInfo', text: '资产VAT点击量' })
  },
  eprInfo: {
    value: 16,
    label: getLabelText({ key: 'remote.complianceAsset.eprInfo', text: '资产EPR点击量' })
  },
  authorizedRepresentative: {
    value: 17,
    label: getLabelText({ key: 'remote.complianceAsset.authorizedRepresentative', text: '资产授权代表点击量' })
  },
  trademark: {
    value: 18,
    label: getLabelText({ key: 'remote.complianceAsset.trademark', text: '资产商标点击量' })
  },
  patent: {
    value: 19,
    label: getLabelText({ key: 'remote.complianceAsset.patent', text: '资产专利点击量' })
  },
  copyright: {
    value: 20,
    label: getLabelText({ key: 'remote.complianceAsset.copyright', text: '资产版权点击量' })
  },
  harborDeclaration: {
    value: 21,
    label: getLabelText({ key: 'remote.complianceAsset.harborDeclaration', text: '资产海关备案点击量' })
  },
  eori: {
    value: 22,
    label: getLabelText({ key: 'remote.complianceAsset.eori', text: '资产EORI点击量' })
  },
  storeAuthorization: {
    value: 23,
    label: getLabelText({ key: 'remote.complianceAsset.storeAuthorization', text: '店铺授权点击量' })
  },
  calendar: {
    value: 24,
    label: getLabelText({ key: 'remote.complianceAsset.calendar', text: '合规日历点击量' })
  },
  SHOP_LEVEL1: {
    value: 25,
    label: getLabelText({ key: 'remote.complianceAsset.shopLevel1', text: '店铺（一级页面）点击量' })
  },
  SHOP_COMPANY_PERSON: {
    value: 26,
    label: getLabelText({ key: 'remote.complianceAsset.shopCompanyPerson', text: '店铺-所属公司/个人点击量' })
  },
  VAT_LEVEL1: {
    value: 27,
    label: getLabelText({ key: 'remote.complianceAsset.vatLevel1', text: 'VAT(一级页面)点击量' })
  },
  VAT_COMPANY_PERSON: {
    value: 28,
    label: getLabelText({ key: 'remote.complianceAsset.vatCompanyPerson', text: 'VAT-所属公司/个人点击量' })
  },
  VAT_PANORAMA: {
    value: 29,
    label: getLabelText({ key: 'remote.complianceAsset.vatPanorama', text: 'VAT-全景图点击量' })
  },
  EPR_LEVEL1: {
    value: 30,
    label: getLabelText({ key: 'remote.complianceAsset.eprLevel1', text: 'EPR(一级页面)点击量' })
  },
  EPR_COMPANY_PERSON: {
    value: 31,
    label: getLabelText({ key: 'remote.complianceAsset.eprCompanyPerson', text: 'EPR-所属公司/个人点击量' })
  },
  EPR_PANORAMA: {
    value: 32,
    label: getLabelText({ key: 'remote.complianceAsset.eprPanorama', text: 'EPR-全景图点击量' })
  },
  AUTH_REP_LEVEL1: {
    value: 33,
    label: getLabelText({ key: 'remote.complianceAsset.authRepLevel1', text: '授权代表（一级页面）点击量' })
  },
  AUTH_REP_COMPANY_PERSON: {
    value: 34,
    label: getLabelText({ key: 'remote.complianceAsset.authRepCompanyPerson', text: '授权代表-所属公司/个人点击量' })
  },
  AUTH_REP_PANORAMA: {
    value: 35,
    label: getLabelText({ key: 'remote.complianceAsset.authRepPanorama', text: '授权代表-全景图点击量' })
  },
  IP_LEVEL1: {
    value: 36,
    label: getLabelText({ key: 'remote.complianceAsset.ipLevel1', text: '知识产权（一级页面）点击量' })
  },
  IP_COMPANY_PERSON: {
    value: 37,
    label: getLabelText({ key: 'remote.complianceAsset.ipCompanyPerson', text: '知识产权-所属公司/个人点击量' })
  },
  CUSTOMS_FILING_LEVEL1: {
    value: 38,
    label: getLabelText({ key: 'remote.complianceAsset.customsFilingLevel1', text: '海关备案（一级页面）点击量' })
  },
  CUSTOMS_FILING_COMPANY_PERSON: {
    value: 39,
    label: getLabelText({ key: 'remote.complianceAsset.customsFilingCompanyPerson', text: '海关备案-所属公司/个人点击量' })
  },
  complianceSpaceMenu: {
    value: 40,
    label: getLabelText({ key: 'remote.complianceAsset.complianceSpaceMenu', text: '合规空间菜单点击量' })
  },
  compliantAssetsMenu: {
    value: 41,
    label: getLabelText({ key: 'remote.complianceAsset.compliantAssetsMenu', text: '合规资产菜单点击量' })
  },
  EORI_LEVEL1: {
    value: 42,
    label: getLabelText({ key: 'remote.complianceAsset.eoriLevel1', text: 'EORI(一级页面)点击量' })
  },
  EORI_COMPANY_PERSON: {
    value: 43,
    label: getLabelText({ key: 'remote.complianceAsset.eoriCompanyPerson', text: 'EORI-所属公司/个人点击量' })
  }
})

// 1.普通支付，2：服务费 + 官费 一口价 3：既有服务费，也有官费，但服务费为 0
const LZPAYTYPE = {
  NORMAL: 1,
  LZ_PAY_TOGETHER: 2,
  LZ_SERVICE_FEE_ZERO: 3
}

const complianceAssetsWorkType = new GenerateEnum({
  SINGLE_ARTWORK: {
    value: 0,
    label: getLabelText({ key: 'remote.complianceAssets.singleArtwork', text: '单件美术作品' })
  },
  UNPUBLISHED_SERIES_ARTWORK: {
    value: 1,
    label: getLabelText({ key: 'remote.complianceAssets.unpublishedSeriesArtwork', text: '未公开系列美术作品' })
  },
  PHOTOGRAPHIC_WORK: {
    value: 2,
    label: getLabelText({ key: 'remote.complianceAssets.photographicWork', text: '摄影作品' })
  },
  OTHER: {
    value: 3,
    label: getLabelText({ key: 'remote.common.other', text: '其他' })
  }
})
const ACCESS_METHOD_ENUM = {
  DIRECT: 1,
  N_SELECT_M: 2
}

export {
  complianceAssetsWorkType,
  ACCESS_METHOD_ENUM,
  LZPAYTYPE,
  complianceAssetClickType,
  assetRecognitionStatusType,
  licenseNumberValidStatusType,
  spaceDataSourceType,
  spaceDataRangeType,
  linkSafePlatformType,
  linkSafeSourceType,
  SUBPOSITION_ENUM,
  settlementType,
  distributionCenterWithdrawTypeEnum,
  payerType,
  lzProductList,
  PRODUCTTYPEOBJ,
  aliExportCategoryList,
  orderExportTypeEnum,
  paySettleDetailStatusEnum,
  env,
  scoreType,
  SERVICE_STATUS,
  scoreLimitFlagModule,
  scoreStoreProductType,
  advertisementModuleType,
  faceThePeopleData,
  entryCompanyEnum,
  SERVICE_STATUS_MAP,
  withdrawType,
  productTypeEnum,
  countryList,
  payClass,
  currencyList,
  currencyMap,
  sourceType,
  rateTypeModules,
  rateType,
  PERCENTAGE_BASE,
  VALIDOBJ,
  VALIDMAP,
  PERCENTAGE_BASE_MAP,
  BILLING_DATA,
  payWay,
  balanceTradeType,
  balanceTradeStatus,
  payModelModule,
  isPresentedType,
  fundPaymentMethodEnum,
  PERCENTAGE_BASE_LIST,
  ACTIVITY_TYPE,
  ACTIVITY_OBJ,
  ACTIVITY_URL,
  ACTIVITY_MENU,
  country,
  productNameType,
  SENDWAYKEY,
  CART_TYPE,
  sendWay,
  fifterAwardIncident,
  EXPERIENCE_VIP,
  FIXED_CURRENCY_PREFIX,
  VIP_TYPE,
  VIP_TYPE_MAP,
  EXPERIENCE_VIP_TYPE,
  EXPERIENCE_VIP_TYPE_MAP,
  ALL_VIP_TYPE_MAP,
  PRICE_TYPE,
  PRODUCTVALID,
  PRODUCTONSHOW,
  MSG_NETWORK_ERR,
  OFFICIAL_IS_INCLUDE,
  IS_BOOLEAN_NAME,
  ISSALETYPE,
  MODULE_TYPE_OBJ,
  ATTRIBUTE_SIGN,
  DESIGN_PATENT_ATTR_SIGN,
  businessPlatform,
  isDefaultImg,
  LIUDUTYPENAME,
  systemTypeName,
  HEADERSYSTEMTYPE,
  specialOrderListEnum,
  attachFeeTypeEnum,
  probabilityTask,
  drawForm,
  luckyDrawOpportunity,
  cancellationType,
  couponisLimitCountType,
  couponBtnStatus,
  LS_KEY,
  DECLARE_TYPE_ENUM_DATA,
  DECLARE_TYPE_ENUM,
  DECLARE_TYPE_OPTIONS,
  recordListDeclaerType,
  ORDER_STATUS,
  afterSalesOrderStatus,
  ORDER_TYPE,
  EPR_LOG_OFF_LIST,
  GET_LOG_OFF_W3ETYPE,
  DEADLINE_LIST,
  InvoiceIdentifyEnum,
  residenceStateEnum,
  legalEntityTypeEnum,
  CUSTOM_APPLY_TYPE,
  entryCompanyEnumAdmin,
  selectEntryCompanyEnum,
  invoiceTypeEnum,
  businessTypeEnum,
  currencyType,
  tradeType,
  businessType,
  businessTypeText,
  taxesType,
  backTaxesType,
  accountStatus,
  serverRateType,
  autoMsg,
  declareType,
  companyType,
  orderStatus,
  declarePeriodType,
  RPAApplyResult,
  officialCondition,
  officialCycle,
  officialCurrency,
  SERVICE_TYPE_FOR_Add_LIST,
  SERVICE_TYPE_FOR_USER_LIST,
  SERVICE_ITEM,
  SERVICE_ITEM_MAP,
  YES_OR_NO,
  YES_OR_NO_MAP,
  YES_OR_NO_LIST,
  YES_OR_NO_NUM,
  YES_OR_NO_BOOLEAN,
  CUSTOMER_TYPE,
  CUSTOMER_TYPE_MAP,
  CUSTOMER_TYPE_LIST,
  EXCHANGE_RATE_TYPE,
  EXCHANGE_RATE_TYPE_MAP,
  EXCHANGE_RATE_LIST,
  VIP_TYPE_LIST,
  EXPERIENCE_VIP_TYPE_LIST,
  VIP_SOURCE,
  VIP_SOURCE_MAP,
  VIP_SOURCE_LIST,
  ACTIVITY_STATUS,
  ACTIVITY_STATUS_MAP,
  ACTIVITY_STATUS_LIST,
  IS_BATCH,
  IMP_USER_TYPE,
  VIP_ACTIVITY_TYPE,
  VIP_ACTIVITY_TYPE_MAP,
  VIP_ACTIVITY_TYPE_LIST,
  EXPERIENCE_VIP_PRICE_LIMIT,
  EXPERIENCE_VIP_PRICE_LIMIT_MAP,
  EXPERIENCE_VIP_PRICE_LIMIT_LIST,
  COUNT_WAT,
  COUNT_WAT_MAP,
  COUNT_WAT_LIST,
  TRADEMARK_QUERY_TYPE,
  TRADEMARK_QUERY_TYPE_MAP,
  TRADEMARK_QUERY_TYPE_LIST,
  COST_GET_TYPE,
  COST_GET_TYPE_COUNTRY_SERVICE_MAP,
  COST_GET_TYPE_MAP,
  COST_GET_TYPE_LIST,
  DISPATCH_RULE_NODE,
  DISPATCH_RULE_NODE_MAP,
  DISPATCH_RULE_NODE_LIST,
  CONVERSION_TYPE,
  CONVERSION_TYPE_MAP,
  CONVERSION_TYPE_LIST,
  REGION,
  REGION_MAP,
  REGION_LIST,
  INVITATION_STATUS,
  INVITATION_STATUS_MAP,
  INVITATION_STATUS_LIST,
  INVITATION_REWARD,
  INVITATION_REWARD_MAP,
  INVITATION_REWARD_LIST,
  AWARY_TYPE,
  fullDiscountType,
  VIPLevel,
  REWARD_PURCHASE_TYPE,
  REWARD_PURCHASE_TYPE_MAP,
  REWARD_PURCHASE_TYPE_LIST,
  MSGKIND,
  MSGKINDMAP,
  SEND_STATUS,
  SEND_STATUS_MAP,
  SEND_STATUS_LIST,
  ORDER_STATUS_ADMIN,
  PLAT_FORM,
  PLAT_FORM_MAP,
  SYSTEM_TYPE,
  BUSINESS_TYPE,
  PLAT_FORM_LIST,
  ORDER_STATUS_MAP,
  ORDER_STATUS_LIST,
  TAX_POINT,
  REASON_GRADE,
  REASON_GRADE_MAP,
  CENTER_BASE_URL,
  REFUND_DEPARTMENT,
  REFUND_DEPARTMENT_MAP,
  REFUND_DEPARTMENT_LIST,
  INTENTION_ENUM,
  ORDER_PAYMENT_METHOD_ENUM,
  ORDER_SOURCE_ENUM,
  ORDER_STATUS_ENUM,
  CURRENCY_LIST,
  NEED_PRICE_LIST,
  COST_TYPE,
  WRITE_OFF_STATE,
  WRITE_OFF_STATE_MAP,
  WRITE_OFF_STATE_LIST,
  CONTRACTING_ENTITY,
  CONTRACTING_ENTITY_MAP,
  CONTRACTING_ENTITY_LIST,
  MDT_CONTRACTING_ENTITY,
  MDT_CONTRACTING_ENTITY_MAP,
  MDT_CONTRACTING_ENTITY_LIST,
  LIDO_CONTRACTING_ENTITY,
  LIDO_CONTRACTING_ENTITY_MAP,
  LIDO_CONTRACTING_ENTITY_LIST,
  TH_CONTRACTING_ENTITY,
  TH_CONTRACTING_ENTITY_MAP,
  TH_CONTRACTING_ENTITY_LIST,
  XM_CONTRACTING_ENTITY,
  XM_CONTRACTING_ENTITY_MAP,
  XM_CONTRACTING_ENTITY_LIST,
  COST_ESTIMATION,
  COST_ESTIMATION_MAP,
  COST_TIME_DIMENSIONAL_MAP,
  MESSAGE_TYPES,
  BILLING_STATUS,
  RED_INVOICE_STATUS,
  WORK_TYPE_ENUM,
  ostEntryCompanyEnum,
  mdtEntryCompanyEnum,
  TRACK_CODE,
  lidoEntryCompanyEnum,
  xmEntryCompanyEnum,
  thEntryCompanyEnum,
  invoiceTypeMap,
  OrderMergeType,
  supplierAuthInfoMap,
  EPR_DECLARE_PERIOD_ENUM,
  EPR_DECLARE_PERIOD_ENUM_MAP,
  VAT_DRAWBACK_TAX_STATUS,
  APPLY_STATUS_MAP,
  tradeClassType,
  currentPayCounty,
  currentPayCountyItem,
  countyList,
  COMMON_YES_NO,
  REGISTER_TYPE,
  COUPON_DISCOUNT_TYPE,
  SEND_CODE_TYPE,
  SEND_TYPE,
  DECLARATION_STATUS,
  DECLARE_PERIOD_ENUM,
  DECLARE_PERIOD_ENUM_MAP,
  DEDUCTION_TYPE_LIST,
  TAX_CALCULATE_VERSION,
  DECLARATION_STATUS_OPTIONS,
  DECLARATION_STATUS_MAP,
  COUNTRY_NEW,
  COUNTRY_NEW_MAP,
  POST_MSG_TYPE,
  TRADEMARK_COUNTRY_LIST,
  OrderType,
  CATEGORY_LIST,
  TRADEMARK_CATEGORY_DESC,
  PLAT_FORM_ENUM,
  SELF_PLAT_FORM_ENUM,
  moneyTypeData,
  payClassTwo,
  CHANNEL_TYPE,
  CHANNEL_TYPE_MAP,
  CHANNEL_TYPE_LIST,
  platformMappingList,
  BELONG_TO,
  CONFIG_TYPE,
  BELONG_TO_LIST,
  CONFIG_TYPE_LIST,
  TARGET_DATA,
  TARGET_DATA_VALUE,
  CALL_CENTER_SERVICE_TYPE,
  USER_DEPT_TYPE,
  VAT_ACTIVE,
  PLATFORM,
  PLATFORM_MAP,
  PLATFORM_LIST,
  DECLARE_COUNTRY_LIST,
  DECLARE_BUSINESS_TYPE,
  DECLARE_BUSINESS_TYPE_MAP,
  DECLARE_BUSINESS_TYPE_LIST,
  DECLARE_BUSINESS_TYPE_SELECT_ITEM,
  DECLARE_BUSINESS_TYPE_MAP_SELECT_ITEM,
  DECLARE_SERVICE_TYPE,
  DECLARE_SERVICE_TYPE_MAP,
  DECLARE_SERVICE_TYPE_LIST,
  DECLARE_SERVICE_TYPE_SELECT_ITEM,
  DECLARE_SERVICE_TYPE_MAP_SELECT_ITEM,
  ALL_DECLARE_TASK_STATUS,
  SHOW_USER_DECLARE_RECORD,
  ALL_DECLARE_TASK_STATUS_MAP,
  ALL_DECLARE_TASK_STATUS_LIST,
  ZM_DECLARE_PERIOD_TYPE,
  ZM_DECLARE_PERIOD_TYPE_MAP,
  ZM_DECLARE_PERIOD_TYPE_LIST,
  DECLARE_STATUS,
  DECLARE_STATUS_MAP,
  DECLARE_STATUS_LIST,
  TASK_CLOSE_TAG,
  TASK_CLOSE_TAG_LIST,
  TASK_LOG_TYPE,
  MERC_TYPE,
  MERC_TYPE_MAP,
  MERC_TYPE_LIST,
  MERC_LEVEL,
  MERC_LEVEL_MAP,
  MERC_LEVEL_LIST,
  SALES_PLAT_FORM,
  DE_DECLARE_DATA_ORIGIN,
  DE_VAT_YEAR_DECLARE_TYPE,
  B2B_SALES_SYSTEM,
  DECLARE_STATUS_ENUM,
  DECLARE_DATA_ORIGIN,
  FILE_STATUS_MAP,
  FILE_STATUS_ENUM,
  SCORE_TYPE_ENUM,
  DECLARE_DATA_ORIGIN_ENUM,
  DECLARATION_CYCLE_TYPE,
  DECLARATION_CYCLE_TYPE_ENUM,
  EPR_DECLARATION_STATUS,
  EPR_DECLARATION_STATUS_ENUM,
  RESPONSE_STATUS_CODE,
  ES_EPR_DECLARATION_STATUS,
  B2B_ACCOUNT_STATUS_ENUM,
  B2B_ACCOUNT_STATUS_ENUM_OBJ,
  PACK_CH_NAME_INPUT_LIMIT,
  COMMON_BUSINESS_TYPE,
  HANDLE_EVENT_TYPE,
  DECLARE_COUNTRY_OPTIONS,
  DECLARE_TYPE,
  OPERATION_TYPE_ENUM,
  EPR_DECLARE_STATUS_ENUM,
  EPR_IMPORT_STATUS_ENUM,
  EPR_DECLARE_PERIOD_OPTIONS,
  EPR_DECLARE_PERIOD_MAP,
  TICKET_TYPE_ENUM,
  PAYMENT_BUSINESS_ENUM,
  PAY_CHANNEL_ENUM,
  REFUND_TYPE,
  ENTRY_ACCOUNT,
  serviceStatusEnum,
  terminationTypeEnum,
  terminationResultEnum,
  leaveReassignFlagEnum,
  taxesTypeMerchant,
  SYSTEM_SERVICE_TYPE_MAP,
  PAY_TAX_METHOD,
  DE_PACK_DECLARE_MATERIAL,
  IS_NEED_DECLARE,
  W3E_CODE_STATE_ENUM,
  W3E_CODE_STATE_MAP,
  DE_PACK_DECLARE_DATA_ORIGIN,
  PLANTTYPEOBJ,
  CATEGORY_MAP,
  BILLING_DATA_ENUM,
  CATEGORY_MAP_EN,
  PLATFORM_MORE_LIST,
  createSelectList,
  createSelectItem,
  SETTLEMENT_CHANNEL,
  LAWYER_TYPE_LIST,
  CLOSURE_REASON_LIST,
  CLOSURE_REASON_MAP,
  CLOSURE_REASON_EN_MAP,
  OST_BUY_TYPE,
  WX_TYPE,
  QR_CODE_TYPE,
  LOGIN_TYPE,
  LOGIN_DETAIL_TYPE,
  FIRST_LOGIN_TIP,
  CART_OP_CODE,
  PAYMENT_METHOD_MAP,
  PAYMENT_METHOD_LIST,
  HAND_STATE,
  EVENT_BUS,
  W3E_LIST,
  PLASTIC_STATUS_LIST,
  PLASTIC_LIST,
  QUERY_W3E_PROGRESS,
  PRODUCT_DESC_TYPE,
  COMP_HELPER_DOMAIN_NAME,
  isBooleanModule,
  eprRspTerminationTypeEnum,
  PAYMENT_METHOD,
  CURRENTCY_MAP,
  VIP_SERVICE_TYPE_VALUES,
  GF_SERVICE_TYPE_VALUES,
  thirdProductType,
  convertTypeLabel,
  ES_BUTTERY_PRODUCT_TYPE_ENUM,
  RULE_TYPE_ENUM,
  ES_W3E_RULE_TYPE_ENUM,
  EPR_FILE_IDENTIFY_STATUS,
  DEDUCTION_ITEM_TAX_RATE,
  DEDUCTION_ITEM_TAX_RATE_DE,
  DEDUCTION_ITEM_TAX_RATE_ENUM,
  DEDUCTION_ITEM_TAX_RATE_ENUM_DE,
  CLOSURE_REASON_OPTIONS,
  payType,
  JCT_PAY_TAX_WAY_ENUM,
  JCT_DECLARE_WAY_ENUM,
  JP_DECLARE_TYPE_ENUM,
  taskTypeEnum,
  taskRefreshInterval,
  taskActivityStatus,
  userSystemType,
  BASE_STATUS,
  BLACK_ADD_METHODS,
  languageEnum,
  dictTypeEnum,
  CATEGORY_COUNTRY_LIST,
  WE3_CODE_STATE,
  withdrawTypeEnum,
  billingTypeEnum,
  errorCodeEnum,
  SUPPLIER_COST_TYPE,
  FINANCIAL_AUDIT_TYPE,
  PATENT_SEARCH_COUNTRY,
  OTHER_PATENT_SEARCH_COUNTRY,
  PATENT_SEARCH_ALL_COUNTRY,
  OTHER_PATENT_TEXT_SEARCH_COUNTRY,
  AI_IDENTIFY_STATUS_ENUM,
  AI_IDENTIFY_DETAIL_STATUS_ENUM,
  COOKIE_TIME_STR,
  COOKIE_TIME_OBJ,
  COOKIE_TIME_BY_JS_COOKIE,
  VATAI_REGISTER_ENUM,
  OA_TYPE,
  OBJECTION_OA_TYPE,
  EPRSERIALNUMBERMARKING,
  SUPPLIER_COST_TYPE_MAP,
  SUPPLIER_COST_TYPE_LIST,
  specialQueryTypeEnum,
  homePageModuleTitleTypeEnum
}



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/enum/env.js